import { v4 } from 'uuid';
import { Base64 } from 'js-base64';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var ObjectUtil = /** @class */ (function () {
    function ObjectUtil() {
    }
    ObjectUtil.isNotNullOrUndefined = function (value) {
        return value !== null && value !== undefined;
    };
    ObjectUtil.isNullOrUndefined = function (value) {
        return value === null || value === undefined;
    };
    ObjectUtil.requiredNotNullOrUndefined = function (value, message) {
        if (message === void 0) { message = function () { return "Required value is null or undefined"; }; }
        if (this.isNullOrUndefined(value)) {
            throw new Error(message());
        }
        return value;
    };
    ObjectUtil.fromMap = function (map) {
        var object = {};
        map.forEach(function (value, key) {
            object[key] = value;
        });
        return object;
    };
    return ObjectUtil;
}());

var CollectionUtil = /** @class */ (function () {
    function CollectionUtil() {
    }
    CollectionUtil.mapNotNullOrUndefined = function (array, transform) {
        var results = Array();
        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
            var element = array_1[_i];
            var value = transform(element);
            if (ObjectUtil.isNotNullOrUndefined(value)) {
                results.push(value);
            }
        }
        return results;
    };
    CollectionUtil.mapOrUndefined = function (array, transform) {
        var results = Array();
        for (var _i = 0, array_2 = array; _i < array_2.length; _i++) {
            var element = array_2[_i];
            var value = transform(element);
            if (ObjectUtil.isNullOrUndefined(value)) {
                return undefined;
            }
            results.push(value);
        }
        return results;
    };
    CollectionUtil.associateTo = function (array, destination, transform) {
        for (var _i = 0, array_3 = array; _i < array_3.length; _i++) {
            var element = array_3[_i];
            var entry = transform(element);
            destination.set(entry[0], entry[1]);
        }
        return destination;
    };
    CollectionUtil.associate = function (array, transform) {
        return this.associateTo(array, new Map(), transform);
    };
    CollectionUtil.associateBy = function (receiver, keySelector) {
        return this.associate(receiver, function (it) { return [keySelector(it), it]; });
    };
    CollectionUtil.associateRecord = function (array, transform) {
        var record = {};
        for (var _i = 0, array_4 = array; _i < array_4.length; _i++) {
            var element = array_4[_i];
            var _a = transform(element), key = _a[0], value = _a[1];
            record[key] = value;
        }
        return record;
    };
    CollectionUtil.chunked = function (arr, chunkSize) {
        var chunkedArr = [];
        var origin = arr.slice();
        while (origin.length) {
            chunkedArr.push(origin.splice(0, chunkSize));
        }
        return chunkedArr;
    };
    CollectionUtil.sum = function (arr, valueResolver) {
        return arr.reduce(function (acc, cur) { return acc + valueResolver(cur); }, 0);
    };
    return CollectionUtil;
}());

var logLevels = {
    DISABLE: 0,
    ERROR: 1,
    WARN: 2,
    INFO: 3,
    DEBUG: 4
};
var Logger = /** @class */ (function () {
    function Logger() {
    }
    Logger.setLogLevel = function (logLevel) {
        if (logLevel === void 0) { logLevel = logLevels.INFO; }
        this.logLevel = logLevel;
    };
    Logger.initCounter = function (resolveCounter) {
        this.counters = CollectionUtil.associate(Object.keys(logLevels), function (logLevel) { return [logLevel, resolveCounter(logLevel)]; });
    };
    Logger._log = function (level, message) {
        var color;
        switch (level) {
            case "WARN":
                color = "orange";
                break;
            case "ERROR":
                color = "red";
                break;
            default:
                color = "#AAAAAA";
        }
        if (message instanceof Error) {
            ConsoleLogger.log(level, color, message.message, message);
            return;
        }
        try {
            ConsoleLogger.log(level, color, message);
        }
        catch (e) { }
    };
    Logger.increment = function (level) {
        var _a, _b;
        (_b = (_a = Logger.counters) === null || _a === void 0 ? void 0 : _a.get(level)) === null || _b === void 0 ? void 0 : _b.increment();
    };
    Logger.logLevel = logLevels.INFO;
    Logger.log = {
        error: function (message) {
            if (Logger.logLevel >= logLevels.ERROR) {
                Logger._log("ERROR", message);
                Logger.increment("ERROR");
            }
        },
        warn: function (message) {
            if (Logger.logLevel >= logLevels.WARN) {
                Logger._log("WARN", message);
                Logger.increment("WARN");
            }
        },
        info: function (message) {
            if (Logger.logLevel >= logLevels.INFO) {
                Logger._log("INFO", message);
                Logger.increment("INFO");
            }
        },
        debug: function (message) {
            if (Logger.logLevel >= logLevels.DEBUG) {
                Logger._log("DEBUG", message);
                Logger.increment("DEBUG");
            }
        }
    };
    return Logger;
}());
var ConsoleLogger = /** @class */ (function () {
    function ConsoleLogger() {
    }
    ConsoleLogger.log = function (level, color, message, error) {
        try {
            console.log("%c[".concat(level, "] Hackle: ").concat(message), "color: ".concat(color));
        }
        catch (e) { }
    };
    return ConsoleLogger;
}());

var log$c = Logger.log;
var IdentifierUtil = /** @class */ (function () {
    function IdentifierUtil() {
    }
    IdentifierUtil.isEqual = function (a, b) {
        return a.type === b.type && a.value === b.value;
    };
    IdentifierUtil.isEquals = function (identifiers, other) {
        if (other === undefined || other === null) {
            return false;
        }
        var identifierTypes = Object.keys(identifiers);
        if (identifierTypes.length !== Object.keys(other).length) {
            return false;
        }
        return identifierTypes.every(function (it) { return identifiers[it] === other[it]; });
    };
    IdentifierUtil.sanitize = function (identifiers) {
        var sanitized = {};
        if (ObjectUtil.isNullOrUndefined(identifiers)) {
            return sanitized;
        }
        for (var _i = 0, _a = Object.entries(identifiers); _i < _a.length; _i++) {
            var _b = _a[_i], type = _b[0], value = _b[1];
            if (!this.isValidType(type)) {
                log$c.debug("Invalid identifier type. The identifier type must be a string of 128 characters or less. [".concat(type, "]"));
                continue;
            }
            var sanitizedValue = this.sanitizeValue(value);
            if (ObjectUtil.isNullOrUndefined(sanitizedValue)) {
                log$c.debug("Invalid identifier value. The identifier type value be a string of 512 characters or less. [".concat(type, "]"));
                continue;
            }
            sanitized[type] = sanitizedValue;
        }
        return sanitized;
    };
    IdentifierUtil.isValidType = function (type) {
        if (ObjectUtil.isNullOrUndefined(type)) {
            return false;
        }
        return typeof type === "string" && type.length > 0 && type.length <= this.MAX_IDENTIFIER_TYPE_LENGTH;
    };
    IdentifierUtil.sanitizeValue = function (identifierValue) {
        if (typeof identifierValue === "string" &&
            identifierValue.length > 0 &&
            identifierValue.length <= this.MAX_IDENTIFIER_VALUE_LENGTH) {
            return identifierValue;
        }
        if (typeof identifierValue === "number") {
            return identifierValue.toString();
        }
        return null;
    };
    IdentifierUtil.MAX_IDENTIFIER_TYPE_LENGTH = 128;
    IdentifierUtil.MAX_IDENTIFIER_VALUE_LENGTH = 512;
    return IdentifierUtil;
}());

var log$b = Logger.log;
var PropertyUtil = /** @class */ (function () {
    function PropertyUtil() {
    }
    PropertyUtil.sanitize = function (properties) {
        var sanitized = {};
        if (ObjectUtil.isNullOrUndefined(properties)) {
            return sanitized;
        }
        for (var _i = 0, _a = Object.entries(properties); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (Object.keys(sanitized).length >= this.MAX_PROPERTIES_COUNT) {
                log$b.debug("The number of properties cannot exceed 128. Drops excess properties. [".concat(key, ", ").concat(value, "]"));
                break;
            }
            if (!this.isValidKey(key)) {
                log$b.debug("Invalid property key. The property key must be a string of 128 characters or less. [".concat(key, "]"));
                continue;
            }
            var sanitizedValue = this.sanitizeValue(key, value);
            if (ObjectUtil.isNullOrUndefined(sanitizedValue)) {
                log$b.debug("Invalid property value. The property value mus be 'string(..1024)', 'number', 'boolean', or 'array' type. [".concat(value, "]"));
                continue;
            }
            sanitized[key] = sanitizedValue;
        }
        return sanitized;
    };
    PropertyUtil.isValidProperty = function (key, value) {
        return this.isValidKey(key) && this.isValidValue(value);
    };
    PropertyUtil.isValidKey = function (key) {
        return (ObjectUtil.isNotNullOrUndefined(key) &&
            typeof key === "string" &&
            key.length > 0 &&
            key.length <= this.MAX_PROPERTY_KEY_LENGTH);
    };
    PropertyUtil.sanitizeValue = function (key, value) {
        var _this = this;
        if (typeof key === "string" && key.startsWith(this.SYSTEM_PROPERTY_KEY_PREFIX)) {
            return value;
        }
        if (!this.isValidValue(value)) {
            return null;
        }
        if (Array.isArray(value)) {
            return value.filter(function (it) { return _this.isValidElement(it); });
        }
        return value;
    };
    PropertyUtil.isValidValue = function (value) {
        if (ObjectUtil.isNullOrUndefined(value)) {
            return false;
        }
        if (typeof value === "string") {
            return value.length <= this.MAX_PROPERTY_VALUE_LENGTH;
        }
        if (typeof value === "number") {
            return !isNaN(value) && isFinite(value);
        }
        return typeof value === "boolean" || Array.isArray(value);
    };
    PropertyUtil.isValidElement = function (element) {
        if (ObjectUtil.isNullOrUndefined(element)) {
            return false;
        }
        if (typeof element === "string") {
            return element.length > 0 && element.length <= this.MAX_PROPERTY_VALUE_LENGTH;
        }
        return typeof element === "number";
    };
    PropertyUtil.truncateStringValue = function (value) {
        if (typeof value === "string" && value.length > this.MAX_PROPERTY_VALUE_LENGTH) {
            return value.slice(0, this.MAX_PROPERTY_VALUE_LENGTH);
        }
        return value;
    };
    PropertyUtil.SYSTEM_PROPERTY_KEY_PREFIX = "$";
    PropertyUtil.MAX_PROPERTIES_COUNT = 128;
    PropertyUtil.MAX_PROPERTY_KEY_LENGTH = 128;
    PropertyUtil.MAX_PROPERTY_VALUE_LENGTH = 1024;
    return PropertyUtil;
}());

var TIME_UNIT = ["nanoseconds", "microseconds", "milliseconds", "seconds", "minutes", "hours", "days"];
var DAY_OF_WEEK = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
var TimeUtil = /** @class */ (function () {
    function TimeUtil() {
    }
    TimeUtil.nanosToUnit = function (nanos, unit) {
        switch (unit) {
            case "nanoseconds":
                return nanos;
            case "microseconds":
                return nanos / (TimeUtil.C1 / TimeUtil.C0);
            case "milliseconds":
                return nanos / (TimeUtil.C2 / TimeUtil.C0);
            case "seconds":
                return nanos / (TimeUtil.C3 / TimeUtil.C0);
            case "minutes":
                return nanos / (TimeUtil.C4 / TimeUtil.C0);
            case "hours":
                return nanos / (TimeUtil.C5 / TimeUtil.C0);
            case "days":
                return nanos / (TimeUtil.C6 / TimeUtil.C0);
        }
    };
    TimeUtil.microsToUnit = function (micros, unit) {
        switch (unit) {
            case "nanoseconds":
                return micros * (TimeUtil.C1 / TimeUtil.C0);
            case "milliseconds":
                return micros / (TimeUtil.C2 / TimeUtil.C1);
            case "microseconds":
                return micros;
            case "seconds":
                return micros / (TimeUtil.C3 / TimeUtil.C1);
            case "minutes":
                return micros / (TimeUtil.C4 / TimeUtil.C1);
            case "hours":
                return micros / (TimeUtil.C5 / TimeUtil.C1);
            case "days":
                return micros / (TimeUtil.C6 / TimeUtil.C1);
        }
    };
    TimeUtil.millisToUnit = function (millis, unit) {
        switch (unit) {
            case "nanoseconds":
                return millis * (TimeUtil.C2 / TimeUtil.C0);
            case "microseconds":
                return millis * (TimeUtil.C2 / TimeUtil.C1);
            case "milliseconds":
                return millis;
            case "seconds":
                return millis / (TimeUtil.C3 / TimeUtil.C2);
            case "minutes":
                return millis / (TimeUtil.C4 / TimeUtil.C2);
            case "hours":
                return millis / (TimeUtil.C5 / TimeUtil.C2);
            case "days":
                return millis / (TimeUtil.C6 / TimeUtil.C2);
        }
    };
    TimeUtil.secondsToUnit = function (seconds, unit) {
        switch (unit) {
            case "nanoseconds":
                return seconds * (TimeUtil.C3 / TimeUtil.C0);
            case "microseconds":
                return seconds * (TimeUtil.C3 / TimeUtil.C1);
            case "milliseconds":
                return seconds * (TimeUtil.C3 / TimeUtil.C2);
            case "seconds":
                return seconds;
            case "minutes":
                return seconds / (TimeUtil.C4 / TimeUtil.C3);
            case "hours":
                return seconds / (TimeUtil.C5 / TimeUtil.C3);
            case "days":
                return seconds / (TimeUtil.C6 / TimeUtil.C3);
        }
    };
    TimeUtil.minutesToUnit = function (minutes, unit) {
        switch (unit) {
            case "nanoseconds":
                return minutes * (TimeUtil.C4 / TimeUtil.C0);
            case "microseconds":
                return minutes * (TimeUtil.C4 / TimeUtil.C1);
            case "milliseconds":
                return minutes * (TimeUtil.C4 / TimeUtil.C2);
            case "seconds":
                return minutes * (TimeUtil.C4 / TimeUtil.C3);
            case "minutes":
                return minutes;
            case "hours":
                return minutes / (TimeUtil.C5 / TimeUtil.C4);
            case "days":
                return minutes / (TimeUtil.C6 / TimeUtil.C4);
        }
    };
    TimeUtil.hoursToUnit = function (hours, unit) {
        switch (unit) {
            case "nanoseconds":
                return hours * (TimeUtil.C5 / TimeUtil.C0);
            case "microseconds":
                return hours * (TimeUtil.C5 / TimeUtil.C1);
            case "milliseconds":
                return hours * (TimeUtil.C5 / TimeUtil.C2);
            case "seconds":
                return hours * (TimeUtil.C5 / TimeUtil.C3);
            case "minutes":
                return hours * (TimeUtil.C5 / TimeUtil.C4);
            case "hours":
                return hours;
            case "days":
                return hours / (TimeUtil.C6 / TimeUtil.C5);
        }
    };
    TimeUtil.daysToUnit = function (days, unit) {
        switch (unit) {
            case "nanoseconds":
                return days * (TimeUtil.C6 / TimeUtil.C0);
            case "microseconds":
                return days * (TimeUtil.C6 / TimeUtil.C1);
            case "milliseconds":
                return days * (TimeUtil.C6 / TimeUtil.C2);
            case "seconds":
                return days * (TimeUtil.C6 / TimeUtil.C3);
            case "minutes":
                return days * (TimeUtil.C6 / TimeUtil.C4);
            case "hours":
                return days * (TimeUtil.C6 / TimeUtil.C5);
            case "days":
                return days;
        }
    };
    TimeUtil.dayOfWeek = function (timestamp) {
        var date = new Date(timestamp);
        var day = date.getUTCDay();
        return DAY_OF_WEEK[(day + 6) % 7];
    };
    TimeUtil.midnight = function (timestamp) {
        var date = new Date(timestamp);
        return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    };
    TimeUtil.C0 = 1;
    TimeUtil.C1 = TimeUtil.C0 * 1000;
    TimeUtil.C2 = TimeUtil.C1 * 1000;
    TimeUtil.C3 = TimeUtil.C2 * 1000;
    TimeUtil.C4 = TimeUtil.C3 * 60;
    TimeUtil.C5 = TimeUtil.C4 * 60;
    TimeUtil.C6 = TimeUtil.C5 * 24;
    TimeUtil.converter = {
        nanoseconds: TimeUtil.nanosToUnit,
        microseconds: TimeUtil.microsToUnit,
        milliseconds: TimeUtil.millisToUnit,
        seconds: TimeUtil.secondsToUnit,
        minutes: TimeUtil.minutesToUnit,
        hours: TimeUtil.hoursToUnit,
        days: TimeUtil.daysToUnit
    };
    return TimeUtil;
}());
var SystemClock = /** @class */ (function () {
    function SystemClock() {
    }
    SystemClock.prototype.tick = function () {
        return Date.now() * 1e3;
    };
    SystemClock.prototype.currentMillis = function () {
        return Date.now();
    };
    SystemClock.instance = new SystemClock();
    return SystemClock;
}());

var EmptyParameterConfig = /** @class */ (function () {
    function EmptyParameterConfig() {
        this.parameters = {};
    }
    EmptyParameterConfig.prototype.get = function (key, defaultValue) {
        return defaultValue;
    };
    return EmptyParameterConfig;
}());
var DefaultParameterConfig = /** @class */ (function () {
    function DefaultParameterConfig(parameters) {
        this.parameters = parameters;
    }
    DefaultParameterConfig.prototype.get = function (key, defaultValue) {
        var parameterValue = this.parameters[key];
        if (ObjectUtil.isNullOrUndefined(parameterValue)) {
            return defaultValue;
        }
        if (ObjectUtil.isNullOrUndefined(defaultValue)) {
            return parameterValue;
        }
        if (typeof parameterValue === typeof defaultValue) {
            return parameterValue;
        }
        return defaultValue;
    };
    return DefaultParameterConfig;
}());

var DEFAULT_SDK_URL = "https://sdk-api.hackle.io";
var DEFAULT_EVENT_URL = "https://event-api.hackle.io";
var DEFAULT_MONITORING_URL = "https://monitoring.hackle.io";
var DEFAULT_CDN_URL = "https://static.hackle.io";
var SDK_KEY_HEADER = "X-HACKLE-SDK-KEY";
var SDK_NAME_HEADER = "X-HACKLE-SDK-NAME";
var SDK_VERSION_HEADER = "X-HACKLE-SDK-VERSION";
var SDK_TIME_HEADER = "X-HACKLE-SDK-TIME";
var SDK_VERSION = "11.52.0" ;
var BROWSER_MIN_POOL_INTERVAL = 60000; // 60 seconds
var BROWSER_BATCH_SIZE = 100;
var METRIC_FLUSH_INTERVAL = 1000 * 60;
var BROWSER_FLUSH_INTERVAL = 500; // milliseconds
var DEFAULT_ON_READY_TIMEOUT = 3000;
var COOKIE_EXPIRE_DAYS = 365 * 10;
var COOKIE_HID_KEY = "_hackle_hid";
var COOKIE_USER_ID_KEY = "_hackle_id";
var LOCAL_STORAGE_KEY_PREFIX = "hackle-repository-storage";
var DEFAULT_SESSION_TIMEOUT_MILLIS = 1000 * 60 * 30; // 30m
var SESSION_ID_STORAGE_KEY = "_hackle_session_id";
var LAST_EVENT_TIME_STORAGE_KEY = "_hackle_last_event_ts";
var NO_POLLING = -1;
var DEFAULT_DEDUP_INTERVAL_MILLIS = 1000 * 60; // 1m
var NO_DEDUP = -1;
var USER_ID_STORAGE_KEY = "_hackle_uid";
var DEVICE_ID_STORAGE_KEY = "_hackle_did";
var MARKETING_STORAGE_KEY = "_hackle_mkt";
var OVERRIDE_AB_STORAGE_PREFIX = "hackle-manual-override_ab";
var OVERRIDE_FF_STORAGE_PREFIX = "hackle-manual-override_ff";
var IAM_HIDE_STORAGE_PREFIX = "hackle-iam-hide";
var IAM_IMPRESSION_STORAGE_PREFIX = "hackle-iam-impression";
var IAM_RENDERER_VERSION = "0.0.12";
var SPLIT_URL_REDIRECT_CHECK_COOKIE_KEY = "hackle-split-url-redirected";
var SPLIT_URL_REDIRECT_CHECK_COOKIE_EXPIRE_DAYS = 3 * (1 / (60 * 60 * 24)); // 3s
var WORKSPACE_CONFIG_STORAGE_KEY = "hackle-workspace-config";
var FETCH_THROTTLE_INTERVAL_MILLIS = 1000 * 60; // 1 min
var DEFAULT_ENGAGEMENT_DURATION_MILLIS = 1000;
// 24 hours in ms
var IAM_HIDE_EXPIRATION_MILLIS = 24 * 60 * 60 * 1000;
var CAMPAIGN_DELAY_STORAGE_KEY = "hackle-campaign-delay";

var log$a = Logger.log;
function parseOrNull(types, type) {
    var t = types.find(function (it) { return it === type || it.toLowerCase() === type.toLowerCase(); });
    if (!t) {
        log$a.debug("Unsupported type [".concat(type, "]. Please use the latest version of sdk."));
    }
    return t;
}
function parseAllOrNull(types, names) {
    if (ObjectUtil.isNullOrUndefined(names)) {
        return undefined;
    }
    var result = new Array();
    for (var _i = 0, names_1 = names; _i < names_1.length; _i++) {
        var name_1 = names_1[_i];
        var element = parseOrNull(types, name_1);
        if (ObjectUtil.isNullOrUndefined(element)) {
            return undefined;
        }
        result.push(element);
    }
    return result;
}
/**
 * An object that contains the decided config parameter value and the reason for the config parameter decision.
 */
var RemoteConfigDecision = /** @class */ (function () {
    function RemoteConfigDecision(value, reason) {
        this.value = value;
        this.reason = reason;
    }
    RemoteConfigDecision.of = function (value, reason) {
        return new RemoteConfigDecision(value, reason);
    };
    return RemoteConfigDecision;
}());
/**
 * An object that contains the decided variation and the reason for the decision.
 */
var Decision = /** @class */ (function () {
    function Decision(variation, reason, config, experiment) {
        this.variation = variation;
        this.reason = reason;
        this.config = config;
        this.experiment = experiment;
    }
    Decision.of = function (variation, reason, config, experiment) {
        if (config === void 0) { config = new EmptyParameterConfig(); }
        if (experiment === void 0) { experiment = undefined; }
        return new Decision(variation, reason, config, experiment);
    };
    Object.defineProperty(Decision.prototype, "parameters", {
        get: function () {
            return this.config.parameters;
        },
        enumerable: false,
        configurable: true
    });
    Decision.prototype.get = function (key, defaultValue) {
        switch (typeof defaultValue) {
            case "string":
                return this.config.get(key, defaultValue);
            case "number":
                return this.config.get(key, defaultValue);
            case "boolean":
                return this.config.get(key, defaultValue);
            default:
                return this.config.get(key, defaultValue);
        }
    };
    return Decision;
}());
/**
 * An object that contains the decided flag and the reason for the feature flag decision.
 */
var FeatureFlagDecision = /** @class */ (function () {
    function FeatureFlagDecision(isOn, reason, config, experiment) {
        this.isOn = isOn;
        this.reason = reason;
        this.config = config;
        this.experiment = experiment;
    }
    FeatureFlagDecision.on = function (reason, config, experiment) {
        if (config === void 0) { config = new EmptyParameterConfig(); }
        if (experiment === void 0) { experiment = undefined; }
        return new FeatureFlagDecision(true, reason, config, experiment);
    };
    FeatureFlagDecision.off = function (reason, config, experiment) {
        if (config === void 0) { config = new EmptyParameterConfig(); }
        if (experiment === void 0) { experiment = undefined; }
        return new FeatureFlagDecision(false, reason, config, experiment);
    };
    Object.defineProperty(FeatureFlagDecision.prototype, "parameters", {
        get: function () {
            return this.config.parameters;
        },
        enumerable: false,
        configurable: true
    });
    FeatureFlagDecision.prototype.get = function (key, defaultValue) {
        switch (typeof defaultValue) {
            case "string":
                return this.config.get(key, defaultValue);
            case "number":
                return this.config.get(key, defaultValue);
            case "boolean":
                return this.config.get(key, defaultValue);
            default:
                return this.config.get(key, defaultValue);
        }
    };
    return FeatureFlagDecision;
}());
var EmptyHackleRemoteConfig = /** @class */ (function () {
    function EmptyHackleRemoteConfig() {
    }
    EmptyHackleRemoteConfig.prototype.get = function (key, defaultValue) {
        return defaultValue;
    };
    return EmptyHackleRemoteConfig;
}());
var ParameterConfiguration = /** @class */ (function () {
    function ParameterConfiguration(id, config) {
        this.id = id;
        this.config = config;
    }
    Object.defineProperty(ParameterConfiguration.prototype, "parameters", {
        get: function () {
            return this.config.parameters;
        },
        enumerable: false,
        configurable: true
    });
    ParameterConfiguration.fromJson = function (dto) {
        return new ParameterConfiguration(dto.id, new DefaultParameterConfig(CollectionUtil.associateRecord(dto.parameters, function (it) { return [it.key, it.value]; })));
    };
    ParameterConfiguration.prototype.get = function (key, defaultValue) {
        switch (typeof defaultValue) {
            case "string":
                return this.config.get(key, defaultValue);
            case "number":
                return this.config.get(key, defaultValue);
            case "boolean":
                return this.config.get(key, defaultValue);
            default:
                return defaultValue;
        }
    };
    return ParameterConfiguration;
}());
/**
 * Describes the reason for the [Variation] decision.
 */
var DecisionReason = /** @class */ (function () {
    function DecisionReason() {
    }
    DecisionReason.SDK_NOT_READY = "SDK_NOT_READY";
    DecisionReason.EXCEPTION = "EXCEPTION";
    DecisionReason.INVALID_INPUT = "INVALID_INPUT";
    DecisionReason.UNSUPPORTED_PLATFORM = "UNSUPPORTED_PLATFORM";
    DecisionReason.TYPE_MISMATCH = "TYPE_MISMATCH";
    DecisionReason.EXPERIMENT_NOT_FOUND = "EXPERIMENT_NOT_FOUND";
    DecisionReason.EXPERIMENT_DRAFT = "EXPERIMENT_DRAFT";
    DecisionReason.EXPERIMENT_PAUSED = "EXPERIMENT_PAUSED";
    DecisionReason.EXPERIMENT_COMPLETED = "EXPERIMENT_COMPLETED";
    DecisionReason.OVERRIDDEN = "OVERRIDDEN";
    DecisionReason.TRAFFIC_NOT_ALLOCATED = "TRAFFIC_NOT_ALLOCATED";
    DecisionReason.NOT_IN_MUTUAL_EXCLUSION_EXPERIMENT = "NOT_IN_MUTUAL_EXCLUSION_EXPERIMENT";
    DecisionReason.IDENTIFIER_NOT_FOUND = "IDENTIFIER_NOT_FOUND";
    DecisionReason.VARIATION_DROPPED = "VARIATION_DROPPED";
    DecisionReason.TRAFFIC_ALLOCATED = "TRAFFIC_ALLOCATED";
    DecisionReason.TRAFFIC_ALLOCATED_BY_TARGETING = "TRAFFIC_ALLOCATED_BY_TARGETING";
    DecisionReason.NOT_IN_EXPERIMENT_TARGET = "NOT_IN_EXPERIMENT_TARGET";
    DecisionReason.FEATURE_FLAG_NOT_FOUND = "FEATURE_FLAG_NOT_FOUND";
    DecisionReason.FEATURE_FLAG_INACTIVE = "FEATURE_FLAG_INACTIVE";
    DecisionReason.INDIVIDUAL_TARGET_MATCH = "INDIVIDUAL_TARGET_MATCH";
    DecisionReason.TARGET_RULE_MATCH = "TARGET_RULE_MATCH";
    DecisionReason.DEFAULT_RULE = "DEFAULT_RULE";
    DecisionReason.REMOTE_CONFIG_PARAMETER_NOT_FOUND = "REMOTE_CONFIG_PARAMETER_NOT_FOUND";
    DecisionReason.IN_APP_MESSAGE_NOT_FOUND = "IN_APP_MESSAGE_NOT_FOUND";
    DecisionReason.IN_APP_MESSAGE_DRAFT = "IN_APP_MESSAGE_DRAFT";
    DecisionReason.IN_APP_MESSAGE_PAUSED = "IN_APP_MESSAGE_PAUSED";
    DecisionReason.IN_APP_MESSAGE_HIDDEN = "IN_APP_MESSAGE_HIDDEN";
    DecisionReason.IN_APP_MESSAGE_TARGET = "IN_APP_MESSAGE_TARGET";
    DecisionReason.NOT_IN_IN_APP_MESSAGE_PERIOD = "NOT_IN_IN_APP_MESSAGE_PERIOD";
    DecisionReason.NOT_IN_IN_APP_MESSAGE_TIMETABLE = "NOT_IN_IN_APP_MESSAGE_TIMETABLE";
    DecisionReason.NOT_IN_IN_APP_MESSAGE_TARGET = "NOT_IN_IN_APP_MESSAGE_TARGET";
    DecisionReason.IN_APP_MESSAGE_FREQUENCY_CAPPED = "IN_APP_MESSAGE_FREQUENCY_CAPPED";
    DecisionReason.EXPERIMENT_CONTROL_GROUP = "EXPERIMENT_CONTROL_GROUP";
    return DecisionReason;
}());
var EXPERIMENT_IMPLEMENTATION_TYPE = ["DEFAULT", "SPLIT_URL", "IN_APP_MESSAGE"];
var Experiment = /** @class */ (function () {
    function Experiment(id, key, type, identifierType, status, version, executionVersion, variations, userOverrides, segmentOverrides, targetAudiences, splitUrlTargets, targetRules, defaultRule, containerId, implementationType, winnerVariationId) {
        this.id = id;
        this.key = key;
        this.type = type;
        this.identifierType = identifierType;
        this.status = status;
        this.version = version;
        this.executionVersion = executionVersion;
        this.variations = variations;
        this.userOverrides = userOverrides;
        this.segmentOverrides = segmentOverrides;
        this.targetAudiences = targetAudiences;
        this.splitUrlTargets = splitUrlTargets;
        this.targetRules = targetRules;
        this.defaultRule = defaultRule;
        this.containerId = containerId;
        this.implementationType = implementationType;
        this.winnerVariationId = winnerVariationId;
    }
    Experiment.fromJson = function (type, dto, configs) {
        var experimentStatus = Experiment.experimentStatusOrNull(dto.execution.status);
        var variations = dto.variations.map(function (it) {
            return new Variation(it.id, it.key, it.status === "DROPPED", configs.find(function (c) { return c.id === it.parameterConfigurationId; }));
        });
        var userOverrides = CollectionUtil.associate(dto.execution.userOverrides, function (it) { return [it.userId, it.variationId]; });
        var segmentOverrides = CollectionUtil.mapNotNullOrUndefined(dto.execution.segmentOverrides, function (it) {
            return TargetRule.fromJson(it, TargetingType.IDENTIFIER);
        });
        var targetAudiences = CollectionUtil.mapNotNullOrUndefined(dto.execution.targetAudiences, function (it) {
            return Target.fromJson(it, TargetingType.PROPERTY);
        });
        var splitUrlTargets = SplitUrlTargets.fromJson(dto.execution.targetUrls);
        var implementationType = parseOrNull(EXPERIMENT_IMPLEMENTATION_TYPE, dto.implementationType);
        var targetRules = CollectionUtil.mapNotNullOrUndefined(dto.execution.targetRules, function (it) {
            return TargetRule.fromJson(it, TargetingType.PROPERTY);
        });
        var defaultRule = TargetAction.fromJson(dto.execution.defaultRule);
        return (experimentStatus &&
            implementationType &&
            defaultRule &&
            new Experiment(dto.id, dto.key, type, dto.identifierType, experimentStatus, dto.version, dto.execution.version, variations, userOverrides, segmentOverrides, targetAudiences, splitUrlTargets, targetRules, defaultRule, dto.containerId, implementationType, dto.winnerVariationId));
    };
    Experiment.experimentStatusOrNull = function (executionStatus) {
        switch (executionStatus) {
            case "READY":
                return "DRAFT";
            case "RUNNING":
                return "RUNNING";
            case "PAUSED":
                return "PAUSED";
            case "STOPPED":
                return "COMPLETED";
            default:
                log$a.debug("Unsupported status [".concat(executionStatus, "]"));
                return undefined;
        }
    };
    Experiment.prototype._winnerVariationOrNull = function () {
        if (this.winnerVariationId) {
            return this._getVariationByIdOrNull(this.winnerVariationId);
        }
        return undefined;
    };
    Experiment.prototype._getVariationByIdOrNull = function (variationId) {
        return this.variations.find(function (it) { return it.id === variationId; });
    };
    Experiment.prototype._getVariationByKeyOrNull = function (variationKey) {
        return this.variations.find(function (it) { return it.key === variationKey; });
    };
    return Experiment;
}());
var Variation = /** @class */ (function () {
    function Variation(id, key, isDropped, config) {
        this.id = id;
        this.key = key;
        this.isDropped = isDropped;
        this.config = config;
    }
    Object.defineProperty(Variation.prototype, "parameters", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.parameters) !== null && _b !== void 0 ? _b : {};
        },
        enumerable: false,
        configurable: true
    });
    return Variation;
}());
var Bucket = /** @class */ (function () {
    function Bucket(id, seed, slotSize, slots) {
        this.id = id;
        this.seed = seed;
        this.slotSize = slotSize;
        this.slots = slots;
    }
    Bucket.fromJson = function (dto) {
        return new Bucket(dto.id, dto.seed, dto.slotSize, dto.slots.map(function (_a) {
            var startInclusive = _a.startInclusive, endExclusive = _a.endExclusive, variationId = _a.variationId;
            return new Slot(startInclusive, endExclusive, variationId);
        }));
    };
    return Bucket;
}());
var Slot = /** @class */ (function () {
    function Slot(startInclusive, endExclusive, variationId) {
        this.startInclusive = startInclusive;
        this.endExclusive = endExclusive;
        this.variationId = variationId;
    }
    Slot.prototype.contains = function (slotNumber) {
        return this.startInclusive <= slotNumber && slotNumber < this.endExclusive;
    };
    return Slot;
}());
var EventType = /** @class */ (function () {
    function EventType(id, key) {
        this.id = id;
        this.key = key;
    }
    EventType.fromJson = function (dto) {
        return new EventType(dto.id, dto.key);
    };
    return EventType;
}());
var IdentifierType = /** @class */ (function () {
    function IdentifierType() {
    }
    IdentifierType.ID = "$id";
    IdentifierType.USER = "$userId";
    IdentifierType.DEVICE = "$deviceId";
    IdentifierType.SESSION = "$sessionId";
    IdentifierType.HACKLE_DEVICE = "$hackleDeviceId";
    return IdentifierType;
}());
var resolveIdentifiers = function (user) {
    var builder = new IdentifiersBuilder();
    builder.addIdentifiers(user.identifiers || {});
    builder.add(IdentifierType.ID, user.id);
    builder.add(IdentifierType.DEVICE, user.deviceId);
    if (ObjectUtil.isNotNullOrUndefined(user.userId)) {
        builder.add(IdentifierType.USER, user.userId);
    }
    return builder.build();
};
var IdentifiersBuilder = /** @class */ (function () {
    function IdentifiersBuilder() {
        this.identifiers = {};
    }
    IdentifiersBuilder.prototype.addIdentifiers = function (identifiers) {
        for (var identifierType in identifiers) {
            this.add(identifierType, identifiers[identifierType]);
        }
        return this;
    };
    IdentifiersBuilder.prototype.add = function (type, value) {
        var sanitizeIdentifierValue = IdentifierUtil.sanitizeValue(value);
        if (IdentifierUtil.isValidType(type) && sanitizeIdentifierValue) {
            this.identifiers[type] = value;
        }
        else {
            log$a.warn("Invalid user identifier [type=".concat(type, ", value=").concat(value, "]"));
        }
        return this;
    };
    IdentifiersBuilder.prototype.build = function () {
        return this.identifiers;
    };
    return IdentifiersBuilder;
}());
var isValidUser = function (user) {
    return Boolean(user.id || user.userId || user.deviceId || (user.identifiers && Object.keys(user.identifiers).length > 0));
};
var sanitizeUser = function (user) {
    var _a, _b, _c;
    var sanitized = {};
    sanitized.id = (_a = IdentifierUtil.sanitizeValue(user.id)) !== null && _a !== void 0 ? _a : undefined;
    sanitized.userId = (_b = IdentifierUtil.sanitizeValue(user.userId)) !== null && _b !== void 0 ? _b : undefined;
    sanitized.deviceId = (_c = IdentifierUtil.sanitizeValue(user.deviceId)) !== null && _c !== void 0 ? _c : undefined;
    if (typeof user.properties === "object") {
        sanitized.properties = PropertyUtil.sanitize(user.properties);
    }
    if (typeof user.identifiers === "object") {
        sanitized.identifiers = IdentifierUtil.sanitize(user.identifiers);
    }
    if (isValidUser(sanitized)) {
        return sanitized;
    }
    else {
        return null;
    }
};
var Target = /** @class */ (function () {
    function Target(conditions) {
        this.conditions = conditions;
    }
    Target.fromJson = function (dto, targetingType) {
        var conditions = CollectionUtil.mapNotNullOrUndefined(dto.conditions, function (it) {
            return TargetCondition.fromJson(it, targetingType);
        });
        return new Target(conditions);
    };
    Target.prototype.toJson = function () {
        return {
            conditions: this.conditions.map(function (condition) { return condition.toJson(); })
        };
    };
    return Target;
}());
var TargetCondition = /** @class */ (function () {
    function TargetCondition(key, match) {
        this.key = key;
        this.match = match;
    }
    TargetCondition.fromJson = function (dto, targetingType) {
        var key = TargetKey.fromJson(dto.key);
        if (!key) {
            return undefined;
        }
        if (!targetingType.supports(key.type)) {
            return undefined;
        }
        var match = TargetMatch.fromJson(dto.match);
        return match && new TargetCondition(key, match);
    };
    TargetCondition.prototype.toJson = function () {
        return {
            key: this.key.toJson(),
            match: this.match.toJson()
        };
    };
    return TargetCondition;
}());
var TargetKey = /** @class */ (function () {
    function TargetKey(type, name) {
        this.type = type;
        this.name = name;
    }
    TargetKey.fromJson = function (dto) {
        var keyType = parseOrNull(TARGET_KEY_TYPES, dto.type);
        return keyType && new TargetKey(keyType, dto.name);
    };
    TargetKey.prototype.toJson = function () {
        return {
            type: this.type,
            name: this.name
        };
    };
    return TargetKey;
}());
var TargetMatch = /** @class */ (function () {
    function TargetMatch(type, operator, valueType, values) {
        this.type = type;
        this.operator = operator;
        this.valueType = valueType;
        this.values = values;
    }
    TargetMatch.fromJson = function (dto) {
        var matchType = parseOrNull(MATCH_TYPES, dto.type);
        var operator = parseOrNull(MATCH_OPERATORS, dto.operator);
        var valueType = parseOrNull(MATCH_VALUE_TYPES, dto.valueType);
        return matchType && operator && valueType && new TargetMatch(matchType, operator, valueType, dto.values);
    };
    TargetMatch.prototype.toJson = function () {
        return {
            operator: this.operator,
            type: this.type,
            valueType: this.valueType,
            values: this.values
        };
    };
    return TargetMatch;
}());
var TargetAction = /** @class */ (function () {
    function TargetAction(type, variationId, bucketId) {
        this.type = type;
        this.variationId = variationId;
        this.bucketId = bucketId;
    }
    TargetAction.fromJson = function (dto) {
        var type = parseOrNull(TARGET_ACTION_TYPES, dto.type);
        return type && new TargetAction(type, dto.variationId, dto.bucketId);
    };
    return TargetAction;
}());
var TargetRule = /** @class */ (function () {
    function TargetRule(target, action) {
        this.target = target;
        this.action = action;
    }
    TargetRule.fromJson = function (dto, targetingType) {
        var target = Target.fromJson(dto.target, targetingType);
        var action = TargetAction.fromJson(dto.action);
        return target && action && new TargetRule(target, action);
    };
    return TargetRule;
}());
var Segment = /** @class */ (function () {
    function Segment(id, key, type, targets) {
        this.id = id;
        this.key = key;
        this.type = type;
        this.targets = targets;
    }
    Segment.fromJson = function (dto) {
        var segmentType = parseOrNull(SEGMENT_TYPES, dto.type);
        return (segmentType &&
            new Segment(dto.id, dto.key, segmentType, CollectionUtil.mapNotNullOrUndefined(dto.targets, function (it) { return Target.fromJson(it, TargetingType.SEGMENT); })));
    };
    return Segment;
}());
var Container = /** @class */ (function () {
    function Container(id, bucketId, groups) {
        this.id = id;
        this.bucketId = bucketId;
        this.groups = groups;
    }
    Container.fromJson = function (dto) {
        return new Container(dto.id, dto.bucketId, dto.groups.map(function (it) { return ContainerGroup.fromJson(it); }));
    };
    Container.prototype.getGroupOrNull = function (containerGroupId) {
        return this.groups.find(function (it) { return it.id === containerGroupId; });
    };
    return Container;
}());
var ContainerGroup = /** @class */ (function () {
    function ContainerGroup(id, experiments) {
        this.id = id;
        this.experiments = experiments;
    }
    ContainerGroup.fromJson = function (dto) {
        return new ContainerGroup(dto.id, dto.experiments);
    };
    return ContainerGroup;
}());
var RemoteConfigParameter = /** @class */ (function () {
    function RemoteConfigParameter(id, key, type, identifierType, targetRules, defaultValue) {
        this.id = id;
        this.key = key;
        this.type = type;
        this.identifierType = identifierType;
        this.targetRules = targetRules;
        this.defaultValue = defaultValue;
    }
    RemoteConfigParameter.fromJson = function (dto) {
        var remoteConfigParameterType = parseOrNull(MATCH_VALUE_TYPES, dto.type);
        var targetRules = CollectionUtil.mapNotNullOrUndefined(dto.targetRules, function (it) {
            return RemoteConfigTargetRule.fromJson(it, TargetingType.PROPERTY);
        });
        var defaultValue = RemoteConfigParameterValue.fromJson(dto.defaultValue);
        return (remoteConfigParameterType &&
            new RemoteConfigParameter(dto.id, dto.key, remoteConfigParameterType, dto.identifierType, targetRules, defaultValue));
    };
    return RemoteConfigParameter;
}());
var RemoteConfigTargetRule = /** @class */ (function () {
    function RemoteConfigTargetRule(key, name, target, bucketId, value) {
        this.key = key;
        this.name = name;
        this.target = target;
        this.bucketId = bucketId;
        this.value = value;
    }
    RemoteConfigTargetRule.fromJson = function (dto, targetingType) {
        var target = Target.fromJson(dto.target, targetingType);
        return (target &&
            new RemoteConfigTargetRule(dto.key, dto.name, target, dto.bucketId, RemoteConfigParameterValue.fromJson(dto.value)));
    };
    return RemoteConfigTargetRule;
}());
var RemoteConfigParameterValue = /** @class */ (function () {
    function RemoteConfigParameterValue(id, rawValue) {
        this.id = id;
        this.rawValue = rawValue;
    }
    RemoteConfigParameterValue.fromJson = function (dto) {
        return new RemoteConfigParameterValue(dto.id, dto.value);
    };
    return RemoteConfigParameterValue;
}());
function compareValues(a, b) {
    return a - b;
}
var Version = /** @class */ (function () {
    function Version(coreVersion, prerelease, build) {
        this.coreVersion = coreVersion;
        this.prerelease = prerelease;
        this.build = build;
    }
    Version.tryParse = function (value) {
        if (value instanceof Version) {
            return value;
        }
        var match = Version.regExp.exec(value);
        if (!match)
            return undefined;
        match[0]; var major = match[1], _a = match[2], minor = _a === void 0 ? "0" : _a, _b = match[3], patch = _b === void 0 ? "0" : _b, prerelease = match[4], build = match[5];
        var coreVersion = new CoreVersion(parseInt(major, 10), parseInt(minor, 10), parseInt(patch, 10));
        return new Version(coreVersion, MetaVersion.parse(prerelease), MetaVersion.parse(build));
    };
    Version.prototype.compareTo = function (other) {
        return this.coreVersion.compareTo(other.coreVersion) || this.prerelease.compareTo(other.prerelease);
    };
    Version.prototype.isEqualTo = function (other) {
        return this.compareTo(other) === 0;
    };
    Version.prototype.isGreaterThan = function (other) {
        return this.compareTo(other) > 0;
    };
    Version.prototype.isGreaterThanOrEqualTo = function (other) {
        return this.compareTo(other) >= 0;
    };
    Version.prototype.isLessThan = function (other) {
        return this.compareTo(other) < 0;
    };
    Version.prototype.isLessThanOrEqualTo = function (other) {
        return this.compareTo(other) <= 0;
    };
    Version.regExp = /^(0|[1-9]\d*)(?:\.(0|[1-9]\d*))?(?:\.(0|[1-9]\d*))?(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
    return Version;
}());
var CoreVersion = /** @class */ (function () {
    function CoreVersion(major, minor, patch) {
        this.major = major;
        this.minor = minor;
        this.patch = patch;
    }
    CoreVersion.prototype.compareTo = function (other) {
        return (compareValues(this.major, other.major) ||
            compareValues(this.minor, other.minor) ||
            compareValues(this.patch, other.patch));
    };
    return CoreVersion;
}());
var MetaVersion = /** @class */ (function () {
    function MetaVersion(identifiers) {
        this.identifiers = identifiers;
    }
    MetaVersion.parse = function (text) {
        if (!text) {
            return MetaVersion.EMPTY;
        }
        else {
            return new MetaVersion(text.split("."));
        }
    };
    MetaVersion.prototype.isEmpty = function () {
        return this.identifiers.length === 0;
    };
    MetaVersion.prototype.isNotEmpty = function () {
        return !this.isEmpty();
    };
    MetaVersion.prototype.compareTo = function (other) {
        if (this.isEmpty() && other.isEmpty()) {
            return 0;
        }
        if (this.isEmpty() && other.isNotEmpty()) {
            return 1;
        }
        if (this.isNotEmpty() && other.isEmpty()) {
            return -1;
        }
        return this.compareIdentifiers(other);
    };
    MetaVersion.prototype.compareIdentifiers = function (other) {
        var length = Math.min(this.identifiers.length, other.identifiers.length);
        for (var i = 0; i < length; i++) {
            var result = MetaVersion.compareIdentifiers(this.identifiers[i], other.identifiers[i]);
            if (result !== 0) {
                return result;
            }
        }
        return compareValues(this.identifiers.length, other.identifiers.length);
    };
    MetaVersion.compareIdentifiers = function (identifier1, identifier2) {
        if (MetaVersion.numericIdentifierRegExp.test(identifier1) &&
            MetaVersion.numericIdentifierRegExp.test(identifier2)) {
            return compareValues(+identifier1, +identifier2);
        }
        if (identifier1 === identifier2) {
            return 0;
        }
        return identifier1 < identifier2 ? -1 : 1;
    };
    MetaVersion.EMPTY = new MetaVersion([]);
    MetaVersion.numericIdentifierRegExp = /^(0|[1-9]\d*)$/;
    return MetaVersion;
}());
var MATCH_TYPES = ["MATCH", "NOT_MATCH"];
var MATCH_VALUE_TYPES = ["STRING", "NUMBER", "BOOLEAN", "VERSION", "JSON", "URL", "NULL", "UNKNOWN"];
var MATCH_OPERATORS = [
    "IN",
    "CONTAINS",
    "STARTS_WITH",
    "ENDS_WITH",
    "GT",
    "GTE",
    "LT",
    "LTE",
    "EXISTS"
];
var TARGET_ACTION_TYPES = ["VARIATION", "BUCKET"];
var TARGET_KEY_TYPES = [
    "USER_ID",
    "USER_PROPERTY",
    "HACKLE_PROPERTY",
    "SEGMENT",
    "AB_TEST",
    "FEATURE_FLAG",
    "EVENT_PROPERTY",
    "COHORT",
    "NUMBER_OF_EVENTS_IN_DAYS",
    "NUMBER_OF_EVENTS_WITH_PROPERTY_IN_DAYS"
];
var SEGMENT_TYPES = ["USER_ID", "USER_PROPERTY"];
var TargetingType = /** @class */ (function () {
    function TargetingType() {
        var supportedKeyTypes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            supportedKeyTypes[_i] = arguments[_i];
        }
        this.supportedKeyTypes = supportedKeyTypes;
    }
    TargetingType.prototype.supports = function (keyType) {
        return this.supportedKeyTypes.includes(keyType);
    };
    TargetingType.IDENTIFIER = new TargetingType("SEGMENT");
    TargetingType.PROPERTY = new TargetingType("SEGMENT", "USER_PROPERTY", "HACKLE_PROPERTY", "AB_TEST", "FEATURE_FLAG", "EVENT_PROPERTY", "COHORT", "NUMBER_OF_EVENTS_IN_DAYS", "NUMBER_OF_EVENTS_WITH_PROPERTY_IN_DAYS");
    TargetingType.SEGMENT = new TargetingType("USER_ID", "USER_PROPERTY", "HACKLE_PROPERTY", "COHORT", "NUMBER_OF_EVENTS_IN_DAYS", "NUMBER_OF_EVENTS_WITH_PROPERTY_IN_DAYS");
    return TargetingType;
}());
var IAM_STATUS = ["ACTIVE", "DRAFT", "PAUSE"];
var IAM_PLATFORM_TYPE = ["WEB", "ANDROID", "IOS"];
var IAM_TIMEUNIT = ["IMMEDIATE", "CUSTOM"];
var IAM_DISPLAY_TYPE = ["MODAL", "BANNER", "BOTTOM_SHEET", "NONE"];
var IAM_LAYOUT_TYPE = ["IMAGE_TEXT", "IMAGE_ONLY", "TEXT_ONLY", "IMAGE", "NONE"];
var IAM_ORIENTATION = ["VERTICAL", "HORIZONTAL"];
var IAM_BEHAVIOR = ["CLICK"];
var IAM_ACTION_TYPE = [
    "CLOSE",
    "WEB_LINK",
    "HIDDEN",
    "LINK_AND_CLOSE",
    "LINK_NEW_TAB",
    "LINK_NEW_TAB_AND_CLOSE",
    "LINK_NEW_WINDOW",
    "LINK_NEW_WINDOW_AND_CLOSE"
];
var IAM_VERTICAL_ALIGNMENT = ["TOP", "MIDDLE", "BOTTOM"];
var IAM_HORIZONTAL_ALIGNMENT = ["LEFT", "CENTER", "RIGHT"];
var IAM_ACTION_AREA = ["BUTTON", "IMAGE", "MESSAGE", "X_BUTTON"];
var IAM_TIMETABLE_TYPE = ["ALL", "CUSTOM"];
var InAppMessage = /** @class */ (function () {
    function InAppMessage(id, key, status, period, timetable, eventTrigger, targetContext, messageContext, evaluateContext) {
        this.id = id;
        this.key = key;
        this.status = status;
        this.period = period;
        this.timetable = timetable;
        this.eventTrigger = eventTrigger;
        this.targetContext = targetContext;
        this.messageContext = messageContext;
        this.evaluateContext = evaluateContext;
    }
    InAppMessage.fromJson = function (dto) {
        var _a, _b, _c;
        var status = parseOrNull(IAM_STATUS, dto.status);
        if (ObjectUtil.isNullOrUndefined(status)) {
            return undefined;
        }
        var period;
        switch (parseOrNull(IAM_TIMEUNIT, dto.timeUnit)) {
            case "IMMEDIATE":
                period = new InAppMessagePeriodAlways();
                break;
            case "CUSTOM":
                if (ObjectUtil.isNullOrUndefined(dto.startEpochTimeMillis)) {
                    return undefined;
                }
                if (ObjectUtil.isNullOrUndefined(dto.endEpochTimeMillis)) {
                    return undefined;
                }
                period = new InAppMessagePeriodCustom(dto.startEpochTimeMillis, dto.endEpochTimeMillis);
                break;
            default:
                return undefined;
        }
        var timetable = (_a = (dto.timetable && InAppMessageTimetable.fromJson(dto.timetable))) !== null && _a !== void 0 ? _a : new InAppMessageTimetableAll();
        var messageContext = InAppMessageContext.fromJson(dto.messageContext);
        if (ObjectUtil.isNullOrUndefined(messageContext)) {
            return undefined;
        }
        var eventTriggerRules = dto.eventTriggerRules.map(InAppMessageEventTriggerRule.fromJson);
        var eventFrequencyCap = InAppMessageEventFrequencyCap.fromJson(dto.eventFrequencyCap);
        var delay = (_b = (dto.eventTriggerDelay && Delay.fromJson(dto.eventTriggerDelay))) !== null && _b !== void 0 ? _b : Delay.immediate();
        var evaluateContext = InAppMessageEvaluateContext.fromJson((_c = dto.evaluateContext) !== null && _c !== void 0 ? _c : { atDeliverTime: false });
        return new InAppMessage(dto.id, dto.key, status, period, timetable, new InAppMessageEventTrigger(eventTriggerRules, eventFrequencyCap, delay), InAppMessageTargetContext.fromJson(dto.targetContext), messageContext, evaluateContext);
    };
    InAppMessage.prototype.supports = function (platformType) {
        return this.messageContext.platformTypes.includes(platformType);
    };
    InAppMessage.prototype.toString = function () {
        return "InAppMessage(id=".concat(this.id, ", key=").concat(this.key, ", status=").concat(this.status, ")");
    };
    return InAppMessage;
}());
var InAppMessagePeriodAlways = /** @class */ (function () {
    function InAppMessagePeriodAlways() {
        this.type = "IMMEDIATE";
    }
    InAppMessagePeriodAlways.prototype.within = function (timestamp) {
        return true;
    };
    return InAppMessagePeriodAlways;
}());
var InAppMessagePeriodCustom = /** @class */ (function () {
    function InAppMessagePeriodCustom(startMillisInclusive, endMillisExclusive) {
        this.startMillisInclusive = startMillisInclusive;
        this.endMillisExclusive = endMillisExclusive;
        this.type = "CUSTOM";
    }
    InAppMessagePeriodCustom.prototype.within = function (timestamp) {
        return this.startMillisInclusive <= timestamp && timestamp < this.endMillisExclusive;
    };
    return InAppMessagePeriodCustom;
}());
var InAppMessageTimetable = /** @class */ (function () {
    function InAppMessageTimetable() {
    }
    InAppMessageTimetable.fromJson = function (dto) {
        switch (parseOrNull(IAM_TIMETABLE_TYPE, dto.type)) {
            case "ALL":
                return new InAppMessageTimetableAll();
            case "CUSTOM":
                return new InAppMessageTimetableCustom(CollectionUtil.mapNotNullOrUndefined(dto.slots, function (it) { return InAppMessageTimetableSlot.fromJson(it); }));
            default:
                return undefined;
        }
    };
    return InAppMessageTimetable;
}());
var InAppMessageTimetableAll = /** @class */ (function (_super) {
    __extends(InAppMessageTimetableAll, _super);
    function InAppMessageTimetableAll() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "ALL";
        return _this;
    }
    InAppMessageTimetableAll.prototype.within = function (_) {
        return true;
    };
    return InAppMessageTimetableAll;
}(InAppMessageTimetable));
var InAppMessageTimetableCustom = /** @class */ (function (_super) {
    __extends(InAppMessageTimetableCustom, _super);
    function InAppMessageTimetableCustom(slots) {
        var _this = _super.call(this) || this;
        _this.slots = slots;
        _this.type = "CUSTOM";
        return _this;
    }
    InAppMessageTimetableCustom.prototype.within = function (timestamp) {
        return this.slots.some(function (it) { return it.within(timestamp); });
    };
    return InAppMessageTimetableCustom;
}(InAppMessageTimetable));
var InAppMessageTimetableSlot = /** @class */ (function () {
    function InAppMessageTimetableSlot(dayOfWeek, startMillisInclusive, endMillisExclusive) {
        this.dayOfWeek = dayOfWeek;
        this.startMillisInclusive = startMillisInclusive;
        this.endMillisExclusive = endMillisExclusive;
    }
    InAppMessageTimetableSlot.prototype.within = function (timestamp) {
        var dayOfWeek = TimeUtil.dayOfWeek(timestamp);
        if (this.dayOfWeek !== dayOfWeek) {
            return false;
        }
        var midnight = TimeUtil.midnight(timestamp);
        var startTimestampInclusive = midnight + this.startMillisInclusive;
        var endTimestampExclusive = midnight + this.endMillisExclusive;
        return startTimestampInclusive <= timestamp && timestamp < endTimestampExclusive;
    };
    InAppMessageTimetableSlot.fromJson = function (dto) {
        var dayOfWeek = parseOrNull(DAY_OF_WEEK, dto.dayOfWeek);
        return dayOfWeek && new InAppMessageTimetableSlot(dayOfWeek, dto.startMillisInclusive, dto.endMillisExclusive);
    };
    return InAppMessageTimetableSlot;
}());
var InAppMessageEventTrigger = /** @class */ (function () {
    function InAppMessageEventTrigger(rules, frequencyCap, delay) {
        this.rules = rules;
        this.frequencyCap = frequencyCap;
        this.delay = delay;
    }
    return InAppMessageEventTrigger;
}());
var InAppMessageEventTriggerRule = /** @class */ (function () {
    function InAppMessageEventTriggerRule(eventKey, targets) {
        this.eventKey = eventKey;
        this.targets = targets;
    }
    InAppMessageEventTriggerRule.fromJson = function (dto) {
        return new InAppMessageEventTriggerRule(dto.eventKey, CollectionUtil.mapNotNullOrUndefined(dto.targets, function (it) { return Target.fromJson(it, TargetingType.PROPERTY); }));
    };
    return InAppMessageEventTriggerRule;
}());
var InAppMessageEventFrequencyCap = /** @class */ (function () {
    function InAppMessageEventFrequencyCap(identifierCaps, durationCap) {
        this.identifierCaps = identifierCaps;
        this.durationCap = durationCap;
    }
    InAppMessageEventFrequencyCap.fromJson = function (dto) {
        if (!dto)
            return null;
        var identifierCaps = dto.identifiers.map(InAppMessageIdentifierCap.fromJson);
        var durationCaps = InAppMessageDurationCap.fromJson(dto.duration);
        return new InAppMessageEventFrequencyCap(identifierCaps, durationCaps);
    };
    return InAppMessageEventFrequencyCap;
}());
var InAppMessageIdentifierCap = /** @class */ (function () {
    function InAppMessageIdentifierCap(identifierType, count) {
        this.identifierType = identifierType;
        this.count = count;
    }
    InAppMessageIdentifierCap.fromJson = function (dto) {
        return new InAppMessageIdentifierCap(dto.identifierType, dto.countPerIdentifier);
    };
    return InAppMessageIdentifierCap;
}());
var InAppMessageDurationCap = /** @class */ (function () {
    function InAppMessageDurationCap(durationMillis, count) {
        this.durationMillis = durationMillis;
        this.count = count;
    }
    InAppMessageDurationCap.fromJson = function (dto) {
        if (!dto)
            return null;
        var timeUnit = parseOrNull(TIME_UNIT, dto.durationUnit.timeUnit);
        if (!timeUnit)
            return null;
        return new InAppMessageDurationCap(TimeUtil.converter[timeUnit](dto.durationUnit.amount, "milliseconds"), dto.countPerDuration);
    };
    return InAppMessageDurationCap;
}());
var InAppMessageTargetContext = /** @class */ (function () {
    function InAppMessageTargetContext(overrides, targets) {
        this.overrides = overrides;
        this.targets = targets;
    }
    InAppMessageTargetContext.fromJson = function (dto) {
        return new InAppMessageTargetContext(dto.overrides.map(InAppMessageUserOverride.fromJson), CollectionUtil.mapNotNullOrUndefined(dto.targets, function (it) { return Target.fromJson(it, TargetingType.PROPERTY); }));
    };
    return InAppMessageTargetContext;
}());
var InAppMessageUserOverride = /** @class */ (function () {
    function InAppMessageUserOverride(identifierType, identifiers) {
        this.identifierType = identifierType;
        this.identifiers = identifiers;
    }
    InAppMessageUserOverride.fromJson = function (dto) {
        return new InAppMessageUserOverride(dto.identifierType, dto.identifiers);
    };
    return InAppMessageUserOverride;
}());
var InAppMessageContext = /** @class */ (function () {
    function InAppMessageContext(defaultLang, experimentContext, platformTypes, orientations, messages) {
        this.defaultLang = defaultLang;
        this.experimentContext = experimentContext;
        this.platformTypes = platformTypes;
        this.orientations = orientations;
        this.messages = messages;
    }
    InAppMessageContext.fromJson = function (dto) {
        var experiment = null;
        if (dto.exposure.type === "AB_TEST" && dto.exposure.key !== null) {
            experiment = new InAppMessageExperimentContext(dto.exposure.key);
        }
        var platformTypes = parseAllOrNull(IAM_PLATFORM_TYPE, dto.platformTypes);
        if (ObjectUtil.isNullOrUndefined(platformTypes)) {
            return undefined;
        }
        var orientations = parseAllOrNull(IAM_ORIENTATION, dto.orientations);
        if (ObjectUtil.isNullOrUndefined(orientations)) {
            return undefined;
        }
        var messages = CollectionUtil.mapOrUndefined(dto.messages, InAppMessageContextMessage.fromJson);
        if (ObjectUtil.isNullOrUndefined(messages)) {
            return undefined;
        }
        return new InAppMessageContext(dto.defaultLang, experiment, platformTypes, orientations, messages);
    };
    return InAppMessageContext;
}());
var InAppMessageExperimentContext = /** @class */ (function () {
    function InAppMessageExperimentContext(key) {
        this.key = key;
    }
    return InAppMessageExperimentContext;
}());
var InAppMessageContextMessage = /** @class */ (function () {
    function InAppMessageContextMessage(variationKey, lang, layout, images, imageAutoScroll, text, buttons, closeButton, background, action, outerButtons, innerButtons) {
        this.variationKey = variationKey;
        this.lang = lang;
        this.layout = layout;
        this.images = images;
        this.imageAutoScroll = imageAutoScroll;
        this.text = text;
        this.buttons = buttons;
        this.closeButton = closeButton;
        this.background = background;
        this.action = action;
        this.outerButtons = outerButtons;
        this.innerButtons = innerButtons;
    }
    InAppMessageContextMessage.fromJson = function (dto) {
        var layout = InAppMessageContextLayout.fromJson(dto.layout);
        if (ObjectUtil.isNullOrUndefined(layout)) {
            return undefined;
        }
        var images = CollectionUtil.mapOrUndefined(dto.images, InAppMessageImage.fromJson);
        if (ObjectUtil.isNullOrUndefined(images)) {
            return undefined;
        }
        var imageAutoScroll = undefined;
        if (ObjectUtil.isNotNullOrUndefined(dto.imageAutoScroll)) {
            imageAutoScroll = InAppMessageImageAutoScroll.fromJson(dto.imageAutoScroll);
            if (ObjectUtil.isNullOrUndefined(imageAutoScroll)) {
                return undefined;
            }
        }
        var buttons = CollectionUtil.mapOrUndefined(dto.buttons, InAppMessageButton.fromJson);
        if (ObjectUtil.isNullOrUndefined(buttons)) {
            return undefined;
        }
        var closeButton = undefined;
        if (ObjectUtil.isNotNullOrUndefined(dto.closeButton)) {
            closeButton = InAppMessageButton.fromJson2(dto.closeButton);
            if (ObjectUtil.isNullOrUndefined(closeButton)) {
                return undefined;
            }
        }
        var outerButtons = CollectionUtil.mapOrUndefined(dto.outerButtons, InAppMessagePositionalButton.fromJson);
        var innerButtons = CollectionUtil.mapOrUndefined(dto.innerButtons, InAppMessagePositionalButton.fromJson);
        if (ObjectUtil.isNullOrUndefined(outerButtons) || ObjectUtil.isNullOrUndefined(innerButtons)) {
            return undefined;
        }
        return new InAppMessageContextMessage(dto.variationKey, dto.lang, layout, images, imageAutoScroll, dto.text ? InAppMessageText.fromJson(dto.text) : undefined, buttons, closeButton, new InAppMessageBackground(dto.background.color), dto.action ? InAppMessageAction.fromJson(dto.action) : undefined, outerButtons, innerButtons);
    };
    InAppMessageContextMessage.prototype.toJson = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return {
            variationKey: this.variationKey,
            lang: this.lang,
            layout: {
                layoutType: this.layout.layoutType,
                alignment: (_b = (_a = this.layout.alignment) === null || _a === void 0 ? void 0 : _a.toJson()) !== null && _b !== void 0 ? _b : null,
                displayType: this.layout.displayType
            },
            images: this.images.map(function (it) { return it.toJson(); }),
            imageAutoScroll: (_d = (_c = this.imageAutoScroll) === null || _c === void 0 ? void 0 : _c.toJson()) !== null && _d !== void 0 ? _d : null,
            text: (_f = (_e = this.text) === null || _e === void 0 ? void 0 : _e.toJson()) !== null && _f !== void 0 ? _f : null,
            closeButton: (_h = (_g = this.closeButton) === null || _g === void 0 ? void 0 : _g.toCloseButtonJson()) !== null && _h !== void 0 ? _h : null,
            buttons: this.buttons.map(function (it) { return it.toJson(); }),
            background: {
                color: this.background.color
            },
            action: (_k = (_j = this.action) === null || _j === void 0 ? void 0 : _j.toJson()) !== null && _k !== void 0 ? _k : null,
            outerButtons: this.outerButtons.map(function (it) { return it.toJson(); }),
            innerButtons: this.innerButtons.map(function (it) { return it.toJson(); })
        };
    };
    return InAppMessageContextMessage;
}());
var InAppMessageContextLayout = /** @class */ (function () {
    function InAppMessageContextLayout(displayType, layoutType, alignment) {
        this.displayType = displayType;
        this.layoutType = layoutType;
        this.alignment = alignment;
    }
    InAppMessageContextLayout.fromJson = function (dto) {
        var layoutType = parseOrNull(IAM_LAYOUT_TYPE, dto.layoutType);
        var displayType = parseOrNull(IAM_DISPLAY_TYPE, dto.displayType);
        if (ObjectUtil.isNullOrUndefined(displayType)) {
            return undefined;
        }
        if (ObjectUtil.isNullOrUndefined(layoutType)) {
            return undefined;
        }
        return new InAppMessageContextLayout(displayType, layoutType, dto.alignment ? InAppMessageAlignment.fromJson(dto.alignment) : undefined);
    };
    return InAppMessageContextLayout;
}());
var InAppMessageAlignment = /** @class */ (function () {
    function InAppMessageAlignment(horizontal, vertical) {
        this.horizontal = horizontal;
        this.vertical = vertical;
    }
    InAppMessageAlignment.fromJson = function (dto) {
        var horizontal = parseOrNull(IAM_HORIZONTAL_ALIGNMENT, dto.horizontal);
        if (ObjectUtil.isNullOrUndefined(horizontal)) {
            return undefined;
        }
        var vertical = parseOrNull(IAM_VERTICAL_ALIGNMENT, dto.vertical);
        if (ObjectUtil.isNullOrUndefined(vertical)) {
            return undefined;
        }
        return new InAppMessageAlignment(horizontal, vertical);
    };
    InAppMessageAlignment.prototype.toJson = function () {
        return { horizontal: this.horizontal, vertical: this.vertical };
    };
    return InAppMessageAlignment;
}());
var InAppMessageImage = /** @class */ (function () {
    function InAppMessageImage(orientation, imagePath, action) {
        this.orientation = orientation;
        this.imagePath = imagePath;
        this.action = action;
    }
    InAppMessageImage.fromJson = function (dto) {
        var orientation = parseOrNull(IAM_ORIENTATION, dto.orientation);
        if (ObjectUtil.isNullOrUndefined(orientation)) {
            return undefined;
        }
        var action = undefined;
        if (ObjectUtil.isNotNullOrUndefined(dto.action)) {
            action = InAppMessageAction.fromJson(dto.action);
            if (ObjectUtil.isNullOrUndefined(action)) {
                return undefined;
            }
        }
        return new InAppMessageImage(orientation, dto.imagePath, action);
    };
    InAppMessageImage.prototype.toJson = function () {
        var _a, _b;
        return {
            orientation: this.orientation,
            imagePath: this.imagePath,
            action: (_b = (_a = this.action) === null || _a === void 0 ? void 0 : _a.toJson()) !== null && _b !== void 0 ? _b : null
        };
    };
    return InAppMessageImage;
}());
var InAppMessageImageAutoScroll = /** @class */ (function () {
    function InAppMessageImageAutoScroll(intervalMillis) {
        this.intervalMillis = intervalMillis;
    }
    InAppMessageImageAutoScroll.fromJson = function (dto) {
        var timeUnit = parseOrNull(TIME_UNIT, dto.interval.timeUnit);
        if (!timeUnit)
            return undefined;
        return new InAppMessageImageAutoScroll(TimeUtil.converter[timeUnit](dto.interval.amount, "milliseconds"));
    };
    InAppMessageImageAutoScroll.prototype.toJson = function () {
        return {
            interval: {
                timeUnit: "milliseconds",
                amount: this.intervalMillis
            }
        };
    };
    return InAppMessageImageAutoScroll;
}());
var InAppMessageText = /** @class */ (function () {
    function InAppMessageText(title, body) {
        this.title = title;
        this.body = body;
    }
    InAppMessageText.fromJson = function (dto) {
        return new InAppMessageText(InAppMessageTextAttribute.fromJson(dto.title), InAppMessageTextAttribute.fromJson(dto.body));
    };
    InAppMessageText.prototype.toJson = function () {
        return {
            title: {
                text: this.title.text,
                style: {
                    textColor: this.title.style.color
                }
            },
            body: {
                text: this.body.text,
                style: {
                    textColor: this.body.style.color
                }
            }
        };
    };
    return InAppMessageText;
}());
var InAppMessageTextAttribute = /** @class */ (function () {
    function InAppMessageTextAttribute(text, style) {
        this.text = text;
        this.style = style;
    }
    InAppMessageTextAttribute.fromJson = function (dto) {
        return new InAppMessageTextAttribute(dto.text, new InAppMessageTextStyle(dto.style.textColor));
    };
    return InAppMessageTextAttribute;
}());
var InAppMessageTextStyle = /** @class */ (function () {
    function InAppMessageTextStyle(color) {
        this.color = color;
    }
    return InAppMessageTextStyle;
}());
var InAppMessageButton = /** @class */ (function () {
    function InAppMessageButton(text, style, action) {
        this.text = text;
        this.style = style;
        this.action = action;
    }
    InAppMessageButton.fromJson = function (dto) {
        var action = InAppMessageAction.fromJson(dto.action);
        if (ObjectUtil.isNullOrUndefined(action)) {
            return undefined;
        }
        return new InAppMessageButton(dto.text, new InAppMessageButtonStyle(dto.style.textColor, dto.style.bgColor, dto.style.borderColor), action);
    };
    InAppMessageButton.fromJson2 = function (dto) {
        var action = InAppMessageAction.fromJson(dto.action);
        if (ObjectUtil.isNullOrUndefined(action)) {
            return undefined;
        }
        return new InAppMessageButton("✕", new InAppMessageButtonStyle(dto.style.color, "#FFFFFF", "#FFFFFF"), action);
    };
    InAppMessageButton.prototype.toJson = function () {
        return {
            text: this.text,
            action: this.action.toJson(),
            style: {
                textColor: this.style.textColor,
                bgColor: this.style.backgroundColor,
                borderColor: this.style.borderColor
            }
        };
    };
    InAppMessageButton.prototype.toCloseButtonJson = function () {
        return {
            action: this.action.toJson(),
            style: {
                color: this.style.textColor
            }
        };
    };
    return InAppMessageButton;
}());
var InAppMessagePositionalButton = /** @class */ (function () {
    function InAppMessagePositionalButton(button, alignment) {
        this.button = button;
        this.alignment = alignment;
    }
    InAppMessagePositionalButton.fromJson = function (dto) {
        var button = InAppMessageButton.fromJson(dto.button);
        if (ObjectUtil.isNullOrUndefined(button)) {
            return undefined;
        }
        var alignment = InAppMessageAlignment.fromJson(dto.alignment);
        if (ObjectUtil.isNullOrUndefined(alignment)) {
            return undefined;
        }
        return new InAppMessagePositionalButton(button, alignment);
    };
    InAppMessagePositionalButton.prototype.toJson = function () {
        return { button: this.button.toJson(), alignment: this.alignment.toJson() };
    };
    return InAppMessagePositionalButton;
}());
var InAppMessageButtonStyle = /** @class */ (function () {
    function InAppMessageButtonStyle(textColor, backgroundColor, borderColor) {
        this.textColor = textColor;
        this.backgroundColor = backgroundColor;
        this.borderColor = borderColor;
    }
    return InAppMessageButtonStyle;
}());
var InAppMessageBackground = /** @class */ (function () {
    function InAppMessageBackground(color) {
        this.color = color;
    }
    return InAppMessageBackground;
}());
var InAppMessageAction = /** @class */ (function () {
    function InAppMessageAction(behavior, type, value) {
        this.behavior = behavior;
        this.type = type;
        this.value = value;
    }
    InAppMessageAction.fromJson = function (dto) {
        var _a;
        var behavior = parseOrNull(IAM_BEHAVIOR, dto.behavior);
        if (ObjectUtil.isNullOrUndefined(behavior)) {
            return undefined;
        }
        var type = parseOrNull(IAM_ACTION_TYPE, dto.type);
        if (ObjectUtil.isNullOrUndefined(type)) {
            return undefined;
        }
        return new InAppMessageAction(behavior, type, (_a = dto.value) !== null && _a !== void 0 ? _a : undefined);
    };
    InAppMessageAction.prototype.toJson = function () {
        var _a;
        return {
            behavior: this.behavior,
            type: this.type,
            value: (_a = this.value) !== null && _a !== void 0 ? _a : null
        };
    };
    return InAppMessageAction;
}());
var InAppMessageEvaluateContext = /** @class */ (function () {
    function InAppMessageEvaluateContext(atDeliverTime) {
        this.atDeliverTime = atDeliverTime;
    }
    InAppMessageEvaluateContext.fromJson = function (dto) {
        return new InAppMessageEvaluateContext(dto.atDeliverTime);
    };
    return InAppMessageEvaluateContext;
}());
var InAppMessageAfterCondition = /** @class */ (function () {
    function InAppMessageAfterCondition(durationMillis) {
        this.durationMillis = durationMillis;
    }
    InAppMessageAfterCondition.fromJson = function (dto) {
        var timeUnit = parseOrNull(TIME_UNIT, dto.duration.timeUnit);
        if (ObjectUtil.isNullOrUndefined(timeUnit)) {
            return null;
        }
        var durationMillis = TimeUtil.converter[timeUnit](dto.duration.amount, "milliseconds");
        return new InAppMessageAfterCondition(durationMillis);
    };
    return InAppMessageAfterCondition;
}());
var Delay = /** @class */ (function () {
    function Delay(type, afterCondition) {
        this.type = type;
        this.afterCondition = afterCondition;
    }
    Delay.fromJson = function (dto) {
        var afterCondition = dto.afterCondition && InAppMessageAfterCondition.fromJson(dto.afterCondition);
        return new Delay(dto.type, afterCondition);
    };
    Delay.immediate = function () {
        return new Delay("IMMEDIATE", null);
    };
    Delay.prototype.deliverAt = function (startedAt) {
        var delayType = this.type;
        switch (delayType) {
            case "IMMEDIATE":
                return startedAt;
            case "AFTER":
                if (this.afterCondition === null) {
                    throw new Error("AfterCondition is required for AFTER delay type");
                }
                return startedAt + this.afterCondition.durationMillis;
            default:
                throw new Error("Unsupported delay type: ".concat(delayType));
        }
    };
    return Delay;
}());
var HackleInAppMessageActionImpl = /** @class */ (function () {
    function HackleInAppMessageActionImpl(type, close, link) {
        this.type = type;
        this.close = close;
        this.link = link;
    }
    HackleInAppMessageActionImpl.fromJson = function (action) {
        var actionType = action.type;
        var actionValue = action.value;
        var isLinkActionType = this.linkActionTypes.some(function (type) { return type === actionType; });
        var isCloseActionType = this.closeActionTypes.some(function (type) { return type === actionType; });
        var isTabTargetActionType = this.tabTargetActionsTypes.some(function (type) { return type === actionType; });
        var isWindowTargetActionType = this.windowTargetActionsTypes.some(function (type) { return type === actionType; });
        var isHiddenActionType = actionType === "HIDDEN";
        return new HackleInAppMessageActionImpl(isLinkActionType ? "LINK" : "CLOSE", isCloseActionType
            ? {
                hideDurationMillis: isHiddenActionType ? IAM_HIDE_EXPIRATION_MILLIS : null
            }
            : undefined, isLinkActionType
            ? {
                url: actionValue !== null && actionValue !== void 0 ? actionValue : "",
                target: isWindowTargetActionType ? "NEW_WINDOW" : isTabTargetActionType ? "NEW_TAB" : "CURRENT",
                shouldCloseAfterLink: isCloseActionType
            }
            : undefined);
    };
    HackleInAppMessageActionImpl.fromInteraction = function (interaction) {
        if (interaction.type === "CLOSE") {
            return new HackleInAppMessageActionImpl(interaction.type, { hideDurationMillis: null });
        }
        return HackleInAppMessageActionImpl.fromJson(interaction.action);
    };
    HackleInAppMessageActionImpl.fromAction = function (action) {
        return HackleInAppMessageActionImpl.fromJson(action.toJson());
    };
    HackleInAppMessageActionImpl.linkActionTypes = [
        "LINK_AND_CLOSE",
        "LINK_NEW_TAB",
        "LINK_NEW_TAB_AND_CLOSE",
        "LINK_NEW_WINDOW",
        "LINK_NEW_WINDOW_AND_CLOSE",
        "WEB_LINK"
    ];
    HackleInAppMessageActionImpl.closeActionTypes = [
        "CLOSE",
        "HIDDEN",
        "LINK_AND_CLOSE",
        "LINK_NEW_TAB_AND_CLOSE",
        "LINK_NEW_WINDOW_AND_CLOSE"
    ];
    HackleInAppMessageActionImpl.tabTargetActionsTypes = ["LINK_NEW_TAB", "LINK_NEW_TAB_AND_CLOSE"];
    HackleInAppMessageActionImpl.windowTargetActionsTypes = ["LINK_NEW_WINDOW", "LINK_NEW_WINDOW_AND_CLOSE"];
    return HackleInAppMessageActionImpl;
}());
var Cohort = /** @class */ (function () {
    function Cohort(id) {
        this.id = id;
    }
    return Cohort;
}());
// Split URL
var SplitUrlRedirectType;
(function (SplitUrlRedirectType) {
    SplitUrlRedirectType["MANUAL"] = "MANUAL";
})(SplitUrlRedirectType || (SplitUrlRedirectType = {}));
var isSplitUrlRedirectType = function (value) {
    return Object.values(SplitUrlRedirectType).includes(value);
};
var SplitUrlConfig = /** @class */ (function () {
    function SplitUrlConfig(needRedirect, redirectType, redirectUrl) {
        this.needRedirect = needRedirect;
        this.redirectType = redirectType;
        this.redirectUrl = redirectUrl;
    }
    SplitUrlConfig.fromDto = function (dto) {
        var needRedirect = dto.needRedirect;
        var redirectType = isSplitUrlRedirectType(dto.properties.type) ? dto.properties.type : null;
        var redirectUrl = dto.properties.value;
        return new SplitUrlConfig(needRedirect, redirectType, redirectUrl);
    };
    return SplitUrlConfig;
}());
var SplitUrlTargets = /** @class */ (function () {
    function SplitUrlTargets(includeTargets, excludeTargets) {
        this.includeTargets = includeTargets;
        this.excludeTargets = excludeTargets;
    }
    SplitUrlTargets.fromJson = function (dto) {
        if (dto === null) {
            return undefined;
        }
        var includeTargets = CollectionUtil.mapNotNullOrUndefined(dto.match, function (it) {
            return Target.fromJson(it, TargetingType.PROPERTY);
        });
        var excludeTargets = CollectionUtil.mapNotNullOrUndefined(dto.notMatch, function (it) {
            return Target.fromJson(it, TargetingType.PROPERTY);
        });
        return new SplitUrlTargets(includeTargets, excludeTargets);
    };
    return SplitUrlTargets;
}());
var UserTargetEvent = /** @class */ (function () {
    function UserTargetEvent(eventKey, property, stats) {
        this.eventKey = eventKey;
        this.property = property;
        this.stats = stats;
    }
    UserTargetEvent.fromJson = function (dto) {
        var eventKey = dto.eventKey, property = dto.property, stats = dto.stats;
        return new UserTargetEvent(eventKey, property, stats);
    };
    UserTargetEvent.prototype.countWithinDays = function (daysAgoUtc) {
        return CollectionUtil.sum(this.stats.filter(function (it) { return it.date >= daysAgoUtc; }), function (it) { return it.count; });
    };
    return UserTargetEvent;
}());

var TimerBuilder = /** @class */ (function () {
    function TimerBuilder(name) {
        this.name = name;
        this._tags = {};
        this.name = name;
    }
    TimerBuilder.prototype.tags = function (tags) {
        var _this = this;
        Object.entries(tags).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            _this._tags[key] = value;
        });
        return this;
    };
    TimerBuilder.prototype.tag = function (key, value) {
        this._tags[key] = value;
        return this;
    };
    TimerBuilder.prototype.register = function (registry) {
        return registry.registerTimer({ name: this.name, tags: this._tags, type: "TIMER" });
    };
    return TimerBuilder;
}());
var TimerSample = /** @class */ (function () {
    function TimerSample(clock) {
        this._clock = clock;
        this.startTime = this._clock.tick();
    }
    TimerSample.start = function (clock) {
        if (clock === void 0) { clock = TimerSample.defaultClock; }
        return new TimerSample(clock);
    };
    TimerSample.prototype.stop = function (timer) {
        var now = this._clock.tick();
        var durationMicros = now - this.startTime;
        timer.record(durationMicros, "microseconds");
    };
    TimerSample.defaultClock = new SystemClock();
    return TimerSample;
}());
function isTimerMetric(metric) {
    return metric.id.type === "TIMER";
}

var CounterBuilder = /** @class */ (function () {
    function CounterBuilder(name) {
        this.name = name;
        this._tags = {};
    }
    CounterBuilder.prototype.tags = function (tags) {
        var _this = this;
        Object.entries(tags).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            _this._tags[key] = value;
        });
        return this;
    };
    CounterBuilder.prototype.tag = function (key, value) {
        this._tags[key] = value;
        return this;
    };
    CounterBuilder.prototype.register = function (registry) {
        return registry.registerCounter({ name: this.name, tags: this._tags, type: "COUNTER" });
    };
    return CounterBuilder;
}());
function isCounterMetric(metric) {
    return metric.id.type === "COUNTER";
}

var Comparable = /** @class */ (function () {
    function Comparable(compareFn) {
        this.compareFn = compareFn;
        this.data = new Map();
        this.compareFn = compareFn;
        this.data = new Map();
    }
    Comparable.prototype.values = function () {
        return Array.from(this.data.values());
    };
    Comparable.prototype.keys = function () {
        return Array.from(this.data.keys());
    };
    Comparable.prototype.get = function (key) {
        var _this = this;
        var targetKey = this.keys().find(function (innerKey) { return _this.compareFn(innerKey, key); });
        return targetKey ? this.data.get(targetKey) : undefined;
    };
    Comparable.prototype.has = function (key) {
        return this.get(key) !== undefined;
    };
    Comparable.prototype.add = function (key, value) {
        var addValue = value;
        if (!addValue) {
            addValue = key;
        }
        this.data.set(key, addValue);
        return this;
    };
    Comparable.prototype.delete = function (key) {
        if (!this.has(key))
            return undefined;
        var targetValue = this.get(key);
        this.data.delete(key);
        return targetValue;
    };
    Comparable.prototype.forEach = function (cb) {
        this.data.forEach(cb);
    };
    Comparable.prototype.filter = function (predicate) {
        var destination = new Comparable(this.compareFn);
        for (var _i = 0, _a = this.entries(); _i < _a.length; _i++) {
            var kv = _a[_i];
            if (predicate(kv[0], kv[1])) {
                destination.add(kv[0], kv[1]);
            }
        }
        return destination;
    };
    Comparable.prototype.entries = function () {
        return Array.from(this.data.entries());
    };
    return Comparable;
}());

var Measurement = /** @class */ (function () {
    function Measurement(field, valueSupplier) {
        this.valueSupplier = valueSupplier;
        this.field = field;
    }
    Object.defineProperty(Measurement.prototype, "value", {
        get: function () {
            return this.valueSupplier();
        },
        enumerable: false,
        configurable: true
    });
    return Measurement;
}());
function isMetricIdEqual(lid, rid) {
    return lid.name === rid.name && IdentifierUtil.isEquals(lid.tags, rid.tags);
}

var MetricRegistry = /** @class */ (function () {
    function MetricRegistry() {
        this.id = v4();
        this.name = "MetricRegistry";
        this._metrics = new Comparable(isMetricIdEqual);
    }
    Object.defineProperty(MetricRegistry.prototype, "metrics", {
        get: function () {
            return Array.from(this._metrics.values());
        },
        enumerable: false,
        configurable: true
    });
    MetricRegistry.prototype.registerCounter = function (id) {
        return this.registerMetricIfNecessary(id, this.createCounter.bind(this));
    };
    MetricRegistry.prototype.registerTimer = function (id) {
        return this.registerMetricIfNecessary(id, this.createTimer.bind(this));
    };
    MetricRegistry.prototype.counter = function (name, tags) {
        if (tags === void 0) { tags = {}; }
        return new CounterBuilder(name).tags(tags).register(this);
    };
    MetricRegistry.prototype.timer = function (name, tags) {
        if (tags === void 0) { tags = {}; }
        return new TimerBuilder(name).tags(tags).register(this);
    };
    MetricRegistry.prototype.registerMetricIfNecessary = function (id, create) {
        return this.getOrCreateMetric(id, create);
    };
    MetricRegistry.prototype.getOrCreateMetric = function (id, create) {
        var metric;
        var registeredMetric = this._metrics.get(id);
        if (registeredMetric) {
            metric = registeredMetric;
        }
        else {
            metric = create(id);
            this._metrics.add(id, metric);
        }
        return metric;
    };
    MetricRegistry.prototype.close = function () { };
    return MetricRegistry;
}());

var PushMetricRegistry = /** @class */ (function (_super) {
    __extends(PushMetricRegistry, _super);
    function PushMetricRegistry(scheduler, pushIntervalMillis) {
        var _this = _super.call(this) || this;
        _this.scheduler = scheduler;
        _this.pushIntervalMillis = pushIntervalMillis;
        _this.publishingJob = null;
        return _this;
    }
    PushMetricRegistry.prototype.start = function () {
        var _this = this;
        if (this.publishingJob !== null)
            return;
        this.publishingJob = this.scheduler.schedulePeriodically(this.pushIntervalMillis, this.pushIntervalMillis, function () {
            return _this.publish(false);
        });
        Logger.log.debug("PushMetricRegistry started. Publish metrics every ".concat(this.pushIntervalMillis, "ms."));
    };
    PushMetricRegistry.prototype.stop = function () {
        var _a;
        (_a = this.publishingJob) === null || _a === void 0 ? void 0 : _a.cancel();
        this.publishingJob = null;
        this.publish(true);
        Logger.log.debug("PushMetricRegistry stopped.");
    };
    PushMetricRegistry.prototype.close = function () {
        this.stop();
    };
    return PushMetricRegistry;
}(MetricRegistry));

var CumulativeCounter = /** @class */ (function () {
    function CumulativeCounter(id) {
        this.counterValue = 0;
        this.id = id;
    }
    CumulativeCounter.prototype.count = function () {
        return this.counterValue;
    };
    CumulativeCounter.prototype.increment = function (delta) {
        this.counterValue += delta !== null && delta !== void 0 ? delta : 1;
    };
    CumulativeCounter.prototype.measure = function () {
        return [new Measurement("count", this.count.bind(this))];
    };
    return CumulativeCounter;
}());

var FlushCounter = /** @class */ (function () {
    function FlushCounter(id) {
        this.id = id;
        this.currentCounter = new CumulativeCounter(id);
    }
    FlushCounter.prototype.flush = function () {
        var prev = this.currentCounter;
        this.currentCounter = new CumulativeCounter(this.id);
        return prev;
    };
    FlushCounter.prototype.count = function () {
        return this.currentCounter.count();
    };
    FlushCounter.prototype.increment = function (delta) {
        this.currentCounter.increment(delta);
    };
    FlushCounter.prototype.measure = function () {
        return [new Measurement("count", this.count.bind(this))];
    };
    return FlushCounter;
}());

function isFlushMetric(metric) {
    return typeof metric.flush !== "undefined" && typeof metric.flush === "function";
}

var CumulativeTimer = /** @class */ (function () {
    function CumulativeTimer(id) {
        this._count = 0;
        this._total = 0;
        this._max = 0;
        this.id = id;
    }
    CumulativeTimer.prototype.count = function () {
        return this._count;
    };
    CumulativeTimer.prototype.totalTime = function (unit) {
        return TimeUtil.nanosToUnit(this._total, unit);
    };
    CumulativeTimer.prototype.max = function (unit) {
        return TimeUtil.nanosToUnit(this._max, unit);
    };
    CumulativeTimer.prototype.mean = function (unit) {
        return this.count() === 0 ? 0.0 : this.totalTime(unit) / this.count();
    };
    CumulativeTimer.prototype.record = function (amount, unit) {
        if (amount < 0)
            return;
        var convertedTime = TimeUtil.converter[unit](amount, "nanoseconds");
        this._count = this.count() + 1;
        this._total += convertedTime;
        this._max = Math.max(convertedTime, this._max);
    };
    CumulativeTimer.prototype.measure = function () {
        var _this = this;
        return [
            new Measurement("count", this.count.bind(this)),
            new Measurement("total", function () { return _this.totalTime("milliseconds"); }),
            new Measurement("max", function () { return _this.max("milliseconds"); }),
            new Measurement("mean", function () { return _this.mean("milliseconds"); })
        ];
    };
    return CumulativeTimer;
}());

var FlushTimer = /** @class */ (function () {
    function FlushTimer(id) {
        this.id = id;
        this.currentTimer = new CumulativeTimer(id);
    }
    FlushTimer.prototype.flush = function () {
        var prev = this.currentTimer;
        this.currentTimer = new CumulativeTimer(this.id);
        return prev;
    };
    FlushTimer.prototype.count = function () {
        return this.currentTimer.count();
    };
    FlushTimer.prototype.totalTime = function (unit) {
        return this.currentTimer.totalTime(unit);
    };
    FlushTimer.prototype.max = function (unit) {
        return this.currentTimer.max(unit);
    };
    FlushTimer.prototype.record = function (amount, unit) {
        this.currentTimer.record(amount, unit);
    };
    FlushTimer.prototype.mean = function (unit) {
        return this.count() === 0 ? 0.0 : this.totalTime(unit) / this.count();
    };
    FlushTimer.prototype.measure = function () {
        var _this = this;
        return [
            new Measurement("count", this.count.bind(this)),
            new Measurement("total", function () { return _this.totalTime("milliseconds"); }),
            new Measurement("max", function () { return _this.max("milliseconds"); }),
            new Measurement("mean", function () { return _this.mean("milliseconds"); })
        ];
    };
    return FlushTimer;
}());

var FlushMetricRegistry = /** @class */ (function (_super) {
    __extends(FlushMetricRegistry, _super);
    function FlushMetricRegistry(scheduler, pushIntervalMillis) {
        return _super.call(this, scheduler, pushIntervalMillis) || this;
    }
    FlushMetricRegistry.prototype.createCounter = function (id) {
        return new FlushCounter(id);
    };
    FlushMetricRegistry.prototype.createTimer = function (id) {
        return new FlushTimer(id);
    };
    FlushMetricRegistry.prototype.publish = function (sync) {
        if (sync === void 0) { sync = false; }
        var metrics = this.metrics.reduce(function (acc, metric) {
            if (!isFlushMetric(metric))
                return acc;
            return acc.concat(metric.flush());
        }, []);
        this.flushMetrics(metrics, sync);
    };
    return FlushMetricRegistry;
}(PushMetricRegistry));

var NoopCounter = /** @class */ (function () {
    function NoopCounter(id) {
        this.id = id;
    }
    NoopCounter.prototype.count = function () {
        return 0;
    };
    NoopCounter.prototype.increment = function (delta) { };
    NoopCounter.prototype.measure = function () {
        return [new Measurement("count", this.count.bind(this))];
    };
    return NoopCounter;
}());

var DelegatingCounter = /** @class */ (function () {
    function DelegatingCounter(id) {
        this._counters = new Comparable(function (a, b) { return a.id === b.id; });
        this.id = id;
        this.noopCounter = new NoopCounter(id);
    }
    Object.defineProperty(DelegatingCounter.prototype, "counters", {
        get: function () {
            return Array.from(this._counters.values());
        },
        enumerable: false,
        configurable: true
    });
    DelegatingCounter.prototype.add = function (registry) {
        this._counters.add(registry, registry.registerCounter(this.id));
    };
    DelegatingCounter.prototype.count = function () {
        return (this.counters[0] || this.noopCounter).count();
    };
    DelegatingCounter.prototype.increment = function (delta) {
        this.counters.forEach(function (counter) {
            counter.increment(delta);
        });
    };
    DelegatingCounter.prototype.measure = function () {
        return [new Measurement("count", this.count.bind(this))];
    };
    return DelegatingCounter;
}());

function isDelegatingMetric(metric) {
    return typeof metric.add !== "undefined" && typeof metric.add === "function";
}

var NoopTimer = /** @class */ (function () {
    function NoopTimer(id) {
        this.id = id;
    }
    NoopTimer.prototype.measure = function () {
        var _this = this;
        return [
            new Measurement("count", this.count.bind(this)),
            new Measurement("total", function () { return _this.totalTime("milliseconds"); }),
            new Measurement("max", function () { return _this.max("milliseconds"); }),
            new Measurement("mean", function () { return _this.mean("milliseconds"); })
        ];
    };
    NoopTimer.prototype.count = function () {
        return 0;
    };
    NoopTimer.prototype.totalTime = function (unit) {
        return 0;
    };
    NoopTimer.prototype.max = function (unit) {
        return 0;
    };
    NoopTimer.prototype.mean = function (unit) {
        return 0;
    };
    NoopTimer.prototype.record = function (amount, unit) { };
    return NoopTimer;
}());

var DelegatingTimer = /** @class */ (function () {
    function DelegatingTimer(id) {
        this._timers = new Comparable(function (a, b) { return a.id === b.id; });
        this.id = id;
        this.noopTimer = new NoopTimer(id);
    }
    Object.defineProperty(DelegatingTimer.prototype, "firstTimer", {
        get: function () {
            return this.timers[0] || this.noopTimer;
        },
        enumerable: false,
        configurable: true
    });
    DelegatingTimer.prototype.totalTime = function (unit) {
        return this.firstTimer.totalTime(unit);
    };
    DelegatingTimer.prototype.max = function (unit) {
        return this.firstTimer.max(unit);
    };
    DelegatingTimer.prototype.mean = function (unit) {
        return this.firstTimer.mean(unit);
    };
    DelegatingTimer.prototype.record = function (amount, unit) {
        this.timers.forEach(function (timer) {
            timer.record(amount, unit);
        });
    };
    Object.defineProperty(DelegatingTimer.prototype, "timers", {
        get: function () {
            return Array.from(this._timers.values());
        },
        enumerable: false,
        configurable: true
    });
    DelegatingTimer.prototype.add = function (registry) {
        this._timers.add(registry, registry.registerTimer(this.id));
    };
    DelegatingTimer.prototype.count = function () {
        return this.firstTimer.count();
    };
    DelegatingTimer.prototype.measure = function () {
        var _this = this;
        return [
            new Measurement("count", this.count.bind(this)),
            new Measurement("total", function () { return _this.totalTime("milliseconds"); }),
            new Measurement("max", function () { return _this.max("milliseconds"); }),
            new Measurement("mean", function () { return _this.mean("milliseconds"); })
        ];
    };
    return DelegatingTimer;
}());

var DelegatingMetricRegistry = /** @class */ (function (_super) {
    __extends(DelegatingMetricRegistry, _super);
    function DelegatingMetricRegistry() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registries = new Comparable(function (a, b) { return a.id === b.id; });
        return _this;
    }
    DelegatingMetricRegistry.prototype.createCounter = function (id) {
        var counter = new DelegatingCounter(id);
        this.addRegistry(counter);
        return counter;
    };
    DelegatingMetricRegistry.prototype.createTimer = function (id) {
        var timer = new DelegatingTimer(id);
        this.addRegistry(timer);
        return timer;
    };
    DelegatingMetricRegistry.prototype.addRegistry = function (metric) {
        this.registries.forEach(function (registry) { return metric.add(registry); });
    };
    DelegatingMetricRegistry.prototype.add = function (registry) {
        if (registry instanceof DelegatingMetricRegistry)
            return;
        if (this.registries.has(registry))
            return;
        this.registries.add(registry);
        this.metrics.forEach(function (metric) {
            if (!isDelegatingMetric(metric))
                return;
            metric.add(registry);
        });
    };
    DelegatingMetricRegistry.prototype.close = function () {
        this.registries.forEach(function (registry) {
            registry.close();
        });
    };
    return DelegatingMetricRegistry;
}(MetricRegistry));

var Metrics = /** @class */ (function () {
    function Metrics() {
    }
    Metrics.counter = function (name, tags) {
        return Metrics.globalRegistry.counter(name, tags);
    };
    Metrics.timer = function (name, tags) {
        return Metrics.globalRegistry.timer(name, tags);
    };
    Metrics.addRegistry = function (registry) {
        Metrics.globalRegistry.add(registry);
        Logger.log.debug("MetricRegistry added ".concat(registry.name));
    };
    Metrics.globalRegistry = new DelegatingMetricRegistry();
    return Metrics;
}());

var Strings = /** @class */ (function () {
    function Strings() {
    }
    Strings.equalsIgnoreCase = function (a, b) {
        return a.toLowerCase() === b.toLowerCase();
    };
    Strings.isNotEmptyString = function (value) {
        if (ObjectUtil.isNullOrUndefined(value)) {
            return false;
        }
        if (typeof value !== "string") {
            return false;
        }
        return value.length > 0;
    };
    return Strings;
}());

var TransportRequest = /** @class */ (function () {
    function TransportRequest(url, method, body, headers, options) {
        this.url = url;
        this.method = method;
        this.body = body;
        this.headers = headers;
        this.options = options;
    }
    TransportRequest.builder = function () {
        return new TransportRequestBuilder();
    };
    TransportRequest.get = function (url) {
        return TransportRequest.builder().url(url).build();
    };
    TransportRequest.prototype.toBuilder = function () {
        return new TransportRequestBuilder(this);
    };
    return TransportRequest;
}());
var TransportRequestBuilder = /** @class */ (function () {
    function TransportRequestBuilder(request) {
        var _a, _b, _c, _d, _e, _f, _g;
        this._url = (_a = request === null || request === void 0 ? void 0 : request.url) !== null && _a !== void 0 ? _a : null;
        this._method = (_b = request === null || request === void 0 ? void 0 : request.method) !== null && _b !== void 0 ? _b : "GET";
        this._body = (_c = request === null || request === void 0 ? void 0 : request.body) !== null && _c !== void 0 ? _c : null;
        this._headers = (_e = (_d = request === null || request === void 0 ? void 0 : request.headers) === null || _d === void 0 ? void 0 : _d.toBuilder()) !== null && _e !== void 0 ? _e : TransportHeaders.builder();
        this._timeoutMillis = (_g = (_f = request === null || request === void 0 ? void 0 : request.options) === null || _f === void 0 ? void 0 : _f.timeoutMillis) !== null && _g !== void 0 ? _g : null;
    }
    TransportRequestBuilder.prototype.url = function (url) {
        this._url = url;
        return this;
    };
    TransportRequestBuilder.prototype.method = function (method) {
        this._method = method;
        return this;
    };
    TransportRequestBuilder.prototype.body = function (body) {
        this._body = body;
        return this;
    };
    TransportRequestBuilder.prototype.addHeader = function (name, value) {
        this._headers.add(name, value);
        return this;
    };
    TransportRequestBuilder.prototype.timeoutMillis = function (timeoutMillis) {
        this._timeoutMillis = timeoutMillis;
        return this;
    };
    TransportRequestBuilder.prototype.build = function () {
        if (this._url === null) {
            throw new Error("url is null");
        }
        var options = { timeoutMillis: this._timeoutMillis };
        return new TransportRequest(this._url, this._method, this._body, this._headers.build(), options);
    };
    return TransportRequestBuilder;
}());
var TransportResponse = /** @class */ (function () {
    function TransportResponse(statusCode, body, headers) {
        this.statusCode = statusCode;
        this.body = body;
        this.headers = headers;
    }
    TransportResponse.ok = function (body, headers) {
        return TransportResponse.of(200, body, headers);
    };
    TransportResponse.of = function (statusCode, body, headers) {
        return new TransportResponse(statusCode, body !== null && body !== void 0 ? body : null, headers !== null && headers !== void 0 ? headers : TransportHeaders.empty());
    };
    TransportResponse.prototype.isSuccessful = function () {
        return this.statusCode >= 200 && this.statusCode < 300;
    };
    TransportResponse.prototype.isClientError = function () {
        return this.statusCode >= 400 && this.statusCode < 500;
    };
    TransportResponse.prototype.isNotModified = function () {
        return this.statusCode === 304;
    };
    return TransportResponse;
}());
var TransportHeaders = /** @class */ (function () {
    function TransportHeaders(headers) {
        this.headers = headers;
    }
    TransportHeaders.empty = function () {
        return new TransportHeaders(new Map());
    };
    TransportHeaders.builder = function () {
        return new TransportHeadersBuilder(new Map());
    };
    TransportHeaders.prototype.get = function (name) {
        for (var _i = 0, _a = Array.from(this.headers.entries()); _i < _a.length; _i++) {
            var _b = _a[_i], headerName = _b[0], headerValue = _b[1];
            if (Strings.equalsIgnoreCase(headerName, name)) {
                return headerValue;
            }
        }
        return null;
    };
    TransportHeaders.prototype.getOrDefault = function (name, defaultValue) {
        var _a;
        return (_a = this.get(name)) !== null && _a !== void 0 ? _a : defaultValue;
    };
    TransportHeaders.prototype.raw = function () {
        return Array.from(this.headers.entries()).reduce(function (record, _a) {
            var name = _a[0], value = _a[1];
            record[name] = value;
            return record;
        }, {});
    };
    TransportHeaders.prototype.toBuilder = function () {
        return new TransportHeadersBuilder(this.headers);
    };
    TransportHeaders.IF_MODIFIED_SINCE = "If-Modified-Since";
    TransportHeaders.LAST_MODIFIED = "Last-Modified";
    TransportHeaders.ACCEPT_ENCODING = "Accept-Encoding";
    return TransportHeaders;
}());
var TransportHeadersBuilder = /** @class */ (function () {
    function TransportHeadersBuilder(headers) {
        this.headers = headers;
    }
    TransportHeadersBuilder.prototype.add = function (name, value) {
        this.headers.set(name, value);
        return this;
    };
    TransportHeadersBuilder.prototype.build = function () {
        return new TransportHeaders(this.headers);
    };
    return TransportHeadersBuilder;
}());

var MonitoringMetricRegistry = /** @class */ (function (_super) {
    __extends(MonitoringMetricRegistry, _super);
    function MonitoringMetricRegistry(url, transport, synchronousTransport, scheduler, pushIntervalMillis) {
        var _this = _super.call(this, scheduler, pushIntervalMillis) || this;
        _this.url = url;
        _this.transport = transport;
        _this.synchronousTransport = synchronousTransport;
        _this.start();
        return _this;
    }
    MonitoringMetricRegistry.prototype.flushMetrics = function (metrics, sync) {
        var _this = this;
        CollectionUtil.chunked(metrics.filter(this.isDispatchTarget.bind(this)), BROWSER_BATCH_SIZE).forEach(function (targetMetrics) {
            _this.dispatch(targetMetrics, sync);
        });
    };
    // Dispatch only measured metrics
    MonitoringMetricRegistry.prototype.isDispatchTarget = function (metric) {
        if (isCounterMetric(metric) || isTimerMetric(metric))
            return metric.count() > 0;
        return false;
    };
    MonitoringMetricRegistry.prototype.dispatch = function (metrics, sync) {
        var request = this.createRequest(metrics);
        this.execute(request, sync).catch(function (e) { return Logger.log.debug("Failed to flushing metrics: ".concat(e)); });
    };
    MonitoringMetricRegistry.prototype.createRequest = function (metrics) {
        return TransportRequest.builder()
            .url(this.url)
            .method("POST")
            .body(JSON.stringify(this.batch(metrics)))
            .addHeader("Content-Type", "application/json")
            .build();
    };
    MonitoringMetricRegistry.prototype.execute = function (request, sync) {
        if (sync) {
            return this.synchronousTransport.send(request);
        }
        else {
            return this.transport.send(request);
        }
    };
    MonitoringMetricRegistry.prototype.batch = function (metrics) {
        return {
            metrics: metrics.map(function (metric) { return ({
                name: metric.id.name,
                type: metric.id.type,
                tags: metric.id.tags,
                measurements: ObjectUtil.fromMap(CollectionUtil.associate(metric.measure(), function (measurement) { return [measurement.field, measurement.value]; }))
            }); })
        };
    };
    MonitoringMetricRegistry.prototype.onLifecycleChanged = function (visibility, _) {
        switch (visibility) {
            case "hidden":
            case "pagehide":
                return this.publish(true);
            case "visible":
            case "pageshow":
            case "blur":
            case "locationChange":
            case "focus":
                return;
        }
    };
    return MonitoringMetricRegistry;
}(FlushMetricRegistry));
var DecisionMetrics = /** @class */ (function () {
    function DecisionMetrics() {
    }
    DecisionMetrics.experiment = function (sample, key, decision) {
        var timer = Metrics.timer("experiment.decision", {
            key: String(key),
            variation: decision.variation,
            reason: String(decision.reason)
        });
        sample.stop(timer);
    };
    DecisionMetrics.featureFlag = function (sample, key, decision) {
        var timer = Metrics.timer("feature.flag.decision", {
            key: String(key),
            on: String(decision.isOn),
            reason: String(decision.reason)
        });
        sample.stop(timer);
    };
    DecisionMetrics.remoteConfig = function (sample, key, decision) {
        var timer = Metrics.timer("remote.config.decision", {
            key: String(key),
            reason: String(decision.reason)
        });
        sample.stop(timer);
    };
    return DecisionMetrics;
}());
var ApiCallMetrics = /** @class */ (function () {
    function ApiCallMetrics() {
    }
    ApiCallMetrics.record = function (operation, sample, response) {
        var timer = Metrics.timer("api.call", {
            operation: operation,
            success: ApiCallMetrics.success(response)
        });
        sample.stop(timer);
    };
    ApiCallMetrics.success = function (response) {
        if (response === null) {
            return "false";
        }
        return String(response.isSuccessful() || response.isNotModified());
    };
    return ApiCallMetrics;
}());

var HackleRemoteConfigDecider = /** @class */ (function () {
    function HackleRemoteConfigDecider() {
    }
    HackleRemoteConfigDecider.decide = function (core, key, defaultValue, user) {
        if (ObjectUtil.isNullOrUndefined(defaultValue)) {
            return this.decision(core, key, "NULL", defaultValue, user);
        }
        switch (typeof defaultValue) {
            case "string":
                return this.decision(core, key, "STRING", defaultValue, user);
            case "number":
                return this.decision(core, key, "NUMBER", defaultValue, user);
            case "boolean":
                return this.decision(core, key, "BOOLEAN", defaultValue, user);
            default:
                return this.decision(core, key, "UNKNOWN", defaultValue, user);
        }
    };
    HackleRemoteConfigDecider.decision = function (core, key, requiredType, defaultValue, user) {
        if (ObjectUtil.isNullOrUndefined(key)) {
            return RemoteConfigDecision.of(defaultValue, DecisionReason.INVALID_INPUT);
        }
        return core.remoteConfig(key, user, requiredType, defaultValue);
    };
    return HackleRemoteConfigDecider;
}());

var log$9 = Logger.log;
var HackleRemoteConfigImpl = /** @class */ (function () {
    function HackleRemoteConfigImpl(core, userManager, user) {
        this.core = core;
        this.userManager = userManager;
        this.user = user;
    }
    HackleRemoteConfigImpl.prototype.get = function (key, defaultValue) {
        var sample = TimerSample.start();
        var decision;
        try {
            decision = this.decide(key, defaultValue);
        }
        catch (e) {
            log$9.error("Unexpected exception while deciding remote config parameter[".concat(key, "]. Returning default value. : ").concat(e));
            decision = RemoteConfigDecision.of(defaultValue, DecisionReason.EXCEPTION);
        }
        DecisionMetrics.remoteConfig(sample, key, decision);
        return decision.value;
    };
    HackleRemoteConfigImpl.prototype.decide = function (key, defaultValue) {
        var hackleUser = this.userManager.resolve(this.user);
        return HackleRemoteConfigDecider.decide(this.core, key, defaultValue, hackleUser);
    };
    return HackleRemoteConfigImpl;
}());

var PropertiesBuilder = /** @class */ (function () {
    function PropertiesBuilder() {
        this._properties = new Map();
        this.MAX_PROPERTIES_COUNT = 128;
        this.MAX_PROPERTY_KEY_LENGTH = 128;
    }
    PropertiesBuilder.prototype.contains = function (key) {
        return this._properties.has(key);
    };
    PropertiesBuilder.prototype.remove = function (target) {
        var _this = this;
        if (target instanceof Map) {
            target.forEach(function (_value, key) {
                _this.remove(key);
            });
        }
        if (typeof target === "string") {
            this._properties.delete(target);
        }
        return this;
    };
    PropertiesBuilder.prototype.compute = function (key, remapping) {
        var oldValue = this._properties.get(key);
        var newValue = remapping(oldValue);
        if (newValue !== null) {
            this.add(key, newValue);
        }
        else {
            if (oldValue !== null || this.contains(key)) {
                this.remove(key);
            }
        }
    };
    PropertiesBuilder.prototype.add = function (key, value, setOnce) {
        if (setOnce === void 0) { setOnce = false; }
        if (setOnce && this.contains(key))
            return this;
        if (this._properties.size >= this.MAX_PROPERTIES_COUNT)
            return this;
        if (typeof key === "string" && key.length > this.MAX_PROPERTY_KEY_LENGTH)
            return this;
        var sanitizedValue = PropertyUtil.sanitizeValue(key, value);
        if (ObjectUtil.isNullOrUndefined(sanitizedValue))
            return this;
        this._properties.set(key, sanitizedValue);
        return this;
    };
    PropertiesBuilder.prototype.addProperties = function (properties, setOnce) {
        var _this = this;
        if (setOnce === void 0) { setOnce = false; }
        properties.forEach(function (value, key) {
            _this.add(key, value, setOnce);
        });
        return this;
    };
    PropertiesBuilder.prototype.build = function () {
        return this._properties;
    };
    return PropertiesBuilder;
}());

var PropertyOperation;
(function (PropertyOperation) {
    PropertyOperation["SET"] = "$set";
    PropertyOperation["SET_ONCE"] = "$setOnce";
    PropertyOperation["UNSET"] = "$unset";
    PropertyOperation["INCREMENT"] = "$increment";
    PropertyOperation["APPEND"] = "$append";
    PropertyOperation["APPEND_ONCE"] = "$appendOnce";
    PropertyOperation["PREPEND"] = "$prepend";
    PropertyOperation["PREPEND_ONCE"] = "$prependOnce";
    PropertyOperation["REMOVE"] = "$remove";
    PropertyOperation["CLEAR_ALL"] = "$clearAll";
})(PropertyOperation || (PropertyOperation = {}));

var PropertySetOperator = /** @class */ (function () {
    function PropertySetOperator() {
    }
    PropertySetOperator.prototype.operate = function (base, properties) {
        if (base.size === 0)
            return properties;
        if (properties.size === 0)
            return base;
        return new PropertiesBuilder().addProperties(base).addProperties(properties).build();
    };
    return PropertySetOperator;
}());
var PropertySetOnceOperator = /** @class */ (function () {
    function PropertySetOnceOperator() {
    }
    PropertySetOnceOperator.prototype.operate = function (base, properties) {
        if (base.size === 0)
            return properties;
        if (properties.size === 0)
            return base;
        return new PropertiesBuilder().addProperties(base).addProperties(properties, true).build();
    };
    return PropertySetOnceOperator;
}());
var PropertyUnsetOperator = /** @class */ (function () {
    function PropertyUnsetOperator() {
    }
    PropertyUnsetOperator.prototype.operate = function (base, properties) {
        if (base.size === 0)
            return new Map();
        if (properties.size === 0)
            return base;
        return new PropertiesBuilder().addProperties(base).remove(properties).build();
    };
    return PropertyUnsetOperator;
}());
var PropertyIncrementOperator = /** @class */ (function () {
    function PropertyIncrementOperator() {
    }
    PropertyIncrementOperator.prototype.operate = function (base, properties) {
        var _this = this;
        if (properties.size === 0)
            return base;
        var builder = new PropertiesBuilder();
        builder.addProperties(base);
        properties.forEach(function (value, key) {
            builder.compute(key, function (mapper) { return _this.increment(mapper, value); });
        });
        return builder.build();
    };
    PropertyIncrementOperator.prototype.increment = function (baseValue, valueToIncrement) {
        if (typeof valueToIncrement !== "number")
            return baseValue;
        if (typeof baseValue !== "number") {
            if (baseValue === undefined || baseValue === null)
                return valueToIncrement;
            return baseValue;
        }
        return baseValue + valueToIncrement;
    };
    return PropertyIncrementOperator;
}());
var ArrayPropertyOperator = /** @class */ (function () {
    function ArrayPropertyOperator() {
    }
    ArrayPropertyOperator.prototype.operate = function (base, properties) {
        var _this = this;
        if (properties.size === 0)
            return base;
        var builder = new PropertiesBuilder();
        builder.addProperties(base);
        properties.forEach(function (value, key) {
            builder.compute(key, function (mapper) { return _this.compute(mapper, value); });
        });
        return builder.build();
    };
    ArrayPropertyOperator.prototype.compute = function (baseValue, valueToCompute) {
        var base = this.toArray(baseValue);
        var values = this.toArray(valueToCompute);
        return this.operateArray(base, values);
    };
    ArrayPropertyOperator.prototype.toArray = function (value) {
        if (value === undefined || value === null)
            return [];
        if (Array.isArray(value))
            return value;
        return [value];
    };
    ArrayPropertyOperator.prototype.contains = function (base, value) {
        return base.includes(value);
    };
    ArrayPropertyOperator.prototype.prepend = function (value, base, setOnce) {
        if (setOnce === void 0) { setOnce = false; }
        if (setOnce && this.contains(base, value))
            return base;
        return __spreadArray([value], base, true);
    };
    ArrayPropertyOperator.prototype.append = function (base, value, setOnce) {
        if (setOnce === void 0) { setOnce = false; }
        if (setOnce && this.contains(base, value))
            return base;
        return __spreadArray(__spreadArray([], base, true), [value], false);
    };
    return ArrayPropertyOperator;
}());
var PropertyAppendOperator = /** @class */ (function (_super) {
    __extends(PropertyAppendOperator, _super);
    function PropertyAppendOperator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyAppendOperator.prototype.operateArray = function (base, values) {
        var _this = this;
        return values.reduce(function (acc, cur) { return _this.append.bind(_this)(acc, cur); }, base);
    };
    return PropertyAppendOperator;
}(ArrayPropertyOperator));
var PropertyAppendOnceOperator = /** @class */ (function (_super) {
    __extends(PropertyAppendOnceOperator, _super);
    function PropertyAppendOnceOperator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyAppendOnceOperator.prototype.operateArray = function (base, values) {
        return values.reduce(this.appendOnce.bind(this), base);
    };
    PropertyAppendOnceOperator.prototype.appendOnce = function (base, value) {
        return this.append(base, value, true);
    };
    return PropertyAppendOnceOperator;
}(ArrayPropertyOperator));
var PropertyPrependOperator = /** @class */ (function (_super) {
    __extends(PropertyPrependOperator, _super);
    function PropertyPrependOperator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyPrependOperator.prototype.operateArray = function (base, values) {
        var _this = this;
        return values.reduceRight(function (acc, cur) { return _this.prepend.bind(_this)(cur, acc); }, base);
    };
    return PropertyPrependOperator;
}(ArrayPropertyOperator));
var PropertyPrependOnceOperator = /** @class */ (function (_super) {
    __extends(PropertyPrependOnceOperator, _super);
    function PropertyPrependOnceOperator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyPrependOnceOperator.prototype.operateArray = function (base, values) {
        var _this = this;
        return values
            .reduce(this.appendOnce.bind(this), [])
            .reduceRight(function (acc, cur) { return _this.prependOnce.bind(_this)(cur, acc); }, base);
    };
    PropertyPrependOnceOperator.prototype.appendOnce = function (base, value) {
        return this.append(base, value, true);
    };
    PropertyPrependOnceOperator.prototype.prependOnce = function (value, base) {
        return this.prepend(value, base, true);
    };
    return PropertyPrependOnceOperator;
}(ArrayPropertyOperator));
var PropertyRemoveOperator = /** @class */ (function (_super) {
    __extends(PropertyRemoveOperator, _super);
    function PropertyRemoveOperator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyRemoveOperator.prototype.operateArray = function (base, values) {
        return values.reduce(this.remove.bind(this), base);
    };
    PropertyRemoveOperator.prototype.remove = function (builder, value) {
        return builder.filter(function (element) { return element !== value; });
    };
    return PropertyRemoveOperator;
}(ArrayPropertyOperator));
var PropertyClearAllOperator = /** @class */ (function () {
    function PropertyClearAllOperator() {
    }
    PropertyClearAllOperator.prototype.operate = function (base, properties) {
        return new Map();
    };
    return PropertyClearAllOperator;
}());

var PropertyOperators = /** @class */ (function () {
    function PropertyOperators() {
    }
    PropertyOperators.get = function (operation) {
        switch (operation) {
            case PropertyOperation.SET:
                return new PropertySetOperator();
            case PropertyOperation.SET_ONCE:
                return new PropertySetOnceOperator();
            case PropertyOperation.UNSET:
                return new PropertyUnsetOperator();
            case PropertyOperation.INCREMENT:
                return new PropertyIncrementOperator();
            case PropertyOperation.APPEND:
                return new PropertyAppendOperator();
            case PropertyOperation.APPEND_ONCE:
                return new PropertyAppendOnceOperator();
            case PropertyOperation.PREPEND:
                return new PropertyPrependOperator();
            case PropertyOperation.PREPEND_ONCE:
                return new PropertyPrependOnceOperator();
            case PropertyOperation.CLEAR_ALL:
                return new PropertyClearAllOperator();
            case PropertyOperation.REMOVE:
                return new PropertyRemoveOperator();
        }
    };
    return PropertyOperators;
}());

var PropertyOperationsBuilder = /** @class */ (function () {
    function PropertyOperationsBuilder() {
        this.operations = new Map();
    }
    PropertyOperationsBuilder.prototype.set = function (key, value) {
        return this.add(PropertyOperation.SET, key, value);
    };
    PropertyOperationsBuilder.prototype.setOnce = function (key, value) {
        return this.add(PropertyOperation.SET_ONCE, key, value);
    };
    PropertyOperationsBuilder.prototype.unset = function (key) {
        return this.add(PropertyOperation.UNSET, key, "-");
    };
    PropertyOperationsBuilder.prototype.increment = function (key, value) {
        return this.add(PropertyOperation.INCREMENT, key, value);
    };
    PropertyOperationsBuilder.prototype.append = function (key, value) {
        return this.add(PropertyOperation.APPEND, key, value);
    };
    PropertyOperationsBuilder.prototype.appendOnce = function (key, value) {
        return this.add(PropertyOperation.APPEND_ONCE, key, value);
    };
    PropertyOperationsBuilder.prototype.prepend = function (key, value) {
        return this.add(PropertyOperation.PREPEND, key, value);
    };
    PropertyOperationsBuilder.prototype.prependOnce = function (key, value) {
        return this.add(PropertyOperation.PREPEND_ONCE, key, value);
    };
    PropertyOperationsBuilder.prototype.remove = function (key, value) {
        return this.add(PropertyOperation.REMOVE, key, value);
    };
    PropertyOperationsBuilder.prototype.clearAll = function () {
        return this.add(PropertyOperation.CLEAR_ALL, "clearAll", "-");
    };
    PropertyOperationsBuilder.prototype.build = function () {
        var builderPropertyOperation = Array.from(this.operations.entries()).map(function (_a) {
            var operation = _a[0], builder = _a[1];
            return [operation, builder.build()];
        });
        return new PropertyOperations(new Map(builderPropertyOperation));
    };
    PropertyOperationsBuilder.prototype.containsKey = function (key) {
        return Array.from(this.operations.entries()).some(function (_a) {
            _a[0]; var builder = _a[1];
            return builder.contains(key);
        });
    };
    PropertyOperationsBuilder.prototype.add = function (operation, key, value) {
        if (this.containsKey(key))
            return this;
        if (!this.operations.has(operation)) {
            this.operations.set(operation, new PropertiesBuilder());
        }
        var _builder = this.operations.get(operation);
        _builder === null || _builder === void 0 ? void 0 : _builder.add(key, value);
        return this;
    };
    return PropertyOperationsBuilder;
}());
var PropertyOperations = /** @class */ (function () {
    function PropertyOperations(operations) {
        this.operations = operations !== null && operations !== void 0 ? operations : new Map();
    }
    PropertyOperations.prototype.operate = function (base) {
        var accumulator = base;
        this.operations.forEach(function (value, key) {
            accumulator = PropertyOperators.get(key).operate(accumulator, value);
        });
        return accumulator;
    };
    PropertyOperations.prototype.toEvent = function () {
        var event = {
            key: "$properties"
        };
        this.operations.forEach(function (properties, operation) {
            var _a;
            var _b;
            event.properties = __assign(__assign({}, event.properties), (_a = {}, _a[operation] = __assign(__assign({}, (_b = event.properties) === null || _b === void 0 ? void 0 : _b[operation]), PropertyUtil.sanitize(ObjectUtil.fromMap(properties))), _a));
        });
        return event;
    };
    PropertyOperations.prototype.toSecuredEvent = function () {
        var event = {
            key: "$secured_properties"
        };
        this.operations.forEach(function (properties, operation) {
            var _a;
            var _b;
            event.properties = __assign(__assign({}, event.properties), (_a = {}, _a[operation] = __assign(__assign({}, (_b = event.properties) === null || _b === void 0 ? void 0 : _b[operation]), PropertyUtil.sanitize(ObjectUtil.fromMap(properties))), _a));
        });
        return event;
    };
    PropertyOperations.prototype.toRecord = function () {
        var object = {};
        this.operations.forEach(function (properties, operation) {
            var childValue = {};
            properties.forEach(function (value, key) {
                childValue[key] = value;
            });
            object[operation] = childValue;
        });
        return object;
    };
    return PropertyOperations;
}());

var Promises = /** @class */ (function () {
    function Promises() {
    }
    Promises.timeout = function (promise, ms) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () { return reject(new Error("timeout (".concat(ms, "ms)"))); }, ms);
            promise.then(resolve, reject);
        });
    };
    return Promises;
}());

var Page = /** @class */ (function () {
    function Page(pagePath, host, hostname, url, referrer, queryParameter, protocol) {
        if (pagePath === void 0) { pagePath = ""; }
        if (host === void 0) { host = ""; }
        if (hostname === void 0) { hostname = ""; }
        if (url === void 0) { url = ""; }
        if (referrer === void 0) { referrer = ""; }
        if (queryParameter === void 0) { queryParameter = ""; }
        if (protocol === void 0) { protocol = ""; }
        this.pagePath = pagePath;
        this.host = host;
        this.hostname = hostname;
        this.url = url;
        this.referrer = referrer;
        this.queryParameter = queryParameter;
        this.protocol = protocol;
    }
    Page.prototype.isEquals = function (other) {
        return this.url === other.url;
    };
    Object.defineProperty(Page.prototype, "pageTitle", {
        get: function () {
            if (typeof window === "undefined" || typeof document === "undefined") {
                return "";
            }
            // The page title changes dynamically, so window.document.title is returned each time.
            return window.document.title;
        },
        enumerable: false,
        configurable: true
    });
    Page.createWithCurrentPage = function () {
        if (typeof window === "undefined" || typeof document === "undefined") {
            return new Page();
        }
        return new Page(window.location.pathname, window.location.host, window.location.hostname, window.location.href, window.document.referrer, window.location.search, window.location.protocol);
    };
    Page.prototype.toProperties = function () {
        return {
            pagePath: this.pagePath,
            pageTitle: this.pageTitle,
            host: this.host,
            url: this.url,
            referrer: this.referrer,
            queryParameter: this.queryParameter,
            protocol: this.protocol.replace(":", "")
        };
    };
    return Page;
}());

var PhoneNumber = /** @class */ (function () {
    function PhoneNumber(value) {
        this.value = value;
    }
    PhoneNumber.create = function (phoneNumber) {
        return new PhoneNumber(phoneNumber);
    };
    PhoneNumber.prototype.getValue = function () {
        return this.value;
    };
    return PhoneNumber;
}());

var InAppMessageConverter = /** @class */ (function () {
    function InAppMessageConverter() {
    }
    InAppMessageConverter.toPublic = function (inAppMessage) {
        return {
            key: inAppMessage.key
        };
    };
    return InAppMessageConverter;
}());
var InAppMessageViewConverter = /** @class */ (function () {
    function InAppMessageViewConverter() {
    }
    InAppMessageViewConverter.toPublic = function (view) {
        return {
            close: view.close.bind(view),
            inAppMessage: InAppMessageConverter.toPublic(view.context.inAppMessage)
        };
    };
    return InAppMessageViewConverter;
}());

var log$8 = Logger.log;
var HackleClientImpl = /** @class */ (function () {
    function HackleClientImpl(core, synchronizer, sessionManager, userManager, piiEventManager, fetchThrottler, pageEventTracker, inAppMessageUi, devTools) {
        this.core = core;
        this.synchronizer = synchronizer;
        this.sessionManager = sessionManager;
        this.userManager = userManager;
        this.piiEventManager = piiEventManager;
        this.fetchThrottler = fetchThrottler;
        this.pageEventTracker = pageEventTracker;
        this.inAppMessageUi = inAppMessageUi;
        this.devTools = devTools;
        this.initialized = false;
        // This is to prevent the "This Binding" problem.
        this.initialize = this.initialize.bind(this);
        this.getSessionId = this.getSessionId.bind(this);
        this.getUser = this.getUser.bind(this);
        this.setUser = this.setUser.bind(this);
        this.setUserId = this.setUserId.bind(this);
        this.setDeviceId = this.setDeviceId.bind(this);
        this.setUserProperty = this.setUserProperty.bind(this);
        this.setUserProperties = this.setUserProperties.bind(this);
        this.updateUserProperties = this.updateUserProperties.bind(this);
        this.updatePushSubscriptions = this.updatePushSubscriptions.bind(this);
        this.updateSmsSubscriptions = this.updateSmsSubscriptions.bind(this);
        this.updateKakaoSubscriptions = this.updateKakaoSubscriptions.bind(this);
        this.resetUser = this.resetUser.bind(this);
        this.variation = this.variation.bind(this);
        this.variationDetail = this.variationDetail.bind(this);
        this.isFeatureOn = this.isFeatureOn.bind(this);
        this.featureFlagDetail = this.featureFlagDetail.bind(this);
        this.track = this.track.bind(this);
        this.trackPageView = this.trackPageView.bind(this);
        this.remoteConfig = this.remoteConfig.bind(this);
        this.onReady = this.onReady.bind(this);
        this.onInitialized = this.onInitialized.bind(this);
        this.showUserExplorer = this.showUserExplorer.bind(this);
        this.hideUserExplorer = this.hideUserExplorer.bind(this);
        this.fetch = this.fetch.bind(this);
        this.close = this.close.bind(this);
        this.setInAppMessageListener = this.setInAppMessageListener.bind(this);
        this.getExperiment = this.getExperiment.bind(this);
        this.setPhoneNumber = this.setPhoneNumber.bind(this);
        this.unsetPhoneNumber = this.unsetPhoneNumber.bind(this);
        this.getDisplayedInAppMessageView = this.getDisplayedInAppMessageView.bind(this);
        this.initialization = this.initialize();
    }
    HackleClientImpl.prototype.initialize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        log$8.debug("HackleClient initializing");
                        return [4 /*yield*/, this.synchronizer.sync()];
                    case 1:
                        _a.sent();
                        log$8.debug("HackleClient initialized");
                        return [3 /*break*/, 4];
                    case 2:
                        e_1 = _a.sent();
                        log$8.error("HackleClient initialize failed: ".concat(e_1));
                        throw e_1;
                    case 3:
                        this.initialized = true;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HackleClientImpl.prototype.getSessionId = function () {
        return this.sessionManager.sessionId;
    };
    HackleClientImpl.prototype.getUser = function () {
        return this.userManager.currentUser;
    };
    HackleClientImpl.prototype.setUser = function (user) {
        try {
            var sanitizedUser = sanitizeUser(user);
            if (!sanitizedUser) {
                log$8.warn("invalid user");
                return Promise.resolve();
            }
            var updated = this.userManager.setUser(sanitizedUser);
            return this.userManager.syncIfNeeded(updated).catch(function () { return undefined; });
        }
        catch (e) {
            log$8.error("Unexpected exception while set user: ".concat(e));
            return Promise.resolve();
        }
    };
    HackleClientImpl.prototype.setUserId = function (userId) {
        try {
            var updated = void 0;
            if (ObjectUtil.isNullOrUndefined(userId)) {
                updated = this.userManager.setUserId(undefined);
            }
            else {
                var sanitizedUserId = IdentifierUtil.sanitizeValue(userId);
                if (!sanitizedUserId) {
                    log$8.warn("Invalid userId. [userId=".concat(userId, "]"));
                    return Promise.resolve();
                }
                updated = this.userManager.setUserId(sanitizedUserId);
            }
            return this.userManager.syncIfNeeded(updated).catch(function () { return undefined; });
        }
        catch (e) {
            log$8.error("Unexpected exception while set userId: ".concat(e));
            return Promise.resolve();
        }
    };
    HackleClientImpl.prototype.setDeviceId = function (deviceId) {
        try {
            var sanitizedDeviceId = IdentifierUtil.sanitizeValue(deviceId);
            if (!sanitizedDeviceId) {
                log$8.warn("Invalid deviceId. [deviceId=".concat(deviceId, "]"));
                return Promise.resolve();
            }
            var updated = this.userManager.setDeviceId(sanitizedDeviceId);
            return this.userManager.syncIfNeeded(updated).catch(function () { return undefined; });
        }
        catch (e) {
            log$8.error("Unexpected exception while set deviceId: ".concat(e));
            return Promise.resolve();
        }
    };
    HackleClientImpl.prototype.setUserProperty = function (key, value) {
        var operations = new PropertyOperationsBuilder().set(key, value).build();
        return this.updateUserProperties(operations);
    };
    HackleClientImpl.prototype.setUserProperties = function (properties) {
        try {
            var sanitizedProperties = PropertyUtil.sanitize(properties);
            var operations_1 = new PropertyOperationsBuilder();
            Object.entries(sanitizedProperties).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                operations_1.set(key, value);
            });
            return this.updateUserProperties(operations_1.build());
        }
        catch (e) {
            log$8.error("Unexpected exception while set userProperties: ".concat(e));
            return Promise.resolve();
        }
    };
    HackleClientImpl.prototype.updateUserProperties = function (operations) {
        try {
            var event_1 = operations.toEvent();
            this.track(event_1);
            this.userManager.updateUserProperties(operations);
            this.core.flush(false);
            return Promise.resolve();
        }
        catch (e) {
            log$8.error("Unexpected exception while update userProperties: ".concat(e));
            return Promise.resolve();
        }
    };
    HackleClientImpl.prototype.updatePushSubscriptions = function (operations) {
        try {
            var event_2 = operations.toEvent("$push_subscriptions");
            this.track(event_2);
            this.core.flush(false);
            return Promise.resolve();
        }
        catch (e) {
            log$8.error("Unexpected exception while update userProperties: ".concat(e));
            return Promise.resolve();
        }
    };
    HackleClientImpl.prototype.updateSmsSubscriptions = function (operations) {
        try {
            var event_3 = operations.toEvent("$sms_subscriptions");
            this.track(event_3);
            this.core.flush(false);
            return Promise.resolve();
        }
        catch (e) {
            log$8.error("Unexpected exception while update userProperties: ".concat(e));
            return Promise.resolve();
        }
    };
    HackleClientImpl.prototype.updateKakaoSubscriptions = function (operations) {
        try {
            var event_4 = operations.toEvent("$kakao_subscriptions");
            this.track(event_4);
            this.core.flush(false);
            return Promise.resolve();
        }
        catch (e) {
            log$8.error("Unexpected exception while update userProperties: ".concat(e));
            return Promise.resolve();
        }
    };
    HackleClientImpl.prototype.resetUser = function () {
        try {
            var updated = this.userManager.resetUser();
            var clearAllOperations = new PropertyOperationsBuilder().clearAll().build();
            this.track(clearAllOperations.toEvent());
            return this.userManager.syncIfNeeded(updated).catch(function () { return undefined; });
        }
        catch (e) {
            log$8.error("Unexpected exception while reset user: ".concat(e));
            return Promise.resolve();
        }
    };
    HackleClientImpl.prototype.setPhoneNumber = function (phoneNumber) {
        try {
            if (typeof phoneNumber !== "string") {
                log$8.error("Invalid value ".concat(phoneNumber, ": phoneNumber value type must be string."));
                return Promise.resolve();
            }
            var phoneNumberInstance = PhoneNumber.create(phoneNumber);
            var now = SystemClock.instance.currentMillis();
            this.piiEventManager.setPhoneNumber(phoneNumberInstance, now);
            this.core.flush(false);
            return Promise.resolve();
        }
        catch (e) {
            log$8.error("Unexpected exception occurred while setting phone number: ".concat(e));
            return Promise.resolve();
        }
    };
    HackleClientImpl.prototype.unsetPhoneNumber = function () {
        try {
            var now = SystemClock.instance.currentMillis();
            this.piiEventManager.unsetPhoneNumber(now);
            this.core.flush(false);
            return Promise.resolve();
        }
        catch (e) {
            log$8.error("Unexpected exception occurred while unsetting phone number: ".concat(e));
            return Promise.resolve();
        }
    };
    HackleClientImpl.prototype.variation = function (experimentKey, user, defaultVariation) {
        return this.variationDetail(experimentKey, user, defaultVariation).variation;
    };
    HackleClientImpl.prototype.variationDetail = function (experimentKey, user, defaultVariation) {
        var defaultVariationKey = defaultVariation || "A";
        var sample = TimerSample.start();
        var decision = (function (_this) {
            try {
                var hackleUser = _this.userManager.resolve(user);
                return _this.core.experiment(experimentKey, hackleUser, defaultVariationKey);
            }
            catch (e) {
                log$8.error("Unexpected exception while deciding variation for experiment[".concat(experimentKey, "]. Returning default variation[").concat(defaultVariationKey, "] : ").concat(e));
                return Decision.of(defaultVariationKey, DecisionReason.EXCEPTION);
            }
        })(this);
        DecisionMetrics.experiment(sample, experimentKey, decision);
        return decision;
    };
    HackleClientImpl.prototype.isFeatureOn = function (featureKey, user) {
        return this.featureFlagDetail(featureKey, user).isOn;
    };
    HackleClientImpl.prototype.featureFlagDetail = function (featureKey, user) {
        var sample = TimerSample.start();
        var decision = (function (_this) {
            try {
                var hackleUser = _this.userManager.resolve(user);
                return _this.core.featureFlag(featureKey, hackleUser);
            }
            catch (e) {
                log$8.error("Unexpected exception while deciding feature flag[".concat(featureKey, "]. Returning default value[false] : ").concat(e));
                return FeatureFlagDecision.off(DecisionReason.EXCEPTION);
            }
        })(this);
        DecisionMetrics.featureFlag(sample, featureKey, decision);
        return decision;
    };
    HackleClientImpl.prototype.track = function (event, user) {
        try {
            log$8.debug("track event : ".concat(JSON.stringify(event)));
            var hackleEvent = this._convertEvent(event);
            var hackleUser = this.userManager.resolve(user);
            this.core.track(hackleEvent, hackleUser);
        }
        catch (e) {
            log$8.error("Unexpected exception while tracking event: ".concat(e));
        }
    };
    HackleClientImpl.prototype.trackPageView = function (option) {
        var page = Page.createWithCurrentPage();
        this.pageEventTracker.track(page);
    };
    HackleClientImpl.prototype.remoteConfig = function (user) {
        return new HackleRemoteConfigImpl(this.core, this.userManager, user);
    };
    HackleClientImpl.prototype.onReady = function (block, timeout) {
        if (timeout === void 0) { timeout = DEFAULT_ON_READY_TIMEOUT; }
        this.onInitialized({ timeout: timeout }).finally(function () { return block(); });
    };
    HackleClientImpl.prototype.getExperiment = function (experimentKey) {
        try {
            return this.core.getExperiment(experimentKey);
        }
        catch (e) {
            log$8.error("\"Unexpected exception while get experiment[".concat(experimentKey, "]"));
            return undefined;
        }
    };
    HackleClientImpl.prototype.onInitialized = function (config) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.initialized) {
                            return [2 /*return*/, { success: true }];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Promises.timeout(this.initialization, (_a = config === null || config === void 0 ? void 0 : config.timeout) !== null && _a !== void 0 ? _a : DEFAULT_ON_READY_TIMEOUT)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, { success: true }];
                    case 3:
                        e_2 = _b.sent();
                        log$8.error("Failed to onInitialized: ".concat(e_2));
                        return [2 /*return*/, { success: false }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HackleClientImpl.prototype._convertEvent = function (event) {
        if (typeof event === "string") {
            return { key: event };
        }
        return event;
    };
    HackleClientImpl.prototype.showUserExplorer = function () {
        var _a;
        if (!((_a = this.devTools) === null || _a === void 0 ? void 0 : _a.userExplorer)) {
            log$8.error("UserExplorer is not provided");
            return;
        }
        log$8.debug("UserExplorer opened.");
        Metrics.counter("user.explorer.show", {}).increment();
        this.devTools.manager.userExplorer(this.devTools.userExplorer);
    };
    HackleClientImpl.prototype.hideUserExplorer = function () {
        if (!this.devTools) {
            log$8.warn("There is no active HackleDevtools.");
            return;
        }
        this.devTools.manager.close();
    };
    HackleClientImpl.prototype.fetch = function () {
        var _this_1 = this;
        return this.fetchThrottler.execute(function () { return _this_1.synchronizer.sync(); }, function () { return Promise.resolve(); });
    };
    HackleClientImpl.prototype.setInAppMessageListener = function (listener) {
        this.inAppMessageUi.setListener(listener);
    };
    HackleClientImpl.prototype.getDisplayedInAppMessageView = function () {
        if (!this.inAppMessageUi.currentMessageView)
            return null;
        return InAppMessageViewConverter.toPublic(this.inAppMessageUi.currentMessageView);
    };
    HackleClientImpl.prototype.close = function () {
        log$8.debug("HackleClient closing");
        this.core.close();
        this.synchronizer.close();
    };
    return HackleClientImpl;
}());

var log$7 = Logger.log;
var HackleWebAppRemoteConfig = /** @class */ (function () {
    function HackleWebAppRemoteConfig(invocationProcessor, user, browserPropertyProvider) {
        this.invocationProcessor = invocationProcessor;
        this.user = user;
        this.browserPropertyProvider = browserPropertyProvider;
    }
    HackleWebAppRemoteConfig.prototype.get = function (key, defaultValue) {
        var valueType = typeof defaultValue;
        try {
            var remoteConfigInvocation = {
                command: "remoteConfig",
                parameters: {
                    defaultValue: defaultValue,
                    key: key,
                    valueType: valueType,
                    user: this.user
                },
                browserProperties: this.browserPropertyProvider.getBrowserProperties()
            };
            var result = this.invocationProcessor.process(remoteConfigInvocation);
            if (!result) {
                throw new Error("invoke result data not exists");
            }
            switch (valueType) {
                case "number":
                    return Number(result);
                case "boolean":
                    return Boolean(result);
                default:
                    return result;
            }
        }
        catch (e) {
            log$7.error("Unexpected exception while deciding remote config parameter[".concat(key, "]. Returning default value. : ").concat(e));
            return defaultValue;
        }
    };
    return HackleWebAppRemoteConfig;
}());

var UrlUtil = /** @class */ (function () {
    function UrlUtil() {
    }
    UrlUtil.tryParse = function (value) {
        try {
            return new URL(value);
        }
        catch (e) {
            return undefined;
        }
    };
    UrlUtil.removePathnameTrailingSlash = function (url) {
        var parsedUrl = url instanceof URL ? url : UrlUtil.tryParse(url);
        if (!parsedUrl)
            return String(url);
        if (parsedUrl.pathname.endsWith("/")) {
            var SLASH_REG_EXP = /\/+$/;
            parsedUrl.pathname = parsedUrl.pathname.replace(SLASH_REG_EXP, "");
        }
        return parsedUrl.href;
    };
    UrlUtil.tryDecodeURI = function (value) {
        try {
            return decodeURI(value);
        }
        catch (e) {
            return undefined;
        }
    };
    UrlUtil.tryDecodeURIComponent = function (value) {
        try {
            return decodeURIComponent(value);
        }
        catch (e) {
            return undefined;
        }
    };
    UrlUtil.decodeURIOrOriginal = function (value) {
        try {
            return decodeURI(value);
        }
        catch (e) {
            return value;
        }
    };
    UrlUtil.decodeURIComponentOrOriginal = function (value) {
        try {
            return decodeURIComponent(value);
        }
        catch (e) {
            return value;
        }
    };
    return UrlUtil;
}());

var CookieStorage = /** @class */ (function () {
    function CookieStorage(options) {
        if (options === void 0) { options = {
            days: 0,
            isCrossSubdomain: false,
            isSecure: false
        }; }
        this.options = options;
    }
    CookieStorage.extractDomain = function (hostname) {
        var DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
        var SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
        var domain_regex = DOMAIN_MATCH_REGEX;
        var parts = hostname.split(".");
        var tld = parts[parts.length - 1];
        if (tld.length > 4 || tld === "com" || tld === "org") {
            domain_regex = SIMPLE_DOMAIN_MATCH_REGEX;
        }
        var matches = hostname.match(domain_regex);
        return matches ? matches[0] : "";
    };
    CookieStorage.prototype.getItem = function (key) {
        var _a;
        var nameEQ = key + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return (_a = UrlUtil.tryDecodeURIComponent(c.substring(nameEQ.length, c.length))) !== null && _a !== void 0 ? _a : null;
            }
        }
        return null;
    };
    CookieStorage.prototype.getAllItem = function (options) {
        var items = document.cookie.split("; ").map(function (item) { return item.split("="); });
        var prefix = options === null || options === void 0 ? void 0 : options.keyPrefix;
        if (prefix) {
            return items.filter(function (_a) {
                var key = _a[0]; _a[1];
                return key.startsWith(prefix);
            });
        }
        return items;
    };
    CookieStorage.prototype.setItem = function (key, value, options) {
        var optionsEffective = __assign(__assign({}, this.options), options);
        var cdomain = "", expires = "", secure = "", sameSite = "";
        if (optionsEffective.isCrossSubdomain) {
            var domain = CookieStorage.extractDomain(document.location.hostname);
            cdomain = domain ? "; domain=." + domain : "";
        }
        if (optionsEffective.days) {
            var date = new Date();
            date.setTime(date.getTime() + optionsEffective.days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        if (optionsEffective.sameSite) {
            sameSite = "; SameSite=".concat(optionsEffective.sameSite);
        }
        if (optionsEffective.isSecure) {
            secure += "; secure";
        }
        var new_cookie_val = key + "=" + encodeURIComponent(value) + expires + "; path=/" + cdomain + sameSite + secure;
        document.cookie = new_cookie_val;
        return new_cookie_val;
    };
    CookieStorage.prototype.removeItem = function (key, options) {
        this.setItem(key, "", __assign(__assign({}, options), { days: -1 }));
    };
    CookieStorage.prototype.getOptions = function () {
        return this.options;
    };
    CookieStorage.getInstance = function (options) {
        if (options === void 0) { options = { days: COOKIE_EXPIRE_DAYS, isCrossSubdomain: true }; }
        if (!CookieStorage.storage) {
            CookieStorage.storage = new CookieStorage(options);
        }
        return CookieStorage.storage;
    };
    return CookieStorage;
}());

var IdentifierManager = /** @class */ (function () {
    function IdentifierManager() {
    }
    IdentifierManager.prototype.initialize = function () {
        var id = CookieStorage.getInstance().getItem(COOKIE_HID_KEY);
        if (!id) {
            generateIdentifier();
        }
    };
    IdentifierManager.prototype.onLifecycleChanged = function (lifecycle, _) {
        switch (lifecycle) {
            case "hidden":
            case "pagehide":
                return removeUserId();
            case "blur":
            case "focus":
            case "locationChange":
            case "visible":
            case "pageshow":
                return;
        }
    };
    return IdentifierManager;
}());
function getUserId() {
    var cookieStorage = CookieStorage.getInstance();
    var userId = cookieStorage.getItem(COOKIE_USER_ID_KEY);
    if (userId) {
        return userId;
    }
    var id = cookieStorage.getItem(COOKIE_HID_KEY);
    if (id) {
        return id;
    }
    else {
        return generateIdentifier();
    }
}
function setUserId(userId) {
    CookieStorage.getInstance().setItem(COOKIE_USER_ID_KEY, userId);
}
function removeUserId() {
    CookieStorage.getInstance().removeItem(COOKIE_USER_ID_KEY);
}
function generateIdentifier() {
    var id = v4();
    CookieStorage.getInstance().setItem(COOKIE_HID_KEY, id);
    return id;
}

var log$6 = Logger.log;
var HackleAppMode;
(function (HackleAppMode) {
    HackleAppMode["native"] = "native";
    HackleAppMode["web_view_wrapper"] = "web_view_wrapper";
})(HackleAppMode || (HackleAppMode = {}));
function isHackleWebApp(_window) {
    if (!_window || !("_hackleApp" in _window) || _window._hackleApp === null || typeof _window._hackleApp !== "object") {
        return false;
    }
    if (!("getAppSdkKey" in _window._hackleApp) || typeof _window._hackleApp.getAppSdkKey !== "function") {
        return false;
    }
    if (!("getInvocationType" in _window._hackleApp) || typeof _window._hackleApp.getInvocationType !== "function") {
        return false;
    }
    return true;
}
var NativeAppHackleClient = /** @class */ (function () {
    function NativeAppHackleClient(invocationProcessor, browserPropertyProvider) {
        this.invocationProcessor = invocationProcessor;
        this.browserPropertyProvider = browserPropertyProvider;
        // This is to prevent the "This Binding" problem.
        this.getSessionId = this.getSessionId.bind(this);
        this.getUser = this.getUser.bind(this);
        this.setUser = this.setUser.bind(this);
        this.setUserId = this.setUserId.bind(this);
        this.setDeviceId = this.setDeviceId.bind(this);
        this.setUserProperty = this.setUserProperty.bind(this);
        this.setUserProperties = this.setUserProperties.bind(this);
        this.updateUserProperties = this.updateUserProperties.bind(this);
        this.updatePushSubscriptions = this.updatePushSubscriptions.bind(this);
        this.updateSmsSubscriptions = this.updateSmsSubscriptions.bind(this);
        this.updateKakaoSubscriptions = this.updateKakaoSubscriptions.bind(this);
        this.resetUser = this.resetUser.bind(this);
        this.variation = this.variation.bind(this);
        this.variationDetail = this.variationDetail.bind(this);
        this.isFeatureOn = this.isFeatureOn.bind(this);
        this.featureFlagDetail = this.featureFlagDetail.bind(this);
        this.track = this.track.bind(this);
        this.trackPageView = this.trackPageView.bind(this);
        this.remoteConfig = this.remoteConfig.bind(this);
        this.onReady = this.onReady.bind(this);
        this.onInitialized = this.onInitialized.bind(this);
        this.showUserExplorer = this.showUserExplorer.bind(this);
        this.hideUserExplorer = this.hideUserExplorer.bind(this);
        this.fetch = this.fetch.bind(this);
        this.close = this.close.bind(this);
        this.setInAppMessageListener = this.setInAppMessageListener.bind(this);
        this.getExperiment = this.getExperiment.bind(this);
        this.setPhoneNumber = this.setPhoneNumber.bind(this);
        this.unsetPhoneNumber = this.unsetPhoneNumber.bind(this);
        this.getDisplayedInAppMessageView = this.getDisplayedInAppMessageView.bind(this);
    }
    NativeAppHackleClient.prototype.getSessionId = function () {
        try {
            var getSessionIdInvocation = {
                command: "getSessionId",
                browserProperties: this.browserPropertyProvider.getBrowserProperties()
            };
            var result = this.invocationProcessor.process(getSessionIdInvocation);
            return result !== null && result !== void 0 ? result : getUserId();
        }
        catch (e) {
            log$6.error("Unexpected exception while get sessionId: ".concat(e));
            return getUserId();
        }
    };
    NativeAppHackleClient.prototype.getUser = function () {
        var _a;
        try {
            var getUserInvocation = {
                command: "getUser",
                browserProperties: this.browserPropertyProvider.getBrowserProperties()
            };
            var result = this.invocationProcessor.process(getUserInvocation);
            return (_a = sanitizeUser(result)) !== null && _a !== void 0 ? _a : this.defaultUser();
        }
        catch (e) {
            log$6.error("Unexpected exception while get user: ".concat(e));
            return this.defaultUser();
        }
    };
    NativeAppHackleClient.prototype.setUser = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var sanitizedUser, setUserInvocation;
            return __generator(this, function (_a) {
                try {
                    sanitizedUser = sanitizeUser(user);
                    if (!sanitizedUser) {
                        log$6.warn("invalid user");
                        return [2 /*return*/];
                    }
                    setUserInvocation = {
                        command: "setUser",
                        parameters: { user: sanitizedUser },
                        browserProperties: this.browserPropertyProvider.getBrowserProperties()
                    };
                    this.invocationProcessor.process(setUserInvocation);
                }
                catch (e) {
                    log$6.error("Unexpected exception while set user: ".concat(e));
                }
                return [2 /*return*/];
            });
        });
    };
    NativeAppHackleClient.prototype.setUserId = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            var nextUserId, setUserIdInvocation;
            return __generator(this, function (_a) {
                try {
                    nextUserId = void 0;
                    // undefined value is ignored when JSON.stringify(), so we need to convert it to null
                    if (ObjectUtil.isNullOrUndefined(userId)) {
                        nextUserId = null;
                    }
                    else {
                        nextUserId = IdentifierUtil.sanitizeValue(userId);
                        if (!nextUserId) {
                            log$6.warn("Invalid userId. [userId=".concat(userId, "]"));
                            return [2 /*return*/];
                        }
                    }
                    setUserIdInvocation = {
                        command: "setUserId",
                        parameters: { userId: nextUserId },
                        browserProperties: this.browserPropertyProvider.getBrowserProperties()
                    };
                    this.invocationProcessor.process(setUserIdInvocation);
                }
                catch (e) {
                    log$6.error("Unexpected exception while set userId: ".concat(e));
                }
                return [2 /*return*/];
            });
        });
    };
    NativeAppHackleClient.prototype.setDeviceId = function (deviceId) {
        return __awaiter(this, void 0, void 0, function () {
            var sanitizedDeviceId, setDeviceIdInvocation;
            return __generator(this, function (_a) {
                try {
                    sanitizedDeviceId = IdentifierUtil.sanitizeValue(deviceId);
                    if (!sanitizedDeviceId) {
                        log$6.warn("Invalid deviceId. [deviceId=".concat(deviceId, "]"));
                        return [2 /*return*/];
                    }
                    setDeviceIdInvocation = {
                        command: "setDeviceId",
                        parameters: { deviceId: sanitizedDeviceId },
                        browserProperties: this.browserPropertyProvider.getBrowserProperties()
                    };
                    this.invocationProcessor.process(setDeviceIdInvocation);
                }
                catch (e) {
                    log$6.error("Unexpected exception while set deviceId: ".concat(e));
                }
                return [2 /*return*/];
            });
        });
    };
    NativeAppHackleClient.prototype.setUserProperty = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            var setUserPropertyInvocation;
            return __generator(this, function (_a) {
                try {
                    setUserPropertyInvocation = {
                        command: "setUserProperty",
                        parameters: { key: key, value: value },
                        browserProperties: this.browserPropertyProvider.getBrowserProperties()
                    };
                    this.invocationProcessor.process(setUserPropertyInvocation);
                }
                catch (e) {
                    log$6.error("Unexpected exception while set userProperty: ".concat(e));
                }
                return [2 /*return*/];
            });
        });
    };
    NativeAppHackleClient.prototype.setUserProperties = function (properties) {
        return __awaiter(this, void 0, void 0, function () {
            var sanitizedProperties, operations_1;
            return __generator(this, function (_a) {
                try {
                    sanitizedProperties = PropertyUtil.sanitize(properties);
                    operations_1 = new PropertyOperationsBuilder();
                    Object.entries(sanitizedProperties).forEach(function (_a) {
                        var key = _a[0], value = _a[1];
                        operations_1.set(key, value);
                    });
                    this.updateUserProperties(operations_1.build());
                }
                catch (e) {
                    log$6.error("Unexpected exception while set userProperties: ".concat(e));
                }
                return [2 /*return*/];
            });
        });
    };
    NativeAppHackleClient.prototype.updateUserProperties = function (operations) {
        return __awaiter(this, void 0, void 0, function () {
            var updateUserPropertiesInvocation;
            return __generator(this, function (_a) {
                try {
                    updateUserPropertiesInvocation = {
                        command: "updateUserProperties",
                        parameters: { operations: operations.toRecord() },
                        browserProperties: this.browserPropertyProvider.getBrowserProperties()
                    };
                    this.invocationProcessor.process(updateUserPropertiesInvocation);
                }
                catch (e) {
                    log$6.error("Unexpected exception while update userProperties: ".concat(e));
                }
                return [2 /*return*/];
            });
        });
    };
    NativeAppHackleClient.prototype.updatePushSubscriptions = function (operations) {
        return __awaiter(this, void 0, void 0, function () {
            var updatePushSubscriptionsInvocation;
            return __generator(this, function (_a) {
                try {
                    updatePushSubscriptionsInvocation = {
                        command: "updatePushSubscriptions",
                        parameters: { operations: operations.toRecord() },
                        browserProperties: this.browserPropertyProvider.getBrowserProperties()
                    };
                    this.invocationProcessor.process(updatePushSubscriptionsInvocation);
                }
                catch (e) {
                    log$6.error("Unexpected exception while update push subscriptions: ".concat(e));
                }
                return [2 /*return*/];
            });
        });
    };
    NativeAppHackleClient.prototype.updateSmsSubscriptions = function (operations) {
        return __awaiter(this, void 0, void 0, function () {
            var updateSmsSubscriptionsInvocation;
            return __generator(this, function (_a) {
                try {
                    updateSmsSubscriptionsInvocation = {
                        command: "updateSmsSubscriptions",
                        parameters: { operations: operations.toRecord() },
                        browserProperties: this.browserPropertyProvider.getBrowserProperties()
                    };
                    this.invocationProcessor.process(updateSmsSubscriptionsInvocation);
                }
                catch (e) {
                    log$6.error("Unexpected exception while update sms subscriptions: ".concat(e));
                }
                return [2 /*return*/];
            });
        });
    };
    NativeAppHackleClient.prototype.updateKakaoSubscriptions = function (operations) {
        return __awaiter(this, void 0, void 0, function () {
            var updateKakaoSubscriptionsInvocation;
            return __generator(this, function (_a) {
                try {
                    updateKakaoSubscriptionsInvocation = {
                        command: "updateKakaoSubscriptions",
                        parameters: { operations: operations.toRecord() },
                        browserProperties: this.browserPropertyProvider.getBrowserProperties()
                    };
                    this.invocationProcessor.process(updateKakaoSubscriptionsInvocation);
                }
                catch (e) {
                    log$6.error("Unexpected exception while update Kakao subscriptions: ".concat(e));
                }
                return [2 /*return*/];
            });
        });
    };
    NativeAppHackleClient.prototype.resetUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resetUserInvocation;
            return __generator(this, function (_a) {
                try {
                    resetUserInvocation = {
                        command: "resetUser",
                        browserProperties: this.browserPropertyProvider.getBrowserProperties()
                    };
                    this.invocationProcessor.process(resetUserInvocation);
                }
                catch (e) {
                    log$6.error("Unexpected exception while reset user: ".concat(e));
                }
                return [2 /*return*/];
            });
        });
    };
    NativeAppHackleClient.prototype.setPhoneNumber = function (phoneNumber) {
        return __awaiter(this, void 0, void 0, function () {
            var invocation;
            return __generator(this, function (_a) {
                try {
                    if (typeof phoneNumber !== "string") {
                        log$6.error("Invalid type ".concat(phoneNumber, ": phoneNumber value must be string."));
                        return [2 /*return*/, Promise.resolve()];
                    }
                    invocation = {
                        command: "setPhoneNumber",
                        parameters: { phoneNumber: phoneNumber },
                        browserProperties: this.browserPropertyProvider.getBrowserProperties()
                    };
                    this.invocationProcessor.process(invocation);
                }
                catch (e) {
                    log$6.error("Unexpected exception occurred while setting phone number: ".concat(e));
                }
                return [2 /*return*/];
            });
        });
    };
    NativeAppHackleClient.prototype.unsetPhoneNumber = function () {
        return __awaiter(this, void 0, void 0, function () {
            var invocation;
            return __generator(this, function (_a) {
                try {
                    invocation = {
                        command: "unsetPhoneNumber",
                        browserProperties: this.browserPropertyProvider.getBrowserProperties()
                    };
                    this.invocationProcessor.process(invocation);
                }
                catch (e) {
                    log$6.error("Unexpected exception occurred while unsetting phone number: ".concat(e));
                }
                return [2 /*return*/];
            });
        });
    };
    NativeAppHackleClient.prototype.variation = function (experimentKey, user, defaultVariation) {
        if (defaultVariation === void 0) { defaultVariation = "A"; }
        try {
            var variationInvocation = {
                command: "variation",
                parameters: { experimentKey: experimentKey, defaultVariation: defaultVariation, user: this.convertUser(user) },
                browserProperties: this.browserPropertyProvider.getBrowserProperties()
            };
            var result = this.invocationProcessor.process(variationInvocation);
            if (!result) {
                throw new Error("invoke result data not exists");
            }
            return result;
        }
        catch (e) {
            log$6.error("Unexpected exception while deciding variation for experiment[".concat(experimentKey, "]. Returning default variation[").concat(defaultVariation, "] : ").concat(e));
            return defaultVariation;
        }
    };
    NativeAppHackleClient.prototype.variationDetail = function (experimentKey, user, defaultVariation) {
        var _a;
        if (defaultVariation === void 0) { defaultVariation = "A"; }
        try {
            var variationDetailInvocation = {
                command: "variationDetail",
                parameters: { experimentKey: experimentKey, defaultVariation: defaultVariation, user: this.convertUser(user) },
                browserProperties: this.browserPropertyProvider.getBrowserProperties()
            };
            var result = this.invocationProcessor.process(variationDetailInvocation);
            if (result === null) {
                throw new Error("invoke result data not exists");
            }
            return Decision.of(result.variation, result.reason, new DefaultParameterConfig((_a = result.config.parameters) !== null && _a !== void 0 ? _a : {}));
        }
        catch (e) {
            log$6.error("Unexpected exception while deciding variation for experiment[".concat(experimentKey, "]. Returning default variation[").concat(defaultVariation, "] : ").concat(e));
            return Decision.of(defaultVariation, DecisionReason.EXCEPTION);
        }
    };
    NativeAppHackleClient.prototype.isFeatureOn = function (featureKey, user) {
        try {
            var isFeatureOnInvocation = {
                command: "isFeatureOn",
                parameters: { featureKey: featureKey, user: this.convertUser(user) },
                browserProperties: this.browserPropertyProvider.getBrowserProperties()
            };
            var result = this.invocationProcessor.process(isFeatureOnInvocation);
            if (result === null) {
                throw new Error("invoke result data not exists");
            }
            return Boolean(result);
        }
        catch (e) {
            log$6.error("Unexpected exception while deciding feature flag[".concat(featureKey, "]. Returning default value[false] : ").concat(e));
            return false;
        }
    };
    NativeAppHackleClient.prototype.featureFlagDetail = function (featureKey, user) {
        var _a;
        try {
            var featureFlagDetailInvocation = {
                command: "featureFlagDetail",
                parameters: { featureKey: featureKey, user: this.convertUser(user) },
                browserProperties: this.browserPropertyProvider.getBrowserProperties()
            };
            var result = this.invocationProcessor.process(featureFlagDetailInvocation);
            if (result === null) {
                throw new Error("invoke result data not exists");
            }
            return new FeatureFlagDecision(result.isOn, result.reason, new DefaultParameterConfig((_a = result.config.parameters) !== null && _a !== void 0 ? _a : {}), undefined);
        }
        catch (e) {
            log$6.error("Unexpected exception while deciding feature flag[".concat(featureKey, "]. Returning default value[false] : ").concat(e));
            return FeatureFlagDecision.off(DecisionReason.EXCEPTION);
        }
    };
    NativeAppHackleClient.prototype.track = function (event, user) {
        try {
            var trackInvocation = {
                command: "track",
                parameters: { event: this.convertEvent(event), user: this.convertUser(user) },
                browserProperties: this.browserPropertyProvider.getBrowserProperties()
            };
            this.invocationProcessor.process(trackInvocation);
        }
        catch (e) {
            log$6.error("Unexpected exception while tracking event: ".concat(e));
        }
    };
    NativeAppHackleClient.prototype.trackPageView = function (option) {
        log$6.info("Web to app integration feature is not support 'trackPageView' method");
    };
    NativeAppHackleClient.prototype.remoteConfig = function (user) {
        return new HackleWebAppRemoteConfig(this.invocationProcessor, this.convertUser(user), this.browserPropertyProvider);
    };
    NativeAppHackleClient.prototype.onReady = function (block, timeout) {
        block();
    };
    NativeAppHackleClient.prototype.showUserExplorer = function () {
        try {
            var showUserExplorerInvocation = {
                command: "showUserExplorer",
                browserProperties: this.browserPropertyProvider.getBrowserProperties()
            };
            this.invocationProcessor.process(showUserExplorerInvocation);
        }
        catch (e) {
            log$6.error("Unexpected exception while show userExplorer: ".concat(e));
        }
    };
    NativeAppHackleClient.prototype.hideUserExplorer = function () {
        try {
            var hideUserExplorerInvocation = {
                command: "hideUserExplorer",
                browserProperties: this.browserPropertyProvider.getBrowserProperties()
            };
            this.invocationProcessor.process(hideUserExplorerInvocation);
        }
        catch (e) {
            log$6.error("Unexpected exception while hide userExplorer: ".concat(e));
        }
    };
    NativeAppHackleClient.prototype.setInAppMessageListener = function (_listener) {
        log$6.info("Web to app integration feature is not support 'setInAppMessageListener' method");
    };
    NativeAppHackleClient.prototype.fetch = function () {
        return Promise.resolve();
    };
    NativeAppHackleClient.prototype.onInitialized = function (config) {
        return Promise.resolve({ success: true });
    };
    NativeAppHackleClient.prototype.close = function () {
        log$6.info("Web to app integration feature is not support 'close' method");
    };
    NativeAppHackleClient.prototype.getExperiment = function (experimentKey) {
        log$6.info("Web to app integration feature is not support 'getExperiment' method");
        return undefined;
    };
    NativeAppHackleClient.prototype.convertEvent = function (event) {
        if (typeof event === "string") {
            return { key: event };
        }
        return event;
    };
    NativeAppHackleClient.prototype.convertUser = function (user) {
        var _a;
        if (typeof user === "string")
            return user;
        if (!user)
            return undefined;
        return (_a = sanitizeUser(user)) !== null && _a !== void 0 ? _a : undefined;
    };
    NativeAppHackleClient.prototype.defaultUser = function () {
        return {
            deviceId: getUserId()
        };
    };
    NativeAppHackleClient.prototype.getDisplayedInAppMessageView = function () {
        log$6.info("Web to app integration feature is not support 'getDisplayedInAppMessageView' method");
        return null;
    };
    return NativeAppHackleClient;
}());
var WebViewHackleClient = /** @class */ (function () {
    function WebViewHackleClient(browser, app) {
        this.browser = browser;
        this.app = app;
        this.getSessionId = this.getSessionId.bind(this);
        this.getUser = this.getUser.bind(this);
        this.setUser = this.setUser.bind(this);
        this.setUserId = this.setUserId.bind(this);
        this.setDeviceId = this.setDeviceId.bind(this);
        this.setUserProperty = this.setUserProperty.bind(this);
        this.setUserProperties = this.setUserProperties.bind(this);
        this.updateUserProperties = this.updateUserProperties.bind(this);
        this.updatePushSubscriptions = this.updatePushSubscriptions.bind(this);
        this.updateSmsSubscriptions = this.updateSmsSubscriptions.bind(this);
        this.updateKakaoSubscriptions = this.updateKakaoSubscriptions.bind(this);
        this.resetUser = this.resetUser.bind(this);
        this.variation = this.variation.bind(this);
        this.variationDetail = this.variationDetail.bind(this);
        this.isFeatureOn = this.isFeatureOn.bind(this);
        this.featureFlagDetail = this.featureFlagDetail.bind(this);
        this.track = this.track.bind(this);
        this.trackPageView = this.trackPageView.bind(this);
        this.remoteConfig = this.remoteConfig.bind(this);
        this.onReady = this.onReady.bind(this);
        this.onInitialized = this.onInitialized.bind(this);
        this.showUserExplorer = this.showUserExplorer.bind(this);
        this.hideUserExplorer = this.hideUserExplorer.bind(this);
        this.fetch = this.fetch.bind(this);
        this.close = this.close.bind(this);
        this.setInAppMessageListener = this.setInAppMessageListener.bind(this);
        this.getExperiment = this.getExperiment.bind(this);
        this.setPhoneNumber = this.setPhoneNumber.bind(this);
        this.unsetPhoneNumber = this.unsetPhoneNumber.bind(this);
        this.getDisplayedInAppMessageView = this.getDisplayedInAppMessageView.bind(this);
    }
    WebViewHackleClient.prototype.getSessionId = function () {
        return this.browser.getSessionId();
    };
    WebViewHackleClient.prototype.getUser = function () {
        return this.browser.getUser();
    };
    WebViewHackleClient.prototype.syncUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = this.browser.getUser();
                        return [4 /*yield*/, this.app.setUser(user)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebViewHackleClient.prototype.setUser = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.browser.setUser(user)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.syncUser()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebViewHackleClient.prototype.setUserId = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.browser.setUserId(userId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.syncUser()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebViewHackleClient.prototype.setDeviceId = function (deviceId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.browser.setDeviceId(deviceId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.syncUser()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebViewHackleClient.prototype.setUserProperty = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.browser.setUserProperty(key, value)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.syncUser()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebViewHackleClient.prototype.setUserProperties = function (properties) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.browser.setUserProperties(properties)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.syncUser()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebViewHackleClient.prototype.updateUserProperties = function (operations) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.browser.updateUserProperties(operations)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.syncUser()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebViewHackleClient.prototype.updatePushSubscriptions = function (operations) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.browser.updatePushSubscriptions(operations)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebViewHackleClient.prototype.updateSmsSubscriptions = function (operations) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.browser.updateSmsSubscriptions(operations)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebViewHackleClient.prototype.updateKakaoSubscriptions = function (operations) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.browser.updateKakaoSubscriptions(operations)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebViewHackleClient.prototype.resetUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.browser.resetUser()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.syncUser()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebViewHackleClient.prototype.setPhoneNumber = function (phoneNumber) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.browser.setPhoneNumber(phoneNumber)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.syncUser()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebViewHackleClient.prototype.unsetPhoneNumber = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.browser.unsetPhoneNumber()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.syncUser()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebViewHackleClient.prototype.variation = function (experimentKey, user, defaultVariation) {
        if (defaultVariation === void 0) { defaultVariation = "A"; }
        return this.browser.variation(experimentKey, user, defaultVariation);
    };
    WebViewHackleClient.prototype.variationDetail = function (experimentKey, user, defaultVariation) {
        if (defaultVariation === void 0) { defaultVariation = "A"; }
        return this.browser.variationDetail(experimentKey, user, defaultVariation);
    };
    WebViewHackleClient.prototype.isFeatureOn = function (featureKey, user) {
        return this.browser.isFeatureOn(featureKey, user);
    };
    WebViewHackleClient.prototype.featureFlagDetail = function (featureKey, user) {
        return this.browser.featureFlagDetail(featureKey, user);
    };
    WebViewHackleClient.prototype.track = function (event, user) {
        return this.browser.track(event, user);
    };
    WebViewHackleClient.prototype.trackPageView = function (option) {
        return this.browser.trackPageView(option);
    };
    WebViewHackleClient.prototype.remoteConfig = function (user) {
        return this.browser.remoteConfig(user);
    };
    WebViewHackleClient.prototype.onReady = function (block, timeout) {
        this.browser.onReady(block, timeout);
    };
    WebViewHackleClient.prototype.showUserExplorer = function () {
        this.browser.showUserExplorer();
    };
    WebViewHackleClient.prototype.hideUserExplorer = function () {
        this.browser.hideUserExplorer();
    };
    WebViewHackleClient.prototype.fetch = function () {
        return this.browser.fetch();
    };
    WebViewHackleClient.prototype.onInitialized = function (config) {
        return this.browser.onInitialized(config);
    };
    WebViewHackleClient.prototype.close = function () {
        this.browser.close();
    };
    WebViewHackleClient.prototype.setInAppMessageListener = function (listener) {
        this.browser.setInAppMessageListener(listener);
    };
    WebViewHackleClient.prototype.getExperiment = function (experimentKey) {
        return this.browser.getExperiment(experimentKey);
    };
    WebViewHackleClient.prototype.getDisplayedInAppMessageView = function () {
        return this.browser.getDisplayedInAppMessageView();
    };
    return WebViewHackleClient;
}());

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var promise$5 = {exports: {}};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$n =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$p = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$o = fails$p;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$o(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$n = fails$p;

var functionBindNative = !fails$n(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$k = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$k.bind(call$k) : function () {
  return call$k.apply(call$k, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$6 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var bind$d = FunctionPrototype$2.bind;
var call$j = FunctionPrototype$2.call;
var uncurryThis$q = NATIVE_BIND$2 && bind$d.bind(call$j, call$j);

var functionUncurryThis = NATIVE_BIND$2 ? function (fn) {
  return fn && uncurryThis$q(fn);
} : function (fn) {
  return fn && function () {
    return call$j.apply(fn, arguments);
  };
};

var uncurryThis$p = functionUncurryThis;

var toString$7 = uncurryThis$p({}.toString);
var stringSlice$1 = uncurryThis$p(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$1(toString$7(it), 8, -1);
};

var uncurryThis$o = functionUncurryThis;
var fails$m = fails$p;
var classof$9 = classofRaw$1;

var $Object$4 = Object;
var split = uncurryThis$o(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$m(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$9(it) == 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

var $TypeError$e = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$3 = function (it) {
  if (it == undefined) throw $TypeError$e("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$6 = indexedObject;
var requireObjectCoercible$2 = requireObjectCoercible$3;

var toIndexedObject$d = function (it) {
  return IndexedObject$6(requireObjectCoercible$2(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$o = function (argument) {
  return typeof argument == 'function';
};

var isCallable$n = isCallable$o;

var isObject$f = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$n(it);
};

var global$m = global$n;
var isCallable$m = isCallable$o;

var aFunction = function (argument) {
  return isCallable$m(argument) ? argument : undefined;
};

var getBuiltIn$g = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$m[namespace]) : global$m[namespace] && global$m[namespace][method];
};

var uncurryThis$n = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$n({}.isPrototypeOf);

var getBuiltIn$f = getBuiltIn$g;

var engineUserAgent = getBuiltIn$f('navigator', 'userAgent') || '';

var global$l = global$n;
var userAgent$5 = engineUserAgent;

var process$3 = global$l.process;
var Deno$1 = global$l.Deno;
var versions = process$3 && process$3.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$5) {
  match = userAgent$5.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$5.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es-x/no-symbol -- required for testing */

var V8_VERSION$3 = engineV8Version;
var fails$l = fails$p;

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$l(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$3 && V8_VERSION$3 < 41;
});

/* eslint-disable es-x/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$e = getBuiltIn$g;
var isCallable$l = isCallable$o;
var isPrototypeOf$3 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$e('Symbol');
  return isCallable$l($Symbol) && isPrototypeOf$3($Symbol.prototype, $Object$3(it));
};

var $String$3 = String;

var tryToString$5 = function (argument) {
  try {
    return $String$3(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$k = isCallable$o;
var tryToString$4 = tryToString$5;

var $TypeError$d = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$g = function (argument) {
  if (isCallable$k(argument)) return argument;
  throw $TypeError$d(tryToString$4(argument) + ' is not a function');
};

var aCallable$f = aCallable$g;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$7 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable$f(func);
};

var call$i = functionCall;
var isCallable$j = isCallable$o;
var isObject$e = isObject$f;

var $TypeError$c = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$j(fn = input.toString) && !isObject$e(val = call$i(fn, input))) return val;
  if (isCallable$j(fn = input.valueOf) && !isObject$e(val = call$i(fn, input))) return val;
  if (pref !== 'string' && isCallable$j(fn = input.toString) && !isObject$e(val = call$i(fn, input))) return val;
  throw $TypeError$c("Can't convert object to primitive value");
};

var shared$4 = {exports: {}};

var global$k = global$n;

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$7 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$7(global$k, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$k[key] = value;
  } return value;
};

var global$j = global$n;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$j[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.24.1',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.24.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$1 = requireObjectCoercible$3;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$m = function (argument) {
  return $Object$2(requireObjectCoercible$1(argument));
};

var uncurryThis$m = functionUncurryThis;
var toObject$l = toObject$m;

var hasOwnProperty = uncurryThis$m({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$l(it), key);
};

var uncurryThis$l = functionUncurryThis;

var id$1 = 0;
var postfix = Math.random();
var toString$6 = uncurryThis$l(1.0.toString);

var uid$3 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$6(++id$1 + postfix, 36);
};

var global$i = global$n;
var shared$3 = shared$4.exports;
var hasOwn$a = hasOwnProperty_1;
var uid$2 = uid$3;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$3('wks');
var Symbol$1 = global$i.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$2;

var wellKnownSymbol$m = function (name) {
  if (!hasOwn$a(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn$a(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var call$h = functionCall;
var isObject$d = isObject$f;
var isSymbol$1 = isSymbol$2;
var getMethod$6 = getMethod$7;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$l = wellKnownSymbol$m;

var $TypeError$b = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$l('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$d(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$6(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$h(exoticToPrim, input, pref);
    if (!isObject$d(result) || isSymbol$1(result)) return result;
    throw $TypeError$b("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$4 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$h = global$n;
var isObject$c = isObject$f;

var document$3 = global$h.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$c(document$3) && isObject$c(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$c = descriptors;
var fails$k = fails$p;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$c && !fails$k(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$b = descriptors;
var call$g = functionCall;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var createPropertyDescriptor$5 = createPropertyDescriptor$6;
var toIndexedObject$c = toIndexedObject$d;
var toPropertyKey$3 = toPropertyKey$4;
var hasOwn$9 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$b ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$c(O);
  P = toPropertyKey$3(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$9(O, P)) return createPropertyDescriptor$5(!call$g(propertyIsEnumerableModule.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$a = descriptors;
var fails$j = fails$p;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$a && fails$j(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var isObject$b = isObject$f;

var $String$2 = String;
var $TypeError$a = TypeError;

// `Assert: Type(argument) is Object`
var anObject$f = function (argument) {
  if (isObject$b(argument)) return argument;
  throw $TypeError$a($String$2(argument) + ' is not an object');
};

var DESCRIPTORS$9 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$e = anObject$f;
var toPropertyKey$2 = toPropertyKey$4;

var $TypeError$9 = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$9 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$e(O);
  P = toPropertyKey$2(P);
  anObject$e(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$e(O);
  P = toPropertyKey$2(P);
  anObject$e(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$9('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$8 = descriptors;
var definePropertyModule$5 = objectDefineProperty;
var createPropertyDescriptor$4 = createPropertyDescriptor$6;

var createNonEnumerableProperty$6 = DESCRIPTORS$8 ? function (object, key, value) {
  return definePropertyModule$5.f(object, key, createPropertyDescriptor$4(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$7 = descriptors;
var hasOwn$8 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$7 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$8(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$7 || (DESCRIPTORS$7 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$k = functionUncurryThis;
var isCallable$i = isCallable$o;
var store$1 = sharedStore;

var functionToString = uncurryThis$k(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$i(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$4 = store$1.inspectSource;

var global$g = global$n;
var isCallable$h = isCallable$o;
var inspectSource$3 = inspectSource$4;

var WeakMap$2 = global$g.WeakMap;

var nativeWeakMap = isCallable$h(WeakMap$2) && /native code/.test(inspectSource$3(WeakMap$2));

var shared$2 = shared$4.exports;
var uid$1 = uid$3;

var keys = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid$1(key));
};

var hiddenKeys$5 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$f = global$n;
var uncurryThis$j = functionUncurryThis;
var isObject$a = isObject$f;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$6;
var hasOwn$7 = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$4 = hiddenKeys$5;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$2 = global$f.TypeError;
var WeakMap$1 = global$f.WeakMap;
var set$1, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$a(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$2('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap$1());
  var wmget = uncurryThis$j(store.get);
  var wmhas = uncurryThis$j(store.has);
  var wmset = uncurryThis$j(store.set);
  set$1 = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$4[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$7(it, STATE)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$5(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$7(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$7(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var fails$i = fails$p;
var isCallable$g = isCallable$o;
var hasOwn$6 = hasOwnProperty_1;
var DESCRIPTORS$6 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$4;
var InternalStateModule$5 = internalState;

var enforceInternalState = InternalStateModule$5.enforce;
var getInternalState$3 = InternalStateModule$5.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS$6 && !fails$i(function () {
  return defineProperty$6(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$6(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$6) defineProperty$6(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$6(options, 'arity') && value.length !== options.arity) {
    defineProperty$6(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$6(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$6) defineProperty$6(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$6(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$g(this) && getInternalState$3(this).source || inspectSource$2(this);
}, 'toString');

var isCallable$f = isCallable$o;
var definePropertyModule$4 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltIn$3.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$a = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$f(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$4.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$1 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$9 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$8 = toIntegerOrInfinity$9;

var max$4 = Math.max;
var min$5 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$7 = function (index, length) {
  var integer = toIntegerOrInfinity$8(index);
  return integer < 0 ? max$4(integer + length, 0) : min$5(integer, length);
};

var toIntegerOrInfinity$7 = toIntegerOrInfinity$9;

var min$4 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min$4(toIntegerOrInfinity$7(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$t = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$b = toIndexedObject$d;
var toAbsoluteIndex$6 = toAbsoluteIndex$7;
var lengthOfArrayLike$s = lengthOfArrayLike$t;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$5 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$b($this);
    var length = lengthOfArrayLike$s(O);
    var index = toAbsoluteIndex$6(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$5(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$5(false)
};

var uncurryThis$i = functionUncurryThis;
var hasOwn$5 = hasOwnProperty_1;
var toIndexedObject$a = toIndexedObject$d;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$3 = hiddenKeys$5;

var push$6 = uncurryThis$i([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$a(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$5(hiddenKeys$3, key) && hasOwn$5(O, key) && push$6(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$5(O, key = names[i++])) {
    ~indexOf(result, key) || push$6(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$2 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$2);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$d = getBuiltIn$g;
var uncurryThis$h = functionUncurryThis;
var getOwnPropertyNamesModule$1 = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var anObject$d = anObject$f;

var concat = uncurryThis$h([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$d('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule$1.f(anObject$d(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$4 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$3 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$3.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$4(target, key) && !(exceptions && hasOwn$4(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$h = fails$p;
var isCallable$e = isCallable$o;

var replacement = /#|\.prototype\./;

var isForced$3 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$e(detection) ? fails$h(detection)
    : !!detection;
};

var normalize = isForced$3.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$3.data = {};
var NATIVE = isForced$3.NATIVE = 'N';
var POLYFILL = isForced$3.POLYFILL = 'P';

var isForced_1 = isForced$3;

var global$e = global$n;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$6;
var defineBuiltIn$9 = defineBuiltIn$a;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$2 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$e;
  } else if (STATIC) {
    target = global$e[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$e[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$2(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$4(sourceProperty, 'sham', true);
    }
    defineBuiltIn$9(target, key, sourceProperty, options);
  }
};

var fails$g = fails$p;

var correctPrototypeGetter = !fails$g(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$3 = hasOwnProperty_1;
var isCallable$d = isCallable$o;
var toObject$k = toObject$m;
var sharedKey$1 = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO$1 = sharedKey$1('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject$k(O);
  if (hasOwn$3(object, IE_PROTO$1)) return object[IE_PROTO$1];
  var constructor = object.constructor;
  if (isCallable$d(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype : null;
};

var isCallable$c = isCallable$o;

var $String$1 = String;
var $TypeError$8 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$c(argument)) return argument;
  throw $TypeError$8("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThis$g = functionUncurryThis;
var anObject$c = anObject$f;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis$g(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$c(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var objectDefineProperties = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var objectKeys$1 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$5 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$2 = objectDefineProperty;
var anObject$b = anObject$f;
var toIndexedObject$9 = toIndexedObject$d;
var objectKeys = objectKeys$1;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$5 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$b(O);
  var props = toIndexedObject$9(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$2.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$c = getBuiltIn$g;

var html$2 = getBuiltIn$c('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var anObject$a = anObject$f;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys$1 = hiddenKeys$5;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys$1[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var objectCreate$1 = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$a(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var uncurryThis$f = functionUncurryThis;

var $Error$1 = Error;
var replace = uncurryThis$f(''.replace);

var TEST = (function (arg) { return String($Error$1(arg).stack); })('zxcasd');
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

var clearErrorStack$1 = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error$1.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};

var isObject$9 = isObject$f;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$6;

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
var installErrorCause$1 = function (O, options) {
  if (isObject$9(options) && 'cause' in options) {
    createNonEnumerableProperty$3(O, 'cause', options.cause);
  }
};

var uncurryThis$e = functionUncurryThis;
var aCallable$e = aCallable$g;
var NATIVE_BIND$1 = functionBindNative;

var bind$c = uncurryThis$e(uncurryThis$e.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$e(fn);
  return that === undefined ? fn : NATIVE_BIND$1 ? bind$c(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var iterators = {};

var wellKnownSymbol$k = wellKnownSymbol$m;
var Iterators$4 = iterators;

var ITERATOR$5 = wellKnownSymbol$k('iterator');
var ArrayPrototype$1 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$2 = function (it) {
  return it !== undefined && (Iterators$4.Array === it || ArrayPrototype$1[ITERATOR$5] === it);
};

var wellKnownSymbol$j = wellKnownSymbol$m;

var TO_STRING_TAG$4 = wellKnownSymbol$j('toStringTag');
var test$2 = {};

test$2[TO_STRING_TAG$4] = 'z';

var toStringTagSupport = String(test$2) === '[object z]';

var TO_STRING_TAG_SUPPORT$2 = toStringTagSupport;
var isCallable$b = isCallable$o;
var classofRaw = classofRaw$1;
var wellKnownSymbol$i = wellKnownSymbol$m;

var TO_STRING_TAG$3 = wellKnownSymbol$i('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$8 = TO_STRING_TAG_SUPPORT$2 ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG$3)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$b(O.callee) ? 'Arguments' : result;
};

var classof$7 = classof$8;
var getMethod$5 = getMethod$7;
var Iterators$3 = iterators;
var wellKnownSymbol$h = wellKnownSymbol$m;

var ITERATOR$4 = wellKnownSymbol$h('iterator');

var getIteratorMethod$4 = function (it) {
  if (it != undefined) return getMethod$5(it, ITERATOR$4)
    || getMethod$5(it, '@@iterator')
    || Iterators$3[classof$7(it)];
};

var call$f = functionCall;
var aCallable$d = aCallable$g;
var anObject$9 = anObject$f;
var tryToString$3 = tryToString$5;
var getIteratorMethod$3 = getIteratorMethod$4;

var $TypeError$7 = TypeError;

var getIterator$4 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$3(argument) : usingIterator;
  if (aCallable$d(iteratorMethod)) return anObject$9(call$f(iteratorMethod, argument));
  throw $TypeError$7(tryToString$3(argument) + ' is not iterable');
};

var call$e = functionCall;
var anObject$8 = anObject$f;
var getMethod$4 = getMethod$7;

var iteratorClose$2 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$8(iterator);
  try {
    innerResult = getMethod$4(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$e(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$8(innerResult);
  return value;
};

var bind$b = functionBindContext;
var call$d = functionCall;
var anObject$7 = anObject$f;
var tryToString$2 = tryToString$5;
var isArrayIteratorMethod$1 = isArrayIteratorMethod$2;
var lengthOfArrayLike$r = lengthOfArrayLike$t;
var isPrototypeOf$2 = objectIsPrototypeOf;
var getIterator$3 = getIterator$4;
var getIteratorMethod$2 = getIteratorMethod$4;
var iteratorClose$1 = iteratorClose$2;

var $TypeError$6 = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$7 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$b(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose$1(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$7(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$2(iterable);
    if (!iterFn) throw $TypeError$6(tryToString$2(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod$1(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$r(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$2(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator$3(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$d(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose$1(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$2(ResultPrototype, result)) return result;
  } return new Result(false);
};

var classof$6 = classof$8;

var $String = String;

var toString$5 = function (argument) {
  if (classof$6(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var toString$4 = toString$5;

var normalizeStringArgument$1 = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString$4(argument);
};

var fails$f = fails$p;
var createPropertyDescriptor$3 = createPropertyDescriptor$6;

var errorStackInstallable = !fails$f(function () {
  var error = Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es-x/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor$3(1, 7));
  return error.stack !== 7;
});

var $$U = _export;
var isPrototypeOf$1 = objectIsPrototypeOf;
var getPrototypeOf$3 = objectGetPrototypeOf;
var setPrototypeOf$3 = objectSetPrototypeOf;
var copyConstructorProperties = copyConstructorProperties$2;
var create$4 = objectCreate$1;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$6;
var createPropertyDescriptor$2 = createPropertyDescriptor$6;
var clearErrorStack = clearErrorStack$1;
var installErrorCause = installErrorCause$1;
var iterate$6 = iterate$7;
var normalizeStringArgument = normalizeStringArgument$1;
var wellKnownSymbol$g = wellKnownSymbol$m;
var ERROR_STACK_INSTALLABLE = errorStackInstallable;

var TO_STRING_TAG$2 = wellKnownSymbol$g('toStringTag');
var $Error = Error;
var push$5 = [].push;

var $AggregateError = function AggregateError(errors, message /* , options */) {
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var isInstance = isPrototypeOf$1(AggregateErrorPrototype, this);
  var that;
  if (setPrototypeOf$3) {
    that = setPrototypeOf$3(new $Error(), isInstance ? getPrototypeOf$3(this) : AggregateErrorPrototype);
  } else {
    that = isInstance ? this : create$4(AggregateErrorPrototype);
    createNonEnumerableProperty$2(that, TO_STRING_TAG$2, 'Error');
  }
  if (message !== undefined) createNonEnumerableProperty$2(that, 'message', normalizeStringArgument(message));
  if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty$2(that, 'stack', clearErrorStack(that.stack, 1));
  installErrorCause(that, options);
  var errorsArray = [];
  iterate$6(errors, push$5, { that: errorsArray });
  createNonEnumerableProperty$2(that, 'errors', errorsArray);
  return that;
};

if (setPrototypeOf$3) setPrototypeOf$3($AggregateError, $Error);
else copyConstructorProperties($AggregateError, $Error, { name: true });

var AggregateErrorPrototype = $AggregateError.prototype = create$4($Error.prototype, {
  constructor: createPropertyDescriptor$2(1, $AggregateError),
  message: createPropertyDescriptor$2(1, ''),
  name: createPropertyDescriptor$2(1, 'AggregateError')
});

// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$$U({ global: true, constructor: true, arity: 2 }, {
  AggregateError: $AggregateError
});

var wellKnownSymbol$f = wellKnownSymbol$m;
var create$3 = objectCreate$1;
var defineProperty$5 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$f('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty$5(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$3(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$n = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var fails$e = fails$p;
var isCallable$a = isCallable$o;
var getPrototypeOf$2 = objectGetPrototypeOf;
var defineBuiltIn$8 = defineBuiltIn$a;
var wellKnownSymbol$e = wellKnownSymbol$m;

var ITERATOR$3 = wellKnownSymbol$e('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator$1;

/* eslint-disable es-x/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator$1 = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator$1)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$2(getPrototypeOf$2(arrayIterator$1));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails$e(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$3].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$a(IteratorPrototype$2[ITERATOR$3])) {
  defineBuiltIn$8(IteratorPrototype$2, ITERATOR$3, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$4 = objectDefineProperty.f;
var hasOwn$2 = hasOwnProperty_1;
var wellKnownSymbol$d = wellKnownSymbol$m;

var TO_STRING_TAG$1 = wellKnownSymbol$d('toStringTag');

var setToStringTag$4 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$2(target, TO_STRING_TAG$1)) {
    defineProperty$4(target, TO_STRING_TAG$1, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$2 = objectCreate$1;
var createPropertyDescriptor$1 = createPropertyDescriptor$6;
var setToStringTag$3 = setToStringTag$4;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$1 = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$2(IteratorPrototype$1, { next: createPropertyDescriptor$1(+!ENUMERABLE_NEXT, next) });
  setToStringTag$3(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var $$T = _export;
var call$c = functionCall;
var FunctionName = functionName;
var isCallable$9 = isCallable$o;
var createIteratorConstructor = createIteratorConstructor$1;
var getPrototypeOf$1 = objectGetPrototypeOf;
var setPrototypeOf$2 = objectSetPrototypeOf;
var setToStringTag$2 = setToStringTag$4;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$6;
var defineBuiltIn$7 = defineBuiltIn$a;
var wellKnownSymbol$c = wellKnownSymbol$m;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$2 = wellKnownSymbol$c('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$3 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$2]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf$1(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf$1(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$2) {
          setPrototypeOf$2(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$9(CurrentIteratorPrototype[ITERATOR$2])) {
          defineBuiltIn$7(CurrentIteratorPrototype, ITERATOR$2, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$2(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$1(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$c(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$7(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$T({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$2] !== defaultIterator) {
    defineBuiltIn$7(IterablePrototype, ITERATOR$2, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

var toIndexedObject$8 = toIndexedObject$d;
var addToUnscopables$m = addToUnscopables$n;
var Iterators = iterators;
var InternalStateModule$4 = internalState;
var defineProperty$3 = objectDefineProperty.f;
var defineIterator$2 = defineIterator$3;
var DESCRIPTORS$4 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$4 = InternalStateModule$4.set;
var getInternalState$2 = InternalStateModule$4.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator$2(Array, 'Array', function (iterated, kind) {
  setInternalState$4(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject$8(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$2(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$m('keys');
addToUnscopables$m('values');
addToUnscopables$m('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$4 && values.name !== 'values') try {
  defineProperty$3(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

var TO_STRING_TAG_SUPPORT$1 = toStringTagSupport;
var classof$5 = classof$8;

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var objectToString = TO_STRING_TAG_SUPPORT$1 ? {}.toString : function toString() {
  return '[object ' + classof$5(this) + ']';
};

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var defineBuiltIn$6 = defineBuiltIn$a;
var toString$3 = objectToString;

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn$6(Object.prototype, 'toString', toString$3, { unsafe: true });
}

var classof$4 = classofRaw$1;
var global$d = global$n;

var engineIsNode = classof$4(global$d.process) == 'process';

var getBuiltIn$b = getBuiltIn$g;
var definePropertyModule$1 = objectDefineProperty;
var wellKnownSymbol$b = wellKnownSymbol$m;
var DESCRIPTORS$3 = descriptors;

var SPECIES$5 = wellKnownSymbol$b('species');

var setSpecies$3 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$b(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule$1.f;

  if (DESCRIPTORS$3 && Constructor && !Constructor[SPECIES$5]) {
    defineProperty(Constructor, SPECIES$5, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var isPrototypeOf = objectIsPrototypeOf;

var $TypeError$5 = TypeError;

var anInstance$3 = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw $TypeError$5('Incorrect invocation');
};

var uncurryThis$d = functionUncurryThis;
var fails$d = fails$p;
var isCallable$8 = isCallable$o;
var classof$3 = classof$8;
var getBuiltIn$a = getBuiltIn$g;
var inspectSource$1 = inspectSource$4;

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn$a('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis$d(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$8(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$8(argument)) return false;
  switch (classof$3(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$6 = !construct || fails$d(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isConstructor$5 = isConstructor$6;
var tryToString$1 = tryToString$5;

var $TypeError$4 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor$5(argument)) return argument;
  throw $TypeError$4(tryToString$1(argument) + ' is not a constructor');
};

var anObject$6 = anObject$f;
var aConstructor = aConstructor$1;
var wellKnownSymbol$a = wellKnownSymbol$m;

var SPECIES$4 = wellKnownSymbol$a('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$2 = function (O, defaultConstructor) {
  var C = anObject$6(O).constructor;
  var S;
  return C === undefined || (S = anObject$6(C)[SPECIES$4]) == undefined ? defaultConstructor : aConstructor(S);
};

var NATIVE_BIND = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$2 = FunctionPrototype.apply;
var call$b = FunctionPrototype.call;

// eslint-disable-next-line es-x/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call$b.bind(apply$2) : function () {
  return call$b.apply(apply$2, arguments);
});

var uncurryThis$c = functionUncurryThis;

var arraySlice$3 = uncurryThis$c([].slice);

var $TypeError$3 = TypeError;

var validateArgumentsLength$1 = function (passed, required) {
  if (passed < required) throw $TypeError$3('Not enough arguments');
  return passed;
};

var userAgent$4 = engineUserAgent;

var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$4);

var global$c = global$n;
var apply$1 = functionApply;
var bind$a = functionBindContext;
var isCallable$7 = isCallable$o;
var hasOwn$1 = hasOwnProperty_1;
var fails$c = fails$p;
var html = html$2;
var arraySlice$2 = arraySlice$3;
var createElement = documentCreateElement$2;
var validateArgumentsLength = validateArgumentsLength$1;
var IS_IOS$1 = engineIsIos;
var IS_NODE$5 = engineIsNode;

var set = global$c.setImmediate;
var clear = global$c.clearImmediate;
var process$2 = global$c.process;
var Dispatch = global$c.Dispatch;
var Function$1 = global$c.Function;
var MessageChannel = global$c.MessageChannel;
var String$1 = global$c.String;
var counter = 0;
var queue$1 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location = global$c.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn$1(queue$1, id)) {
    var fn = queue$1[id];
    delete queue$1[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global$c.postMessage(String$1(id), location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable$7(handler) ? handler : Function$1(handler);
    var args = arraySlice$2(arguments, 1);
    queue$1[++counter] = function () {
      apply$1(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$1[id];
  };
  // Node.js 0.8-
  if (IS_NODE$5) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind$a(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$c.addEventListener &&
    isCallable$7(global$c.postMessage) &&
    !global$c.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails$c(post)
  ) {
    defer = post;
    global$c.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var userAgent$3 = engineUserAgent;
var global$b = global$n;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$3) && global$b.Pebble !== undefined;

var userAgent$2 = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent$2);

var global$a = global$n;
var bind$9 = functionBindContext;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$4 = engineIsNode;

var MutationObserver = global$a.MutationObserver || global$a.WebKitMutationObserver;
var document$2 = global$a.document;
var process$1 = global$a.process;
var Promise$2 = global$a.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global$a, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify$1, toggle, node, promise$4, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE$4 && (parent = process$1.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify$1();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$4 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$2 && Promise$2.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise$4 = Promise$2.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise$4.constructor = Promise$2;
    then = bind$9(promise$4.then, promise$4);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$4) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind$9(macrotask, global$a);
    notify$1 = function () {
      macrotask(flush);
    };
  }
}

var microtask$1 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify$1();
  } last = task;
};

var global$9 = global$n;

var hostReportErrors$1 = function (a, b) {
  var console = global$9.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$6 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var Queue$1 = function () {
  this.head = null;
  this.tail = null;
};

Queue$1.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

var queue = Queue$1;

var global$8 = global$n;

var promiseNativeConstructor = global$8.Promise;

/* global Deno -- Deno case */

var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var IS_DENO$1 = engineIsDeno;
var IS_NODE$3 = engineIsNode;

var engineIsBrowser = !IS_DENO$1 && !IS_NODE$3
  && typeof window == 'object'
  && typeof document == 'object';

var global$7 = global$n;
var NativePromiseConstructor$4 = promiseNativeConstructor;
var isCallable$6 = isCallable$o;
var isForced$1 = isForced_1;
var inspectSource = inspectSource$4;
var wellKnownSymbol$9 = wellKnownSymbol$m;
var IS_BROWSER = engineIsBrowser;
var IS_DENO = engineIsDeno;
var V8_VERSION$2 = engineV8Version;

NativePromiseConstructor$4 && NativePromiseConstructor$4.prototype;
var SPECIES$3 = wellKnownSymbol$9('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$6(global$7.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced$1('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$4);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$4);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION$2 === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION$2 || V8_VERSION$2 < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor$4(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES$3] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var newPromiseCapability$2 = {};

var aCallable$c = aCallable$g;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$c(resolve);
  this.reject = aCallable$c(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var $$S = _export;
var IS_NODE$2 = engineIsNode;
var global$6 = global$n;
var call$a = functionCall;
var defineBuiltIn$5 = defineBuiltIn$a;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$4;
var setSpecies$2 = setSpecies$3;
var aCallable$b = aCallable$g;
var isCallable$5 = isCallable$o;
var isObject$8 = isObject$f;
var anInstance$2 = anInstance$3;
var speciesConstructor$1 = speciesConstructor$2;
var task = task$1.set;
var microtask = microtask$1;
var hostReportErrors = hostReportErrors$1;
var perform$5 = perform$6;
var Queue = queue;
var InternalStateModule$3 = internalState;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$6 = newPromiseCapability$2;

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule$3.getterFor(PROMISE);
var setInternalState$3 = InternalStateModule$3.set;
var NativePromisePrototype$2 = NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var PromiseConstructor = NativePromiseConstructor$3;
var PromisePrototype = NativePromisePrototype$2;
var TypeError$1 = global$6.TypeError;
var document$1 = global$6.document;
var process = global$6.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$6.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$6.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$8(it) && isCallable$5(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError$1('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$a(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$6.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$6['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$a(task, global$6, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$5(function () {
        if (IS_NODE$2) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE$2 || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$a(task, global$6, function () {
    var promise = state.facade;
    if (IS_NODE$2) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$8 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$a(then, value,
            bind$8(internalResolve, wrapper, state),
            bind$8(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance$2(this, PromisePrototype);
    aCallable$b(executor);
    call$a(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$8(internalResolve, state), bind$8(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState$3(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$5(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor$1(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$5(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$5(onRejected) && onRejected;
    reaction.domain = IS_NODE$2 ? process.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$8(internalResolve, state);
    this.reject = bind$8(internalReject, state);
  };

  newPromiseCapabilityModule$6.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$5(NativePromiseConstructor$3) && NativePromisePrototype$2 !== Object.prototype) {
    nativeThen = NativePromisePrototype$2.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$5(NativePromisePrototype$2, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$a(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$2.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf$1) {
      setPrototypeOf$1(NativePromisePrototype$2, PromisePrototype);
    }
  }
}

$$S({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag$1(PromiseConstructor, PROMISE, false);
setSpecies$2(PROMISE);

var wellKnownSymbol$8 = wellKnownSymbol$m;

var ITERATOR$1 = wellKnownSymbol$8('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$1] = function () {
    return this;
  };
  // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$3 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$1] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var NativePromiseConstructor$2 = promiseNativeConstructor;
var checkCorrectnessOfIteration$2 = checkCorrectnessOfIteration$3;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration$2(function (iterable) {
  NativePromiseConstructor$2.all(iterable).then(undefined, function () { /* empty */ });
});

var $$R = _export;
var call$9 = functionCall;
var aCallable$a = aCallable$g;
var newPromiseCapabilityModule$5 = newPromiseCapability$2;
var perform$4 = perform$6;
var iterate$5 = iterate$7;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$R({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$5.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$4(function () {
      var $promiseResolve = aCallable$a(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$5(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$9($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$Q = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor$1 = promiseNativeConstructor;
var getBuiltIn$9 = getBuiltIn$g;
var isCallable$4 = isCallable$o;
var defineBuiltIn$4 = defineBuiltIn$a;

var NativePromisePrototype$1 = NativePromiseConstructor$1 && NativePromiseConstructor$1.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$Q({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable$4(NativePromiseConstructor$1)) {
  var method$1 = getBuiltIn$9('Promise').prototype['catch'];
  if (NativePromisePrototype$1['catch'] !== method$1) {
    defineBuiltIn$4(NativePromisePrototype$1, 'catch', method$1, { unsafe: true });
  }
}

var $$P = _export;
var call$8 = functionCall;
var aCallable$9 = aCallable$g;
var newPromiseCapabilityModule$4 = newPromiseCapability$2;
var perform$3 = perform$6;
var iterate$4 = iterate$7;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$P({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$4.f(C);
    var reject = capability.reject;
    var result = perform$3(function () {
      var $promiseResolve = aCallable$9(C.resolve);
      iterate$4(iterable, function (promise) {
        call$8($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$O = _export;
var call$7 = functionCall;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$O({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule$3.f(this);
    call$7(capability.reject, undefined, r);
    return capability.promise;
  }
});

var anObject$5 = anObject$f;
var isObject$7 = isObject$f;
var newPromiseCapability = newPromiseCapability$2;

var promiseResolve$2 = function (C, x) {
  anObject$5(C);
  if (isObject$7(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var $$N = _export;
var getBuiltIn$8 = getBuiltIn$g;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve$1 = promiseResolve$2;

getBuiltIn$8('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$N({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve$1(this, x);
  }
});

var $$M = _export;
var call$6 = functionCall;
var aCallable$8 = aCallable$g;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$2 = perform$6;
var iterate$3 = iterate$7;

// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$$M({ target: 'Promise', stat: true }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$2(function () {
      var promiseResolve = aCallable$8(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$3(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$6(promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: error };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$L = _export;
var call$5 = functionCall;
var aCallable$7 = aCallable$g;
var getBuiltIn$7 = getBuiltIn$g;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform$1 = perform$6;
var iterate$2 = iterate$7;

var PROMISE_ANY_ERROR = 'No one promise resolved';

// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$$L({ target: 'Promise', stat: true }, {
  any: function any(iterable) {
    var C = this;
    var AggregateError = getBuiltIn$7('AggregateError');
    var capability = newPromiseCapabilityModule$1.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var promiseResolve = aCallable$7(C.resolve);
      var errors = [];
      var counter = 0;
      var remaining = 1;
      var alreadyResolved = false;
      iterate$2(iterable, function (promise) {
        var index = counter++;
        var alreadyRejected = false;
        remaining++;
        call$5(promiseResolve, C, promise).then(function (value) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyResolved = true;
          resolve(value);
        }, function (error) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyRejected = true;
          errors[index] = error;
          --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
        });
      });
      --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$K = _export;
var NativePromiseConstructor = promiseNativeConstructor;
var fails$b = fails$p;
var getBuiltIn$6 = getBuiltIn$g;
var isCallable$3 = isCallable$o;
var speciesConstructor = speciesConstructor$2;
var promiseResolve = promiseResolve$2;
var defineBuiltIn$3 = defineBuiltIn$a;

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromiseConstructor && fails$b(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$$K({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn$6('Promise'));
    var isFunction = isCallable$3(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (isCallable$3(NativePromiseConstructor)) {
  var method = getBuiltIn$6('Promise').prototype['finally'];
  if (NativePromisePrototype['finally'] !== method) {
    defineBuiltIn$3(NativePromisePrototype, 'finally', method, { unsafe: true });
  }
}

var uncurryThis$b = functionUncurryThis;
var toIntegerOrInfinity$6 = toIntegerOrInfinity$9;
var toString$2 = toString$5;
var requireObjectCoercible = requireObjectCoercible$3;

var charAt$1 = uncurryThis$b(''.charAt);
var charCodeAt = uncurryThis$b(''.charCodeAt);
var stringSlice = uncurryThis$b(''.slice);

var createMethod$4 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$2(requireObjectCoercible($this));
    var position = toIntegerOrInfinity$6(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$1(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$4(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$4(true)
};

var charAt = stringMultibyte.charAt;
var toString$1 = toString$5;
var InternalStateModule$2 = internalState;
var defineIterator$1 = defineIterator$3;

var STRING_ITERATOR = 'String Iterator';
var setInternalState$2 = InternalStateModule$2.set;
var getInternalState$1 = InternalStateModule$2.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator$1(String, 'String', function (iterated) {
  setInternalState$2(this, {
    type: STRING_ITERATOR,
    string: toString$1(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$1(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});

var global$5 = global$n;

var path$2 = global$5;

var path$1 = path$2;

var promise$3 = path$1.Promise;

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$4 = global$n;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$6;
var wellKnownSymbol$7 = wellKnownSymbol$m;

var ITERATOR = wellKnownSymbol$7('iterator');
var TO_STRING_TAG = wellKnownSymbol$7('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$4[COLLECTION_NAME] && global$4[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

var parent$5 = promise$3;


var promise$2 = parent$5;

var parent$4 = promise$2;

var promise$1 = parent$4;

// TODO: Remove from `core-js@4`
var $$J = _export;
var newPromiseCapabilityModule = newPromiseCapability$2;
var perform = perform$6;

// `Promise.try` method
// https://github.com/tc39/proposal-promise-try
$$J({ target: 'Promise', stat: true, forced: true }, {
  'try': function (callbackfn) {
    var promiseCapability = newPromiseCapabilityModule.f(this);
    var result = perform(callbackfn);
    (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
    return promiseCapability.promise;
  }
});

var parent$3 = promise$1;

// TODO: Remove from `core-js@4`




var promise = parent$3;

(function (module) {
	module.exports = promise;
} (promise$5));

var array$4 = {exports: {}};

var anObject$4 = anObject$f;
var iteratorClose = iteratorClose$2;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$4(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

var toPropertyKey$1 = toPropertyKey$4;
var definePropertyModule = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$6;

var createProperty$6 = function (object, key, value) {
  var propertyKey = toPropertyKey$1(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var bind$7 = functionBindContext;
var call$4 = functionCall;
var toObject$j = toObject$m;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
var isArrayIteratorMethod = isArrayIteratorMethod$2;
var isConstructor$4 = isConstructor$6;
var lengthOfArrayLike$q = lengthOfArrayLike$t;
var createProperty$5 = createProperty$6;
var getIterator$2 = getIterator$4;
var getIteratorMethod$1 = getIteratorMethod$4;

var $Array$9 = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject$j(arrayLike);
  var IS_CONSTRUCTOR = isConstructor$4(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind$7(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod$1(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array$9 && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator$2(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call$4(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty$5(result, index, value);
    }
  } else {
    length = lengthOfArrayLike$q(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array$9(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty$5(result, index, value);
    }
  }
  result.length = index;
  return result;
};

var $$I = _export;
var from = arrayFrom;
var checkCorrectnessOfIteration$1 = checkCorrectnessOfIteration$3;

var INCORRECT_ITERATION = !checkCorrectnessOfIteration$1(function (iterable) {
  // eslint-disable-next-line es-x/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$$I({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});

var classof$2 = classofRaw$1;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es-x/no-array-isarray -- safe
var isArray$7 = Array.isArray || function isArray(argument) {
  return classof$2(argument) == 'Array';
};

var $$H = _export;
var isArray$6 = isArray$7;

// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$$H({ target: 'Array', stat: true }, {
  isArray: isArray$6
});

var $$G = _export;
var fails$a = fails$p;
var isConstructor$3 = isConstructor$6;
var createProperty$4 = createProperty$6;

var $Array$8 = Array;

var ISNT_GENERIC = fails$a(function () {
  function F() { /* empty */ }
  // eslint-disable-next-line es-x/no-array-of -- safe
  return !($Array$8.of.call(F) instanceof F);
});

// `Array.of` method
// https://tc39.es/ecma262/#sec-array.of
// WebKit Array.of isn't generic
$$G({ target: 'Array', stat: true, forced: ISNT_GENERIC }, {
  of: function of(/* ...args */) {
    var index = 0;
    var argumentsLength = arguments.length;
    var result = new (isConstructor$3(this) ? this : $Array$8)(argumentsLength);
    while (argumentsLength > index) createProperty$4(result, index, arguments[index++]);
    result.length = argumentsLength;
    return result;
  }
});

var $$F = _export;
var toObject$i = toObject$m;
var lengthOfArrayLike$p = lengthOfArrayLike$t;
var toIntegerOrInfinity$5 = toIntegerOrInfinity$9;
var addToUnscopables$l = addToUnscopables$n;

// `Array.prototype.at` method
// https://github.com/tc39/proposal-relative-indexing-method
$$F({ target: 'Array', proto: true }, {
  at: function at(index) {
    var O = toObject$i(this);
    var len = lengthOfArrayLike$p(O);
    var relativeIndex = toIntegerOrInfinity$5(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return (k < 0 || k >= len) ? undefined : O[k];
  }
});

addToUnscopables$l('at');

var $TypeError$2 = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$7 = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$2('Maximum allowed index exceeded');
  return it;
};

var isArray$5 = isArray$7;
var isConstructor$2 = isConstructor$6;
var isObject$6 = isObject$f;
var wellKnownSymbol$6 = wellKnownSymbol$m;

var SPECIES$2 = wellKnownSymbol$6('species');
var $Array$7 = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray$5(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor$2(C) && (C === $Array$7 || isArray$5(C.prototype))) C = undefined;
    else if (isObject$6(C)) {
      C = C[SPECIES$2];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array$7 : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$6 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var fails$9 = fails$p;
var wellKnownSymbol$5 = wellKnownSymbol$m;
var V8_VERSION$1 = engineV8Version;

var SPECIES$1 = wellKnownSymbol$5('species');

var arrayMethodHasSpeciesSupport$5 = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION$1 >= 51 || !fails$9(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$1] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var $$E = _export;
var fails$8 = fails$p;
var isArray$4 = isArray$7;
var isObject$5 = isObject$f;
var toObject$h = toObject$m;
var lengthOfArrayLike$o = lengthOfArrayLike$t;
var doesNotExceedSafeInteger$6 = doesNotExceedSafeInteger$7;
var createProperty$3 = createProperty$6;
var arraySpeciesCreate$5 = arraySpeciesCreate$6;
var arrayMethodHasSpeciesSupport$4 = arrayMethodHasSpeciesSupport$5;
var wellKnownSymbol$4 = wellKnownSymbol$m;
var V8_VERSION = engineV8Version;

var IS_CONCAT_SPREADABLE = wellKnownSymbol$4('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails$8(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport$4('concat');

var isConcatSpreadable = function (O) {
  if (!isObject$5(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray$4(O);
};

var FORCED$2 = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$$E({ target: 'Array', proto: true, arity: 1, forced: FORCED$2 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject$h(this);
    var A = arraySpeciesCreate$5(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike$o(E);
        doesNotExceedSafeInteger$6(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty$3(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger$6(n + 1);
        createProperty$3(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});

var tryToString = tryToString$5;

var $TypeError$1 = TypeError;

var deletePropertyOrThrow$4 = function (O, P) {
  if (!delete O[P]) throw $TypeError$1('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};

var toObject$g = toObject$m;
var toAbsoluteIndex$5 = toAbsoluteIndex$7;
var lengthOfArrayLike$n = lengthOfArrayLike$t;
var deletePropertyOrThrow$3 = deletePropertyOrThrow$4;

var min$3 = Math.min;

// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es-x/no-array-prototype-copywithin -- safe
var arrayCopyWithin = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject$g(this);
  var len = lengthOfArrayLike$n(O);
  var to = toAbsoluteIndex$5(target, len);
  var from = toAbsoluteIndex$5(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = min$3((end === undefined ? len : toAbsoluteIndex$5(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else deletePropertyOrThrow$3(O, to);
    to += inc;
    from += inc;
  } return O;
};

var $$D = _export;
var copyWithin = arrayCopyWithin;
var addToUnscopables$k = addToUnscopables$n;

// `Array.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
$$D({ target: 'Array', proto: true }, {
  copyWithin: copyWithin
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$k('copyWithin');

var bind$6 = functionBindContext;
var uncurryThis$a = functionUncurryThis;
var IndexedObject$5 = indexedObject;
var toObject$f = toObject$m;
var lengthOfArrayLike$m = lengthOfArrayLike$t;
var arraySpeciesCreate$4 = arraySpeciesCreate$6;

var push$4 = uncurryThis$a([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod$3 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject$f($this);
    var self = IndexedObject$5(O);
    var boundFunction = bind$6(callbackfn, that);
    var length = lengthOfArrayLike$m(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate$4;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push$4(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push$4(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$3(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$3(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$3(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$3(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$3(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$3(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$3(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod$3(7)
};

var fails$7 = fails$p;

var arrayMethodIsStrict$b = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$7(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var $$C = _export;
var $every = arrayIteration.every;
var arrayMethodIsStrict$a = arrayMethodIsStrict$b;

var STRICT_METHOD$8 = arrayMethodIsStrict$a('every');

// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$$C({ target: 'Array', proto: true, forced: !STRICT_METHOD$8 }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var toObject$e = toObject$m;
var toAbsoluteIndex$4 = toAbsoluteIndex$7;
var lengthOfArrayLike$l = lengthOfArrayLike$t;

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
var arrayFill = function fill(value /* , start = 0, end = @length */) {
  var O = toObject$e(this);
  var length = lengthOfArrayLike$l(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex$4(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex$4(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

var $$B = _export;
var fill = arrayFill;
var addToUnscopables$j = addToUnscopables$n;

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$$B({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$j('fill');

var $$A = _export;
var $filter = arrayIteration.filter;
var arrayMethodHasSpeciesSupport$3 = arrayMethodHasSpeciesSupport$5;

var HAS_SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport$3('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$$A({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$3 }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var $$z = _export;
var $find = arrayIteration.find;
var addToUnscopables$i = addToUnscopables$n;

var FIND = 'find';
var SKIPS_HOLES$1 = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES$1 = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$$z({ target: 'Array', proto: true, forced: SKIPS_HOLES$1 }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$i(FIND);

var $$y = _export;
var $findIndex = arrayIteration.findIndex;
var addToUnscopables$h = addToUnscopables$n;

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$$y({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$h(FIND_INDEX);

var bind$5 = functionBindContext;
var IndexedObject$4 = indexedObject;
var toObject$d = toObject$m;
var lengthOfArrayLike$k = lengthOfArrayLike$t;

// `Array.prototype.{ findLast, findLastIndex }` methods implementation
var createMethod$2 = function (TYPE) {
  var IS_FIND_LAST_INDEX = TYPE == 1;
  return function ($this, callbackfn, that) {
    var O = toObject$d($this);
    var self = IndexedObject$4(O);
    var boundFunction = bind$5(callbackfn, that);
    var index = lengthOfArrayLike$k(self);
    var value, result;
    while (index-- > 0) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (result) switch (TYPE) {
        case 0: return value; // findLast
        case 1: return index; // findLastIndex
      }
    }
    return IS_FIND_LAST_INDEX ? -1 : undefined;
  };
};

var arrayIterationFromLast = {
  // `Array.prototype.findLast` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLast: createMethod$2(0),
  // `Array.prototype.findLastIndex` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLastIndex: createMethod$2(1)
};

var $$x = _export;
var $findLast = arrayIterationFromLast.findLast;
var addToUnscopables$g = addToUnscopables$n;

// `Array.prototype.findLast` method
// https://github.com/tc39/proposal-array-find-from-last
$$x({ target: 'Array', proto: true }, {
  findLast: function findLast(callbackfn /* , that = undefined */) {
    return $findLast(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

addToUnscopables$g('findLast');

var $$w = _export;
var $findLastIndex = arrayIterationFromLast.findLastIndex;
var addToUnscopables$f = addToUnscopables$n;

// `Array.prototype.findLastIndex` method
// https://github.com/tc39/proposal-array-find-from-last
$$w({ target: 'Array', proto: true }, {
  findLastIndex: function findLastIndex(callbackfn /* , that = undefined */) {
    return $findLastIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

addToUnscopables$f('findLastIndex');

var isArray$3 = isArray$7;
var lengthOfArrayLike$j = lengthOfArrayLike$t;
var doesNotExceedSafeInteger$5 = doesNotExceedSafeInteger$7;
var bind$4 = functionBindContext;

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray$2 = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind$4(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray$3(element)) {
        elementLen = lengthOfArrayLike$j(element);
        targetIndex = flattenIntoArray$2(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger$5(targetIndex + 1);
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

var flattenIntoArray_1 = flattenIntoArray$2;

var $$v = _export;
var flattenIntoArray$1 = flattenIntoArray_1;
var toObject$c = toObject$m;
var lengthOfArrayLike$i = lengthOfArrayLike$t;
var toIntegerOrInfinity$4 = toIntegerOrInfinity$9;
var arraySpeciesCreate$3 = arraySpeciesCreate$6;

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$$v({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject$c(this);
    var sourceLen = lengthOfArrayLike$i(O);
    var A = arraySpeciesCreate$3(O, 0);
    A.length = flattenIntoArray$1(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity$4(depthArg));
    return A;
  }
});

var $$u = _export;
var flattenIntoArray = flattenIntoArray_1;
var aCallable$6 = aCallable$g;
var toObject$b = toObject$m;
var lengthOfArrayLike$h = lengthOfArrayLike$t;
var arraySpeciesCreate$2 = arraySpeciesCreate$6;

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$$u({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject$b(this);
    var sourceLen = lengthOfArrayLike$h(O);
    var A;
    aCallable$6(callbackfn);
    A = arraySpeciesCreate$2(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});

var $forEach = arrayIteration.forEach;
var arrayMethodIsStrict$9 = arrayMethodIsStrict$b;

var STRICT_METHOD$7 = arrayMethodIsStrict$9('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD$7 ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es-x/no-array-prototype-foreach -- safe
} : [].forEach;

var $$t = _export;
var forEach = arrayForEach;

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es-x/no-array-prototype-foreach -- safe
$$t({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});

var $$s = _export;
var $includes = arrayIncludes.includes;
var fails$6 = fails$p;
var addToUnscopables$e = addToUnscopables$n;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$6(function () {
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$s({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$e('includes');

/* eslint-disable es-x/no-array-prototype-indexof -- required for testing */
var $$r = _export;
var uncurryThis$9 = functionUncurryThis;
var $IndexOf = arrayIncludes.indexOf;
var arrayMethodIsStrict$8 = arrayMethodIsStrict$b;

var un$IndexOf = uncurryThis$9([].indexOf);

var NEGATIVE_ZERO$1 = !!un$IndexOf && 1 / un$IndexOf([1], 1, -0) < 0;
var STRICT_METHOD$6 = arrayMethodIsStrict$8('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$$r({ target: 'Array', proto: true, forced: NEGATIVE_ZERO$1 || !STRICT_METHOD$6 }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
    return NEGATIVE_ZERO$1
      // convert -0 to +0
      ? un$IndexOf(this, searchElement, fromIndex) || 0
      : $IndexOf(this, searchElement, fromIndex);
  }
});

var $$q = _export;
var uncurryThis$8 = functionUncurryThis;
var IndexedObject$3 = indexedObject;
var toIndexedObject$7 = toIndexedObject$d;
var arrayMethodIsStrict$7 = arrayMethodIsStrict$b;

var un$Join = uncurryThis$8([].join);

var ES3_STRINGS = IndexedObject$3 != Object;
var STRICT_METHOD$5 = arrayMethodIsStrict$7('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$$q({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD$5 }, {
  join: function join(separator) {
    return un$Join(toIndexedObject$7(this), separator === undefined ? ',' : separator);
  }
});

/* eslint-disable es-x/no-array-prototype-lastindexof -- safe */
var apply = functionApply;
var toIndexedObject$6 = toIndexedObject$d;
var toIntegerOrInfinity$3 = toIntegerOrInfinity$9;
var lengthOfArrayLike$g = lengthOfArrayLike$t;
var arrayMethodIsStrict$6 = arrayMethodIsStrict$b;

var min$2 = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD$4 = arrayMethodIsStrict$6('lastIndexOf');
var FORCED$1 = NEGATIVE_ZERO || !STRICT_METHOD$4;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
var arrayLastIndexOf = FORCED$1 ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return apply($lastIndexOf, this, arguments) || 0;
  var O = toIndexedObject$6(this);
  var length = lengthOfArrayLike$g(O);
  var index = length - 1;
  if (arguments.length > 1) index = min$2(index, toIntegerOrInfinity$3(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;

var $$p = _export;
var lastIndexOf = arrayLastIndexOf;

// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es-x/no-array-prototype-lastindexof -- required for testing
$$p({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});

var $$o = _export;
var $map = arrayIteration.map;
var arrayMethodHasSpeciesSupport$2 = arrayMethodHasSpeciesSupport$5;

var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport$2('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$$o({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$2 }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var $$n = _export;
var toObject$a = toObject$m;
var lengthOfArrayLike$f = lengthOfArrayLike$t;
var doesNotExceedSafeInteger$4 = doesNotExceedSafeInteger$7;
var fails$5 = fails$p;

var INCORRECT_TO_LENGTH = fails$5(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var SILENT_ON_NON_WRITABLE_LENGTH$1 = !function () {
  try {
    // eslint-disable-next-line es-x/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
}();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$$n({ target: 'Array', proto: true, arity: 1, forced: INCORRECT_TO_LENGTH || SILENT_ON_NON_WRITABLE_LENGTH$1 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject$a(this);
    var len = lengthOfArrayLike$f(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger$4(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    O.length = len;
    return len;
  }
});

var aCallable$5 = aCallable$g;
var toObject$9 = toObject$m;
var IndexedObject$2 = indexedObject;
var lengthOfArrayLike$e = lengthOfArrayLike$t;

var $TypeError = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$1 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable$5(callbackfn);
    var O = toObject$9(that);
    var self = IndexedObject$2(O);
    var length = lengthOfArrayLike$e(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$1(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$1(true)
};

var $$m = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict$5 = arrayMethodIsStrict$b;
var CHROME_VERSION$1 = engineV8Version;
var IS_NODE$1 = engineIsNode;

var STRICT_METHOD$3 = arrayMethodIsStrict$5('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG$1 = !IS_NODE$1 && CHROME_VERSION$1 > 79 && CHROME_VERSION$1 < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$m({ target: 'Array', proto: true, forced: !STRICT_METHOD$3 || CHROME_BUG$1 }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

var $$l = _export;
var $reduceRight = arrayReduce.right;
var arrayMethodIsStrict$4 = arrayMethodIsStrict$b;
var CHROME_VERSION = engineV8Version;
var IS_NODE = engineIsNode;

var STRICT_METHOD$2 = arrayMethodIsStrict$4('reduceRight');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-array.prototype.reduceright
$$l({ target: 'Array', proto: true, forced: !STRICT_METHOD$2 || CHROME_BUG }, {
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduceRight(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var $$k = _export;
var uncurryThis$7 = functionUncurryThis;
var isArray$2 = isArray$7;

var un$Reverse = uncurryThis$7([].reverse);
var test$1 = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$$k({ target: 'Array', proto: true, forced: String(test$1) === String(test$1.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray$2(this)) this.length = this.length;
    return un$Reverse(this);
  }
});

var $$j = _export;
var isArray$1 = isArray$7;
var isConstructor$1 = isConstructor$6;
var isObject$4 = isObject$f;
var toAbsoluteIndex$3 = toAbsoluteIndex$7;
var lengthOfArrayLike$d = lengthOfArrayLike$t;
var toIndexedObject$5 = toIndexedObject$d;
var createProperty$2 = createProperty$6;
var wellKnownSymbol$3 = wellKnownSymbol$m;
var arrayMethodHasSpeciesSupport$1 = arrayMethodHasSpeciesSupport$5;
var un$Slice = arraySlice$3;

var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport$1('slice');

var SPECIES = wellKnownSymbol$3('species');
var $Array$6 = Array;
var max$3 = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$$j({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 }, {
  slice: function slice(start, end) {
    var O = toIndexedObject$5(this);
    var length = lengthOfArrayLike$d(O);
    var k = toAbsoluteIndex$3(start, length);
    var fin = toAbsoluteIndex$3(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray$1(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor$1(Constructor) && (Constructor === $Array$6 || isArray$1(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject$4(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array$6 || Constructor === undefined) {
        return un$Slice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array$6 : Constructor)(max$3(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty$2(result, n, O[k]);
    result.length = n;
    return result;
  }
});

var $$i = _export;
var $some = arrayIteration.some;
var arrayMethodIsStrict$3 = arrayMethodIsStrict$b;

var STRICT_METHOD$1 = arrayMethodIsStrict$3('some');

// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$$i({ target: 'Array', proto: true, forced: !STRICT_METHOD$1 }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var toAbsoluteIndex$2 = toAbsoluteIndex$7;
var lengthOfArrayLike$c = lengthOfArrayLike$t;
var createProperty$1 = createProperty$6;

var $Array$5 = Array;
var max$2 = Math.max;

var arraySliceSimple = function (O, start, end) {
  var length = lengthOfArrayLike$c(O);
  var k = toAbsoluteIndex$2(start, length);
  var fin = toAbsoluteIndex$2(end === undefined ? length : end, length);
  var result = $Array$5(max$2(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty$1(result, n, O[k]);
  result.length = n;
  return result;
};

var arraySlice$1 = arraySliceSimple;

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice$1(array, 0, middle), comparefn),
    mergeSort(arraySlice$1(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

var arraySort = mergeSort;

var userAgent$1 = engineUserAgent;

var firefox = userAgent$1.match(/firefox\/(\d+)/i);

var engineFfVersion = !!firefox && +firefox[1];

var UA = engineUserAgent;

var engineIsIeOrEdge = /MSIE|Trident/.test(UA);

var userAgent = engineUserAgent;

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

var engineWebkitVersion = !!webkit && +webkit[1];

var $$h = _export;
var uncurryThis$6 = functionUncurryThis;
var aCallable$4 = aCallable$g;
var toObject$8 = toObject$m;
var lengthOfArrayLike$b = lengthOfArrayLike$t;
var deletePropertyOrThrow$2 = deletePropertyOrThrow$4;
var toString = toString$5;
var fails$4 = fails$p;
var internalSort = arraySort;
var arrayMethodIsStrict$2 = arrayMethodIsStrict$b;
var FF = engineFfVersion;
var IE_OR_EDGE = engineIsIeOrEdge;
var V8 = engineV8Version;
var WEBKIT = engineWebkitVersion;

var test = [];
var un$Sort = uncurryThis$6(test.sort);
var push$3 = uncurryThis$6(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails$4(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails$4(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict$2('sort');

var STABLE_SORT = !fails$4(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString(x) > toString(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$$h({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable$4(comparefn);

    var array = toObject$8(this);

    if (STABLE_SORT) return comparefn === undefined ? un$Sort(array) : un$Sort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike$b(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push$3(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = items.length;
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow$2(array, index++);

    return array;
  }
});

var setSpecies$1 = setSpecies$3;

// `Array[@@species]` getter
// https://tc39.es/ecma262/#sec-get-array-@@species
setSpecies$1('Array');

var $$g = _export;
var toObject$7 = toObject$m;
var toAbsoluteIndex$1 = toAbsoluteIndex$7;
var toIntegerOrInfinity$2 = toIntegerOrInfinity$9;
var lengthOfArrayLike$a = lengthOfArrayLike$t;
var doesNotExceedSafeInteger$3 = doesNotExceedSafeInteger$7;
var arraySpeciesCreate$1 = arraySpeciesCreate$6;
var createProperty = createProperty$6;
var deletePropertyOrThrow$1 = deletePropertyOrThrow$4;
var arrayMethodHasSpeciesSupport = arrayMethodHasSpeciesSupport$5;

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max$1 = Math.max;
var min$1 = Math.min;

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$$g({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject$7(this);
    var len = lengthOfArrayLike$a(O);
    var actualStart = toAbsoluteIndex$1(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min$1(max$1(toIntegerOrInfinity$2(deleteCount), 0), len - actualStart);
    }
    doesNotExceedSafeInteger$3(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate$1(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow$1(O, to);
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow$1(O, k - 1);
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow$1(O, to);
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables$d = addToUnscopables$n;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$d('flat');

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables$c = addToUnscopables$n;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$c('flatMap');

var $$f = _export;
var toObject$6 = toObject$m;
var lengthOfArrayLike$9 = lengthOfArrayLike$t;
var deletePropertyOrThrow = deletePropertyOrThrow$4;
var doesNotExceedSafeInteger$2 = doesNotExceedSafeInteger$7;

// IE8-
var INCORRECT_RESULT = [].unshift(0) !== 1;

// V8 ~ Chrome < 71 and Safari <= 15.4, FF < 23 throws InternalError
var SILENT_ON_NON_WRITABLE_LENGTH = !function () {
  try {
    // eslint-disable-next-line es-x/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).unshift();
  } catch (error) {
    return error instanceof TypeError;
  }
}();

// `Array.prototype.unshift` method
// https://tc39.es/ecma262/#sec-array.prototype.unshift
$$f({ target: 'Array', proto: true, arity: 1, forced: INCORRECT_RESULT || SILENT_ON_NON_WRITABLE_LENGTH }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  unshift: function unshift(item) {
    var O = toObject$6(this);
    var len = lengthOfArrayLike$9(O);
    var argCount = arguments.length;
    if (argCount) {
      doesNotExceedSafeInteger$2(len + argCount);
      var k = len;
      while (k--) {
        var to = k + argCount;
        if (k in O) O[to] = O[k];
        else deletePropertyOrThrow(O, to);
      }
      for (var j = 0; j < argCount; j++) {
        O[j] = arguments[j];
      }
    } return O.length = len + argCount;
  }
});

var path = path$2;

var array$3 = path.Array;

var parent$2 = array$3;

var array$2 = parent$2;

var internalMetadata = {exports: {}};

var objectGetOwnPropertyNamesExternal = {};

/* eslint-disable es-x/no-object-getownpropertynames -- safe */

var classof$1 = classofRaw$1;
var toIndexedObject$4 = toIndexedObject$d;
var $getOwnPropertyNames = objectGetOwnPropertyNames.f;
var arraySlice = arraySliceSimple;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
objectGetOwnPropertyNamesExternal.f = function getOwnPropertyNames(it) {
  return windowNames && classof$1(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject$4(it));
};

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails$3 = fails$p;

var arrayBufferNonExtensible = fails$3(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es-x/no-object-isextensible, es-x/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});

var fails$2 = fails$p;
var isObject$3 = isObject$f;
var classof = classofRaw$1;
var ARRAY_BUFFER_NON_EXTENSIBLE = arrayBufferNonExtensible;

// eslint-disable-next-line es-x/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails$2(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
var objectIsExtensible = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
  if (!isObject$3(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;

var fails$1 = fails$p;

var freezing = !fails$1(function () {
  // eslint-disable-next-line es-x/no-object-isextensible, es-x/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});

var $$e = _export;
var uncurryThis$5 = functionUncurryThis;
var hiddenKeys = hiddenKeys$5;
var isObject$2 = isObject$f;
var hasOwn = hasOwnProperty_1;
var defineProperty$2 = objectDefineProperty.f;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertyNamesExternalModule = objectGetOwnPropertyNamesExternal;
var isExtensible = objectIsExtensible;
var uid = uid$3;
var FREEZING = freezing;

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

var setMetadata = function (it) {
  defineProperty$2(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey$1 = function (it, create) {
  // return a primitive with prefix
  if (!isObject$2(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = uncurryThis$5([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    $$e({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = internalMetadata.exports = {
  enable: enable,
  fastKey: fastKey$1,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;

var isCallable$2 = isCallable$o;
var isObject$1 = isObject$f;
var setPrototypeOf = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$1 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable$2(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject$1(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};

var $$d = _export;
var global$3 = global$n;
var uncurryThis$4 = functionUncurryThis;
var isForced = isForced_1;
var defineBuiltIn$2 = defineBuiltIn$a;
var InternalMetadataModule = internalMetadata.exports;
var iterate$1 = iterate$7;
var anInstance$1 = anInstance$3;
var isCallable$1 = isCallable$o;
var isObject = isObject$f;
var fails = fails$p;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$3;
var setToStringTag = setToStringTag$4;
var inheritIfRequired = inheritIfRequired$1;

var collection$1 = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global$3[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = uncurryThis$4(NativePrototype[KEY]);
    defineBuiltIn$2(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable$1(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance$1(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate$1(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $$d({ global: true, constructor: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};

var defineBuiltIn$1 = defineBuiltIn$a;

var defineBuiltIns$2 = function (target, src, options) {
  for (var key in src) defineBuiltIn$1(target, key, src[key], options);
  return target;
};

var defineProperty$1 = objectDefineProperty.f;
var create$1 = objectCreate$1;
var defineBuiltIns$1 = defineBuiltIns$2;
var bind$3 = functionBindContext;
var anInstance = anInstance$3;
var iterate = iterate$7;
var defineIterator = defineIterator$3;
var setSpecies = setSpecies$3;
var DESCRIPTORS$2 = descriptors;
var fastKey = internalMetadata.exports.fastKey;
var InternalStateModule$1 = internalState;

var setInternalState$1 = InternalStateModule$1.set;
var internalStateGetterFor = InternalStateModule$1.getterFor;

var collectionStrong$1 = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState$1(that, {
        type: CONSTRUCTOR_NAME,
        index: create$1(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS$2) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS$2) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    defineBuiltIns$1(Prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS$2) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS$2) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind$3(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    defineBuiltIns$1(Prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS$2) defineProperty$1(Prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return Constructor;
  },
  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState$1(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};

var collection = collection$1;
var collectionStrong = collectionStrong$1;

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);

var lengthOfArrayLike$8 = lengthOfArrayLike$t;

var arrayFromConstructorAndList$2 = function (Constructor, list) {
  var index = 0;
  var length = lengthOfArrayLike$8(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var bind$2 = functionBindContext;
var uncurryThis$3 = functionUncurryThis;
var IndexedObject$1 = indexedObject;
var toObject$5 = toObject$m;
var toPropertyKey = toPropertyKey$4;
var lengthOfArrayLike$7 = lengthOfArrayLike$t;
var objectCreate = objectCreate$1;
var arrayFromConstructorAndList$1 = arrayFromConstructorAndList$2;

var $Array$4 = Array;
var push$2 = uncurryThis$3([].push);

var arrayGroup = function ($this, callbackfn, that, specificConstructor) {
  var O = toObject$5($this);
  var self = IndexedObject$1(O);
  var boundFunction = bind$2(callbackfn, that);
  var target = objectCreate(null);
  var length = lengthOfArrayLike$7(self);
  var index = 0;
  var Constructor, key, value;
  for (;length > index; index++) {
    value = self[index];
    key = toPropertyKey(boundFunction(value, index, O));
    // in some IE10 builds, `hasOwnProperty` returns incorrect result on integer keys
    // but since it's a `null` prototype object, we can safely use `in`
    if (key in target) push$2(target[key], value);
    else target[key] = [value];
  }
  // TODO: Remove this block from `core-js@4`
  if (specificConstructor) {
    Constructor = specificConstructor(O);
    if (Constructor !== $Array$4) {
      for (key in target) target[key] = arrayFromConstructorAndList$1(Constructor, target[key]);
    }
  } return target;
};

var $$c = _export;
var $group$1 = arrayGroup;
var addToUnscopables$b = addToUnscopables$n;

// `Array.prototype.group` method
// https://github.com/tc39/proposal-array-grouping
$$c({ target: 'Array', proto: true }, {
  group: function group(callbackfn /* , thisArg */) {
    var thisArg = arguments.length > 1 ? arguments[1] : undefined;
    return $group$1(this, callbackfn, thisArg);
  }
});

addToUnscopables$b('group');

// TODO: Remove from `core-js@4`
var $$b = _export;
var $group = arrayGroup;
var arrayMethodIsStrict$1 = arrayMethodIsStrict$b;
var addToUnscopables$a = addToUnscopables$n;

// `Array.prototype.groupBy` method
// https://github.com/tc39/proposal-array-grouping
// https://bugs.webkit.org/show_bug.cgi?id=236541
$$b({ target: 'Array', proto: true, forced: !arrayMethodIsStrict$1('groupBy') }, {
  groupBy: function groupBy(callbackfn /* , thisArg */) {
    var thisArg = arguments.length > 1 ? arguments[1] : undefined;
    return $group(this, callbackfn, thisArg);
  }
});

addToUnscopables$a('groupBy');

var getBuiltIn$5 = getBuiltIn$g;
var bind$1 = functionBindContext;
var uncurryThis$2 = functionUncurryThis;
var IndexedObject = indexedObject;
var toObject$4 = toObject$m;
var lengthOfArrayLike$6 = lengthOfArrayLike$t;

var Map$2 = getBuiltIn$5('Map');
var MapPrototype$1 = Map$2.prototype;
var mapGet = uncurryThis$2(MapPrototype$1.get);
var mapHas$1 = uncurryThis$2(MapPrototype$1.has);
var mapSet$1 = uncurryThis$2(MapPrototype$1.set);
var push$1 = uncurryThis$2([].push);

// `Array.prototype.groupToMap` method
// https://github.com/tc39/proposal-array-grouping
var arrayGroupToMap = function groupToMap(callbackfn /* , thisArg */) {
  var O = toObject$4(this);
  var self = IndexedObject(O);
  var boundFunction = bind$1(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  var map = new Map$2();
  var length = lengthOfArrayLike$6(self);
  var index = 0;
  var key, value;
  for (;length > index; index++) {
    value = self[index];
    key = boundFunction(value, index, O);
    if (mapHas$1(map, key)) push$1(mapGet(map, key), value);
    else mapSet$1(map, key, [value]);
  } return map;
};

// TODO: Remove from `core-js@4`
var $$a = _export;
var arrayMethodIsStrict = arrayMethodIsStrict$b;
var addToUnscopables$9 = addToUnscopables$n;
var $groupToMap$1 = arrayGroupToMap;

// `Array.prototype.groupByToMap` method
// https://github.com/tc39/proposal-array-grouping
// https://bugs.webkit.org/show_bug.cgi?id=236541
$$a({ target: 'Array', proto: true, name: 'groupToMap', forced: !arrayMethodIsStrict('groupByToMap') }, {
  groupByToMap: $groupToMap$1
});

addToUnscopables$9('groupByToMap');

var $$9 = _export;
var addToUnscopables$8 = addToUnscopables$n;
var $groupToMap = arrayGroupToMap;

// `Array.prototype.groupToMap` method
// https://github.com/tc39/proposal-array-grouping
$$9({ target: 'Array', proto: true }, {
  groupToMap: $groupToMap
});

addToUnscopables$8('groupToMap');

var lengthOfArrayLike$5 = lengthOfArrayLike$t;

// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toReversed
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.toReversed
var arrayToReversed$1 = function (O, C) {
  var len = lengthOfArrayLike$5(O);
  var A = new C(len);
  var k = 0;
  for (; k < len; k++) A[k] = O[len - k - 1];
  return A;
};

var $$8 = _export;
var arrayToReversed = arrayToReversed$1;
var toIndexedObject$3 = toIndexedObject$d;
var addToUnscopables$7 = addToUnscopables$n;

var $Array$3 = Array;

// `Array.prototype.toReversed` method
// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toReversed
$$8({ target: 'Array', proto: true }, {
  toReversed: function toReversed() {
    return arrayToReversed(toIndexedObject$3(this), $Array$3);
  }
});

addToUnscopables$7('toReversed');

var global$2 = global$n;

var entryVirtual = function (CONSTRUCTOR) {
  return global$2[CONSTRUCTOR].prototype;
};

var $$7 = _export;
var uncurryThis$1 = functionUncurryThis;
var aCallable$3 = aCallable$g;
var toIndexedObject$2 = toIndexedObject$d;
var arrayFromConstructorAndList = arrayFromConstructorAndList$2;
var getVirtual$1 = entryVirtual;
var addToUnscopables$6 = addToUnscopables$n;

var $Array$2 = Array;
var sort = uncurryThis$1(getVirtual$1('Array').sort);

// `Array.prototype.toSorted` method
// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toSorted
$$7({ target: 'Array', proto: true }, {
  toSorted: function toSorted(compareFn) {
    if (compareFn !== undefined) aCallable$3(compareFn);
    var O = toIndexedObject$2(this);
    var A = arrayFromConstructorAndList($Array$2, O);
    return sort(A, compareFn);
  }
});

addToUnscopables$6('toSorted');

var $$6 = _export;
var addToUnscopables$5 = addToUnscopables$n;
var doesNotExceedSafeInteger$1 = doesNotExceedSafeInteger$7;
var lengthOfArrayLike$4 = lengthOfArrayLike$t;
var toAbsoluteIndex = toAbsoluteIndex$7;
var toIndexedObject$1 = toIndexedObject$d;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$9;

var $Array$1 = Array;
var max = Math.max;
var min = Math.min;

// `Array.prototype.toSpliced` method
// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toSpliced
$$6({ target: 'Array', proto: true }, {
  toSpliced: function toSpliced(start, deleteCount /* , ...items */) {
    var O = toIndexedObject$1(this);
    var len = lengthOfArrayLike$4(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var k = 0;
    var insertCount, actualDeleteCount, newLen, A;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity$1(deleteCount), 0), len - actualStart);
    }
    newLen = doesNotExceedSafeInteger$1(len + insertCount - actualDeleteCount);
    A = $Array$1(newLen);

    for (; k < actualStart; k++) A[k] = O[k];
    for (; k < actualStart + insertCount; k++) A[k] = arguments[k - actualStart + 2];
    for (; k < newLen; k++) A[k] = O[k + actualDeleteCount - insertCount];

    return A;
  }
});

addToUnscopables$5('toSpliced');

var lengthOfArrayLike$3 = lengthOfArrayLike$t;
var toIntegerOrInfinity = toIntegerOrInfinity$9;

var $RangeError = RangeError;

// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.with
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.with
var arrayWith$1 = function (O, C, index, value) {
  var len = lengthOfArrayLike$3(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualIndex = relativeIndex < 0 ? len + relativeIndex : relativeIndex;
  if (actualIndex >= len || actualIndex < 0) throw $RangeError('Incorrect index');
  var A = new C(len);
  var k = 0;
  for (; k < len; k++) A[k] = k === actualIndex ? value : O[k];
  return A;
};

var $$5 = _export;
var arrayWith = arrayWith$1;
var toIndexedObject = toIndexedObject$d;

var $Array = Array;

// `Array.prototype.with` method
// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.with
$$5({ target: 'Array', proto: true }, {
  'with': function (index, value) {
    return arrayWith(toIndexedObject(this), $Array, index, value);
  }
});

var parent$1 = array$2;













var array$1 = parent$1;

var global$1 = global$n;
var shared = sharedStore;
var isCallable = isCallable$o;
var getPrototypeOf = objectGetPrototypeOf;
var defineBuiltIn = defineBuiltIn$a;
var wellKnownSymbol$2 = wellKnownSymbol$m;

var USE_FUNCTION_CONSTRUCTOR = 'USE_FUNCTION_CONSTRUCTOR';
var ASYNC_ITERATOR$2 = wellKnownSymbol$2('asyncIterator');
var AsyncIterator = global$1.AsyncIterator;
var PassedAsyncIteratorPrototype = shared.AsyncIteratorPrototype;
var AsyncIteratorPrototype$1, prototype;

if (PassedAsyncIteratorPrototype) {
  AsyncIteratorPrototype$1 = PassedAsyncIteratorPrototype;
} else if (isCallable(AsyncIterator)) {
  AsyncIteratorPrototype$1 = AsyncIterator.prototype;
} else if (shared[USE_FUNCTION_CONSTRUCTOR] || global$1[USE_FUNCTION_CONSTRUCTOR]) {
  try {
    // eslint-disable-next-line no-new-func -- we have no alternatives without usage of modern syntax
    prototype = getPrototypeOf(getPrototypeOf(getPrototypeOf(Function('return async function*(){}()')())));
    if (getPrototypeOf(prototype) === Object.prototype) AsyncIteratorPrototype$1 = prototype;
  } catch (error) { /* empty */ }
}

if (!AsyncIteratorPrototype$1) AsyncIteratorPrototype$1 = {};

if (!isCallable(AsyncIteratorPrototype$1[ASYNC_ITERATOR$2])) {
  defineBuiltIn(AsyncIteratorPrototype$1, ASYNC_ITERATOR$2, function () {
    return this;
  });
}

var asyncIteratorPrototype = AsyncIteratorPrototype$1;

var call$3 = functionCall;
var anObject$3 = anObject$f;
var create = objectCreate$1;
var getMethod$3 = getMethod$7;
var defineBuiltIns = defineBuiltIns$2;
var InternalStateModule = internalState;
var getBuiltIn$4 = getBuiltIn$g;
var AsyncIteratorPrototype = asyncIteratorPrototype;

var Promise$1 = getBuiltIn$4('Promise');

var ASYNC_FROM_SYNC_ITERATOR = 'AsyncFromSyncIterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ASYNC_FROM_SYNC_ITERATOR);

var asyncFromSyncIteratorContinuation = function (result, resolve, reject) {
  var done = result.done;
  Promise$1.resolve(result.value).then(function (value) {
    resolve({ done: done, value: value });
  }, reject);
};

var AsyncFromSyncIterator$2 = function AsyncIterator(iterator) {
  setInternalState(this, {
    type: ASYNC_FROM_SYNC_ITERATOR,
    iterator: anObject$3(iterator),
    next: iterator.next
  });
};

AsyncFromSyncIterator$2.prototype = defineBuiltIns(create(AsyncIteratorPrototype), {
  next: function next() {
    var state = getInternalState(this);
    return new Promise$1(function (resolve, reject) {
      var result = anObject$3(call$3(state.next, state.iterator));
      asyncFromSyncIteratorContinuation(result, resolve, reject);
    });
  },
  'return': function () {
    var iterator = getInternalState(this).iterator;
    return new Promise$1(function (resolve, reject) {
      var $return = getMethod$3(iterator, 'return');
      if ($return === undefined) return resolve({ done: true, value: undefined });
      var result = anObject$3(call$3($return, iterator));
      asyncFromSyncIteratorContinuation(result, resolve, reject);
    });
  }
});

var asyncFromSyncIterator = AsyncFromSyncIterator$2;

var call$2 = functionCall;
var AsyncFromSyncIterator$1 = asyncFromSyncIterator;
var anObject$2 = anObject$f;
var getIterator$1 = getIterator$4;
var getMethod$2 = getMethod$7;
var wellKnownSymbol$1 = wellKnownSymbol$m;

var ASYNC_ITERATOR$1 = wellKnownSymbol$1('asyncIterator');

var getAsyncIterator$1 = function (it, usingIterator) {
  var method = arguments.length < 2 ? getMethod$2(it, ASYNC_ITERATOR$1) : usingIterator;
  return method ? anObject$2(call$2(method, it)) : new AsyncFromSyncIterator$1(getIterator$1(it));
};

var aCallable$2 = aCallable$g;
var anObject$1 = anObject$f;

var getIteratorDirect$1 = function (obj) {
  return {
    iterator: obj,
    next: aCallable$2(anObject$1(obj).next)
  };
};

var call$1 = functionCall;
var getBuiltIn$3 = getBuiltIn$g;
var getMethod$1 = getMethod$7;

var asyncIteratorClose = function (iterator, method, argument, reject) {
  try {
    var returnMethod = getMethod$1(iterator, 'return');
    if (returnMethod) {
      return getBuiltIn$3('Promise').resolve(call$1(returnMethod, iterator)).then(function () {
        method(argument);
      }, function (error) {
        reject(error);
      });
    }
  } catch (error2) {
    return reject(error2);
  } method(argument);
};

// https://github.com/tc39/proposal-iterator-helpers
// https://github.com/tc39/proposal-array-from-async
var call = functionCall;
var aCallable$1 = aCallable$g;
var anObject = anObject$f;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$7;
var getBuiltIn$2 = getBuiltIn$g;
var getIteratorDirect = getIteratorDirect$1;
var closeAsyncIteration = asyncIteratorClose;

var createMethod = function (TYPE) {
  var IS_TO_ARRAY = TYPE == 0;
  var IS_FOR_EACH = TYPE == 1;
  var IS_EVERY = TYPE == 2;
  var IS_SOME = TYPE == 3;
  return function (object, fn, target) {
    var record = getIteratorDirect(object);
    var Promise = getBuiltIn$2('Promise');
    var iterator = record.iterator;
    var next = record.next;
    var index = 0;
    var MAPPING = fn !== undefined;
    if (MAPPING || !IS_TO_ARRAY) aCallable$1(fn);

    return new Promise(function (resolve, reject) {
      var ifAbruptCloseAsyncIterator = function (error) {
        closeAsyncIteration(iterator, reject, error, reject);
      };

      var loop = function () {
        try {
          if (IS_TO_ARRAY && MAPPING) try {
            doesNotExceedSafeInteger(index);
          } catch (error5) { ifAbruptCloseAsyncIterator(error5); }
          Promise.resolve(anObject(call(next, iterator))).then(function (step) {
            try {
              if (anObject(step).done) {
                if (IS_TO_ARRAY) {
                  target.length = index;
                  resolve(target);
                } else resolve(IS_SOME ? false : IS_EVERY || undefined);
              } else {
                var value = step.value;
                try {
                  if (MAPPING) {
                    Promise.resolve(IS_TO_ARRAY ? fn(value, index) : fn(value)).then(function (result) {
                      if (IS_FOR_EACH) {
                        loop();
                      } else if (IS_EVERY) {
                        result ? loop() : closeAsyncIteration(iterator, resolve, false, reject);
                      } else if (IS_TO_ARRAY) {
                        try {
                          target[index++] = result;
                          loop();
                        } catch (error4) { ifAbruptCloseAsyncIterator(error4); }
                      } else {
                        result ? closeAsyncIteration(iterator, resolve, IS_SOME || value, reject) : loop();
                      }
                    }, ifAbruptCloseAsyncIterator);
                  } else {
                    target[index++] = value;
                    loop();
                  }
                } catch (error3) { ifAbruptCloseAsyncIterator(error3); }
              }
            } catch (error2) { reject(error2); }
          }, reject);
        } catch (error) { reject(error); }
      };

      loop();
    });
  };
};

var asyncIteratorIteration = {
  toArray: createMethod(0),
  forEach: createMethod(1),
  every: createMethod(2),
  some: createMethod(3),
  find: createMethod(4)
};

var bind = functionBindContext;
var toObject$3 = toObject$m;
var isConstructor = isConstructor$6;
var getAsyncIterator = getAsyncIterator$1;
var getIterator = getIterator$4;
var getIteratorMethod = getIteratorMethod$4;
var getMethod = getMethod$7;
var getVirtual = entryVirtual;
var getBuiltIn$1 = getBuiltIn$g;
var wellKnownSymbol = wellKnownSymbol$m;
var AsyncFromSyncIterator = asyncFromSyncIterator;
var toArray = asyncIteratorIteration.toArray;

var ASYNC_ITERATOR = wellKnownSymbol('asyncIterator');
var arrayIterator = getVirtual('Array').values;

// `Array.fromAsync` method implementation
// https://github.com/tc39/proposal-array-from-async
var arrayFromAsync = function fromAsync(asyncItems /* , mapfn = undefined, thisArg = undefined */) {
  var C = this;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var thisArg = argumentsLength > 2 ? arguments[2] : undefined;
  return new (getBuiltIn$1('Promise'))(function (resolve) {
    var O = toObject$3(asyncItems);
    if (mapfn !== undefined) mapfn = bind(mapfn, thisArg);
    var usingAsyncIterator = getMethod(O, ASYNC_ITERATOR);
    var usingSyncIterator = usingAsyncIterator ? undefined : getIteratorMethod(O) || arrayIterator;
    var A = isConstructor(C) ? new C() : [];
    var iterator = usingAsyncIterator
      ? getAsyncIterator(O, usingAsyncIterator)
      : new AsyncFromSyncIterator(getIterator(O, usingSyncIterator));
    resolve(toArray(iterator, mapfn, A));
  });
};

var $$4 = _export;
var fromAsync = arrayFromAsync;

// `Array.fromAsync` method
// https://github.com/tc39/proposal-array-from-async
$$4({ target: 'Array', stat: true, forced: true }, {
  fromAsync: fromAsync
});

// TODO: remove from `core-js@4`
var $$3 = _export;
var $filterReject$1 = arrayIteration.filterReject;
var addToUnscopables$4 = addToUnscopables$n;

// `Array.prototype.filterOut` method
// https://github.com/tc39/proposal-array-filtering
$$3({ target: 'Array', proto: true, forced: true }, {
  filterOut: function filterOut(callbackfn /* , thisArg */) {
    return $filterReject$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

addToUnscopables$4('filterOut');

var $$2 = _export;
var $filterReject = arrayIteration.filterReject;
var addToUnscopables$3 = addToUnscopables$n;

// `Array.prototype.filterReject` method
// https://github.com/tc39/proposal-array-filtering
$$2({ target: 'Array', proto: true, forced: true }, {
  filterReject: function filterReject(callbackfn /* , thisArg */) {
    return $filterReject(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

addToUnscopables$3('filterReject');

var $$1 = _export;
var isArray = isArray$7;

// eslint-disable-next-line es-x/no-object-isfrozen -- safe
var isFrozen = Object.isFrozen;

var isFrozenStringArray = function (array, allowUndefined) {
  if (!isFrozen || !isArray(array) || !isFrozen(array)) return false;
  var index = 0;
  var length = array.length;
  var element;
  while (index < length) {
    element = array[index++];
    if (!(typeof element == 'string' || (allowUndefined && typeof element == 'undefined'))) {
      return false;
    }
  } return length !== 0;
};

// `Array.isTemplateObject` method
// https://github.com/tc39/proposal-array-is-template-object
$$1({ target: 'Array', stat: true, sham: true, forced: true }, {
  isTemplateObject: function isTemplateObject(value) {
    if (!isFrozenStringArray(value, true)) return false;
    var raw = value.raw;
    return raw.length === value.length && isFrozenStringArray(raw, false);
  }
});

var makeBuiltIn = makeBuiltIn$3.exports;
var defineProperty = objectDefineProperty;

var defineBuiltInAccessor$2 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};

// TODO: Remove from `core-js@4`
var DESCRIPTORS$1 = descriptors;
var addToUnscopables$2 = addToUnscopables$n;
var toObject$2 = toObject$m;
var lengthOfArrayLike$2 = lengthOfArrayLike$t;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$2;

// `Array.prototype.lastIndex` accessor
// https://github.com/keithamus/proposal-array-last
if (DESCRIPTORS$1) {
  defineBuiltInAccessor$1(Array.prototype, 'lastItem', {
    configurable: true,
    get: function lastItem() {
      var O = toObject$2(this);
      var len = lengthOfArrayLike$2(O);
      return len == 0 ? undefined : O[len - 1];
    },
    set: function lastItem(value) {
      var O = toObject$2(this);
      var len = lengthOfArrayLike$2(O);
      return O[len == 0 ? 0 : len - 1] = value;
    }
  });

  addToUnscopables$2('lastItem');
}

// TODO: Remove from `core-js@4`
var DESCRIPTORS = descriptors;
var addToUnscopables$1 = addToUnscopables$n;
var toObject$1 = toObject$m;
var lengthOfArrayLike$1 = lengthOfArrayLike$t;
var defineBuiltInAccessor = defineBuiltInAccessor$2;

// `Array.prototype.lastIndex` getter
// https://github.com/keithamus/proposal-array-last
if (DESCRIPTORS) {
  defineBuiltInAccessor(Array.prototype, 'lastIndex', {
    configurable: true,
    get: function lastIndex() {
      var O = toObject$1(this);
      var len = lengthOfArrayLike$1(O);
      return len == 0 ? 0 : len - 1;
    }
  });

  addToUnscopables$1('lastIndex');
}

var getBuiltIn = getBuiltIn$g;
var uncurryThis = functionUncurryThis;
var aCallable = aCallable$g;
var lengthOfArrayLike = lengthOfArrayLike$t;
var toObject = toObject$m;
var arraySpeciesCreate = arraySpeciesCreate$6;

var Map$1 = getBuiltIn('Map');
var MapPrototype = Map$1.prototype;
var mapForEach = uncurryThis(MapPrototype.forEach);
var mapHas = uncurryThis(MapPrototype.has);
var mapSet = uncurryThis(MapPrototype.set);
var push = uncurryThis([].push);

// `Array.prototype.uniqueBy` method
// https://github.com/tc39/proposal-array-unique
var arrayUniqueBy = function uniqueBy(resolver) {
  var that = toObject(this);
  var length = lengthOfArrayLike(that);
  var result = arraySpeciesCreate(that, 0);
  var map = new Map$1();
  var resolverFunction = resolver != null ? aCallable(resolver) : function (value) {
    return value;
  };
  var index, item, key;
  for (index = 0; index < length; index++) {
    item = that[index];
    key = resolverFunction(item);
    if (!mapHas(map, key)) mapSet(map, key, item);
  }
  mapForEach(map, function (value) {
    push(result, value);
  });
  return result;
};

var $ = _export;
var addToUnscopables = addToUnscopables$n;
var uniqueBy = arrayUniqueBy;

// `Array.prototype.uniqueBy` method
// https://github.com/tc39/proposal-array-unique
$({ target: 'Array', proto: true, forced: true }, {
  uniqueBy: uniqueBy
});

addToUnscopables('uniqueBy');

var parent = array$1;


// TODO: Remove from `core-js@4`

// TODO: Remove from `core-js@4`







var array = parent;

(function (module) {
	module.exports = array;
} (array$4));

var UserEvent = /** @class */ (function () {
    function UserEvent(timestamp, user, insertId) {
        if (insertId === void 0) { insertId = v4(); }
        this.timestamp = timestamp;
        this.user = user;
        this.insertId = insertId;
    }
    UserEvent.exposure = function (user, evaluation, properties, timestamp) {
        return new ExposureEvent(timestamp, user, evaluation.experiment, evaluation.variationId, evaluation.variationKey, evaluation.reason, properties);
    };
    UserEvent.track = function (eventType, event, user, timestamp) {
        return new TrackEvent(timestamp, user, eventType, event);
    };
    UserEvent.remoteConfig = function (user, evaluation, properties, timestamp) {
        return new RemoteConfigEvent(timestamp, user, evaluation.parameter, evaluation.valueId, evaluation.reason, properties);
    };
    UserEvent.isExposureEvent = function (event) {
        return event.experiment !== undefined;
    };
    UserEvent.isTrackEvent = function (event) {
        return event.eventType !== undefined;
    };
    UserEvent.isRemoteConfigEvent = function (event) {
        return event.parameter !== undefined;
    };
    UserEvent.isExposureEventDto = function (event) {
        return ("experimentId" in event && typeof event.experimentId !== "undefined");
    };
    UserEvent.isTrackEventDto = function (event) {
        return "eventTypeId" in event && typeof event.eventTypeId !== "undefined";
    };
    UserEvent.isRemoteConfigEventDto = function (event) {
        return ("parameterId" in event &&
            typeof event.parameterId !== "undefined");
    };
    UserEvent.prototype.toDto = function () {
        return {
            insertId: this.insertId,
            timestamp: this.timestamp,
            userId: this.user.identifiers[IdentifierType.ID],
            identifiers: this.user.identifiers,
            userProperties: PropertyUtil.sanitize(this.user.properties),
            hackleProperties: PropertyUtil.sanitize(this.user.hackleProperties)
        };
    };
    return UserEvent;
}());
var ExposureEvent = /** @class */ (function (_super) {
    __extends(ExposureEvent, _super);
    function ExposureEvent(timestamp, user, experiment, variationId, variationKey, decisionReason, properties, insertId) {
        var _this = _super.call(this, timestamp, user, insertId) || this;
        _this.experiment = experiment;
        _this.variationId = variationId;
        _this.variationKey = variationKey;
        _this.decisionReason = decisionReason;
        _this.properties = properties;
        return _this;
    }
    ExposureEvent.prototype.copyWithUser = function (user) {
        return new ExposureEvent(this.timestamp, user, this.experiment, this.variationId, this.variationKey, this.decisionReason, this.properties, this.insertId);
    };
    ExposureEvent.prototype.toDto = function () {
        return __assign(__assign({}, _super.prototype.toDto.call(this)), { experimentId: this.experiment.id, experimentKey: this.experiment.key, experimentType: this.experiment.type, experimentVersion: this.experiment.version, variationId: this.variationId, variationKey: this.variationKey, decisionReason: this.decisionReason.toString(), properties: this.properties });
    };
    return ExposureEvent;
}(UserEvent));
var TrackEvent = /** @class */ (function (_super) {
    __extends(TrackEvent, _super);
    function TrackEvent(timestamp, user, eventType, event, insertId) {
        var _this = _super.call(this, timestamp, user, insertId) || this;
        _this.eventType = eventType;
        _this.event = event;
        return _this;
    }
    TrackEvent.prototype.copyWithUser = function (user) {
        return new TrackEvent(this.timestamp, user, this.eventType, this.event, this.insertId);
    };
    TrackEvent.prototype.toDto = function () {
        return __assign(__assign({}, _super.prototype.toDto.call(this)), { eventTypeId: this.eventType.id, eventTypeKey: this.eventType.key, value: this.event.value || 0, properties: PropertyUtil.sanitize(this.event.properties) });
    };
    return TrackEvent;
}(UserEvent));
var RemoteConfigEvent = /** @class */ (function (_super) {
    __extends(RemoteConfigEvent, _super);
    function RemoteConfigEvent(timestamp, user, parameter, valueId, decisionReason, properties, insertId) {
        var _this = _super.call(this, timestamp, user, insertId) || this;
        _this.parameter = parameter;
        _this.valueId = valueId;
        _this.decisionReason = decisionReason;
        _this.properties = properties;
        return _this;
    }
    RemoteConfigEvent.prototype.copyWithUser = function (user) {
        return new RemoteConfigEvent(this.timestamp, user, this.parameter, this.valueId, this.decisionReason, this.properties, this.insertId);
    };
    RemoteConfigEvent.prototype.toDto = function () {
        return __assign(__assign({}, _super.prototype.toDto.call(this)), { parameterId: this.parameter.id, parameterKey: this.parameter.key, parameterType: this.parameter.type, valueId: this.valueId, decisionReason: this.decisionReason.toString(), properties: PropertyUtil.sanitize(this.properties) });
    };
    return RemoteConfigEvent;
}(UserEvent));

var SessionEventTracker = /** @class */ (function () {
    function SessionEventTracker(userManager, core) {
        this.userManager = userManager;
        this.core = core;
    }
    SessionEventTracker.isSessionEvent = function (event) {
        if (!UserEvent.isTrackEvent(event)) {
            return false;
        }
        return (event.event.key === SessionEventTracker.SESSION_START_EVENT_NAME ||
            event.event.key === SessionEventTracker.SESSION_END_EVENT_NAME);
    };
    SessionEventTracker.prototype.onSessionStarted = function (sessionId, user, timestamp) {
        this.track(SessionEventTracker.SESSION_START_EVENT_NAME, sessionId, user, timestamp);
    };
    SessionEventTracker.prototype.onSessionEnded = function (sessionId, user, timestamp) {
        this.track(SessionEventTracker.SESSION_END_EVENT_NAME, sessionId, user, timestamp);
    };
    SessionEventTracker.prototype.track = function (eventKey, sessionId, user, timestamp) {
        var hackleEvent = { key: eventKey };
        var hackleUser = this.userManager.toHackleUser(user);
        var decoratedUser = this.decorateSession(hackleUser, sessionId);
        this.core.track(hackleEvent, decoratedUser, timestamp);
    };
    SessionEventTracker.prototype.decorateSession = function (user, sessionId) {
        var identifiers = new IdentifiersBuilder()
            .add(IdentifierType.SESSION, sessionId)
            .addIdentifiers(user.identifiers)
            .build();
        return __assign(__assign({}, user), { identifiers: identifiers });
    };
    SessionEventTracker.SESSION_START_EVENT_NAME = "$session_start";
    SessionEventTracker.SESSION_END_EVENT_NAME = "$session_end";
    return SessionEventTracker;
}());

var BrowserEventProcessor = /** @class */ (function () {
    function BrowserEventProcessor(delegate, eventDedupDeterminer, sessionManager, userManager) {
        this.delegate = delegate;
        this.eventDedupDeterminer = eventDedupDeterminer;
        this.sessionManager = sessionManager;
        this.userManager = userManager;
        this.decorators = [];
    }
    BrowserEventProcessor.prototype.addDecorator = function (decorator) {
        this.decorators.push(decorator);
    };
    BrowserEventProcessor.prototype.process = function (event) {
        if (!SessionEventTracker.isSessionEvent(event)) {
            this.sessionManager.startNewSessionIfNeeded(this.userManager.currentUser, event.timestamp);
        }
        if (this.eventDedupDeterminer.isDedupTarget(event)) {
            return;
        }
        var decoratedEvent = this.decorators.reduce(function (acc, decorator) { return decorator.decorate(acc); }, event);
        this.delegate.process(decoratedEvent);
    };
    BrowserEventProcessor.prototype.flush = function (sync) {
        this.delegate.flush(sync);
    };
    BrowserEventProcessor.prototype.close = function () {
        this.delegate.close();
    };
    BrowserEventProcessor.prototype.onLifecycleChanged = function (lifecycle, _) {
        switch (lifecycle) {
            case "hidden":
            case "pagehide":
                return this.flush(true);
            case "blur":
            case "focus":
            case "locationChange":
            case "visible":
            case "pageshow":
                return;
        }
    };
    return BrowserEventProcessor;
}());

var TraceTransformer = /** @class */ (function () {
    function TraceTransformer() {
    }
    TraceTransformer.toEvent = function (exception) {
        var _a;
        return {
            key: TraceTransformer.EVENT_KEY,
            properties: {
                level: TraceTransformer.LEVEL_ERROR,
                type: exception.name,
                message: (_a = exception.message) !== null && _a !== void 0 ? _a : "",
                $stacktrace: TraceTransformer._stacktrace(exception)
            }
        };
    };
    TraceTransformer._stacktrace = function (exception) {
        if (ObjectUtil.isNullOrUndefined(exception.stack)) {
            return "";
        }
        return exception.stack.split("\n")
            .slice(0, TraceTransformer.STACK_TRACK_LIMIT)
            .join("\n");
    };
    TraceTransformer.EVENT_KEY = "$trace";
    TraceTransformer.LEVEL_ERROR = "error";
    TraceTransformer.STACK_TRACK_LIMIT = 30;
    return TraceTransformer;
}());

var ContextualEvaluator = /** @class */ (function () {
    function ContextualEvaluator() {
    }
    ContextualEvaluator.prototype.evaluate = function (request, context) {
        if (!this.supports(request)) {
            throw new Error("Unsupported EvaluatorRequest ".concat(request.toString()));
        }
        if (context.contains(request)) {
            var stack = context.stack.map(function (it) { return it.toString(); }).join(" - ");
            throw new Error("Circular evaluation has occurred [".concat(stack, " - ").concat(request.toString(), "]"));
        }
        context.addRequest(request);
        try {
            return this.evaluateInternal(request, context);
        }
        finally {
            context.removeRequest(request);
        }
    };
    return ContextualEvaluator;
}());

var ExperimentEvaluation = /** @class */ (function () {
    function ExperimentEvaluation(reason, targetEvaluations, experiment, variationId, variationKey, config) {
        this.reason = reason;
        this.targetEvaluations = targetEvaluations;
        this.experiment = experiment;
        this.variationId = variationId;
        this.variationKey = variationKey;
        this.config = config;
    }
    ExperimentEvaluation.prototype.with = function (reason) {
        return new ExperimentEvaluation(reason, this.targetEvaluations, this.experiment, this.variationId, this.variationKey, this.config);
    };
    ExperimentEvaluation.of = function (request, context, variation, reason) {
        return new ExperimentEvaluation(reason, context.targetEvaluations, request.experiment, variation.id, variation.key, variation.config);
    };
    ExperimentEvaluation.ofDefault = function (request, context, reason) {
        var variation = request.experiment._getVariationByKeyOrNull(request.defaultVariationKey);
        if (ObjectUtil.isNotNullOrUndefined(variation)) {
            return this.of(request, context, variation, reason);
        }
        else {
            return new ExperimentEvaluation(reason, context.targetEvaluations, request.experiment, undefined, request.defaultVariationKey, undefined);
        }
    };
    return ExperimentEvaluation;
}());

var ExperimentEvaluator = /** @class */ (function (_super) {
    __extends(ExperimentEvaluator, _super);
    function ExperimentEvaluator(evaluationFlowFactory) {
        var _this = _super.call(this) || this;
        _this.experimentFlowFactory = evaluationFlowFactory;
        return _this;
    }
    ExperimentEvaluator.prototype.supports = function (request) {
        return request.experiment !== undefined;
    };
    ExperimentEvaluator.prototype.evaluateInternal = function (request, context) {
        var _a;
        var evaluationFlow = this.experimentFlowFactory.getExperimentFlow(request.experiment.type);
        return ((_a = evaluationFlow.evaluate(request, context)) !== null && _a !== void 0 ? _a : ExperimentEvaluation.ofDefault(request, context, DecisionReason.TRAFFIC_NOT_ALLOCATED));
    };
    return ExperimentEvaluator;
}(ContextualEvaluator));

var RemoteConfigEvaluation = /** @class */ (function () {
    function RemoteConfigEvaluation(reason, targetEvaluations, parameter, valueId, value, properties) {
        this.reason = reason;
        this.targetEvaluations = targetEvaluations;
        this.parameter = parameter;
        this.valueId = valueId;
        this.value = value;
        this.properties = properties;
    }
    RemoteConfigEvaluation.of = function (request, context, valueId, value, reason, properties) {
        properties["returnValue"] = PropertyUtil.truncateStringValue(value);
        return new RemoteConfigEvaluation(reason, context.targetEvaluations, request.parameter, valueId, value, properties);
    };
    RemoteConfigEvaluation.ofDefault = function (request, context, reason, properties) {
        return this.of(request, context, undefined, request.defaultValue, reason, properties);
    };
    return RemoteConfigEvaluation;
}());

var RemoteConfigEvaluator = /** @class */ (function (_super) {
    __extends(RemoteConfigEvaluator, _super);
    function RemoteConfigEvaluator(targetRuleDeterminer) {
        var _this = _super.call(this) || this;
        _this.targetRuleDeterminer = targetRuleDeterminer;
        return _this;
    }
    RemoteConfigEvaluator.prototype.supports = function (request) {
        return request.parameter !== undefined;
    };
    RemoteConfigEvaluator.prototype.evaluateInternal = function (request, context) {
        var properties = {};
        properties["requestValueType"] = request.requiredType;
        properties["requestDefaultValue"] = PropertyUtil.truncateStringValue(request.defaultValue);
        if (ObjectUtil.isNullOrUndefined(request.user.identifiers[request.parameter.identifierType])) {
            return RemoteConfigEvaluation.ofDefault(request, context, DecisionReason.IDENTIFIER_NOT_FOUND, properties);
        }
        var targetRule = this.targetRuleDeterminer.determineTargetRuleOrNull(request, context);
        if (ObjectUtil.isNotNullOrUndefined(targetRule)) {
            properties["targetRuleKey"] = targetRule.key;
            properties["targetRuleName"] = targetRule.name;
            return this.evaluation(request, context, targetRule.value, DecisionReason.TARGET_RULE_MATCH, properties);
        }
        return this.evaluation(request, context, request.parameter.defaultValue, DecisionReason.DEFAULT_RULE, properties);
    };
    RemoteConfigEvaluator.prototype.evaluation = function (request, context, parameterValue, reason, properties) {
        if (request.requiredType === "UNKNOWN" ||
            (request.requiredType !== "NULL" && typeof request.defaultValue !== typeof parameterValue.rawValue)) {
            return RemoteConfigEvaluation.ofDefault(request, context, DecisionReason.TYPE_MISMATCH, properties);
        }
        return RemoteConfigEvaluation.of(request, context, parameterValue.id, parameterValue.rawValue, reason, properties);
    };
    return RemoteConfigEvaluator;
}(ContextualEvaluator));

var EvaluatorKey = /** @class */ (function () {
    function EvaluatorKey(type, id) {
        this.type = type;
        this.id = id;
    }
    EvaluatorKey.prototype.isEquals = function (other) {
        return this.type === other.type && this.id === other.id;
    };
    return EvaluatorKey;
}());
var EvaluatorContext = /** @class */ (function () {
    function EvaluatorContext() {
        this._stack = [];
        this._targetEvaluations = [];
        this._properties = {};
        this.map = new WeakMap();
    }
    EvaluatorContext.create = function () {
        return new EvaluatorContext();
    };
    Object.defineProperty(EvaluatorContext.prototype, "stack", {
        get: function () {
            return Array.from(this._stack);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvaluatorContext.prototype, "targetEvaluations", {
        get: function () {
            return Array.from(this._targetEvaluations);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvaluatorContext.prototype, "properties", {
        get: function () {
            return PropertyUtil.sanitize(this._properties);
        },
        enumerable: false,
        configurable: true
    });
    EvaluatorContext.prototype.contains = function (request) {
        return this._stack.some(function (it) { return it.key.isEquals(request.key); });
    };
    EvaluatorContext.prototype.addRequest = function (request) {
        this._stack.push(request);
    };
    EvaluatorContext.prototype.removeRequest = function (request) {
        var index = this._stack.indexOf(request, 0);
        if (index > -1) {
            this._stack.splice(index, 1);
        }
    };
    EvaluatorContext.prototype.getEvaluation = function (experiment) {
        return this._targetEvaluations.find(function (it) { return it instanceof ExperimentEvaluation && it.experiment.id === experiment.id; });
    };
    EvaluatorContext.prototype.addEvaluation = function (evaluation) {
        this._targetEvaluations.push(evaluation);
    };
    EvaluatorContext.prototype.setProperty = function (key, value) {
        this._properties[key] = value;
    };
    EvaluatorContext.prototype.get = function (key) {
        var value = this.map.get(key);
        if (!value)
            return null;
        // NoSuchElementException
        if (!(value instanceof key)) {
            throw new Error("Context does not contain a value of type ".concat(key.name));
        }
        return value;
    };
    EvaluatorContext.prototype.set = function (key, value) {
        this.map.set(key, value);
    };
    return EvaluatorContext;
}());

var ExperimentRequest = /** @class */ (function () {
    function ExperimentRequest(workspace, user, experiment, defaultVariationKey) {
        this.key = new EvaluatorKey("EXPERIMENT", experiment.id);
        this.workspace = workspace;
        this.user = user;
        this.experiment = experiment;
        this.defaultVariationKey = defaultVariationKey;
    }
    ExperimentRequest.of = function (workspace, user, experiment, defaultVariationKey) {
        return new ExperimentRequest(workspace, user, experiment, defaultVariationKey);
    };
    ExperimentRequest.by = function (requestedBy, experiment) {
        return new ExperimentRequest(requestedBy.workspace, requestedBy.user, experiment, "A");
    };
    ExperimentRequest.prototype.toString = function () {
        return "EvaluatorRequest(type=".concat(this.experiment.type, ", key=").concat(this.experiment.key, ")");
    };
    return ExperimentRequest;
}());

var RemoteConfigRequest = /** @class */ (function () {
    function RemoteConfigRequest(workspace, user, parameter, requiredType, defaultValue) {
        this.key = new EvaluatorKey("REMOTE_CONFIG", parameter.id);
        this.workspace = workspace;
        this.user = user;
        this.parameter = parameter;
        this.requiredType = requiredType;
        this.defaultValue = defaultValue;
    }
    RemoteConfigRequest.of = function (workspace, user, parameter, requiredType, defaultValue) {
        return new RemoteConfigRequest(workspace, user, parameter, requiredType, defaultValue);
    };
    RemoteConfigRequest.prototype.toString = function () {
        return "EvaluatorRequest(type=".concat(this.key.type, ", key=").concat(this.parameter.key, ")");
    };
    return RemoteConfigRequest;
}());

var TypeUtil = /** @class */ (function () {
    function TypeUtil() {
    }
    TypeUtil.asString = function (value) {
        switch (typeof value) {
            case "string":
                return value;
            case "number":
                return value.toString();
            case "boolean":
                return value ? "true" : "false";
            default:
                return undefined;
        }
    };
    TypeUtil.asNumber = function (value) {
        switch (typeof value) {
            case "number":
                return this.asActualNumber(value);
            case "string":
                return this.asActualNumber(Number(value));
            default:
                return undefined;
        }
    };
    TypeUtil.asBoolean = function (value) {
        switch (typeof value) {
            case "boolean":
                return value;
            case "string":
                switch (value) {
                    case "true":
                        return true;
                    case "false":
                        return false;
                    default:
                        return undefined;
                }
            default:
                return undefined;
        }
    };
    TypeUtil.asActualNumber = function (number) {
        if (!isNaN(number) && isFinite(number)) {
            return number;
        }
        else {
            return undefined;
        }
    };
    return TypeUtil;
}());

var DelegatingManualOverrideStorage = /** @class */ (function () {
    function DelegatingManualOverrideStorage(storages) {
        this.storages = storages;
    }
    DelegatingManualOverrideStorage.prototype.getVariation = function (experiment, user) {
        if (this.storages.length === 0)
            return;
        for (var _i = 0, _a = this.storages; _i < _a.length; _i++) {
            var storage = _a[_i];
            var _variation = storage.getVariation(experiment, user);
            if (_variation !== undefined) {
                return _variation;
            }
        }
        return undefined;
    };
    return DelegatingManualOverrideStorage;
}());
var HackleUserManualOverrideStorage = /** @class */ (function () {
    function HackleUserManualOverrideStorage(listStorage) {
        this.listStorage = listStorage;
    }
    HackleUserManualOverrideStorage.prototype.getVariation = function (experiment, user) {
        var variationId = this.get(experiment);
        if (!variationId)
            return undefined;
        return experiment._getVariationByIdOrNull(variationId);
    };
    HackleUserManualOverrideStorage.prototype.get = function (experiment) {
        var variationId = this.listStorage.getItem(experiment.id.toString());
        return TypeUtil.asNumber(variationId);
    };
    HackleUserManualOverrideStorage.prototype.getAll = function () {
        var results = new Map();
        this.listStorage.entries().forEach(function (_a) {
            var key = _a[0], value = _a[1];
            var experimentId = TypeUtil.asNumber(key);
            var variationId = TypeUtil.asNumber(value);
            if (ObjectUtil.isNullOrUndefined(experimentId) || experimentId < 0) {
                return;
            }
            if (ObjectUtil.isNullOrUndefined(variationId) || experimentId < 0) {
                return;
            }
            results.set(experimentId, variationId);
        });
        return results;
    };
    HackleUserManualOverrideStorage.prototype.set = function (experiment, variationId) {
        this.listStorage.setItem(experiment.id.toString(), variationId.toString());
    };
    HackleUserManualOverrideStorage.prototype.remove = function (experiment) {
        this.listStorage.removeItem(experiment.id.toString());
    };
    HackleUserManualOverrideStorage.prototype.clear = function () {
        this.listStorage.clear();
    };
    return HackleUserManualOverrideStorage;
}());

var DelegatingEvaluator = /** @class */ (function () {
    function DelegatingEvaluator() {
        this.evaluators = new Array();
    }
    DelegatingEvaluator.prototype.add = function (evaluator) {
        this.evaluators.push(evaluator);
    };
    DelegatingEvaluator.prototype.evaluate = function (request, context) {
        var evaluator = this.evaluators.find(function (it) { return it.supports(request); });
        if (ObjectUtil.isNullOrUndefined(evaluator)) {
            throw new Error("Unsupported EvaluatorRequest [".concat(request.toString(), "]"));
        }
        return evaluator.evaluate(request, context);
    };
    return DelegatingEvaluator;
}());

var HackleCoreContext = /** @class */ (function () {
    function HackleCoreContext() {
    }
    HackleCoreContext.get = function (name) {
        return ObjectUtil.requiredNotNullOrUndefined(this.getOrNull(name), function () { return "Instance not registered [".concat(name, "]"); });
    };
    HackleCoreContext.getOrNull = function (name) {
        return HackleCoreContext.instances.get(name);
    };
    HackleCoreContext.register = function (name, instance) {
        HackleCoreContext.instances.set(name, instance);
        return instance;
    };
    HackleCoreContext.instances = new Map();
    return HackleCoreContext;
}());

var RemoteConfigParameterTargetRuleDeterminer = /** @class */ (function () {
    function RemoteConfigParameterTargetRuleDeterminer(targetMatcher, bucketer) {
        this.targetMatcher = targetMatcher;
        this.bucketer = bucketer;
    }
    RemoteConfigParameterTargetRuleDeterminer.prototype.determineTargetRuleOrNull = function (request, context) {
        var _this = this;
        return request.parameter.targetRules.find(function (it) { return _this.matches(request, context, it); });
    };
    RemoteConfigParameterTargetRuleDeterminer.prototype.matches = function (request, context, targetRule) {
        if (!this.targetMatcher.matches(request, context, targetRule.target)) {
            return false;
        }
        var identifier = request.user.identifiers[request.parameter.identifierType];
        if (ObjectUtil.isNullOrUndefined(identifier)) {
            return false;
        }
        var bucket = request.workspace.getBucketOrNull(targetRule.bucketId);
        if (ObjectUtil.isNullOrUndefined(bucket)) {
            throw new Error("bucket[".concat(targetRule.bucketId, "]"));
        }
        return ObjectUtil.isNotNullOrUndefined(this.bucketer.bucketing(bucket, identifier));
    };
    return RemoteConfigParameterTargetRuleDeterminer;
}());

var ActionResolver = /** @class */ (function () {
    function ActionResolver(bucketer) {
        this.bucketer = bucketer;
    }
    ActionResolver.prototype.resolveOrNull = function (request, context, action) {
        switch (action.type) {
            case "VARIATION":
                return this.resolveVariation(request, action);
            case "BUCKET":
                return this.resolveBucket(request, action);
        }
    };
    ActionResolver.prototype.resolveVariation = function (request, action) {
        return request.experiment._getVariationByIdOrNull(action.variationId);
    };
    ActionResolver.prototype.resolveBucket = function (request, action) {
        var bucket = request.workspace.getBucketOrNull(action.bucketId);
        var identifier = request.user.identifiers[request.experiment.identifierType];
        if (!identifier) {
            return undefined;
        }
        var allocatedSlot = this.bucketer.bucketing(bucket, identifier);
        if (!allocatedSlot) {
            return undefined;
        }
        return request.experiment._getVariationByIdOrNull(allocatedSlot.variationId);
    };
    return ActionResolver;
}());

var EvaluationFlow = /** @class */ (function () {
    function EvaluationFlow(flowEvaluator, nextFlow) {
        this.flowEvaluator = flowEvaluator;
        this.nextFlow = nextFlow;
    }
    EvaluationFlow.prototype.evaluate = function (request, context) {
        if (this.flowEvaluator && this.nextFlow) {
            return this.flowEvaluator.evaluate(request, context, this.nextFlow);
        }
        else {
            return undefined;
        }
    };
    EvaluationFlow.end = function () {
        return new EvaluationFlow(undefined, undefined);
    };
    EvaluationFlow.decision = function (flowEvaluator, nextFlow) {
        return new EvaluationFlow(flowEvaluator, nextFlow);
    };
    EvaluationFlow.of = function () {
        var evaluators = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            evaluators[_i] = arguments[_i];
        }
        var flow = this.end();
        for (var _a = 0, _b = evaluators.reverse(); _a < _b.length; _a++) {
            var evaluator = _b[_a];
            flow = this.decision(evaluator, flow);
        }
        return flow;
    };
    return EvaluationFlow;
}());

var OverrideEvaluator = /** @class */ (function () {
    function OverrideEvaluator(overrideResolver) {
        this.overrideResolver = overrideResolver;
    }
    OverrideEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        var overriddenVariation = this.overrideResolver.resolveOrNull(request, context);
        if (overriddenVariation) {
            switch (request.experiment.type) {
                case "AB_TEST":
                    return ExperimentEvaluation.of(request, context, overriddenVariation, DecisionReason.OVERRIDDEN);
                case "FEATURE_FLAG":
                    return ExperimentEvaluation.of(request, context, overriddenVariation, DecisionReason.INDIVIDUAL_TARGET_MATCH);
            }
        }
        else {
            return nextFlow.evaluate(request, context);
        }
    };
    return OverrideEvaluator;
}());
var DraftEvaluator = /** @class */ (function () {
    function DraftEvaluator() {
    }
    DraftEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        if (request.experiment.status === "DRAFT") {
            return ExperimentEvaluation.ofDefault(request, context, DecisionReason.EXPERIMENT_DRAFT);
        }
        else {
            return nextFlow.evaluate(request, context);
        }
    };
    return DraftEvaluator;
}());
var PausedEvaluator = /** @class */ (function () {
    function PausedEvaluator() {
    }
    PausedEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        if (request.experiment.status === "PAUSED") {
            switch (request.experiment.type) {
                case "AB_TEST":
                    return ExperimentEvaluation.ofDefault(request, context, DecisionReason.EXPERIMENT_PAUSED);
                case "FEATURE_FLAG":
                    return ExperimentEvaluation.ofDefault(request, context, DecisionReason.FEATURE_FLAG_INACTIVE);
            }
        }
        else {
            return nextFlow.evaluate(request, context);
        }
    };
    return PausedEvaluator;
}());
var CompletedEvaluator = /** @class */ (function () {
    function CompletedEvaluator() {
    }
    CompletedEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        if (request.experiment.status === "COMPLETED") {
            var winnerVariation = request.experiment._winnerVariationOrNull();
            if (!winnerVariation) {
                throw new Error("winner variation [".concat(request.experiment.id, "]"));
            }
            return ExperimentEvaluation.of(request, context, winnerVariation, DecisionReason.EXPERIMENT_COMPLETED);
        }
        else {
            return nextFlow.evaluate(request, context);
        }
    };
    return CompletedEvaluator;
}());
var ExperimentTargetEvaluator = /** @class */ (function () {
    function ExperimentTargetEvaluator(experimentTargetDeterminer) {
        this.experimentTargetDeterminer = experimentTargetDeterminer;
    }
    ExperimentTargetEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        if (request.experiment.type !== "AB_TEST") {
            throw new Error("experiment type must be AB_TEST [".concat(request.experiment.id, "]"));
        }
        var isUserInExperimentTarget = this.experimentTargetDeterminer.isUserInExperimentTarget(request, context);
        if (isUserInExperimentTarget) {
            return nextFlow.evaluate(request, context);
        }
        else {
            return ExperimentEvaluation.ofDefault(request, context, DecisionReason.NOT_IN_EXPERIMENT_TARGET);
        }
    };
    return ExperimentTargetEvaluator;
}());
var TrafficAllocateEvaluator = /** @class */ (function () {
    function TrafficAllocateEvaluator(actionResolver) {
        this.actionResolver = actionResolver;
    }
    TrafficAllocateEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        if (request.experiment.status !== "RUNNING") {
            throw new Error("experiment status must be RUNNING [".concat(request.experiment.id, "]"));
        }
        if (request.experiment.type !== "AB_TEST") {
            throw new Error("experiment type must be AB_TEST [".concat(request.experiment.id, "]"));
        }
        var variation = this.actionResolver.resolveOrNull(request, context, request.experiment.defaultRule);
        if (!variation) {
            return ExperimentEvaluation.ofDefault(request, context, DecisionReason.TRAFFIC_NOT_ALLOCATED);
        }
        if (variation.isDropped) {
            return ExperimentEvaluation.ofDefault(request, context, DecisionReason.VARIATION_DROPPED);
        }
        return ExperimentEvaluation.of(request, context, variation, DecisionReason.TRAFFIC_ALLOCATED);
    };
    return TrafficAllocateEvaluator;
}());
var TargetRuleEvaluator = /** @class */ (function () {
    function TargetRuleEvaluator(targetRuleDeterminer, actionResolver) {
        this.targetRuleDeterminer = targetRuleDeterminer;
        this.actionResolver = actionResolver;
    }
    TargetRuleEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        if (request.experiment.status !== "RUNNING") {
            throw new Error("experiment status must be RUNNING [".concat(request.experiment.id, "]"));
        }
        if (request.experiment.type !== "FEATURE_FLAG") {
            throw new Error("experiment type must be FEATURE_FLAG [".concat(request.experiment.id, "]"));
        }
        if (!request.user.identifiers[request.experiment.identifierType]) {
            return nextFlow.evaluate(request, context);
        }
        var targetRule = this.targetRuleDeterminer.determineTargetRuleOrNull(request, context);
        if (!targetRule) {
            return nextFlow.evaluate(request, context);
        }
        var variation = this.actionResolver.resolveOrNull(request, context, targetRule.action);
        if (!variation) {
            throw new Error("FeatureFlag must decide the Variation [".concat(request.experiment.id, "]"));
        }
        return ExperimentEvaluation.of(request, context, variation, DecisionReason.TARGET_RULE_MATCH);
    };
    return TargetRuleEvaluator;
}());
var DefaultRuleEvaluator = /** @class */ (function () {
    function DefaultRuleEvaluator(actionResolver) {
        this.actionResolver = actionResolver;
    }
    DefaultRuleEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        if (request.experiment.status !== "RUNNING") {
            throw new Error("experiment status must be RUNNING [".concat(request.experiment.id, "]"));
        }
        if (request.experiment.type !== "FEATURE_FLAG") {
            throw new Error("experiment type must be FEATURE_FLAG [".concat(request.experiment.id, "]"));
        }
        if (!request.user.identifiers[request.experiment.identifierType]) {
            return ExperimentEvaluation.ofDefault(request, context, DecisionReason.DEFAULT_RULE);
        }
        var variation = this.actionResolver.resolveOrNull(request, context, request.experiment.defaultRule);
        if (!variation) {
            throw new Error("FeatureFlag must decide the Variation [".concat(request.experiment.id, "]"));
        }
        return ExperimentEvaluation.of(request, context, variation, DecisionReason.DEFAULT_RULE);
    };
    return DefaultRuleEvaluator;
}());
var ContainerEvaluator = /** @class */ (function () {
    function ContainerEvaluator(containerResolver) {
        this.containerResolver = containerResolver;
    }
    ContainerEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        var containerId = request.experiment.containerId;
        if (!containerId) {
            return nextFlow.evaluate(request, context);
        }
        var container = request.workspace.getContainerOrNull(containerId);
        if (!container) {
            throw new Error("container[".concat(containerId, "]"));
        }
        var isUserInContainerGroup = this.containerResolver.isUserInContainerGroup(request, context, container);
        if (isUserInContainerGroup) {
            return nextFlow.evaluate(request, context);
        }
        else {
            return ExperimentEvaluation.ofDefault(request, context, DecisionReason.NOT_IN_MUTUAL_EXCLUSION_EXPERIMENT);
        }
    };
    return ContainerEvaluator;
}());
var IdentifierEvaluator = /** @class */ (function () {
    function IdentifierEvaluator() {
    }
    IdentifierEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        if (request.user.identifiers[request.experiment.identifierType]) {
            return nextFlow.evaluate(request, context);
        }
        else {
            return ExperimentEvaluation.ofDefault(request, context, DecisionReason.IDENTIFIER_NOT_FOUND);
        }
    };
    return IdentifierEvaluator;
}());

var ExperimentTargetDeterminer = /** @class */ (function () {
    function ExperimentTargetDeterminer(targetMatcher) {
        this.targetMatcher = targetMatcher;
    }
    ExperimentTargetDeterminer.prototype.isUserInExperimentTarget = function (request, context) {
        var _this = this;
        if (request.experiment.targetAudiences.length === 0) {
            return true;
        }
        return request.experiment.targetAudiences.some(function (it) { return _this.targetMatcher.matches(request, context, it); });
    };
    return ExperimentTargetDeterminer;
}());

var TargetRuleDeterminer = /** @class */ (function () {
    function TargetRuleDeterminer(targetMatcher) {
        this.targetMatcher = targetMatcher;
    }
    TargetRuleDeterminer.prototype.determineTargetRuleOrNull = function (request, context) {
        var _this = this;
        return request.experiment.targetRules.find(function (it) { return _this.targetMatcher.matches(request, context, it.target); });
    };
    return TargetRuleDeterminer;
}());

var OverrideResolver = /** @class */ (function () {
    function OverrideResolver(manualOverrideStorage, targetMatcher, actionResolver) {
        this.manualOverrideStorage = manualOverrideStorage;
        this.targetMatcher = targetMatcher;
        this.actionResolver = actionResolver;
    }
    OverrideResolver.prototype.resolveOrNull = function (request, context) {
        var _a, _b;
        return ((_b = (_a = this.resolveManualOverride(request)) !== null && _a !== void 0 ? _a : this._resolveUserOverride(request)) !== null && _b !== void 0 ? _b : this._resolveSegmentOverride(request, context));
    };
    OverrideResolver.prototype.resolveManualOverride = function (request) {
        return this.manualOverrideStorage.getVariation(request.experiment, request.user);
    };
    OverrideResolver.prototype._resolveUserOverride = function (request) {
        var experiment = request.experiment;
        var identifier = request.user.identifiers[experiment.identifierType];
        if (!identifier) {
            return undefined;
        }
        var overriddenVariationId = experiment.userOverrides.get(identifier);
        if (!overriddenVariationId) {
            return undefined;
        }
        return experiment._getVariationByIdOrNull(overriddenVariationId);
    };
    OverrideResolver.prototype._resolveSegmentOverride = function (request, context) {
        var _this = this;
        var overriddenRule = request.experiment.segmentOverrides.find(function (it) {
            return _this.targetMatcher.matches(request, context, it.target);
        });
        if (!overriddenRule) {
            return undefined;
        }
        return this.actionResolver.resolveOrNull(request, context, overriddenRule.action);
    };
    return OverrideResolver;
}());

var ContainerResolver = /** @class */ (function () {
    function ContainerResolver(bucketer) {
        this.bucketer = bucketer;
    }
    ContainerResolver.prototype.isUserInContainerGroup = function (request, context, container) {
        var identifier = request.user.identifiers[request.experiment.identifierType];
        if (ObjectUtil.isNullOrUndefined(identifier)) {
            return false;
        }
        var bucket = request.workspace.getBucketOrNull(container.bucketId);
        if (ObjectUtil.isNullOrUndefined(bucket)) {
            throw new Error("Bucket[".concat(container.bucketId, "]"));
        }
        var slot = this.bucketer.bucketing(bucket, identifier);
        if (ObjectUtil.isNullOrUndefined(slot)) {
            return false;
        }
        var containerGroup = container.getGroupOrNull(slot.variationId);
        if (ObjectUtil.isNullOrUndefined(containerGroup)) {
            throw new Error("ContainerGroup[".concat(slot.variationId, "]"));
        }
        return containerGroup.experiments.includes(request.experiment.id);
    };
    return ContainerResolver;
}());

var ExperimentFlowFactory = /** @class */ (function () {
    function ExperimentFlowFactory(manualOverrideStorage, bucketer, targetMatcher) {
        var actionResolver = new ActionResolver(bucketer);
        var overrideResolver = new OverrideResolver(manualOverrideStorage, targetMatcher, actionResolver);
        var containerResolver = new ContainerResolver(bucketer);
        this.abTestFlow = EvaluationFlow.of(new OverrideEvaluator(overrideResolver), new IdentifierEvaluator(), new ContainerEvaluator(containerResolver), new ExperimentTargetEvaluator(new ExperimentTargetDeterminer(targetMatcher)), new DraftEvaluator(), new PausedEvaluator(), new CompletedEvaluator(), new TrafficAllocateEvaluator(actionResolver));
        this.featureFlagFlow = EvaluationFlow.of(new DraftEvaluator(), new PausedEvaluator(), new CompletedEvaluator(), new OverrideEvaluator(overrideResolver), new IdentifierEvaluator(), new TargetRuleEvaluator(new TargetRuleDeterminer(targetMatcher), actionResolver), new DefaultRuleEvaluator(actionResolver));
    }
    ExperimentFlowFactory.prototype.getExperimentFlow = function (experimentType) {
        switch (experimentType) {
            case "AB_TEST":
                return this.abTestFlow;
            case "FEATURE_FLAG":
                return this.featureFlagFlow;
        }
    };
    return ExperimentFlowFactory;
}());

var TargetMatcher = /** @class */ (function () {
    function TargetMatcher(conditionMatcherFactory) {
        this.conditionMatcherFactory = conditionMatcherFactory;
    }
    TargetMatcher.prototype.matches = function (request, context, target) {
        var _this = this;
        return target.conditions.every(function (it) { return _this._matches(request, context, it); });
    };
    TargetMatcher.prototype.anyMatches = function (request, context, targets) {
        var _this = this;
        if (!targets.length)
            return true;
        return targets.some(function (target) { return _this.matches(request, context, target); });
    };
    TargetMatcher.prototype._matches = function (request, context, condition) {
        var conditionMatcher = this.conditionMatcherFactory.getMatcher(condition.key.type);
        return conditionMatcher.matches(request, context, condition);
    };
    return TargetMatcher;
}());

var NoopValueDecorator = /** @class */ (function () {
    function NoopValueDecorator() {
    }
    NoopValueDecorator.prototype.decorate = function (value) {
        return value;
    };
    return NoopValueDecorator;
}());
var UrlDecodeValueDecorator = /** @class */ (function () {
    function UrlDecodeValueDecorator() {
    }
    UrlDecodeValueDecorator.prototype.decorate = function (value) {
        return typeof value === "string" ? UrlUtil.decodeURIOrOriginal(value) : value;
    };
    return UrlDecodeValueDecorator;
}());

var ValueOperatorMatcher = /** @class */ (function () {
    function ValueOperatorMatcher(valueMatcherFactory, operatorMatcherFactory) {
        this.valueMatcherFactory = valueMatcherFactory;
        this.operatorMatcherFactory = operatorMatcherFactory;
    }
    ValueOperatorMatcher.prototype.matches = function (userValue, match, valueDecorator) {
        if (valueDecorator === void 0) { valueDecorator = new NoopValueDecorator(); }
        var valueMatcher = this.valueMatcherFactory.getMatcher(match.valueType);
        var operatorMatcher = this.operatorMatcherFactory.getMatcher(match.operator);
        var isMatched = this.userValueMatches(userValue, match, valueMatcher, operatorMatcher, valueDecorator);
        return this.typeMatches(match.type, isMatched);
    };
    ValueOperatorMatcher.prototype.userValueMatches = function (userValue, match, valueMatcher, operatorMatcher, valueDecorator) {
        if (Array.isArray(userValue)) {
            return this.arrayMatches(userValue, match, valueMatcher, operatorMatcher, valueDecorator);
        }
        return this.singleMatches(userValue, match, valueMatcher, operatorMatcher, valueDecorator);
    };
    ValueOperatorMatcher.prototype.singleMatches = function (userValue, match, valueMatcher, operatorMatcher, valueDecorator) {
        var decoratedUserValue = valueDecorator.decorate(userValue);
        var decoratedMatchValues = match.values.map(valueDecorator.decorate);
        return operatorMatcher.matches(valueMatcher, decoratedUserValue, decoratedMatchValues);
    };
    ValueOperatorMatcher.prototype.arrayMatches = function (userValues, match, valueMatcher, operatorMatcher, valueDecorator) {
        var _this = this;
        return userValues.some(function (it) { return _this.singleMatches(it, match, valueMatcher, operatorMatcher, valueDecorator); });
    };
    ValueOperatorMatcher.prototype.typeMatches = function (matchType, isMatched) {
        switch (matchType) {
            case "MATCH":
                return isMatched;
            case "NOT_MATCH":
                return !isMatched;
        }
    };
    return ValueOperatorMatcher;
}());

var InMatcher = /** @class */ (function () {
    function InMatcher() {
    }
    InMatcher.prototype.matches = function (valueMatcher, userValue, matchValues) {
        if (ObjectUtil.isNullOrUndefined(userValue))
            return false;
        return matchValues.some(function (matchValue) { return valueMatcher.inMatches(userValue, matchValue); });
    };
    return InMatcher;
}());
var ContainsMatcher = /** @class */ (function () {
    function ContainsMatcher() {
    }
    ContainsMatcher.prototype.matches = function (valueMatcher, userValue, matchValues) {
        if (ObjectUtil.isNullOrUndefined(userValue))
            return false;
        return matchValues.some(function (matchValue) { return valueMatcher.containsMatches(userValue, matchValue); });
    };
    return ContainsMatcher;
}());
var StartsWithMatcher = /** @class */ (function () {
    function StartsWithMatcher() {
    }
    StartsWithMatcher.prototype.matches = function (valueMatcher, userValue, matchValues) {
        if (ObjectUtil.isNullOrUndefined(userValue))
            return false;
        return matchValues.some(function (matchValue) { return valueMatcher.startsWithMatches(userValue, matchValue); });
    };
    return StartsWithMatcher;
}());
var EndsWithMatcher = /** @class */ (function () {
    function EndsWithMatcher() {
    }
    EndsWithMatcher.prototype.matches = function (valueMatcher, userValue, matchValues) {
        if (ObjectUtil.isNullOrUndefined(userValue))
            return false;
        return matchValues.some(function (matchValue) { return valueMatcher.endsWithMatches(userValue, matchValue); });
    };
    return EndsWithMatcher;
}());
var GreaterThanMatcher = /** @class */ (function () {
    function GreaterThanMatcher() {
    }
    GreaterThanMatcher.prototype.matches = function (valueMatcher, userValue, matchValues) {
        if (ObjectUtil.isNullOrUndefined(userValue))
            return false;
        return matchValues.some(function (matchValue) { return valueMatcher.greaterThanMatches(userValue, matchValue); });
    };
    return GreaterThanMatcher;
}());
var GreaterThanOrEqualToMatcher = /** @class */ (function () {
    function GreaterThanOrEqualToMatcher() {
    }
    GreaterThanOrEqualToMatcher.prototype.matches = function (valueMatcher, userValue, matchValues) {
        if (ObjectUtil.isNullOrUndefined(userValue))
            return false;
        return matchValues.some(function (matchValue) { return valueMatcher.greaterThanOrEqualMatches(userValue, matchValue); });
    };
    return GreaterThanOrEqualToMatcher;
}());
var LessThanMatcher = /** @class */ (function () {
    function LessThanMatcher() {
    }
    LessThanMatcher.prototype.matches = function (valueMatcher, userValue, matchValues) {
        if (ObjectUtil.isNullOrUndefined(userValue))
            return false;
        return matchValues.some(function (matchValue) { return valueMatcher.lessThanMatches(userValue, matchValue); });
    };
    return LessThanMatcher;
}());
var LessThanOrEqualToMatcher = /** @class */ (function () {
    function LessThanOrEqualToMatcher() {
    }
    LessThanOrEqualToMatcher.prototype.matches = function (valueMatcher, userValue, matchValues) {
        if (ObjectUtil.isNullOrUndefined(userValue))
            return false;
        return matchValues.some(function (matchValue) { return valueMatcher.lessThanOrEqualMatches(userValue, matchValue); });
    };
    return LessThanOrEqualToMatcher;
}());
var ExistsMatcher = /** @class */ (function () {
    function ExistsMatcher() {
    }
    ExistsMatcher.prototype.matches = function (valueMatcher, userValue, matchValues) {
        return !ObjectUtil.isNullOrUndefined(userValue);
    };
    return ExistsMatcher;
}());
var OperatorMatcherFactory = /** @class */ (function () {
    function OperatorMatcherFactory() {
    }
    OperatorMatcherFactory.prototype.getMatcher = function (operator) {
        switch (operator) {
            case "IN":
                return OperatorMatcherFactory.IN_MATCHER;
            case "CONTAINS":
                return OperatorMatcherFactory.CONTAINS_MATCHER;
            case "STARTS_WITH":
                return OperatorMatcherFactory.STARTS_WITH_MATCHER;
            case "ENDS_WITH":
                return OperatorMatcherFactory.ENDS_WITH_MATCHER;
            case "GT":
                return OperatorMatcherFactory.GT_MATCHER;
            case "GTE":
                return OperatorMatcherFactory.GTE_MATCHER;
            case "LT":
                return OperatorMatcherFactory.LT_MATCHER;
            case "LTE":
                return OperatorMatcherFactory.LTE_MATCHER;
            case "EXISTS":
                return OperatorMatcherFactory.EXISTS_MATCHER;
        }
    };
    OperatorMatcherFactory.IN_MATCHER = new InMatcher();
    OperatorMatcherFactory.CONTAINS_MATCHER = new ContainsMatcher();
    OperatorMatcherFactory.STARTS_WITH_MATCHER = new StartsWithMatcher();
    OperatorMatcherFactory.ENDS_WITH_MATCHER = new EndsWithMatcher();
    OperatorMatcherFactory.GT_MATCHER = new GreaterThanMatcher();
    OperatorMatcherFactory.GTE_MATCHER = new GreaterThanOrEqualToMatcher();
    OperatorMatcherFactory.LT_MATCHER = new LessThanMatcher();
    OperatorMatcherFactory.LTE_MATCHER = new LessThanOrEqualToMatcher();
    OperatorMatcherFactory.EXISTS_MATCHER = new ExistsMatcher();
    return OperatorMatcherFactory;
}());

var StringMatcher = /** @class */ (function () {
    function StringMatcher() {
    }
    StringMatcher.prototype.inMatches = function (userValue, matchValue) {
        var typedUserValue = TypeUtil.asString(userValue);
        var typedMatchValue = TypeUtil.asString(matchValue);
        if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
            return false;
        }
        return typedUserValue === typedMatchValue;
    };
    StringMatcher.prototype.containsMatches = function (userValue, matchValue) {
        var typedUserValue = TypeUtil.asString(userValue);
        var typedMatchValue = TypeUtil.asString(matchValue);
        if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
            return false;
        }
        return typedUserValue.includes(typedMatchValue);
    };
    StringMatcher.prototype.startsWithMatches = function (userValue, matchValue) {
        var typedUserValue = TypeUtil.asString(userValue);
        var typedMatchValue = TypeUtil.asString(matchValue);
        if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
            return false;
        }
        return typedUserValue.startsWith(typedMatchValue);
    };
    StringMatcher.prototype.endsWithMatches = function (userValue, matchValue) {
        var typedUserValue = TypeUtil.asString(userValue);
        var typedMatchValue = TypeUtil.asString(matchValue);
        if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
            return false;
        }
        return typedUserValue.endsWith(typedMatchValue);
    };
    StringMatcher.prototype.greaterThanMatches = function (userValue, matchValue) {
        var typedUserValue = TypeUtil.asString(userValue);
        var typedMatchValue = TypeUtil.asString(matchValue);
        if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
            return false;
        }
        return typedUserValue > typedMatchValue;
    };
    StringMatcher.prototype.greaterThanOrEqualMatches = function (userValue, matchValue) {
        var typedUserValue = TypeUtil.asString(userValue);
        var typedMatchValue = TypeUtil.asString(matchValue);
        if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
            return false;
        }
        return typedUserValue >= typedMatchValue;
    };
    StringMatcher.prototype.lessThanMatches = function (userValue, matchValue) {
        var typedUserValue = TypeUtil.asString(userValue);
        var typedMatchValue = TypeUtil.asString(matchValue);
        if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
            return false;
        }
        return typedUserValue < typedMatchValue;
    };
    StringMatcher.prototype.lessThanOrEqualMatches = function (userValue, matchValue) {
        var typedUserValue = TypeUtil.asString(userValue);
        var typedMatchValue = TypeUtil.asString(matchValue);
        if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
            return false;
        }
        return typedUserValue <= typedMatchValue;
    };
    return StringMatcher;
}());
var NumberMatcher = /** @class */ (function () {
    function NumberMatcher() {
    }
    NumberMatcher.prototype.inMatches = function (userValue, matchValue) {
        var typedUserValue = TypeUtil.asNumber(userValue);
        var typedMatchValue = TypeUtil.asNumber(matchValue);
        if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
            return false;
        }
        return typedUserValue === typedMatchValue;
    };
    NumberMatcher.prototype.containsMatches = function (userValue, matchValue) {
        return false;
    };
    NumberMatcher.prototype.startsWithMatches = function (userValue, matchValue) {
        return false;
    };
    NumberMatcher.prototype.endsWithMatches = function (userValue, matchValue) {
        return false;
    };
    NumberMatcher.prototype.greaterThanMatches = function (userValue, matchValue) {
        var typedUserValue = TypeUtil.asNumber(userValue);
        var typedMatchValue = TypeUtil.asNumber(matchValue);
        if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
            return false;
        }
        return typedUserValue > typedMatchValue;
    };
    NumberMatcher.prototype.greaterThanOrEqualMatches = function (userValue, matchValue) {
        var typedUserValue = TypeUtil.asNumber(userValue);
        var typedMatchValue = TypeUtil.asNumber(matchValue);
        if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
            return false;
        }
        return typedUserValue >= typedMatchValue;
    };
    NumberMatcher.prototype.lessThanMatches = function (userValue, matchValue) {
        var typedUserValue = TypeUtil.asNumber(userValue);
        var typedMatchValue = TypeUtil.asNumber(matchValue);
        if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
            return false;
        }
        return typedUserValue < typedMatchValue;
    };
    NumberMatcher.prototype.lessThanOrEqualMatches = function (userValue, matchValue) {
        var typedUserValue = TypeUtil.asNumber(userValue);
        var typedMatchValue = TypeUtil.asNumber(matchValue);
        if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
            return false;
        }
        return typedUserValue <= typedMatchValue;
    };
    return NumberMatcher;
}());
var BooleanMatcher = /** @class */ (function () {
    function BooleanMatcher() {
    }
    BooleanMatcher.prototype.inMatches = function (userValue, matchValue) {
        var typedUserValue = TypeUtil.asBoolean(userValue);
        var typedMatchValue = TypeUtil.asBoolean(matchValue);
        if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
            return false;
        }
        return typedUserValue === typedMatchValue;
    };
    BooleanMatcher.prototype.containsMatches = function (userValue, matchValue) {
        return false;
    };
    BooleanMatcher.prototype.startsWithMatches = function (userValue, matchValue) {
        return false;
    };
    BooleanMatcher.prototype.endsWithMatches = function (userValue, matchValue) {
        return false;
    };
    BooleanMatcher.prototype.greaterThanMatches = function (userValue, matchValue) {
        return false;
    };
    BooleanMatcher.prototype.greaterThanOrEqualMatches = function (userValue, matchValue) {
        return false;
    };
    BooleanMatcher.prototype.lessThanMatches = function (userValue, matchValue) {
        return false;
    };
    BooleanMatcher.prototype.lessThanOrEqualMatches = function (userValue, matchValue) {
        return false;
    };
    return BooleanMatcher;
}());
var VersionMatcher = /** @class */ (function () {
    function VersionMatcher() {
    }
    VersionMatcher.prototype.inMatches = function (userValue, matchValue) {
        var userVersion = Version.tryParse(userValue);
        var matchVersion = Version.tryParse(matchValue);
        if (ObjectUtil.isNullOrUndefined(userVersion) || ObjectUtil.isNullOrUndefined(matchVersion)) {
            return false;
        }
        return userVersion.isEqualTo(matchVersion);
    };
    VersionMatcher.prototype.containsMatches = function (userValue, matchValue) {
        return false;
    };
    VersionMatcher.prototype.startsWithMatches = function (userValue, matchValue) {
        return false;
    };
    VersionMatcher.prototype.endsWithMatches = function (userValue, matchValue) {
        return false;
    };
    VersionMatcher.prototype.greaterThanMatches = function (userValue, matchValue) {
        var userVersion = Version.tryParse(userValue);
        var matchVersion = Version.tryParse(matchValue);
        if (ObjectUtil.isNullOrUndefined(userVersion) || ObjectUtil.isNullOrUndefined(matchVersion)) {
            return false;
        }
        return userVersion.isGreaterThan(matchVersion);
    };
    VersionMatcher.prototype.greaterThanOrEqualMatches = function (userValue, matchValue) {
        var userVersion = Version.tryParse(userValue);
        var matchVersion = Version.tryParse(matchValue);
        if (ObjectUtil.isNullOrUndefined(userVersion) || ObjectUtil.isNullOrUndefined(matchVersion)) {
            return false;
        }
        return userVersion.isGreaterThanOrEqualTo(matchVersion);
    };
    VersionMatcher.prototype.lessThanMatches = function (userValue, matchValue) {
        var userVersion = Version.tryParse(userValue);
        var matchVersion = Version.tryParse(matchValue);
        if (ObjectUtil.isNullOrUndefined(userVersion) || ObjectUtil.isNullOrUndefined(matchVersion)) {
            return false;
        }
        return userVersion.isLessThan(matchVersion);
    };
    VersionMatcher.prototype.lessThanOrEqualMatches = function (userValue, matchValue) {
        var userVersion = Version.tryParse(userValue);
        var matchVersion = Version.tryParse(matchValue);
        if (ObjectUtil.isNullOrUndefined(userVersion) || ObjectUtil.isNullOrUndefined(matchVersion)) {
            return false;
        }
        return userVersion.isLessThanOrEqualTo(matchVersion);
    };
    return VersionMatcher;
}());
var UrlMatcher = /** @class */ (function () {
    function UrlMatcher() {
    }
    UrlMatcher.prototype.inMatches = function (userValue, matchValue) {
        var typedUserValue = UrlUtil.tryParse(userValue);
        var typedMatchValue = TypeUtil.asString(matchValue);
        if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
            return false;
        }
        var decodedUserValue = UrlUtil.decodeURIOrOriginal(UrlUtil.removePathnameTrailingSlash(typedUserValue));
        var decodedMatchValue = UrlUtil.decodeURIOrOriginal(UrlUtil.removePathnameTrailingSlash(typedMatchValue));
        return decodedUserValue === decodedMatchValue;
    };
    UrlMatcher.prototype.containsMatches = function (userValue, matchValue) {
        var typedUserValue = UrlUtil.tryParse(userValue);
        var typedMatchValue = TypeUtil.asString(matchValue);
        if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
            return false;
        }
        var decodedUserValue = UrlUtil.decodeURIOrOriginal(typedUserValue.href);
        return decodedUserValue.includes(typedMatchValue) || decodedUserValue.includes(encodeURI(typedMatchValue));
    };
    UrlMatcher.prototype.startsWithMatches = function (userValue, matchValue) {
        var typedUserValue = UrlUtil.tryParse(userValue);
        var typedMatchValue = TypeUtil.asString(matchValue);
        if (ObjectUtil.isNullOrUndefined(typedUserValue) || ObjectUtil.isNullOrUndefined(typedMatchValue)) {
            return false;
        }
        var decodedUserValue = UrlUtil.decodeURIOrOriginal(typedUserValue.href);
        return decodedUserValue.startsWith(typedMatchValue) || decodedUserValue.startsWith(encodeURI(typedMatchValue));
    };
    UrlMatcher.prototype.endsWithMatches = function (userValue, matchValue) {
        return false;
    };
    UrlMatcher.prototype.greaterThanMatches = function (userValue, matchValue) {
        return false;
    };
    UrlMatcher.prototype.greaterThanOrEqualMatches = function (userValue, matchValue) {
        return false;
    };
    UrlMatcher.prototype.lessThanMatches = function (userValue, matchValue) {
        return false;
    };
    UrlMatcher.prototype.lessThanOrEqualMatches = function (userValue, matchValue) {
        return false;
    };
    return UrlMatcher;
}());
var NullMatcher = /** @class */ (function () {
    function NullMatcher() {
    }
    NullMatcher.prototype.inMatches = function (userValue, matchValue) {
        return false;
    };
    NullMatcher.prototype.containsMatches = function (userValue, matchValue) {
        return false;
    };
    NullMatcher.prototype.startsWithMatches = function (userValue, matchValue) {
        return false;
    };
    NullMatcher.prototype.endsWithMatches = function (userValue, matchValue) {
        return false;
    };
    NullMatcher.prototype.greaterThanMatches = function (userValue, matchValue) {
        return false;
    };
    NullMatcher.prototype.greaterThanOrEqualMatches = function (userValue, matchValue) {
        return false;
    };
    NullMatcher.prototype.lessThanMatches = function (userValue, matchValue) {
        return false;
    };
    NullMatcher.prototype.lessThanOrEqualMatches = function (userValue, matchValue) {
        return false;
    };
    return NullMatcher;
}());
var ValueMatcherFactory = /** @class */ (function () {
    function ValueMatcherFactory() {
    }
    ValueMatcherFactory.prototype.getMatcher = function (valueType) {
        switch (valueType) {
            case "STRING":
                return ValueMatcherFactory.STRING_MATCHER;
            case "JSON":
                return ValueMatcherFactory.STRING_MATCHER;
            case "NUMBER":
                return ValueMatcherFactory.NUMBER_MATCHER;
            case "BOOLEAN":
                return ValueMatcherFactory.BOOLEAN_MATCHER;
            case "VERSION":
                return ValueMatcherFactory.VERSION_MATCHER;
            case "URL":
                return ValueMatcherFactory.URL_MATCHER;
            case "NULL":
                return ValueMatcherFactory.NULL_MATCHER;
            case "UNKNOWN":
                return ValueMatcherFactory.NULL_MATCHER;
        }
    };
    ValueMatcherFactory.STRING_MATCHER = new StringMatcher();
    ValueMatcherFactory.NUMBER_MATCHER = new NumberMatcher();
    ValueMatcherFactory.BOOLEAN_MATCHER = new BooleanMatcher();
    ValueMatcherFactory.VERSION_MATCHER = new VersionMatcher();
    ValueMatcherFactory.URL_MATCHER = new UrlMatcher();
    ValueMatcherFactory.NULL_MATCHER = new NullMatcher();
    return ValueMatcherFactory;
}());

var UserConditionMatcher = /** @class */ (function () {
    function UserConditionMatcher(userValueResolver, valueOperatorMatcher) {
        this.URL_HACKLE_PROPERTY_KEY_NAMES = ["pagePath", "host", "url", "queryParameter"];
        this.userValueResolver = userValueResolver;
        this.valueOperatorMatcher = valueOperatorMatcher;
    }
    UserConditionMatcher.prototype.matches = function (request, context, condition) {
        var userValue = this.userValueResolver.resolveOrNull(request.user, condition.key);
        var valueDecorator = this.valueDecorator(condition.key);
        return this.valueOperatorMatcher.matches(userValue, condition.match, valueDecorator);
    };
    UserConditionMatcher.prototype.valueDecorator = function (key) {
        if (key.type === "HACKLE_PROPERTY" && this.URL_HACKLE_PROPERTY_KEY_NAMES.includes(key.name)) {
            return new UrlDecodeValueDecorator();
        }
        return new NoopValueDecorator();
    };
    return UserConditionMatcher;
}());
var UserValueResolver = /** @class */ (function () {
    function UserValueResolver() {
    }
    UserValueResolver.prototype.resolveOrNull = function (user, key) {
        switch (key.type) {
            case "USER_ID":
                return user.identifiers[key.name];
            case "USER_PROPERTY":
                return user.properties[key.name];
            case "HACKLE_PROPERTY":
                return user.hackleProperties[key.name];
            default:
                throw new Error("Unsupported TargetKeyType [".concat(key.type, "]"));
        }
    };
    return UserValueResolver;
}());

var SegmentConditionMatcher = /** @class */ (function () {
    function SegmentConditionMatcher(segmentMatcher) {
        this.segmentMatcher = segmentMatcher;
    }
    SegmentConditionMatcher.prototype.matches = function (request, context, condition) {
        var _this = this;
        if (condition.key.type != "SEGMENT") {
            throw new Error("Unsupported TargetKeyType [".concat(condition.key.type, "]"));
        }
        var isMatched = condition.match.values.some(function (it) { return _this._matches(request, context, it); });
        switch (condition.match.type) {
            case "MATCH":
                return isMatched;
            case "NOT_MATCH":
                return !isMatched;
        }
    };
    SegmentConditionMatcher.prototype._matches = function (request, context, value) {
        if (typeof value !== "string") {
            throw new Error("SegmentKey[".concat(value, "]"));
        }
        var segment = request.workspace.getSegmentOrNull(value);
        if (!segment) {
            throw new Error("Segment[".concat(value, "]"));
        }
        return this.segmentMatcher.matches(request, context, segment);
    };
    return SegmentConditionMatcher;
}());
var SegmentMatcher = /** @class */ (function () {
    function SegmentMatcher(userConditionMatcher) {
        this.userConditionMatcher = userConditionMatcher;
    }
    SegmentMatcher.prototype.matches = function (request, context, segment) {
        var _this = this;
        return segment.targets.some(function (it) { return _this._matches(request, context, it); });
    };
    SegmentMatcher.prototype._matches = function (request, context, target) {
        var _this = this;
        return target.conditions.every(function (it) { return _this.userConditionMatcher.matches(request, context, it); });
    };
    return SegmentMatcher;
}());

var ExperimentContextualEvaluator = /** @class */ (function () {
    function ExperimentContextualEvaluator(evaluator) {
        this.evaluator = evaluator;
    }
    ExperimentContextualEvaluator.prototype.evaluateInternal = function (request, context, experiment) {
        var experimentRequest = ExperimentRequest.by(request, experiment);
        var evaluation = this.evaluator.evaluate(experimentRequest, context);
        if (!(evaluation instanceof ExperimentEvaluation)) {
            throw new Error("Unexpected evaluation [expected=ExperimentEvaluation, actual=".concat(evaluation.constructor.name, "]"));
        }
        var resolvedEvaluation = this.resolve(request, context, evaluation);
        context.addEvaluation(resolvedEvaluation);
        return resolvedEvaluation;
    };
    ExperimentContextualEvaluator.prototype.evaluate = function (request, context, experiment) {
        var _a;
        var evaluation = (_a = context.getEvaluation(experiment)) !== null && _a !== void 0 ? _a : this.evaluateInternal(request, context, experiment);
        return evaluation;
    };
    return ExperimentContextualEvaluator;
}());

var ExperimentConditionMatcher = /** @class */ (function () {
    function ExperimentConditionMatcher(abTestMatcher, featureFlagMatcher) {
        this.abTestMatcher = abTestMatcher;
        this.featureFlagMatcher = featureFlagMatcher;
    }
    /**
     * @override
     */
    ExperimentConditionMatcher.prototype.matches = function (request, context, condition) {
        switch (condition.key.type) {
            case "AB_TEST":
                return this.abTestMatcher.matches(request, context, condition);
            case "FEATURE_FLAG":
                return this.featureFlagMatcher.matches(request, context, condition);
            default:
                throw new Error("Unsupported TargetKeyType [".concat(condition.key.type, "]"));
        }
    };
    return ExperimentConditionMatcher;
}());
var ExperimentMatcher = /** @class */ (function (_super) {
    __extends(ExperimentMatcher, _super);
    function ExperimentMatcher(evaluator, valueOperatorMatcher) {
        var _this = _super.call(this, evaluator) || this;
        _this.valueOperatorMatcher = valueOperatorMatcher;
        return _this;
    }
    ExperimentMatcher.prototype.matches = function (request, context, condition) {
        var key = ObjectUtil.requiredNotNullOrUndefined(TypeUtil.asNumber(condition.key.name), function () { return "Invalid key [".concat(condition.key.type, ", ").concat(condition.key.name, "]"); });
        var experiment = this.experiment(request, key);
        if (ObjectUtil.isNullOrUndefined(experiment)) {
            return false;
        }
        var evaluation = this.evaluate(request, context, experiment);
        return this.evaluationMatches(evaluation, condition);
    };
    return ExperimentMatcher;
}(ExperimentContextualEvaluator));
var AbTestConditionMatcher = /** @class */ (function (_super) {
    __extends(AbTestConditionMatcher, _super);
    function AbTestConditionMatcher(evaluator, valueOperatorMatcher) {
        return _super.call(this, evaluator, valueOperatorMatcher) || this;
    }
    /**
     * @override
     */
    AbTestConditionMatcher.prototype.experiment = function (request, key) {
        return request.workspace.getExperimentOrNull(key);
    };
    /**
     * @override
     */
    AbTestConditionMatcher.prototype.resolve = function (request, context, evaluation) {
        if (evaluation.reason === DecisionReason.TRAFFIC_ALLOCATED) {
            return evaluation.with(DecisionReason.TRAFFIC_ALLOCATED_BY_TARGETING);
        }
        return evaluation;
    };
    /**
     * @override
     */
    AbTestConditionMatcher.prototype.evaluationMatches = function (evaluation, condition) {
        if (!AbTestConditionMatcher.AB_TEST_MATCHED_REASONS.includes(evaluation.reason)) {
            return false;
        }
        return this.valueOperatorMatcher.matches(evaluation.variationKey, condition.match);
    };
    AbTestConditionMatcher.AB_TEST_MATCHED_REASONS = [
        DecisionReason.OVERRIDDEN,
        DecisionReason.TRAFFIC_ALLOCATED,
        DecisionReason.EXPERIMENT_COMPLETED,
        DecisionReason.TRAFFIC_ALLOCATED_BY_TARGETING
    ];
    return AbTestConditionMatcher;
}(ExperimentMatcher));
var FeatureFlagConditionMatcher = /** @class */ (function (_super) {
    __extends(FeatureFlagConditionMatcher, _super);
    function FeatureFlagConditionMatcher(evaluator, valueOperatorMatcher) {
        return _super.call(this, evaluator, valueOperatorMatcher) || this;
    }
    /**
     * @override
     */
    FeatureFlagConditionMatcher.prototype.experiment = function (request, key) {
        return request.workspace.getFeatureFlagOrNull(key);
    };
    /**
     * @override
     */
    FeatureFlagConditionMatcher.prototype.resolve = function (request, context, evaluation) {
        return evaluation;
    };
    /**
     * @override
     */
    FeatureFlagConditionMatcher.prototype.evaluationMatches = function (evaluation, condition) {
        var on = evaluation.variationKey !== "A";
        return this.valueOperatorMatcher.matches(on, condition.match);
    };
    return FeatureFlagConditionMatcher;
}(ExperimentMatcher));

var EventConditionMatcher = /** @class */ (function () {
    function EventConditionMatcher(eventValueResolver, valueOperatorMatcher) {
        this.eventValueResolver = eventValueResolver;
        this.valueOperatorMatcher = valueOperatorMatcher;
    }
    EventConditionMatcher.prototype.matches = function (request, context, condition) {
        if (!this.isEventEvaluatorRequest(request)) {
            return false;
        }
        var eventValue = this.eventValueResolver.resolveOrNull(request.event, condition.key);
        return this.valueOperatorMatcher.matches(eventValue, condition.match);
    };
    EventConditionMatcher.prototype.isEventEvaluatorRequest = function (request) {
        return request.event !== undefined;
    };
    return EventConditionMatcher;
}());
var EventValueResolver = /** @class */ (function () {
    function EventValueResolver() {
    }
    EventValueResolver.prototype.resolveOrNull = function (event, key) {
        var _a;
        switch (key.type) {
            case "EVENT_PROPERTY":
                return (_a = this.properties(event)) === null || _a === void 0 ? void 0 : _a[key.name];
            case "USER_ID":
            case "USER_PROPERTY":
            case "HACKLE_PROPERTY":
            case "SEGMENT":
            case "AB_TEST":
            case "FEATURE_FLAG":
            case "COHORT":
                throw new Error("Unsupported TargetKeyType [".concat(key.type, "]"));
        }
    };
    EventValueResolver.prototype.properties = function (event) {
        if (UserEvent.isTrackEvent(event)) {
            return event.event.properties;
        }
        if (UserEvent.isExposureEvent(event)) {
            return event.properties;
        }
        if (UserEvent.isRemoteConfigEvent(event)) {
            return event.properties;
        }
        return undefined;
    };
    return EventValueResolver;
}());

var CohortConditionMatcher = /** @class */ (function () {
    function CohortConditionMatcher(valueOperatorMatcher) {
        this.valueOperatorMatcher = valueOperatorMatcher;
    }
    CohortConditionMatcher.prototype.matches = function (request, context, condition) {
        var _a, _b;
        if (condition.key.type !== "COHORT") {
            throw new Error("Unsupported TargetKeyType [".concat(condition.key.type, "]"));
        }
        var cohortIds = (_b = (_a = request.user.cohorts) === null || _a === void 0 ? void 0 : _a.map(function (it) { return it.id; })) !== null && _b !== void 0 ? _b : [];
        return this.valueOperatorMatcher.matches(cohortIds, condition.match);
    };
    return CohortConditionMatcher;
}());

var UserTargetConditionMatcher = /** @class */ (function () {
    function UserTargetConditionMatcher(valueOperatorMatcher, clock) {
        this.valueOperatorMatcher = valueOperatorMatcher;
        this.clock = clock;
    }
    UserTargetConditionMatcher.prototype.supports = function (targetKeyType) {
        return "NUMBER_OF_EVENTS_IN_DAYS" === targetKeyType || "NUMBER_OF_EVENTS_WITH_PROPERTY_IN_DAYS" === targetKeyType;
    };
    UserTargetConditionMatcher.prototype.matches = function (request, context, condition) {
        var _a;
        var keyType = condition.key.type;
        if (!this.supports(keyType)) {
            throw new Error("Unsupported TargetKeyType [".concat(keyType, "]"));
        }
        var targetEvents = (_a = request.user.targetEvents) !== null && _a !== void 0 ? _a : [];
        switch (keyType) {
            case "NUMBER_OF_EVENTS_IN_DAYS":
                return new NumberOfEventsInDaysMatcher(this.valueOperatorMatcher, this.clock).matches(request, targetEvents, condition);
            case "NUMBER_OF_EVENTS_WITH_PROPERTY_IN_DAYS":
                return new NumberOfEventsWithPropertyInDaysMatcher(this.valueOperatorMatcher, this.clock).matches(request, targetEvents, condition);
            default:
                return keyType;
        }
    };
    return UserTargetConditionMatcher;
}());
var TargetSegmentationExpressionMatcher = /** @class */ (function () {
    function TargetSegmentationExpressionMatcher() {
    }
    return TargetSegmentationExpressionMatcher;
}());
var NumberOfEventsInDaysMatcher = /** @class */ (function (_super) {
    __extends(NumberOfEventsInDaysMatcher, _super);
    function NumberOfEventsInDaysMatcher(valueOperatorMatcher, clock) {
        var _this = _super.call(this) || this;
        _this.valueOperatorMatcher = valueOperatorMatcher;
        _this.clock = clock;
        return _this;
    }
    NumberOfEventsInDaysMatcher.prototype.matches = function (_request, targetEvents, condition) {
        var _this = this;
        var expression = this.convertTargetConditionToExpression(condition);
        var daysAgoUtc = this.clock.currentMillis() - TimeUtil.daysToUnit(expression.days, "milliseconds");
        var userTargetEvents = targetEvents.filter(function (it) { return _this.expressionMatch(it, expression); });
        var sumOfEventCount = CollectionUtil.sum(userTargetEvents, function (it) { return it.countWithinDays(daysAgoUtc); });
        return this.valueOperatorMatcher.matches(sumOfEventCount, condition.match);
    };
    NumberOfEventsInDaysMatcher.prototype.expressionMatch = function (targetEvent, expression) {
        return targetEvent.eventKey === expression.eventKey && targetEvent.property === null;
    };
    NumberOfEventsInDaysMatcher.prototype.convertTargetConditionToExpression = function (condition) {
        try {
            return JSON.parse(condition.key.name);
        }
        catch (error) {
            throw new Error("Failed to parse UserTargetCondition. ".concat(error));
        }
    };
    return NumberOfEventsInDaysMatcher;
}(TargetSegmentationExpressionMatcher));
var NumberOfEventsWithPropertyInDaysMatcher = /** @class */ (function (_super) {
    __extends(NumberOfEventsWithPropertyInDaysMatcher, _super);
    function NumberOfEventsWithPropertyInDaysMatcher(valueOperatorMatcher, clock) {
        var _this = _super.call(this) || this;
        _this.valueOperatorMatcher = valueOperatorMatcher;
        _this.clock = clock;
        return _this;
    }
    NumberOfEventsWithPropertyInDaysMatcher.prototype.matches = function (_request, targetEvents, condition) {
        var _this = this;
        var expression = this.convertTargetConditionToExpression(condition);
        var daysAgoUtc = this.clock.currentMillis() - TimeUtil.daysToUnit(expression.days, "milliseconds");
        var userTargetEvents = targetEvents.filter(function (it) { return _this.expressionMatch(it, expression); });
        var sumOfEventCount = CollectionUtil.sum(userTargetEvents, function (it) { return it.countWithinDays(daysAgoUtc); });
        return this.valueOperatorMatcher.matches(sumOfEventCount, condition.match);
    };
    NumberOfEventsWithPropertyInDaysMatcher.prototype.propertyMatch = function (property, propertyCondition) {
        if ((property === null || property === void 0 ? void 0 : property.type) !== propertyCondition.key.type || property.key !== propertyCondition.key.name)
            return false;
        return this.valueOperatorMatcher.matches(property.value, propertyCondition.match);
    };
    NumberOfEventsWithPropertyInDaysMatcher.prototype.expressionMatch = function (targetEvent, expression) {
        if (targetEvent.eventKey !== expression.eventKey)
            return false;
        return this.propertyMatch(targetEvent.property, expression.propertyFilter);
    };
    NumberOfEventsWithPropertyInDaysMatcher.prototype.convertTargetConditionToExpression = function (condition) {
        try {
            return JSON.parse(condition.key.name);
        }
        catch (error) {
            throw new Error("Failed to parse UserTargetCondition. ".concat(error));
        }
    };
    return NumberOfEventsWithPropertyInDaysMatcher;
}(TargetSegmentationExpressionMatcher));

var ConditionMatcherFactory = /** @class */ (function () {
    function ConditionMatcherFactory(evaluator, clock) {
        var valueOperatorMatcher = new ValueOperatorMatcher(new ValueMatcherFactory(), new OperatorMatcherFactory());
        this.userConditionMatcher = new UserConditionMatcher(new UserValueResolver(), valueOperatorMatcher);
        this.eventConditionMatcher = new EventConditionMatcher(new EventValueResolver(), valueOperatorMatcher);
        this.segmentConditionMatcher = new SegmentConditionMatcher(new SegmentMatcher(this.userConditionMatcher));
        this.experimentConditionMatcher = new ExperimentConditionMatcher(new AbTestConditionMatcher(evaluator, valueOperatorMatcher), new FeatureFlagConditionMatcher(evaluator, valueOperatorMatcher));
        this.cohortConditionMatcher = new CohortConditionMatcher(valueOperatorMatcher);
        this.userTargetConditionMatcher = new UserTargetConditionMatcher(valueOperatorMatcher, clock);
    }
    ConditionMatcherFactory.prototype.getMatcher = function (type) {
        switch (type) {
            case "USER_ID":
            case "USER_PROPERTY":
            case "HACKLE_PROPERTY":
                return this.userConditionMatcher;
            case "EVENT_PROPERTY":
                return this.eventConditionMatcher;
            case "SEGMENT":
                return this.segmentConditionMatcher;
            case "AB_TEST":
            case "FEATURE_FLAG":
                return this.experimentConditionMatcher;
            case "COHORT":
                return this.cohortConditionMatcher;
            case "NUMBER_OF_EVENTS_IN_DAYS":
            case "NUMBER_OF_EVENTS_WITH_PROPERTY_IN_DAYS":
                return this.userTargetConditionMatcher;
            default:
                return type;
        }
    };
    return ConditionMatcherFactory;
}());

var Murmur3 = {
    murmurhash3_x86_32: function (data, seed, offset, len) {
        if (len === void 0) { len = data.length; }
        var c1 = 0xcc9e2d51;
        var c2 = 0x1b873593;
        var roundedEnd = len & ~0x3;
        var h1 = seed;
        var k1;
        for (var i = 0; i < roundedEnd; i += 4) {
            k1 =
                (data.charCodeAt(i) & 0xff) |
                    ((data.charCodeAt(i + 1) & 0xff) << 8) |
                    ((data.charCodeAt(i + 2) & 0xff) << 16) |
                    ((data.charCodeAt(i + 3) & 0xff) << 24);
            k1 = this.mul32(k1, c1);
            k1 = ((k1 & 0x1ffff) << 15) | (k1 >>> 17); // ROTL32(k1,15);
            k1 = this.mul32(k1, c2);
            h1 ^= k1;
            h1 = ((h1 & 0x7ffff) << 13) | (h1 >>> 19); // ROTL32(h1,13);
            h1 = (h1 * 5 + 0xe6546b64) | 0;
        }
        k1 = 0;
        switch (len % 4) {
            case 3:
                k1 = (data.charCodeAt(roundedEnd + 2) & 0xff) << 16;
            // fallthrough
            case 2:
                k1 |= (data.charCodeAt(roundedEnd + 1) & 0xff) << 8;
            // fallthrough
            case 1:
                k1 |= data.charCodeAt(roundedEnd) & 0xff;
                k1 = this.mul32(k1, c1);
                k1 = ((k1 & 0x1ffff) << 15) | (k1 >>> 17); // ROTL32(k1,15);
                k1 = this.mul32(k1, c2);
                h1 ^= k1;
        }
        // finalization
        h1 ^= len;
        // fmix(h1);
        h1 ^= h1 >>> 16;
        h1 = this.mul32(h1, 0x85ebca6b);
        h1 ^= h1 >>> 13;
        h1 = this.mul32(h1, 0xc2b2ae35);
        h1 ^= h1 >>> 16;
        return h1;
    },
    mul32: function (m, n) {
        var nlo = n & 0xffff;
        var nhi = n - nlo;
        return (((nhi * m) | 0) + ((nlo * m) | 0)) | 0;
    }
};

var Bucketer = /** @class */ (function () {
    function Bucketer() {
    }
    Bucketer.prototype.bucketing = function (bucket, identifier) {
        var slotNumber = this.calculateSlotNumber(bucket.seed, bucket.slotSize, identifier);
        return bucket.slots.find(function (it) { return it.contains(slotNumber); });
    };
    Bucketer.prototype.calculateSlotNumber = function (seed, slotSize, value) {
        var hashValue = Murmur3.murmurhash3_x86_32(value, seed);
        return Math.abs(hashValue) % Math.abs(slotSize);
    };
    return Bucketer;
}());

var log$5 = Logger.log;
/**
 * DO NOT use this class directly.
 * This class is only used internally by Hackle.
 * Backward compatibility is not supported.
 * Please use server-side or client-side HackleClient instead.
 */
var HackleCore = /** @class */ (function () {
    function HackleCore(experimentEvaluator, remoteConfigEvaluator, workspaceFetcher, eventFactory, eventProcessor, errorDedupDeterminer) {
        this.experimentEvaluator = experimentEvaluator;
        this.remoteConfigEvaluator = remoteConfigEvaluator;
        this.workspaceFetcher = workspaceFetcher;
        this.eventFactory = eventFactory;
        this.eventProcessor = eventProcessor;
        this.errorDedupDeterminer = errorDedupDeterminer;
    }
    HackleCore.create = function (workspaceFetcher, eventFactory, eventProcessor, manualOverrideStorages) {
        var clock = SystemClock.instance;
        var delegatingEvaluator = HackleCoreContext.register("delegatingEvaluator", new DelegatingEvaluator());
        var bucketer = new Bucketer();
        var targetMatcher = HackleCoreContext.register("targetMatcher", new TargetMatcher(new ConditionMatcherFactory(delegatingEvaluator, clock)));
        var manualOverrideStorage = new DelegatingManualOverrideStorage(manualOverrideStorages);
        var remoteConfigParameterTargetRuleDeterminer = new RemoteConfigParameterTargetRuleDeterminer(targetMatcher, bucketer);
        var experimentFlowFactory = new ExperimentFlowFactory(manualOverrideStorage, bucketer, HackleCoreContext.get("targetMatcher"));
        var experimentEvaluator = new ExperimentEvaluator(experimentFlowFactory);
        var remoteConfigEvaluator = new RemoteConfigEvaluator(remoteConfigParameterTargetRuleDeterminer);
        delegatingEvaluator.add(experimentEvaluator);
        delegatingEvaluator.add(remoteConfigEvaluator);
        return new HackleCore(experimentEvaluator, remoteConfigEvaluator, workspaceFetcher, eventFactory, eventProcessor, new ErrorDedupDeterminer());
    };
    HackleCore.prototype.getExperiment = function (experimentKey) {
        if (!experimentKey) {
            log$5.error("experimentKey must not be empty");
            return undefined;
        }
        var workspace = this.workspaceFetcher.get();
        if (!workspace) {
            return undefined;
        }
        return workspace.getExperimentOrNull(experimentKey);
    };
    HackleCore.prototype.experiment = function (experimentKey, user, defaultVariation) {
        var _this = this;
        if (!experimentKey) {
            log$5.error("experimentKey must not be empty");
            return Decision.of(defaultVariation, DecisionReason.INVALID_INPUT);
        }
        var workspace = this.workspaceFetcher.get();
        if (!workspace) {
            log$5.warn("SDK not ready.");
            return Decision.of(defaultVariation, DecisionReason.SDK_NOT_READY);
        }
        var experiment = workspace.getExperimentOrNull(experimentKey);
        if (!experiment) {
            log$5.warn("Experiment does not exist.");
            return Decision.of(defaultVariation, DecisionReason.EXPERIMENT_NOT_FOUND);
        }
        var request = ExperimentRequest.of(workspace, user, experiment, defaultVariation);
        var _a = this.experimentInternal(request), evaluation = _a[0], decision = _a[1];
        var events = this.eventFactory.create(request, evaluation);
        events.forEach(function (event) { return _this.eventProcessor.process(event); });
        return decision;
    };
    HackleCore.prototype.experiments = function (user) {
        var _this = this;
        var decisions = new Comparable(function (a, b) { return a.id === b.id; });
        var workspace = this.workspaceFetcher.get();
        if (!workspace) {
            return decisions;
        }
        workspace.getExperiments().forEach(function (experiment) {
            var request = ExperimentRequest.of(workspace, user, experiment, "A");
            var _a = _this.experimentInternal(request); _a[0]; var decision = _a[1];
            decisions.add(experiment, decision);
        });
        return decisions;
    };
    HackleCore.prototype.experimentInternal = function (request) {
        var _a;
        var evaluation = this.experimentEvaluator.evaluate(request, EvaluatorContext.create());
        var config = (_a = evaluation.config) !== null && _a !== void 0 ? _a : new EmptyParameterConfig();
        var decision = Decision.of(evaluation.variationKey, evaluation.reason, config, evaluation.experiment);
        return [evaluation, decision];
    };
    HackleCore.prototype.featureFlag = function (featureKey, user) {
        var _this = this;
        if (!featureKey) {
            log$5.error("featureKey must not be empty");
            return FeatureFlagDecision.off(DecisionReason.INVALID_INPUT);
        }
        var workspace = this.workspaceFetcher.get();
        if (!workspace) {
            log$5.warn("SDK not ready.");
            return FeatureFlagDecision.off(DecisionReason.SDK_NOT_READY);
        }
        var featureFlag = workspace.getFeatureFlagOrNull(featureKey);
        if (!featureFlag) {
            log$5.warn("FeatureFlag does not exist.");
            return FeatureFlagDecision.off(DecisionReason.FEATURE_FLAG_NOT_FOUND);
        }
        var request = ExperimentRequest.of(workspace, user, featureFlag, "A");
        var _a = this.featureFlagInternal(request), evaluation = _a[0], decision = _a[1];
        var events = this.eventFactory.create(request, evaluation);
        events.forEach(function (event) { return _this.eventProcessor.process(event); });
        return decision;
    };
    HackleCore.prototype.featureFlags = function (user) {
        var _this = this;
        var decisions = new Comparable(function (a, b) { return a.id === b.id; });
        var workspace = this.workspaceFetcher.get();
        if (!workspace) {
            return decisions;
        }
        workspace.getFeatureFlags().forEach(function (featureFlag) {
            var request = ExperimentRequest.of(workspace, user, featureFlag, "A");
            var _a = _this.featureFlagInternal(request); _a[0]; var decision = _a[1];
            decisions.add(featureFlag, decision);
        });
        return decisions;
    };
    HackleCore.prototype.featureFlagInternal = function (request) {
        var _a;
        var evaluation = this.experimentEvaluator.evaluate(request, EvaluatorContext.create());
        var config = (_a = evaluation.config) !== null && _a !== void 0 ? _a : new EmptyParameterConfig();
        var decision = evaluation.variationKey === "A"
            ? FeatureFlagDecision.off(evaluation.reason, config, evaluation.experiment)
            : FeatureFlagDecision.on(evaluation.reason, config, evaluation.experiment);
        return [evaluation, decision];
    };
    HackleCore.prototype.inAppMessage = function (request, context, evaluator) {
        var evaluation = evaluator.evaluate(request, context);
        evaluator.record(request, evaluation);
        return evaluation;
    };
    HackleCore.prototype.track = function (event, user, timestamp) {
        var _a;
        if (timestamp === void 0) { timestamp = new Date().getTime(); }
        if (!event) {
            log$5.warn("event must not be null.");
            return;
        }
        if (typeof event !== "object") {
            log$5.warn("Event must be event type.");
            return;
        }
        if (typeof event === "object") {
            if (!event.key || typeof event.key !== "string") {
                log$5.warn("Event key must be not null. or event key must be string type.");
                return;
            }
        }
        var eventType = ((_a = this.workspaceFetcher.get()) === null || _a === void 0 ? void 0 : _a.getEventTypeOrNull(event.key)) || new EventType(0, event.key);
        this.eventProcessor.process(UserEvent.track(eventType, event, user, timestamp));
    };
    HackleCore.prototype.trackException = function (exception, user) {
        if (this.errorDedupDeterminer.isDedupTarget(exception)) {
            return;
        }
        var event = TraceTransformer.toEvent(exception);
        this.flush();
        this.track(event, user);
        this.flush();
    };
    HackleCore.prototype.flush = function (sync) {
        if (sync === void 0) { sync = false; }
        this.eventProcessor.flush(sync);
    };
    HackleCore.prototype.remoteConfig = function (parameterKey, user, requiredType, defaultValue) {
        var _this = this;
        var workspace = this.workspaceFetcher.get();
        if (ObjectUtil.isNullOrUndefined(workspace)) {
            log$5.warn("SDK not ready.");
            return RemoteConfigDecision.of(defaultValue, DecisionReason.SDK_NOT_READY);
        }
        var remoteConfigParameter = workspace.getRemoteConfigParameterOrNull(parameterKey);
        if (ObjectUtil.isNullOrUndefined(remoteConfigParameter)) {
            log$5.warn("Remote config parameter does not exist.");
            return RemoteConfigDecision.of(defaultValue, DecisionReason.REMOTE_CONFIG_PARAMETER_NOT_FOUND);
        }
        var request = RemoteConfigRequest.of(workspace, user, remoteConfigParameter, requiredType, defaultValue);
        var evaluation = this.remoteConfigEvaluator.evaluate(request, EvaluatorContext.create());
        var events = this.eventFactory.create(request, evaluation);
        events.forEach(function (event) { return _this.eventProcessor.process(event); });
        return RemoteConfigDecision.of(evaluation.value, evaluation.reason);
    };
    HackleCore.prototype.close = function () {
        this.eventProcessor.close();
    };
    return HackleCore;
}());
var ErrorDedupDeterminer = /** @class */ (function () {
    function ErrorDedupDeterminer() {
    }
    ErrorDedupDeterminer.prototype.isDedupTarget = function (error) {
        if (this._isSameError(error, this.previous)) {
            return true;
        }
        this.previous = error;
        return false;
    };
    ErrorDedupDeterminer.prototype._isSameError = function (currentError, previousError) {
        if (ObjectUtil.isNullOrUndefined(previousError)) {
            return false;
        }
        return (currentError.name === previousError.name &&
            currentError.message === previousError.message &&
            currentError.stack === previousError.stack);
    };
    return ErrorDedupDeterminer;
}());

var GlobalErrorHandler = /** @class */ (function () {
    function GlobalErrorHandler() {
        this._installed = [];
        this._installations = {
            onerror: _installOnError,
            onunhandledrejection: _installOnUnhandledRejection
        };
    }
    GlobalErrorHandler.prototype.install = function (core, userManager) {
        this._install("onerror", core, userManager);
        this._install("onunhandledrejection", core, userManager);
    };
    GlobalErrorHandler.prototype._install = function (key, core, userManager) {
        if (key in this._installed) {
            return;
        }
        var install = this._installations[key];
        install(core, userManager);
        this._installed.push(key);
    };
    return GlobalErrorHandler;
}());
var _oldOnErrorEventHandler = null;
function _installOnError(core, userManager) {
    _oldOnErrorEventHandler = window.onerror;
    window.onerror = function (msg, url, line, column, error) {
        if (ObjectUtil.isNotNullOrUndefined(error)) {
            core.trackException(error, userManager.resolve());
        }
        if (_oldOnErrorEventHandler) {
            // @ts-ignore
            _oldOnErrorEventHandler.apply(this, arguments);
        }
    };
}
var _oldOnUnhandledRejectionEventHandler;
function _installOnUnhandledRejection(core, userManager) {
    _oldOnUnhandledRejectionEventHandler = window.onunhandledrejection;
    window.onunhandledrejection = function (e) {
        var error;
        try {
            if ("reason" in e) {
                error = e.reason;
            }
            else if ("detail" in e && "reason" in e.detail) {
                error = e.detail.reason;
            }
        }
        catch (_) {
            // ignore
        }
        if (error instanceof Error) {
            core.trackException(error, userManager.resolve());
        }
        if (_oldOnUnhandledRejectionEventHandler) {
            // @ts-ignore
            _oldOnUnhandledRejectionEventHandler.apply(this, arguments);
        }
    };
}

var EventRepositoryImpl = /** @class */ (function () {
    function EventRepositoryImpl(storage, storageKey, maxSize) {
        this.storage = storage;
        this.storageKey = storageKey;
        this.maxSize = maxSize;
    }
    EventRepositoryImpl.prototype.read = function () {
        return __awaiter(this, void 0, void 0, function () {
            var json;
            return __generator(this, function (_a) {
                json = this.storage.getItem(this.storageKey);
                if (json) {
                    return [2 /*return*/, JSON.parse(json)];
                }
                return [2 /*return*/, []];
            });
        });
    };
    EventRepositoryImpl.prototype.save = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            var json;
            return __generator(this, function (_a) {
                if (items.length === 0) {
                    return [2 /*return*/, this.clear()];
                }
                json = JSON.stringify(items.slice(-this.maxSize));
                this.storage.setItem(this.storageKey, json);
                return [2 /*return*/];
            });
        });
    };
    EventRepositoryImpl.prototype.add = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.read()];
                    case 1:
                        data = _a.sent();
                        return [4 /*yield*/, this.save(data.concat(items).slice(-this.maxSize))];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EventRepositoryImpl.prototype.delete = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            var data, newData;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.read()];
                    case 1:
                        data = _a.sent();
                        newData = data.filter(function (it) { return !_this.isDeleteTarget(it, items); });
                        return [4 /*yield*/, this.save(newData)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EventRepositoryImpl.prototype.isDeleteTarget = function (item, items) {
        return items.some(function (it) { return it.insertId === item.insertId; });
    };
    EventRepositoryImpl.prototype.clear = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.storage.removeItem(this.storageKey);
                return [2 /*return*/];
            });
        });
    };
    return EventRepositoryImpl;
}());

var isSameUser = function (a, b) {
    if (a === null)
        return false;
    return a.userId === b.userId && a.deviceId === b.deviceId;
};
var mergeUsers = function (oldUser, newUser) {
    if (isSameUser(oldUser, newUser)) {
        return __assign(__assign({}, newUser), { properties: __assign(__assign({}, oldUser.properties), newUser.properties) });
    }
    return newUser;
};

var UserCohorts = /** @class */ (function () {
    function UserCohorts(cohorts) {
        this.cohorts = cohorts;
    }
    UserCohorts.builder = function () {
        return new UserCohortsBuilder();
    };
    UserCohorts.empty = function () {
        return UserCohorts.builder().build();
    };
    UserCohorts.from = function (cohorts) {
        return new UserCohorts(cohorts);
    };
    UserCohorts.fromDto = function (dto) {
        var builder = UserCohorts.builder();
        for (var _i = 0, _a = dto.cohorts; _i < _a.length; _i++) {
            var cohort = _a[_i];
            builder.put({
                identifier: cohort.identifier,
                cohorts: cohort.cohorts.map(function (id) { return new Cohort(id); })
            });
        }
        return builder.build();
    };
    Object.defineProperty(UserCohorts.prototype, "rawCohorts", {
        get: function () {
            return this.cohorts.values().flatMap(function (it) { return it.cohorts; });
        },
        enumerable: false,
        configurable: true
    });
    UserCohorts.prototype.get = function (identifier) {
        return this.cohorts.get(identifier);
    };
    UserCohorts.prototype.filterBy = function (user) {
        var identifiers = resolveIdentifiers(user);
        var filtered = this.asComparable().filter(function (identifier, _) { return identifiers[identifier.type] === identifier.value; });
        return UserCohorts.from(filtered);
    };
    UserCohorts.prototype.asArray = function () {
        return this.cohorts.values();
    };
    UserCohorts.prototype.asComparable = function () {
        return this.cohorts;
    };
    UserCohorts.prototype.toBuilder = function () {
        return new UserCohortsBuilder(this);
    };
    return UserCohorts;
}());
var UserCohortsBuilder = /** @class */ (function () {
    function UserCohortsBuilder(cohorts) {
        this.cohorts = new Comparable(IdentifierUtil.isEqual);
        if (cohorts) {
            this.putAll(cohorts);
        }
    }
    UserCohortsBuilder.prototype.put = function (cohort) {
        this.cohorts.add(cohort.identifier, cohort);
        return this;
    };
    UserCohortsBuilder.prototype.putAll = function (cohorts) {
        var _this = this;
        cohorts.asArray().forEach(function (it) { return _this.put(it); });
        return this;
    };
    UserCohortsBuilder.prototype.build = function () {
        return new UserCohorts(this.cohorts);
    };
    return UserCohortsBuilder;
}());

var MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable";
var UAParser = /** @class */ (function () {
    function UAParser() {
    }
    UAParser.parse = function (uaString) {
        return {
            browser: UAParser.getBrowser(uaString),
            cpu: UAParser.getCPU(uaString),
            device: UAParser.getDevice(uaString),
            engine: UAParser.getEngine(uaString),
            os: UAParser.getOS(uaString)
        };
    };
    UAParser.getBrowser = function (uaString) {
        var browser = { name: undefined, version: undefined, major: undefined };
        UAParser.mapper.rgx.call(browser, uaString, UAParser.regexes.browser);
        browser.major = UAParser.util.major(browser.version);
        return browser;
    };
    UAParser.getCPU = function (uaString) {
        var cpu = { architecture: undefined };
        UAParser.mapper.rgx.call(cpu, uaString, UAParser.regexes.cpu);
        return cpu;
    };
    UAParser.getDevice = function (uaString) {
        var device = { model: undefined, type: undefined, vendor: undefined };
        UAParser.mapper.rgx.call(device, uaString, UAParser.regexes.device);
        return device;
    };
    UAParser.getEngine = function (uaString) {
        var engine = { name: undefined, version: undefined };
        UAParser.mapper.rgx.call(engine, uaString, UAParser.regexes.os);
        return engine;
    };
    UAParser.getOS = function (uaString) {
        var os = { name: undefined, version: undefined };
        UAParser.mapper.rgx.call(os, uaString, UAParser.regexes.os);
        return os;
    };
    UAParser.util = {
        extend: function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    // @ts-ignore
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                }
                else {
                    // @ts-ignore
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        has: function (str1, str2) {
            if (typeof str1 === "string") {
                return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
            }
            else {
                return false;
            }
        },
        lowerize: function (str) {
            return str.toLowerCase();
        },
        major: function (version) {
            return typeof version === "string" ? version.replace(/[^\d\.]/g, "").split(".")[0] : undefined;
        },
        trim: function (str) {
            return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
        }
    };
    UAParser.mapper = {
        rgx: function (ua, arrays) {
            var i = 0, j, k, p, q, matches, match;
            // loop through all regexes maps
            while (i < arrays.length && !matches) {
                var regex = arrays[i], // even sequence (0,2,4,..)
                props = arrays[i + 1]; // odd sequence (1,3,5,..)
                j = k = 0;
                // try matching uastring with regexes
                while (j < regex.length && !matches) {
                    matches = regex[j++].exec(ua);
                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === "object" && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == "function") {
                                        // assign modified match
                                        // @ts-ignore
                                        this[q[0]] = q[1].call(this, match);
                                    }
                                    else {
                                        // assign given value, ignore regex match
                                        // @ts-ignore
                                        this[q[0]] = q[1];
                                    }
                                }
                                else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === "function" && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        // @ts-ignore
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    }
                                    else {
                                        // sanitize match using given regex
                                        // @ts-ignore
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                }
                                else if (q.length == 4) {
                                    // @ts-ignore
                                    this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            }
                            else {
                                // @ts-ignore
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },
        str: function (str, map) {
            for (var i in map) {
                // check if array
                // @ts-ignore
                if (typeof map[i] === "object" && map[i].length > 0) {
                    // @ts-ignore
                    for (var j = 0; j < map[i].length; j++) {
                        // @ts-ignore
                        if (UAParser.util.has(map[i][j], str)) {
                            return i === "?" ? undefined : i;
                        }
                    }
                    // @ts-ignore
                }
                else if (UAParser.util.has(map[i], str)) {
                    return i === "?" ? undefined : i;
                }
            }
            return str;
        }
    };
    UAParser.maps = {
        browser: {
            oldsafari: {
                version: {
                    "1.0": "/8",
                    "1.2": "/1",
                    "1.3": "/3",
                    "2.0": "/412",
                    "2.0.2": "/416",
                    "2.0.3": "/417",
                    "2.0.4": "/419",
                    "?": "/"
                }
            }
        },
        device: {
            amazon: {
                model: {
                    "Fire Phone": ["SD", "KF"]
                }
            },
            sprint: {
                model: {
                    "Evo Shift 4G": "7373KT"
                },
                vendor: {
                    HTC: "APA",
                    Sprint: "Sprint"
                }
            }
        },
        os: {
            windows: {
                version: {
                    ME: "4.90",
                    "NT 3.11": "NT3.51",
                    "NT 4.0": "NT4.0",
                    "2000": "NT 5.0",
                    XP: ["NT 5.1", "NT 5.2"],
                    Vista: "NT 6.0",
                    "7": "NT 6.1",
                    "8": "NT 6.2",
                    "8.1": "NT 6.3",
                    "10": ["NT 6.4", "NT 10.0"],
                    RT: "ARM"
                }
            }
        }
    };
    UAParser.regexes = {
        browser: [
            [
                // Presto based
                /(opera\smini)\/([\w\.-]+)/i,
                /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,
                /(opera).+version\/([\w\.]+)/i,
                /(opera)[\/\s]+([\w\.]+)/i // Opera < 9.80
            ],
            [NAME, VERSION],
            [
                /(opios)[\/\s]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [[NAME, "Opera Mini"], VERSION],
            [
                /\s(opr)\/([\w\.]+)/i // Opera Webkit
            ],
            [[NAME, "Opera"], VERSION],
            [
                // Mixed
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
                // Lunascape/Maxthon/Netfront/Jasmine/Blazer
                // Trident based
                /(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i,
                // Avant/IEMobile/SlimBrowser
                /(bidubrowser|baidubrowser)[\/\s]?([\w\.]+)/i,
                /(?:ms|\()(ie)\s([\w\.]+)/i,
                // Webkit/KHTML based
                /(rekonq)\/([\w\.]*)/i,
                /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i
                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            ],
            [NAME, VERSION],
            [
                /(konqueror)\/([\w\.]+)/i // Konqueror
            ],
            [[NAME, "Konqueror"], VERSION],
            [
                /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i // IE11
            ],
            [[NAME, "IE"], VERSION],
            [
                /(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i // Microsoft Edge
            ],
            [[NAME, "Edge"], VERSION],
            [
                /(yabrowser)\/([\w\.]+)/i // Yandex
            ],
            [[NAME, "Yandex"], VERSION],
            [
                /(Avast)\/([\w\.]+)/i // Avast Secure Browser
            ],
            [[NAME, "Avast Secure Browser"], VERSION],
            [
                /(AVG)\/([\w\.]+)/i // AVG Secure Browser
            ],
            [[NAME, "AVG Secure Browser"], VERSION],
            [
                /(puffin)\/([\w\.]+)/i // Puffin
            ],
            [[NAME, "Puffin"], VERSION],
            [
                /(focus)\/([\w\.]+)/i // Firefox Focus
            ],
            [[NAME, "Firefox Focus"], VERSION],
            [
                /(opt)\/([\w\.]+)/i // Opera Touch
            ],
            [[NAME, "Opera Touch"], VERSION],
            [
                /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i // UCBrowser
            ],
            [[NAME, "UCBrowser"], VERSION],
            [
                /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
            ],
            [[NAME, /_/g, " "], VERSION],
            [
                /(windowswechat qbcore)\/([\w\.]+)/i // WeChat Desktop for Windows Built-in Browser
            ],
            [[NAME, "WeChat(Win) Desktop"], VERSION],
            [
                /(micromessenger)\/([\w\.]+)/i // WeChat
            ],
            [[NAME, "WeChat"], VERSION],
            [
                /(brave)\/([\w\.]+)/i // Brave browser
            ],
            [[NAME, "Brave"], VERSION],
            [
                /(whale)\/([\w\.]+)/i // Whale browser
            ],
            [[NAME, "Whale"], VERSION],
            [
                /(qqbrowserlite)\/([\w\.]+)/i // QQBrowserLite
            ],
            [NAME, VERSION],
            [
                /(QQ)\/([\d\.]+)/i // QQ, aka ShouQ
            ],
            [NAME, VERSION],
            [
                /m?(qqbrowser)[\/\s]?([\w\.]+)/i // QQBrowser
            ],
            [NAME, VERSION],
            [
                /(baiduboxapp)[\/\s]?([\w\.]+)/i // Baidu App
            ],
            [NAME, VERSION],
            [
                /(2345Explorer)[\/\s]?([\w\.]+)/i // 2345 Browser
            ],
            [NAME, VERSION],
            [
                /(MetaSr)[\/\s]?([\w\.]+)/i // SouGouBrowser
            ],
            [NAME],
            [
                /(LBBROWSER)/i // LieBao Browser
            ],
            [NAME],
            [
                /xiaomi\/miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [VERSION, [NAME, "MIUI Browser"]],
            [
                /;fbav\/([\w\.]+);/i // Facebook App for iOS & Android
            ],
            [VERSION, [NAME, "Facebook"]],
            [
                /safari\s(line)\/([\w\.]+)/i,
                /android.+(line)\/([\w\.]+)\/iab/i // Line App for Android
            ],
            [NAME, VERSION],
            [
                /headlesschrome(?:\/([\w\.]+)|\s)/i // Chrome Headless
            ],
            [VERSION, [NAME, "Chrome Headless"]],
            [
                /\swv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [[NAME, /(.+)/, "$1 WebView"], VERSION],
            [/((?:oculus|samsung)browser)\/([\w\.]+)/i],
            [[NAME, /(.+(?:g|us))(.+)/, "$1 $2"], VERSION],
            [
                // Oculus / Samsung Browser
                /((?:android.+)crmo|crios)\/([\w\.]+)/i,
                /android.+(chrome)\/([\w\.]+)\s+(?:mobile\s?safari)/i
            ],
            [[NAME, "Chrome Mobile"], VERSION],
            [
                /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i // Android Browser
            ],
            [VERSION, [NAME, "Android Browser"]],
            [
                /(sailfishbrowser)\/([\w\.]+)/i // Sailfish Browser
            ],
            [[NAME, "Sailfish Browser"], VERSION],
            [
                /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [NAME, VERSION],
            [
                /(dolfin)\/([\w\.]+)/i // Dolphin
            ],
            [[NAME, "Dolphin"], VERSION],
            [
                /(qihu|qhbrowser|qihoobrowser|360browser)/i // 360
            ],
            [[NAME, "360 Browser"]],
            [
                /(coast)\/([\w\.]+)/i // Opera Coast
            ],
            [[NAME, "Opera Coast"], VERSION],
            [
                /fxios\/([\w\.-]+)/i // Firefox for iOS
            ],
            [VERSION, [NAME, "Firefox"]],
            [
                /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i // Mobile Safari
            ],
            [VERSION, [NAME, "Mobile Safari"]],
            [
                /version\/([\w\.]+).+?(mobile\s?safari|safari)/i // Safari & Safari Mobile
            ],
            [VERSION, NAME],
            [
                /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i // Google Search Appliance on iOS
            ],
            [[NAME, "GSA"], VERSION],
            [
                /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [NAME, [VERSION, UAParser.mapper.str, UAParser.maps.browser.oldsafari.version]],
            [/(webkit|khtml)\/([\w\.]+)/i],
            [NAME, VERSION],
            [
                // Gecko based
                /(navigator|netscape)\/([\w\.-]+)/i // Netscape
            ],
            [[NAME, "Netscape"], VERSION],
            [
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
                /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
                /(links)\s\(([\w\.]+)/i,
                /(gobrowser)\/?([\w\.]*)/i,
                /(ice\s?browser)\/v?([\w\._]+)/i,
                /(mosaic)[\/\s]([\w\.]+)/i // Mosaic
            ],
            [NAME, VERSION]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i // AMD64
            ],
            [[ARCHITECTURE, "amd64"]],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [[ARCHITECTURE, UAParser.util.lowerize]],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32
            ],
            [[ARCHITECTURE, "ia32"]],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows\s(ce|mobile);\sppc;/i
            ],
            [[ARCHITECTURE, "arm"]],
            [
                /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i // PowerPC
            ],
            [[ARCHITECTURE, /ower/, "", UAParser.util.lowerize]],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [[ARCHITECTURE, "sparc"]],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ],
            [[ARCHITECTURE, UAParser.util.lowerize]]
        ],
        device: [
            [
                /\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i // iPad/PlayBook
            ],
            [MODEL, VENDOR, [TYPE, TABLET]],
            [
                /applecoremedia\/[\w\.]+ \((ipad)/ // iPad
            ],
            [MODEL, [VENDOR, "Apple"], [TYPE, TABLET]],
            [
                /(apple\s{0,1}tv)/i // Apple TV
            ],
            [
                [MODEL, "Apple TV"],
                [VENDOR, "Apple"],
                [TYPE, SMARTTV]
            ],
            [
                /(archos)\s(gamepad2?)/i,
                /(hp).+(touchpad)/i,
                /(hp).+(tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /\s(nook)[\w\s]+build\/(\w+)/i,
                /(dell)\s(strea[kpr\s\d]*[\dko])/i // Dell Streak
            ],
            [VENDOR, MODEL, [TYPE, TABLET]],
            [
                /(kf[A-z]+)\sbuild\/.+silk\//i // Kindle Fire HD
            ],
            [MODEL, [VENDOR, "Amazon"], [TYPE, TABLET]],
            [
                /(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i // Fire Phone
            ],
            [
                [MODEL, UAParser.mapper.str, UAParser.maps.device.amazon.model],
                [VENDOR, "Amazon"],
                [TYPE, MOBILE]
            ],
            [
                /android.+aft([bms])\sbuild/i // Fire TV
            ],
            [MODEL, [VENDOR, "Amazon"], [TYPE, SMARTTV]],
            [
                /\((ip[honed|\s\w*]+);.+(apple)/i // iPod/iPhone
            ],
            [MODEL, VENDOR, [TYPE, MOBILE]],
            [
                /\((ip[honed|\s\w*]+);/i // iPod/iPhone
            ],
            [MODEL, [VENDOR, "Apple"], [TYPE, MOBILE]],
            [
                /(blackberry)[\s-]?(\w+)/i,
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
                /(hp)\s([\w\s]+\w)/i,
                /(asus)-?(\w+)/i // Asus
            ],
            [VENDOR, MODEL, [TYPE, MOBILE]],
            [
                /\(bb10;\s(\w+)/i // BlackBerry 10
            ],
            [MODEL, [VENDOR, "BlackBerry"], [TYPE, MOBILE]],
            [
                // Asus Tablets
                /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i
            ],
            [MODEL, [VENDOR, "Asus"], [TYPE, TABLET]],
            [
                /(sony)\s(tablet\s[ps])\sbuild\//i,
                /(sony)?(?:sgp.+)\sbuild\//i
            ],
            [
                [VENDOR, "Sony"],
                [MODEL, "Xperia Tablet"],
                [TYPE, TABLET]
            ],
            [/android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i],
            [MODEL, [VENDOR, "Sony"], [TYPE, MOBILE]],
            [
                /\s(ouya)\s/i,
                /(nintendo)\s([wids3u]+)/i // Nintendo
            ],
            [VENDOR, MODEL, [TYPE, CONSOLE]],
            [
                /android.+;\s(shield)\sbuild/i // Nvidia
            ],
            [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]],
            [
                /(playstation\s[34portablevi]+)/i // Playstation
            ],
            [MODEL, [VENDOR, "Sony"], [TYPE, CONSOLE]],
            [
                /(sprint\s(\w+))/i // Sprint Phones
            ],
            [
                [VENDOR, UAParser.mapper.str, UAParser.maps.device.sprint.vendor],
                [MODEL, UAParser.mapper.str, UAParser.maps.device.sprint.model],
                [TYPE, MOBILE]
            ],
            [
                /(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,
                /(zte)-(\w*)/i,
                /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
                // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]],
            [
                /(nexus\s9)/i // HTC Nexus 9
            ],
            [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]],
            [
                /d\/huawei([\w\s-]+)[;\)]/i,
                /(nexus\s6p|vog-l29|ane-lx1|eml-l29)/i // Huawei
            ],
            [MODEL, [VENDOR, "Huawei"], [TYPE, MOBILE]],
            [
                /android.+(bah2?-a?[lw]\d{2})/i // Huawei MediaPad
            ],
            [MODEL, [VENDOR, "Huawei"], [TYPE, TABLET]],
            [
                /(microsoft);\s(lumia[\s\w]+)/i // Microsoft Lumia
            ],
            [VENDOR, MODEL, [TYPE, MOBILE]],
            [
                /[\s\(;](xbox(?:\sone)?)[\s\);]/i // Microsoft Xbox
            ],
            [MODEL, [VENDOR, "Microsoft"], [TYPE, CONSOLE]],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [MODEL, /\./g, " "],
                [VENDOR, "Microsoft"],
                [TYPE, MOBILE]
            ],
            [
                // Motorola
                /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
                /mot[\s-]?(\w*)/i,
                /(XT\d{3,4}) build\//i,
                /(nexus\s6)/i
            ],
            [MODEL, [VENDOR, "Motorola"], [TYPE, MOBILE]],
            [/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],
            [MODEL, [VENDOR, "Motorola"], [TYPE, TABLET]],
            [
                /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [VENDOR, UAParser.util.trim],
                [MODEL, UAParser.util.trim],
                [TYPE, SMARTTV]
            ],
            [/hbbtv.+maple;(\d+)/i],
            [
                [MODEL, /^/, "SmartTV"],
                [VENDOR, "Samsung"],
                [TYPE, SMARTTV]
            ],
            [
                /\(dtv[\);].+(aquos)/i // Sharp
            ],
            [MODEL, [VENDOR, "Sharp"], [TYPE, SMARTTV]],
            [/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i],
            [[VENDOR, "Samsung"], MODEL, [TYPE, TABLET]],
            [
                // Samsung
                /smart-tv.+(samsung)/i
            ],
            [VENDOR, [TYPE, SMARTTV], MODEL],
            [/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i, /sec-((sgh\w+))/i],
            [[VENDOR, "Samsung"], MODEL, [TYPE, MOBILE]],
            [
                /sie-(\w*)/i // Siemens
            ],
            [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]],
            [
                /(maemo|nokia).*(n900|lumia\s\d+)/i,
                /(nokia)[\s_-]?([\w-]*)/i
            ],
            [[VENDOR, "Nokia"], MODEL, [TYPE, MOBILE]],
            [
                /android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i // Acer
            ],
            [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]],
            [
                /android.+([vl]k\-?\d{3})\s+build/i // LG Tablet
            ],
            [MODEL, [VENDOR, "LG"], [TYPE, TABLET]],
            [
                /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i // LG Tablet
            ],
            [[VENDOR, "LG"], MODEL, [TYPE, TABLET]],
            [
                /(lg) netcast\.tv/i // LG SmartTV
            ],
            [VENDOR, MODEL, [TYPE, SMARTTV]],
            [
                /(nexus\s[45])/i,
                /lg[e;\s\/-]+(\w*)/i,
                /android.+lg(\-?[\d\w]+)\s+build/i
            ],
            [MODEL, [VENDOR, "LG"], [TYPE, MOBILE]],
            [
                /(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i // Lenovo tablets
            ],
            [VENDOR, MODEL, [TYPE, TABLET]],
            [
                /android.+(ideatab[a-z0-9\-\s]+)/i // Lenovo
            ],
            [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]],
            [/(lenovo)[_\s-]?([\w-]+)/i],
            [VENDOR, MODEL, [TYPE, MOBILE]],
            [
                /linux;.+((jolla));/i // Jolla
            ],
            [VENDOR, MODEL, [TYPE, MOBILE]],
            [
                /((pebble))app\/[\d\.]+\s/i // Pebble
            ],
            [VENDOR, MODEL, [TYPE, WEARABLE]],
            [
                /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i // OPPO
            ],
            [VENDOR, MODEL, [TYPE, MOBILE]],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [MODEL, "Chromecast"],
                [VENDOR, "Google"],
                [TYPE, SMARTTV]
            ],
            [
                /android.+;\s(glass)\s\d/i // Google Glass
            ],
            [MODEL, [VENDOR, "Google"], [TYPE, WEARABLE]],
            [
                /android.+;\s(pixel c)[\s)]/i // Google Pixel C
            ],
            [MODEL, [VENDOR, "Google"], [TYPE, TABLET]],
            [
                /android.+;\s(pixel( [23])?( xl)?)[\s)]/i // Google Pixel
            ],
            [MODEL, [VENDOR, "Google"], [TYPE, MOBILE]],
            [
                /android.+;\s(\w+)\s+build\/hm\1/i,
                /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,
                /android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,
                // Xiaomi Mi
                /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i // Redmi Phones
            ],
            [
                [MODEL, /_/g, " "],
                [VENDOR, "Xiaomi"],
                [TYPE, MOBILE]
            ],
            [
                /android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i // Mi Pad tablets
            ],
            [
                [MODEL, /_/g, " "],
                [VENDOR, "Xiaomi"],
                [TYPE, TABLET]
            ],
            [
                /android.+;\s(m[1-5]\snote)\sbuild/i // Meizu
            ],
            [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]],
            [/(mz)-([\w-]{2,})/i],
            [[VENDOR, "Meizu"], MODEL, [TYPE, MOBILE]],
            [
                /android.+a000(1)\s+build/i,
                /android.+oneplus\s(a\d{4})[\s)]/i
            ],
            [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]],
            [
                /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i // RCA Tablets
            ],
            [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]],
            [
                /android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i // Dell Venue Tablets
            ],
            [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]],
            [
                /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i // Verizon Tablet
            ],
            [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]],
            [
                /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i // Barnes & Noble Tablet
            ],
            [[VENDOR, "Barnes & Noble"], MODEL, [TYPE, TABLET]],
            [
                /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i // Barnes & Noble Tablet
            ],
            [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]],
            [
                /android.+;\s(k88)\sbuild/i // ZTE K Series Tablet
            ],
            [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]],
            [
                /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i // Swiss GEN Mobile
            ],
            [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]],
            [
                /android.+[;\/]\s*(zur\d{3})\s+build/i // Swiss ZUR Tablet
            ],
            [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]],
            [
                /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i // Zeki Tablets
            ],
            [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]],
            [
                /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
                /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i // Dragon Touch Tablet
            ],
            [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]],
            [
                /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i // Insignia Tablets
            ],
            [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]],
            [
                /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i // NextBook Tablets
            ],
            [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]],
            [/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],
            [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]],
            [
                // Voice Xtreme Phones
                /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i // LvTel Phones
            ],
            [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]],
            [/android.+;\s(PH-1)\s/i],
            [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]],
            [
                // Essential PH-1
                /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i // Envizen Tablets
            ],
            [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]],
            [
                /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i // Le Pan Tablets
            ],
            [VENDOR, MODEL, [TYPE, TABLET]],
            [
                /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i // MachSpeed Tablets
            ],
            [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]],
            [
                /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i // Trinity Tablets
            ],
            [VENDOR, MODEL, [TYPE, TABLET]],
            [
                /android.+[;\/]\s*TU_(1491)\s+build/i // Rotor Tablets
            ],
            [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]],
            [
                /android.+(KS(.+))\s+build/i // Amazon Kindle Tablets
            ],
            [MODEL, [VENDOR, "Amazon"], [TYPE, TABLET]],
            [
                /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i // Gigaset Tablets
            ],
            [VENDOR, MODEL, [TYPE, TABLET]],
            [
                /\s(tablet|tab)[;\/]/i,
                /\s(mobile)(?:[;\/]|\ssafari)/i // Unidentifiable Mobile
            ],
            [[TYPE, UAParser.util.lowerize], VENDOR, MODEL],
            [
                /[\s\/\(](smart-?tv)[;\)]/i // SmartTV
            ],
            [[TYPE, SMARTTV]],
            [
                /(android[\w\.\s\-]{0,9});.+build/i // Generic Android Device
            ],
            [MODEL, [VENDOR, "Generic"]]
        ],
        engine: [
            [
                /windows.+\sedge\/([\w\.]+)/i // EdgeHTML
            ],
            [VERSION, [NAME, "EdgeHTML"]],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [VERSION, [NAME, "Blink"]],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
                /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,
                /(icab)[\/\s]([23]\.[\d\.]+)/i // iCab
            ],
            [NAME, VERSION],
            [
                /rv\:([\w\.]{1,9}).+(gecko)/i // Gecko
            ],
            [VERSION, NAME]
        ],
        os: [
            [
                // Windows based
                /microsoft\s(windows)\s(vista|xp)/i // Windows (iTunes)
            ],
            [NAME, VERSION],
            [
                /(windows)\snt\s6\.2;\s(arm)/i,
                /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,
                /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
            ],
            [
                [NAME, UAParser.mapper.str, UAParser.maps.os.windows],
                [VERSION, UAParser.mapper.str, UAParser.maps.os.windows.version]
            ],
            [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],
            [
                [NAME, "Windows"],
                [VERSION, UAParser.mapper.str, UAParser.maps.os.windows.version]
            ],
            [
                // Mobile/Embedded OS
                /\((bb)(10);/i // BlackBerry 10
            ],
            [[NAME, "BlackBerry"], VERSION],
            [
                /(blackberry)\w*\/?([\w\.]*)/i,
                /(tizen|kaios)[\/\s]([\w\.]+)/i,
                /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i
                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki/Sailfish OS
            ],
            [NAME, VERSION],
            [
                /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i // Symbian
            ],
            [[NAME, "Symbian"], VERSION],
            [
                /\((series40);/i // Series 40
            ],
            [NAME],
            [
                /mozilla.+\(mobile;.+gecko.+firefox/i // Firefox OS
            ],
            [[NAME, "Firefox OS"], VERSION],
            [
                // Console
                /(nintendo|playstation)\s([wids34portablevu]+)/i,
                // GNU/Linux based
                /(mint)[\/\s\(]?(\w*)/i,
                /(mageia|vectorlinux)[;\s]/i,
                /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
                /(hurd|linux)\s?([\w\.]*)/i,
                /(gnu)\s?([\w\.]*)/i // GNU
            ],
            [[NAME, "Linux"], VERSION],
            [
                /(cros)\s[\w]+\s([\w\.]+\w)/i // Chromium OS
            ],
            [[NAME, "Chromium OS"], VERSION],
            [
                // Solaris
                /(sunos)\s?([\w\.\d]*)/i // Solaris
            ],
            [[NAME, "Solaris"], VERSION],
            [
                // BSD based
                /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
            ],
            [[NAME, "Linux"], VERSION],
            [
                /(iphone)(?:.*os\s*([\w]*)\slike\smac|;\sopera)/i // iOS
            ],
            [
                [NAME, "iOS"],
                [VERSION, /_/g, "."]
            ],
            [
                /(ipad)(?:.*os\s*([\w]*)\slike\smac|;\sopera)/i // iOS
            ],
            [
                [NAME, "iOS"],
                [VERSION, /_/g, "."]
            ],
            [
                /(haiku)\s(\w+)/i // Haiku
            ],
            [NAME, VERSION],
            [
                /cfnetwork\/.+darwin/i,
                /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i // iOS
            ],
            [
                [VERSION, /_/g, "."],
                [NAME, "iOS"]
            ],
            [
                /(mac\sos\sx)\s?([\w\s\.]*)/i,
                /(macintosh|mac(?=_powerpc)\s)/i // Mac OS
            ],
            [
                [NAME, "Mac"],
                [VERSION, /_/g, "."]
            ],
            [
                // Other
                /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,
                /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,
                /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,
                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
                /(unix)\s?([\w\.]*)/i // UNIX
            ],
            [NAME, VERSION]
        ]
    };
    return UAParser;
}());

var BrowserPropertyGenerator = /** @class */ (function () {
    function BrowserPropertyGenerator() {
    }
    BrowserPropertyGenerator.generate = function (global, page) {
        var _a, _b;
        var win;
        // Server-Side Ignore
        if (typeof global === "undefined") {
            win = {
                navigator: { userAgent: "", vendor: "", languages: [] },
                screen: {
                    width: "",
                    height: ""
                }
            };
        }
        else {
            win = global;
        }
        var result = UAParser.parse(win.navigator.userAgent);
        var browser = result.browser;
        var orientation = "";
        try {
            orientation = (_b = (_a = screen.orientation.type.match(/\b(landscape|portrait)\b/)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : "";
        }
        catch (e) { }
        return __assign({ browserName: browser.name || "", browserMajorVersion: browser.major || "", browserVersion: browser.version || "", orientation: orientation, userAgent: win.navigator.userAgent || "" }, page.toProperties());
    };
    return BrowserPropertyGenerator;
}());

var DevicePropertyGenerator = /** @class */ (function () {
    function DevicePropertyGenerator() {
    }
    DevicePropertyGenerator.generate = function (global) {
        var _a, _b, _c, _d, _e, _f;
        var win;
        // Server-Side Ignore
        if (typeof global === "undefined") {
            win = {
                navigator: { userAgent: "", vendor: "", languages: [] },
                screen: {
                    width: "",
                    height: ""
                }
            };
        }
        else {
            win = global;
        }
        var result = UAParser.parse(win.navigator.userAgent);
        var os = result.os;
        var device = result.device;
        var screen = win.screen;
        var locale = ((_a = win.navigator.languages) === null || _a === void 0 ? void 0 : _a[0]) || "";
        var language = locale.split("-")[0];
        var deviceType = ((_b = device.type) !== null && _b !== void 0 ? _b : "pc").replace(/\b(mobile|smarttv)\b/g, function (match, p1) {
            if (p1 === "mobile")
                return "phone";
            if (p1 === "smarttv")
                return "tv";
            return match;
        });
        var osName = os.name || "";
        var timezone = "";
        try {
            osName = (_d = (_c = osName.match(/\b(Mac|Windows|Linux|Android|iOS)\b/)) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : osName;
            orientation = (_f = (_e = screen.orientation.type.match(/\b(landscape|portrait)\b/)) === null || _e === void 0 ? void 0 : _e[0]) !== null && _f !== void 0 ? _f : "";
            timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
        }
        catch (e) { }
        return {
            osName: osName,
            osVersion: os.version || "",
            deviceModel: device.model || "",
            deviceType: deviceType,
            deviceVendor: device.vendor || "",
            deviceBrand: device.vendor || "",
            screenWidth: screen.width || "",
            screenHeight: screen.height || "",
            locale: locale,
            language: language,
            timeZone: timezone
        };
    };
    return DevicePropertyGenerator;
}());

var HacklePropertyGenerator = /** @class */ (function () {
    function HacklePropertyGenerator() {
    }
    HacklePropertyGenerator.generate = function (global, page) {
        var currentPage = page !== null && page !== void 0 ? page : Page.createWithCurrentPage();
        return __assign(__assign({ platform: "Web" }, BrowserPropertyGenerator.generate(global, currentPage)), DevicePropertyGenerator.generate(global));
    };
    return HacklePropertyGenerator;
}());

var Updated = /** @class */ (function () {
    function Updated(previous, current) {
        this.previous = previous;
        this.current = current;
    }
    Updated.prototype.map = function (transform) {
        return new Updated(transform(this.previous), transform(this.current));
    };
    return Updated;
}());

var UserTargets = /** @class */ (function () {
    function UserTargets(events) {
        this.events = events;
    }
    UserTargets.empty = function () {
        return this.from([]);
    };
    UserTargets.from = function (events) {
        return new UserTargets(events);
    };
    UserTargets.fromDto = function (dto) {
        return this.from(dto.events.map(function (event) { return UserTargetEvent.fromJson(event); }));
    };
    Object.defineProperty(UserTargets.prototype, "rawEvents", {
        get: function () {
            return this.events;
        },
        enumerable: false,
        configurable: true
    });
    return UserTargets;
}());

var UserManagerImpl = /** @class */ (function () {
    function UserManagerImpl(hackleDeviceId, storage, userTargetFetcher, userCohortFetcher, campaignParser, pageManager, clock, previousUser, initUser) {
        this.hackleDeviceId = hackleDeviceId;
        this.storage = storage;
        this.userTargetFetcher = userTargetFetcher;
        this.userCohortFetcher = userCohortFetcher;
        this.campaignParser = campaignParser;
        this.pageManager = pageManager;
        this.clock = clock;
        this.userListeners = [];
        this.defaultUser = { id: this.hackleDeviceId, deviceId: this.hackleDeviceId };
        this.context = this.initContext(previousUser, initUser);
        this.storage.saveUser(this.context.user);
    }
    UserManagerImpl.prototype.initContext = function (previousUser, initUser) {
        var _a;
        var user = (_a = initUser !== null && initUser !== void 0 ? initUser : previousUser) !== null && _a !== void 0 ? _a : this.defaultUser;
        return UserContext.of(decorate(user, this.hackleDeviceId), UserCohorts.empty(), UserTargets.empty());
    };
    UserManagerImpl.prototype.addListener = function (listener) {
        this.userListeners.push(listener);
    };
    Object.defineProperty(UserManagerImpl.prototype, "currentUser", {
        get: function () {
            return this.context.user;
        },
        enumerable: false,
        configurable: true
    });
    // HackleUser resolve
    UserManagerImpl.prototype.resolve = function (user) {
        var context = this.resolveContext(user);
        return this.hackleUser(context);
    };
    UserManagerImpl.prototype.resolveContext = function (user) {
        if (user === undefined) {
            return this.context;
        }
        if (typeof user === "string") {
            return this.updateUser({ id: user }).current;
        }
        return this.updateUser(user).current;
    };
    UserManagerImpl.prototype.toHackleUser = function (user) {
        var context = this.context.with(user);
        return this.hackleUser(context);
    };
    UserManagerImpl.prototype.hackleUser = function (context) {
        var builder = new IdentifiersBuilder()
            .addIdentifiers(context.user.identifiers || {})
            .add(IdentifierType.ID, context.user.id || this.hackleDeviceId)
            .add(IdentifierType.DEVICE, context.user.deviceId || this.hackleDeviceId)
            .add(IdentifierType.HACKLE_DEVICE, this.hackleDeviceId);
        if (ObjectUtil.isNotNullOrUndefined(context.user.userId)) {
            builder.add(IdentifierType.USER, context.user.userId);
        }
        var identifiers = builder.build();
        var campaign = this.campaignParser.parse();
        var userProperties = __assign(__assign({}, campaign), context.user.properties);
        return {
            identifiers: identifiers,
            properties: userProperties,
            hackleProperties: this.hackleProperties(),
            cohorts: context.cohorts.rawCohorts,
            targetEvents: context.targetEvents.rawEvents
        };
    };
    UserManagerImpl.prototype.hackleProperties = function () {
        if (typeof window !== "undefined") {
            return HacklePropertyGenerator.generate(window, this.pageManager.currentPage);
        }
        return {};
    };
    // User update
    UserManagerImpl.prototype.setUser = function (user) {
        return this.updateUser(user).map(function (it) { return it.user; });
    };
    UserManagerImpl.prototype.setUserId = function (userId) {
        var user = __assign(__assign({}, this.context.user), { userId: userId });
        return this.setUser(user);
    };
    UserManagerImpl.prototype.setDeviceId = function (deviceId) {
        var user = __assign(__assign({}, this.context.user), { deviceId: deviceId });
        return this.setUser(user);
    };
    UserManagerImpl.prototype.updateUserProperties = function (operations) {
        return this.operateProperties(operations).map(function (it) { return it.user; });
    };
    UserManagerImpl.prototype.resetUser = function () {
        var _this = this;
        return this.updateContext(function () { return _this.defaultUser; }).map(function (it) { return it.user; });
    };
    UserManagerImpl.prototype.changeUser = function (oldUser, newUser, timestamp) {
        this.userListeners.forEach(function (listener) {
            listener.onUserUpdated(oldUser, newUser, timestamp);
        });
    };
    UserManagerImpl.prototype.saveUser = function (user) {
        this.storage.saveUser(user);
    };
    UserManagerImpl.prototype.updateContext = function (updater) {
        var oldContext = this.context;
        var oldUser = oldContext.user;
        var newUser = updater(oldUser);
        var newContext = this.context.with(newUser);
        this.context = newContext;
        if (!isSameUser(oldUser, newUser)) {
            this.changeUser(oldUser, newUser, this.clock.currentMillis());
            this.saveUser(newUser);
        }
        return new Updated(oldContext, newContext);
    };
    UserManagerImpl.prototype.updateUser = function (user) {
        var _this = this;
        return this.updateContext(function (currentUser) { return mergeUsers(currentUser, decorate(user, _this.hackleDeviceId)); });
    };
    UserManagerImpl.prototype.operateProperties = function (operations) {
        return this.updateContext(function (currentUser) {
            var _a;
            var userProperties = (_a = currentUser.properties) !== null && _a !== void 0 ? _a : {};
            var properties = operations.operate(new Map(Object.entries(userProperties)));
            return __assign(__assign({}, currentUser), { properties: ObjectUtil.fromMap(properties) });
        });
    };
    // Sync
    UserManagerImpl.prototype.sync = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([this.syncCohort(), this.syncUserTarget()])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserManagerImpl.prototype.syncIfNeeded = function (updated) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.hasNewIdentifiers(updated.previous, updated.current)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.syncCohort()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!!isSameUser(updated.previous, updated.current)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.syncUserTarget()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UserManagerImpl.prototype.syncCohort = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cohorts, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.userCohortFetcher.fetch(this.currentUser)];
                    case 1:
                        cohorts = _a.sent();
                        this.context = this.context.update(cohorts, this.context.targetEvents);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        Logger.log.error("Failed to sync cohorts: ".concat(err_1));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    UserManagerImpl.prototype.syncUserTarget = function () {
        return __awaiter(this, void 0, void 0, function () {
            var events, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.userTargetFetcher.fetch(this.currentUser)];
                    case 1:
                        events = _a.sent();
                        this.context = this.context.update(this.context.cohorts, events);
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        Logger.log.error("Failed to sync userTargets: ".concat(err_2));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    UserManagerImpl.prototype.hasNewIdentifiers = function (previous, current) {
        var previousIdentifiers = resolveIdentifiers(previous);
        var currentIdentifiers = resolveIdentifiers(current);
        return Object.entries(currentIdentifiers).some(function (_a) {
            var type = _a[0], value = _a[1];
            return previousIdentifiers[type] !== value;
        });
    };
    UserManagerImpl.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    return UserManagerImpl;
}());
var UserStorage = /** @class */ (function () {
    function UserStorage(storage) {
        this.storage = storage;
    }
    UserStorage.prototype.getUser = function () {
        var deviceId = this.deviceId || undefined;
        var userId = this.userId || undefined;
        if (deviceId !== undefined || userId !== undefined) {
            return { deviceId: deviceId, userId: userId };
        }
        return null;
    };
    UserStorage.prototype.saveUser = function (user) {
        this.setDeviceId(user.deviceId || null);
        this.setUserId(user.userId || null);
    };
    Object.defineProperty(UserStorage.prototype, "deviceId", {
        get: function () {
            return this.storage.getItem(DEVICE_ID_STORAGE_KEY);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserStorage.prototype, "userId", {
        get: function () {
            return this.storage.getItem(USER_ID_STORAGE_KEY);
        },
        enumerable: false,
        configurable: true
    });
    UserStorage.prototype.setDeviceId = function (deviceId) {
        this.setId(DEVICE_ID_STORAGE_KEY, deviceId);
    };
    UserStorage.prototype.setUserId = function (userId) {
        this.setId(USER_ID_STORAGE_KEY, userId);
    };
    UserStorage.prototype.setId = function (key, value) {
        if (ObjectUtil.isNotNullOrUndefined(value)) {
            this.storage.setItem(key, value);
        }
        else {
            this.storage.removeItem(key);
        }
    };
    return UserStorage;
}());
var UserContext = /** @class */ (function () {
    function UserContext(user, cohorts, targetEvents) {
        this.user = user;
        this.cohorts = cohorts;
        this.targetEvents = targetEvents;
    }
    UserContext.of = function (user, cohort, targetEvents) {
        return new UserContext(user, cohort.filterBy(user), targetEvents);
    };
    UserContext.prototype.with = function (user) {
        return UserContext.of(user, this.cohorts.filterBy(user), this.targetEvents);
    };
    UserContext.prototype.update = function (cohorts, targetEvents) {
        var filtered = cohorts.filterBy(this.user);
        var newCohorts = this.cohorts.toBuilder().putAll(filtered).build();
        return UserContext.of(this.user, newCohorts, targetEvents);
    };
    return UserContext;
}());
var decorate = function (user, hackleDeviceId) {
    return __assign(__assign({}, user), { id: user.id || hackleDeviceId, deviceId: user.deviceId || hackleDeviceId });
};

var createSessionId = function (timestamp) { return "".concat(timestamp, ".").concat(v4().slice(0, 8)); };

var SessionManagerImpl = /** @class */ (function () {
    function SessionManagerImpl(sessionTimeoutMillis, storage) {
        this.sessionTimeoutMillis = sessionTimeoutMillis;
        this.storage = storage;
        this.sessionListeners = [];
        this._currentSessionId = null;
        this._lastEventTime = null;
        this.loadSession();
        this.loadLastEventTime();
    }
    Object.defineProperty(SessionManagerImpl.prototype, "currentSessionId", {
        get: function () {
            return this._currentSessionId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SessionManagerImpl.prototype, "sessionId", {
        get: function () {
            var _a;
            return (_a = this._currentSessionId) !== null && _a !== void 0 ? _a : SessionManagerImpl.EMPTY_SESSION_ID;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SessionManagerImpl.prototype, "lastEventTime", {
        get: function () {
            return this._lastEventTime;
        },
        enumerable: false,
        configurable: true
    });
    SessionManagerImpl.prototype.addListener = function (listener) {
        this.sessionListeners.push(listener);
    };
    SessionManagerImpl.prototype.startNewSession = function (previousUser, user, timestamp) {
        if (previousUser) {
            this.endSession(previousUser);
        }
        return this.newSession(user, timestamp);
    };
    SessionManagerImpl.prototype.startNewSessionIfNeeded = function (user, timestamp) {
        var lastEventTime = this._lastEventTime;
        if (lastEventTime === null) {
            return this.startNewSession(user, user, timestamp);
        }
        if (this._currentSessionId !== null && timestamp - lastEventTime < this.sessionTimeoutMillis) {
            this.updateLastEventTime(timestamp);
            return this._currentSessionId;
        }
        return this.startNewSession(user, user, timestamp);
    };
    SessionManagerImpl.prototype.updateLastEventTime = function (timestamp) {
        this._lastEventTime = timestamp;
        this.storage.setItem(LAST_EVENT_TIME_STORAGE_KEY, "".concat(timestamp));
    };
    SessionManagerImpl.prototype.endSession = function (user) {
        var currentSessionId = this._currentSessionId;
        var lastEventTime = this._lastEventTime;
        if (currentSessionId !== null && lastEventTime !== null) {
            this.sessionListeners.forEach(function (listener) { return listener.onSessionEnded(currentSessionId, user, lastEventTime); });
        }
    };
    SessionManagerImpl.prototype.newSession = function (user, timestamp) {
        var newSessionId = createSessionId(timestamp);
        this.saveSession(newSessionId);
        this.updateLastEventTime(timestamp);
        this.sessionListeners.forEach(function (listener) {
            listener.onSessionStarted(newSessionId, user, timestamp);
        });
        return newSessionId;
    };
    SessionManagerImpl.prototype.saveSession = function (sessionId) {
        this._currentSessionId = sessionId;
        this.storage.setItem(SESSION_ID_STORAGE_KEY, sessionId);
    };
    SessionManagerImpl.prototype.loadSession = function () {
        this._currentSessionId = this.storage.getItem(SESSION_ID_STORAGE_KEY);
    };
    SessionManagerImpl.prototype.loadLastEventTime = function () {
        var lastEventTimeStr = this.storage.getItem(LAST_EVENT_TIME_STORAGE_KEY);
        if (lastEventTimeStr !== null) {
            var lastEventTime = Number.parseFloat(lastEventTimeStr);
            if (lastEventTime > 0) {
                this._lastEventTime = lastEventTime;
            }
        }
    };
    SessionManagerImpl.prototype.onUserUpdated = function (oldUser, newUser, timestamp) {
        this.endSession(oldUser);
        this.newSession(newUser, timestamp);
    };
    SessionManagerImpl.prototype.onLifecycleChanged = function (lifecycle, timestamp) {
        switch (lifecycle) {
            case "hidden":
            case "pagehide":
                return this.updateLastEventTime(timestamp);
            case "blur":
            case "focus":
            case "locationChange":
            case "visible":
            case "pageshow":
                return;
        }
    };
    SessionManagerImpl.EMPTY_SESSION_ID = "0.ffffffff";
    return SessionManagerImpl;
}());

var WindowLocalStorage = /** @class */ (function () {
    function WindowLocalStorage() {
        this.storage = window.localStorage;
    }
    WindowLocalStorage.prototype.getItem = function (key) {
        var _a, _b;
        return (_b = (_a = this.storage) === null || _a === void 0 ? void 0 : _a.getItem(key)) !== null && _b !== void 0 ? _b : null;
    };
    WindowLocalStorage.prototype.removeItem = function (key) {
        var _a;
        (_a = this.storage) === null || _a === void 0 ? void 0 : _a.removeItem(key);
    };
    WindowLocalStorage.prototype.setItem = function (key, value) {
        var _a;
        (_a = this.storage) === null || _a === void 0 ? void 0 : _a.setItem(key, value);
    };
    WindowLocalStorage.prototype.clear = function () {
        var _a;
        (_a = this.storage) === null || _a === void 0 ? void 0 : _a.clear();
    };
    return WindowLocalStorage;
}());
var KeyTransformStorage = /** @class */ (function () {
    function KeyTransformStorage(delegate, transform) {
        this.delegate = delegate;
        this.transform = transform;
    }
    KeyTransformStorage.postfix = function (delegate, postfix) {
        return new KeyTransformStorage(delegate, function (key) { return "".concat(key).concat(postfix); });
    };
    KeyTransformStorage.prefix = function (delegate, prefix) {
        return new KeyTransformStorage(delegate, function (key) { return "".concat(prefix).concat(key); });
    };
    KeyTransformStorage.prototype.getItem = function (key) {
        return this.delegate.getItem(this.transform(key));
    };
    KeyTransformStorage.prototype.removeItem = function (key) {
        this.delegate.removeItem(this.transform(key));
    };
    KeyTransformStorage.prototype.setItem = function (key, value) {
        this.delegate.setItem(this.transform(key), value);
    };
    return KeyTransformStorage;
}());
var ListStorage = /** @class */ (function () {
    function ListStorage(delegate, listKey, maxLength) {
        if (maxLength === void 0) { maxLength = 4096; }
        var _this = this;
        this.delegate = delegate;
        this.listKey = listKey;
        this.encodedListCharLen = 6;
        this.resolveMaxLength = function (maxLength) {
            var len = maxLength - _this.encodedListCharLen;
            return len < 0 ? 0 : len;
        };
        this.maxLength = this.resolveMaxLength(maxLength);
    }
    ListStorage.prototype.isEqualItem = function (item, key) {
        return Object.prototype.hasOwnProperty.call(item, key);
    };
    ListStorage.prototype.getRemainListSize = function () {
        try {
            return this.maxLength - JSON.stringify(this.getList()).length;
        }
        catch (error) {
            return 0;
        }
    };
    ListStorage.prototype.isAddableItem = function (item) {
        try {
            return this.getRemainListSize() > JSON.stringify(item).length;
        }
        catch (err) {
            return false;
        }
    };
    ListStorage.prototype.getVictimIndex = function (nextItem) {
        var remainListSize = this.getRemainListSize();
        try {
            var _nextItem_1 = JSON.stringify(nextItem);
            var list = this.getList();
            var cum_1 = 0;
            return list.findIndex(function (item) {
                cum_1 += JSON.stringify(item).length;
                return cum_1 + remainListSize >= _nextItem_1.length;
            });
        }
        catch (error) {
            return -1;
        }
    };
    ListStorage.prototype.getList = function () {
        try {
            var item = this.delegate.getItem(this.listKey);
            if (!item)
                return [];
            var parsedItem = JSON.parse(item);
            if (!Array.isArray(parsedItem))
                return [];
            return parsedItem;
        }
        catch (error) {
            return [];
        }
    };
    ListStorage.prototype.entries = function () {
        return this.getList().flatMap(Object.entries);
    };
    ListStorage.prototype.setItem = function (key, value) {
        var _a;
        try {
            this.removeItem(key);
            var items = this.getList();
            var nextItem = (_a = {}, _a[key] = value, _a);
            if (!this.isAddableItem(nextItem)) {
                var victimIndex = this.getVictimIndex(nextItem);
                if (victimIndex < 0)
                    return;
                items = items.slice(victimIndex + 1);
            }
            var nextItems = JSON.stringify(items.concat(nextItem));
            this.delegate.setItem(this.listKey, nextItems);
        }
        catch (error) { }
    };
    ListStorage.prototype.getItem = function (key) {
        var _this = this;
        var item = this.getList().find(function (item) { return _this.isEqualItem(item, key); });
        if (!item || !item[key])
            return undefined;
        return item[key];
    };
    ListStorage.prototype.removeItem = function (key) {
        var _this = this;
        var items = this.getList();
        try {
            var removedItems = items.filter(function (item) { return !_this.isEqualItem(item, key); });
            var nextItems = JSON.stringify(removedItems);
            this.delegate.setItem(this.listKey, nextItems);
        }
        catch (error) { }
    };
    ListStorage.prototype.clear = function () {
        this.delegate.removeItem(this.listKey);
    };
    return ListStorage;
}());

var HackleUserExplorerImpl = /** @class */ (function () {
    function HackleUserExplorerImpl(core, userManager, abOverrideStorage, ffOverrideStorage) {
        this.core = core;
        this.userManager = userManager;
        this.abOverrideStorage = abOverrideStorage;
        this.ffOverrideStorage = ffOverrideStorage;
    }
    HackleUserExplorerImpl.prototype.currentUser = function () {
        return this.userManager.resolve();
    };
    HackleUserExplorerImpl.prototype.getAbTestDecisions = function () {
        return this.core.experiments(this.currentUser()).entries();
    };
    HackleUserExplorerImpl.prototype.getAbTestOverrides = function () {
        return this.abOverrideStorage.getAll();
    };
    HackleUserExplorerImpl.prototype.setAbTestOverride = function (experiment, variationId) {
        this.abOverrideStorage.set(experiment, variationId);
        this.increment("AB_TEST", "set");
    };
    HackleUserExplorerImpl.prototype.resetAbTestOverride = function (experiment) {
        this.abOverrideStorage.remove(experiment);
        this.increment("AB_TEST", "reset");
    };
    HackleUserExplorerImpl.prototype.resetAllAbTestOverride = function () {
        this.abOverrideStorage.clear();
        this.increment("AB_TEST", "reset.all");
    };
    HackleUserExplorerImpl.prototype.getFeatureFlagDecisions = function () {
        return this.core.featureFlags(this.currentUser()).entries();
    };
    HackleUserExplorerImpl.prototype.getFeatureFlagOverrides = function () {
        return this.ffOverrideStorage.getAll();
    };
    HackleUserExplorerImpl.prototype.setFeatureFlagOverride = function (experiment, variationId) {
        this.ffOverrideStorage.set(experiment, variationId);
        this.increment("FEATURE_FLAG", "set");
    };
    HackleUserExplorerImpl.prototype.resetFeatureFlagOverride = function (experiment) {
        this.ffOverrideStorage.remove(experiment);
        this.increment("FEATURE_FLAG", "reset");
    };
    HackleUserExplorerImpl.prototype.resetAllFeatureFlagOverride = function () {
        this.ffOverrideStorage.clear();
        this.increment("FEATURE_FLAG", "reset.all");
    };
    HackleUserExplorerImpl.prototype.increment = function (experimentType, operation) {
        Metrics.counter("experiment.manual.override", {
            "experiment.type": experimentType,
            operation: operation
        }).increment();
    };
    return HackleUserExplorerImpl;
}());

var Urls = /** @class */ (function () {
    function Urls() {
    }
    Urls.serverFetch = function (sdkUrl, sdkKey) {
        return "".concat(sdkUrl, "/api/v2/workspaces/").concat(sdkKey, "/config");
    };
    Urls.clientFetch = function (sdkUrl, sdkKey) {
        return "".concat(sdkUrl, "/api/v2/workspaces/").concat(sdkKey, "/config");
    };
    Urls.userCohorts = function (sdkUrl) {
        return "".concat(sdkUrl, "/api/v1/cohorts");
    };
    Urls.serverDispatch = function (eventUrl) {
        return "".concat(eventUrl, "/api/v2/events");
    };
    Urls.clientDispatch = function (eventUrl) {
        return "".concat(eventUrl, "/api/v2/w/events");
    };
    Urls.beaconDispatch = function (eventUrl, sdkKey) {
        return "".concat(eventUrl, "/api/v2/w/").concat(sdkKey, "/events");
    };
    Urls.inAppMessageRenderer = function (cdnUrl, version) {
        return "".concat(cdnUrl, "/sdk/iam-renderer/").concat(version, "/iam-renderer.js");
    };
    Urls.monitoring = function (monitoringUrl) {
        return "".concat(monitoringUrl, "/metrics");
    };
    Urls.userTargets = function (sdkUrl) {
        return "".concat(sdkUrl, "/api/v1/user-targets");
    };
    return Urls;
}());

var InAppMessageHiddenLocalStorage = /** @class */ (function () {
    function InAppMessageHiddenLocalStorage(storage) {
        this.storage = storage;
    }
    InAppMessageHiddenLocalStorage.prototype.exist = function (inAppMessage, now) {
        var key = this.key(inAppMessage);
        var value = this.storage.getItem(key);
        if (ObjectUtil.isNullOrUndefined(value)) {
            return false;
        }
        var expireAt = Number.parseInt(value, 10);
        if (Number.isNaN(expireAt)) {
            this.storage.removeItem(key);
            return false;
        }
        if (now <= expireAt) {
            return true;
        }
        else {
            this.storage.removeItem(key);
            return false;
        }
    };
    InAppMessageHiddenLocalStorage.prototype.put = function (inAppMessage, expireAt) {
        this.storage.setItem(this.key(inAppMessage), "".concat(expireAt));
    };
    InAppMessageHiddenLocalStorage.prototype.key = function (inAppMessage) {
        return "".concat(inAppMessage.key);
    };
    return InAppMessageHiddenLocalStorage;
}());

var InAppMessageActionHandlerFactory = /** @class */ (function () {
    function InAppMessageActionHandlerFactory(handlers) {
        this.handlers = handlers;
    }
    InAppMessageActionHandlerFactory.prototype.get = function (action) {
        return this.handlers.find(function (it) { return it.supports(action); });
    };
    return InAppMessageActionHandlerFactory;
}());
var InAppMessageCloseActionHandler = /** @class */ (function () {
    function InAppMessageCloseActionHandler() {
    }
    InAppMessageCloseActionHandler.prototype.handle = function (view, action) {
        view.close();
    };
    InAppMessageCloseActionHandler.prototype.supports = function (action) {
        return action.type === "CLOSE";
    };
    return InAppMessageCloseActionHandler;
}());
var InAppMessageLinkActionHandler = /** @class */ (function () {
    function InAppMessageLinkActionHandler(urlHandler) {
        this.urlHandler = urlHandler;
    }
    InAppMessageLinkActionHandler.prototype.handle = function (view, action) {
        try {
            if (!action.value)
                return;
            this.urlHandler.open(new URL(action.value));
        }
        catch (e) {
            Logger.log.error("Invalid url: ".concat(action.value));
        }
    };
    InAppMessageLinkActionHandler.prototype.supports = function (action) {
        return action.type === "WEB_LINK";
    };
    return InAppMessageLinkActionHandler;
}());
var InAppMessageLinkAndCloseActionHandler = /** @class */ (function () {
    function InAppMessageLinkAndCloseActionHandler(urlHandler) {
        this.urlHandler = urlHandler;
    }
    InAppMessageLinkAndCloseActionHandler.prototype.handle = function (view, action) {
        view.close();
        try {
            if (!action.value)
                return;
            this.urlHandler.open(new URL(action.value));
        }
        catch (e) {
            Logger.log.error("Invalid url: ".concat(action.value));
        }
    };
    InAppMessageLinkAndCloseActionHandler.prototype.supports = function (action) {
        return action.type === "LINK_AND_CLOSE";
    };
    return InAppMessageLinkAndCloseActionHandler;
}());
var InAppMessageHiddenActionHandler = /** @class */ (function () {
    function InAppMessageHiddenActionHandler(storage, clock) {
        this.storage = storage;
        this.clock = clock;
    }
    InAppMessageHiddenActionHandler.prototype.handle = function (view, action) {
        if (view.context.decisionReason === DecisionReason.OVERRIDDEN) {
            view.close();
            return;
        }
        var expireAt = this.clock.currentMillis() + IAM_HIDE_EXPIRATION_MILLIS;
        this.storage.put(view.context.inAppMessage, expireAt);
        view.close();
    };
    InAppMessageHiddenActionHandler.prototype.supports = function (action) {
        return action.type === "HIDDEN";
    };
    return InAppMessageHiddenActionHandler;
}());
var InAppMessageLinkNewWindowActionHandler = /** @class */ (function () {
    function InAppMessageLinkNewWindowActionHandler(urlHandler) {
        this.urlHandler = urlHandler;
    }
    InAppMessageLinkNewWindowActionHandler.prototype.handle = function (view, action) {
        try {
            if (!action.value)
                return;
            this.urlHandler.open(new URL(action.value));
        }
        catch (e) {
            Logger.log.error("Invalid url: ".concat(action.value));
        }
    };
    InAppMessageLinkNewWindowActionHandler.prototype.supports = function (action) {
        return action.type === "LINK_NEW_WINDOW";
    };
    return InAppMessageLinkNewWindowActionHandler;
}());
var InAppMessageLinkNewWindowAndCloseActionHandler = /** @class */ (function () {
    function InAppMessageLinkNewWindowAndCloseActionHandler(urlHandler) {
        this.urlHandler = urlHandler;
    }
    InAppMessageLinkNewWindowAndCloseActionHandler.prototype.handle = function (view, action) {
        view.close();
        try {
            if (!action.value)
                return;
            this.urlHandler.open(new URL(action.value));
        }
        catch (e) {
            Logger.log.error("Invalid url: ".concat(action.value));
        }
    };
    InAppMessageLinkNewWindowAndCloseActionHandler.prototype.supports = function (action) {
        return action.type === "LINK_NEW_WINDOW_AND_CLOSE";
    };
    return InAppMessageLinkNewWindowAndCloseActionHandler;
}());
var InAppMessageLinkNewTabActionHandler = /** @class */ (function () {
    function InAppMessageLinkNewTabActionHandler(urlHandler) {
        this.urlHandler = urlHandler;
    }
    InAppMessageLinkNewTabActionHandler.prototype.handle = function (view, action) {
        try {
            if (!action.value)
                return;
            this.urlHandler.open(new URL(action.value));
        }
        catch (e) {
            Logger.log.error("Invalid url: ".concat(action.value));
        }
    };
    InAppMessageLinkNewTabActionHandler.prototype.supports = function (action) {
        return action.type === "LINK_NEW_TAB";
    };
    return InAppMessageLinkNewTabActionHandler;
}());
var InAppMessageLinkNewTabAndCloseActionHandler = /** @class */ (function () {
    function InAppMessageLinkNewTabAndCloseActionHandler(urlHandler) {
        this.urlHandler = urlHandler;
    }
    InAppMessageLinkNewTabAndCloseActionHandler.prototype.handle = function (view, action) {
        view.close();
        try {
            if (!action.value)
                return;
            this.urlHandler.open(new URL(action.value));
        }
        catch (e) {
            Logger.log.error("Invalid url: ".concat(action.value));
        }
    };
    InAppMessageLinkNewTabAndCloseActionHandler.prototype.supports = function (action) {
        return action.type === "LINK_NEW_TAB_AND_CLOSE";
    };
    return InAppMessageLinkNewTabAndCloseActionHandler;
}());

var InAppMessageEventTracker = /** @class */ (function () {
    function InAppMessageEventTracker(core) {
        this.core = core;
    }
    InAppMessageEventTracker.prototype.track = function (context, event, timestamp) {
        var hackleEvent = this.createTrackEvent(event, context);
        this.core.track(hackleEvent, context.user, timestamp);
    };
    InAppMessageEventTracker.prototype.commonProperties = function (context) {
        return __assign(__assign({}, context.properties), { in_app_message_id: context.inAppMessage.id, in_app_message_key: context.inAppMessage.key, in_app_message_display_type: context.message.layout.displayType, decision_reason: String(context.decisionReason) });
    };
    InAppMessageEventTracker.prototype.createTrackEvent = function (event, context) {
        var _a, _b, _c, _d;
        switch (event.type) {
            case "IMPRESSION":
                return {
                    key: "$in_app_impression",
                    properties: __assign(__assign({}, this.commonProperties(context)), { title_text: (_b = (_a = context.message.text) === null || _a === void 0 ? void 0 : _a.title) === null || _b === void 0 ? void 0 : _b.text, body_text: (_d = (_c = context.message.text) === null || _c === void 0 ? void 0 : _c.body) === null || _d === void 0 ? void 0 : _d.text, button_text: context.message.buttons.map(function (it) { return it.text; }), image_url: context.message.images.map(function (it) { return it.imagePath; }) })
                };
            case "CLOSE":
                return {
                    key: "$in_app_close",
                    properties: this.commonProperties(context)
                };
            case "ACTION":
                var actionEvent = event;
                return {
                    key: "$in_app_action",
                    properties: __assign(__assign({}, this.commonProperties(context)), { action_type: actionEvent.action.type, action_area: actionEvent.area, action_value: actionEvent.action.value, button_text: actionEvent.buttonText, image_url: actionEvent.imageUrl, image_order: actionEvent.imageOrder })
                };
            case "IMAGE_IMPRESSION":
                var imageImpressionEvent = event;
                return {
                    key: "$in_app_image_impression",
                    properties: __assign(__assign({}, this.commonProperties(context)), { image_url: imageImpressionEvent.imageUrl, image_order: imageImpressionEvent.imageOrder })
                };
        }
    };
    return InAppMessageEventTracker;
}());

var InAppMessageUi = /** @class */ (function () {
    function InAppMessageUi(messageViewFactory, eventHandler, interactionHandlerFactory, inAppMessageListener) {
        if (inAppMessageListener === void 0) { inAppMessageListener = null; }
        this.messageViewFactory = messageViewFactory;
        this.eventHandler = eventHandler;
        this.interactionHandlerFactory = interactionHandlerFactory;
        this.inAppMessageListener = inAppMessageListener;
        this.currentMessageView = null;
        this.opening = false;
    }
    InAppMessageUi.prototype.setListener = function (listener) {
        this.inAppMessageListener = listener;
    };
    InAppMessageUi.prototype.present = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var messageView;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.currentMessageView)
                            return [2 /*return*/];
                        if (this.opening)
                            return [2 /*return*/];
                        this.opening = true;
                        messageView = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        messageView = this.messageViewFactory.create(context, this);
                        if (messageView === null)
                            return [2 /*return*/];
                        this.currentMessageView = messageView;
                        return [4 /*yield*/, messageView.open()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        _a.sent();
                        messageView === null || messageView === void 0 ? void 0 : messageView.close();
                        return [3 /*break*/, 5];
                    case 4:
                        this.opening = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return InAppMessageUi;
}());

var isInAppMessageLifecycleEvent = function (e) {
    return typeof e.detail.id === "string" && ["OPEN", "CLOSE"].includes(e.detail.type);
};

var ScriptInAppMessageView = /** @class */ (function () {
    function ScriptInAppMessageView(scriptLoader, context, ui, renderTypeResolver, status, lifecycleRegistry) {
        var _this = this;
        this.scriptLoader = scriptLoader;
        this.context = context;
        this.ui = ui;
        this.renderTypeResolver = renderTypeResolver;
        this.status = status;
        this.lifecycleRegistry = lifecycleRegistry;
        this.container = null;
        this.renderer = null;
        this.resolveLifecycleEnd = function (e) {
            if (!(e instanceof CustomEvent) || !isInAppMessageLifecycleEvent(e))
                return;
            var _a = e.detail, id = _a.id, type = _a.type;
            var handler = _this.lifecycleRegistry.getAndRemove(type, id);
            handler === null || handler === void 0 ? void 0 : handler();
        };
        this.handleInAppMessageInteraction = function (e) {
            if (e instanceof CustomEvent && e.type === ScriptInAppMessageView.HACKLE_IAM_INTERACTION_EVENT_TYPE) {
                var interaction = e.detail;
                _this.handleInteraction(interaction);
            }
        };
    }
    ScriptInAppMessageView.prototype.open = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var inAppMessage, container, script, renderType;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.status.canOpen()) {
                            Logger.log.debug("InAppMessage is already opened. (key=".concat(this.context.inAppMessage.key, ")"));
                            return [2 /*return*/];
                        }
                        inAppMessage = InAppMessageConverter.toPublic(this.context.inAppMessage);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        (_b = (_a = this.ui.inAppMessageListener) === null || _a === void 0 ? void 0 : _a.beforeInAppMessageOpen) === null || _b === void 0 ? void 0 : _b.call(_a, inAppMessage);
                        this.status.current = "OPENING";
                        // add in-app message interaction listener
                        window.addEventListener(ScriptInAppMessageView.HACKLE_IAM_INTERACTION_EVENT_TYPE, this.handleInAppMessageInteraction);
                        window.addEventListener(ScriptInAppMessageView.HACKLE_IAM_LIFECYCLE_END_EVENT_TYPE, this.resolveLifecycleEnd);
                        // load script
                        return [4 /*yield*/, this.scriptLoader.load()
                            // add view container
                        ];
                    case 2:
                        // load script
                        _c.sent();
                        container = this.addContainer();
                        container.style.display = "none";
                        container.classList.add("".concat(ScriptInAppMessageView.CONTAINER_CLASS_NAME, "--loading"));
                        script = window.HackleInAppMessageRenderer;
                        this.renderer = new script.HackleInAppMessageRenderer(container);
                        renderType = this.renderTypeResolver.resolve(this.context);
                        // render
                        return [4 /*yield*/, this.renderer.render({
                                messageId: this.context.inAppMessage.id,
                                message: this.context.message.toJson(),
                                renderType: renderType
                            })];
                    case 3:
                        // render
                        _c.sent();
                        container.classList.remove("".concat(ScriptInAppMessageView.CONTAINER_CLASS_NAME, "--loading"));
                        container.style.display = "block";
                        this.handleInAppMessageLifecycle("OPEN", function () {
                            var _a, _b;
                            _this.handleEvent({ type: "IMPRESSION" });
                            _this.status.current = "OPENED";
                            (_b = (_a = _this.ui.inAppMessageListener) === null || _a === void 0 ? void 0 : _a.afterInAppMessageOpen) === null || _b === void 0 ? void 0 : _b.call(_a, inAppMessage);
                        }, function () {
                            Logger.log.warn("Failed to open inAppMessage with [Timeout expired.]");
                            _this.destroy();
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        _c.sent();
                        this.destroy();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ScriptInAppMessageView.prototype.close = function () {
        var _this = this;
        var _a, _b;
        // if view already closed, do nothing
        if (!this.status.canClose()) {
            Logger.log.debug("InAppMessage is already closed. (key=".concat(this.context.inAppMessage.key, ")"));
            return;
        }
        var inAppMessage = InAppMessageConverter.toPublic(this.context.inAppMessage);
        (_b = (_a = this.ui.inAppMessageListener) === null || _a === void 0 ? void 0 : _a.beforeInAppMessageClose) === null || _b === void 0 ? void 0 : _b.call(_a, inAppMessage);
        this.status.current = "CLOSING";
        this.handleInAppMessageLifecycle("CLOSE", function () {
            var _a, _b;
            _this.handleEvent({ type: "CLOSE" });
            _this.destroy();
            (_b = (_a = _this.ui.inAppMessageListener) === null || _a === void 0 ? void 0 : _a.afterInAppMessageClose) === null || _b === void 0 ? void 0 : _b.call(_a, inAppMessage);
        }, function () {
            var _a, _b;
            Logger.log.warn("Failed to close inAppMessage with [Timeout expired.]");
            _this.destroy();
            (_b = (_a = _this.ui.inAppMessageListener) === null || _a === void 0 ? void 0 : _a.afterInAppMessageClose) === null || _b === void 0 ? void 0 : _b.call(_a, inAppMessage);
        });
    };
    ScriptInAppMessageView.prototype.handleInAppMessageLifecycle = function (type, onSuccess, onError) {
        var _this = this;
        var id = this.lifecycleRegistry.register(type, onSuccess);
        window.dispatchEvent(new CustomEvent(ScriptInAppMessageView.HACKLE_IAM_LIFECYCLE_START_EVENT_TYPE, {
            detail: { type: type, id: id }
        }));
        setTimeout(function () {
            var handler = _this.lifecycleRegistry.getAndRemove(type, id);
            var alreadyHandled = handler === undefined;
            if (alreadyHandled)
                return;
            onError();
        }, ScriptInAppMessageView.LIFE_CYCLE_EVENT_LISTEN_TIMEOUT);
    };
    ScriptInAppMessageView.prototype.destroy = function () {
        var _a;
        window.removeEventListener(ScriptInAppMessageView.HACKLE_IAM_INTERACTION_EVENT_TYPE, this.handleInAppMessageInteraction);
        window.removeEventListener(ScriptInAppMessageView.HACKLE_IAM_LIFECYCLE_END_EVENT_TYPE, this.resolveLifecycleEnd);
        (_a = this.renderer) === null || _a === void 0 ? void 0 : _a.destroy();
        this.renderer = null;
        this.removeContainer();
        this.ui.currentMessageView = null;
        this.status.current = "CLOSED";
    };
    ScriptInAppMessageView.prototype.addContainer = function () {
        if (!this.container) {
            var container = document.createElement("div");
            container.classList.add(ScriptInAppMessageView.CONTAINER_CLASS_NAME);
            this.container = container;
        }
        if (!this.container.parentNode) {
            document.body.appendChild(this.container);
        }
        return this.container;
    };
    ScriptInAppMessageView.prototype.removeContainer = function () {
        var _a;
        if (this.container) {
            (_a = this.container.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(this.container);
            this.container = null;
        }
    };
    ScriptInAppMessageView.prototype.handleInteraction = function (interaction) {
        var interactionHandler = this.ui.interactionHandlerFactory.get(interaction);
        if (!interactionHandler)
            return;
        interactionHandler.handle(this, interaction);
    };
    ScriptInAppMessageView.prototype.handleEvent = function (event) {
        this.ui.eventHandler.handle(this, event);
    };
    ScriptInAppMessageView.HACKLE_IAM_INTERACTION_EVENT_TYPE = "hackle-iam-interaction";
    ScriptInAppMessageView.HACKLE_IAM_LIFECYCLE_START_EVENT_TYPE = "hackle-iam-lifecycle-start";
    ScriptInAppMessageView.HACKLE_IAM_LIFECYCLE_END_EVENT_TYPE = "hackle-iam-lifecycle-end";
    ScriptInAppMessageView.CONTAINER_CLASS_NAME = "hackle-iam";
    ScriptInAppMessageView.LIFE_CYCLE_EVENT_LISTEN_TIMEOUT = 5000;
    return ScriptInAppMessageView;
}());

var InAppMessageRenderTypeResolver = /** @class */ (function () {
    function InAppMessageRenderTypeResolver() {
        this.mobileOSRegex = /(iOS|Android|iPad|iPhone)/g;
        this.mobileDeviceRegex = /(mobile|phone|tablet)/g;
    }
    InAppMessageRenderTypeResolver.prototype.isMobileOS = function (context) {
        var hackleProperties = context.user.hackleProperties;
        var osName = hackleProperties.osName;
        return typeof osName === "string" && Boolean(osName.match(this.mobileOSRegex));
    };
    InAppMessageRenderTypeResolver.prototype.isMobileDeviceType = function (context) {
        var hackleProperties = context.user.hackleProperties;
        var deviceType = hackleProperties.deviceType;
        return typeof deviceType === "string" && Boolean(deviceType.match(this.mobileDeviceRegex));
    };
    InAppMessageRenderTypeResolver.prototype.resolve = function (context) {
        if (this.isMobileOS(context) || this.isMobileDeviceType(context))
            return "mobile";
        return "pc";
    };
    return InAppMessageRenderTypeResolver;
}());

var InAppMessageViewStatus = /** @class */ (function () {
    function InAppMessageViewStatus(current) {
        if (current === void 0) { current = "CLOSED"; }
        this.current = current;
    }
    InAppMessageViewStatus.prototype.canOpen = function () {
        return this.current !== "OPENED" && this.current !== "OPENING";
    };
    InAppMessageViewStatus.prototype.canClose = function () {
        return this.current !== "CLOSED" && this.current !== "CLOSING";
    };
    return InAppMessageViewStatus;
}());

var HackleInAppMessageLifecycleRegistry = /** @class */ (function () {
    function HackleInAppMessageLifecycleRegistry() {
        this.record = {};
    }
    HackleInAppMessageLifecycleRegistry.prototype.resolveKey = function (type, id) {
        return "".concat(type, "_").concat(id);
    };
    HackleInAppMessageLifecycleRegistry.prototype.register = function (type, handler) {
        var id = v4();
        var key = this.resolveKey(type, id);
        this.record[key] = handler;
        return id;
    };
    HackleInAppMessageLifecycleRegistry.prototype.getAndRemove = function (type, id) {
        var key = this.resolveKey(type, id);
        var _a = this.record, _b = key, handler = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        this.record = rest;
        return handler;
    };
    return HackleInAppMessageLifecycleRegistry;
}());

var InAppMessageViewFactory = /** @class */ (function () {
    function InAppMessageViewFactory(scriptLoader) {
        this.scriptLoader = scriptLoader;
    }
    InAppMessageViewFactory.create = function (scriptLoader) {
        return new InAppMessageViewFactory(scriptLoader);
    };
    InAppMessageViewFactory.prototype.create = function (context, ui) {
        var renderTypeResolver = new InAppMessageRenderTypeResolver();
        var viewStatus = new InAppMessageViewStatus();
        var lifecycleRegistry = new HackleInAppMessageLifecycleRegistry();
        switch (context.message.layout.displayType) {
            case "MODAL":
            case "BANNER":
            case "BOTTOM_SHEET":
                return new ScriptInAppMessageView(this.scriptLoader, context, ui, renderTypeResolver, viewStatus, lifecycleRegistry);
            case "NONE":
                return null;
        }
    };
    return InAppMessageViewFactory;
}());

var InAppMessageRenderScriptLoader = /** @class */ (function () {
    function InAppMessageRenderScriptLoader(scriptUrl) {
        this.scriptUrl = scriptUrl;
    }
    InAppMessageRenderScriptLoader.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var script;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (window.HackleInAppMessageRenderer) {
                            return [2 /*return*/];
                        }
                        script = this.createScript();
                        document.head.appendChild(script);
                        return [4 /*yield*/, this.waitForLoad(script)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    InAppMessageRenderScriptLoader.prototype.createScript = function () {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = this.scriptUrl;
        return script;
    };
    InAppMessageRenderScriptLoader.prototype.waitForLoad = function (el) {
        return new Promise(function (resolve, reject) {
            var handleLoad = function () {
                cleanup();
                resolve(el);
            };
            var handleError = function (ev) {
                cleanup();
                reject(ev.message);
            };
            var cleanup = function () {
                el.removeEventListener("error", handleError);
                el.removeEventListener("load", handleLoad);
            };
            el.addEventListener("load", handleLoad);
            el.addEventListener("error", handleError);
        });
    };
    return InAppMessageRenderScriptLoader;
}());

var InAppMessageEventTriggerRuleMatcher = /** @class */ (function () {
    function InAppMessageEventTriggerRuleMatcher(targetMatcher) {
        this.targetMatcher = targetMatcher;
    }
    InAppMessageEventTriggerRuleMatcher.prototype.matches = function (workspace, inAppMessage, event) {
        var _this = this;
        return inAppMessage.eventTrigger.rules.some(function (it) { return _this.ruleMatches(workspace, event, inAppMessage, it); });
    };
    InAppMessageEventTriggerRuleMatcher.prototype.ruleMatches = function (workspace, event, inAppMessage, rule) {
        if (event.event.key !== rule.eventKey) {
            return false;
        }
        var request = EvaluatorRequest.of(workspace, event, inAppMessage);
        return this.targetMatcher.anyMatches(request, EvaluatorContext.create(), rule.targets);
    };
    return InAppMessageEventTriggerRuleMatcher;
}());
var EvaluatorRequest = /** @class */ (function () {
    function EvaluatorRequest(key, workspace, user, event) {
        this.key = key;
        this.workspace = workspace;
        this.user = user;
        this.event = event;
    }
    EvaluatorRequest.of = function (workspace, event, inAppMessage) {
        return new EvaluatorRequest(new EvaluatorKey("IN_APP_MESSAGE", inAppMessage.id), workspace, event.user, event);
    };
    return EvaluatorRequest;
}());

var InAppMessageImpressionLocalStorage = /** @class */ (function () {
    function InAppMessageImpressionLocalStorage(storage) {
        this.storage = storage;
    }
    InAppMessageImpressionLocalStorage.prototype.get = function (inAppMessage) {
        var impressions = this.storage.getItem(inAppMessage.id.toString());
        if (ObjectUtil.isNullOrUndefined(impressions))
            return [];
        return JSON.parse(impressions);
    };
    InAppMessageImpressionLocalStorage.prototype.set = function (inAppMessage, impressions) {
        this.storage.setItem(inAppMessage.id.toString(), JSON.stringify(impressions));
    };
    return InAppMessageImpressionLocalStorage;
}());

var InAppMessageEventProcessorFactory = /** @class */ (function () {
    function InAppMessageEventProcessorFactory(processors) {
        this.processors = processors;
    }
    InAppMessageEventProcessorFactory.prototype.get = function (event) {
        return this.processors.find(function (it) { return it.supports(event); });
    };
    return InAppMessageEventProcessorFactory;
}());
var InAppMessageImpressionEventProcessor = /** @class */ (function () {
    function InAppMessageImpressionEventProcessor() {
    }
    InAppMessageImpressionEventProcessor.prototype.process = function (view, event, timestamp) {
        // Do nothing
    };
    InAppMessageImpressionEventProcessor.prototype.supports = function (event) {
        return event.type === "IMPRESSION";
    };
    return InAppMessageImpressionEventProcessor;
}());
var InAppMessageCloseEventProcessor = /** @class */ (function () {
    function InAppMessageCloseEventProcessor() {
    }
    InAppMessageCloseEventProcessor.prototype.process = function (view, event, timestamp) {
        // Do nothing. This method is called after the view is closed.
    };
    InAppMessageCloseEventProcessor.prototype.supports = function (event) {
        return event.type === "CLOSE";
    };
    return InAppMessageCloseEventProcessor;
}());
var InAppMessageActionEventProcessor = /** @class */ (function () {
    function InAppMessageActionEventProcessor(actionHandlerFactory) {
        this.actionHandlerFactory = actionHandlerFactory;
    }
    InAppMessageActionEventProcessor.prototype.process = function (view, event, timestamp) {
        var _a, _b;
        var handler = this.actionHandlerFactory.get(event.action);
        var processed = (_b = (_a = view.ui.inAppMessageListener) === null || _a === void 0 ? void 0 : _a.onInAppMessageClick) === null || _b === void 0 ? void 0 : _b.call(_a, InAppMessageConverter.toPublic(view.context.inAppMessage), InAppMessageViewConverter.toPublic(view), HackleInAppMessageActionImpl.fromAction(event.action));
        if (processed || !view.status.canClose())
            return;
        handler === null || handler === void 0 ? void 0 : handler.handle(view, event.action);
    };
    InAppMessageActionEventProcessor.prototype.supports = function (event) {
        return event.type === "ACTION";
    };
    return InAppMessageActionEventProcessor;
}());

var InAppMessageEventHandler = /** @class */ (function () {
    function InAppMessageEventHandler(clock, eventTracker, eventProcessorFactory) {
        this.clock = clock;
        this.eventTracker = eventTracker;
        this.eventProcessorFactory = eventProcessorFactory;
    }
    InAppMessageEventHandler.prototype.handle = function (view, event) {
        var timestamp = this.clock.currentMillis();
        this.eventTracker.track(view.context, event, timestamp);
        var processor = this.eventProcessorFactory.get(event);
        if (!processor)
            return;
        processor.process(view, event, timestamp);
    };
    return InAppMessageEventHandler;
}());

var InAppMessageEventMatcher = /** @class */ (function () {
    function InAppMessageEventMatcher(ruleMatcher) {
        this.ruleMatcher = ruleMatcher;
    }
    InAppMessageEventMatcher.prototype.matches = function (workspace, inAppMessage, event) {
        return this.ruleMatcher.matches(workspace, inAppMessage, event);
    };
    return InAppMessageEventMatcher;
}());

var InAppMessageInteractionHandlerFactory = /** @class */ (function () {
    function InAppMessageInteractionHandlerFactory(handlers) {
        this.handlers = handlers;
    }
    InAppMessageInteractionHandlerFactory.prototype.get = function (interaction) {
        return this.handlers.find(function (it) { return it.supports(interaction); });
    };
    return InAppMessageInteractionHandlerFactory;
}());
var InAppMessageCloseInteractionHandler = /** @class */ (function () {
    function InAppMessageCloseInteractionHandler() {
    }
    InAppMessageCloseInteractionHandler.prototype.handle = function (view, interaction) {
        view.close();
    };
    InAppMessageCloseInteractionHandler.prototype.supports = function (interaction) {
        return interaction.type === "CLOSE";
    };
    return InAppMessageCloseInteractionHandler;
}());
var InAppMessageActionInteractionHandler = /** @class */ (function () {
    function InAppMessageActionInteractionHandler(eventHandler) {
        this.eventHandler = eventHandler;
    }
    InAppMessageActionInteractionHandler.prototype.handle = function (view, interaction) {
        var event = this.eventOrNull(interaction);
        if (!event)
            return;
        this.eventHandler.handle(view, event);
    };
    InAppMessageActionInteractionHandler.prototype.eventOrNull = function (interaction) {
        var action = InAppMessageAction.fromJson(interaction.action);
        if (!action)
            return null;
        return {
            type: "ACTION",
            action: action,
            area: interaction.area,
            buttonText: interaction.buttonText,
            imageUrl: interaction.imageUrl,
            imageOrder: interaction.imageOrder
        };
    };
    InAppMessageActionInteractionHandler.prototype.supports = function (interaction) {
        return interaction.type === "ACTION";
    };
    return InAppMessageActionInteractionHandler;
}());
var InAppMessageImageImpressionInteractionHandler = /** @class */ (function () {
    function InAppMessageImageImpressionInteractionHandler(eventHandler) {
        this.eventHandler = eventHandler;
    }
    InAppMessageImageImpressionInteractionHandler.prototype.handle = function (view, interaction) {
        var event = {
            type: "IMAGE_IMPRESSION",
            imageUrl: interaction.imageUrl,
            imageOrder: interaction.imageOrder
        };
        this.eventHandler.handle(view, event);
    };
    InAppMessageImageImpressionInteractionHandler.prototype.supports = function (interaction) {
        return interaction.type === "IMAGE_IMPRESSION";
    };
    return InAppMessageImageImpressionInteractionHandler;
}());

var UrlLinkHandler = /** @class */ (function () {
    function UrlLinkHandler() {
    }
    UrlLinkHandler.prototype.open = function (url) {
        window.location.href = url.href;
    };
    return UrlLinkHandler;
}());
var UrlLinkNewWindowHandler = /** @class */ (function () {
    function UrlLinkNewWindowHandler() {
    }
    UrlLinkNewWindowHandler.prototype.open = function (url) {
        window.open(url.href, "Hackle", "resizable:true");
    };
    return UrlLinkNewWindowHandler;
}());
var UrlLinkNewTabHandler = /** @class */ (function () {
    function UrlLinkNewTabHandler() {
    }
    UrlLinkNewTabHandler.prototype.open = function (url) {
        window.open(url.href);
    };
    return UrlLinkNewTabHandler;
}());
var UrlReplaceHandler = /** @class */ (function () {
    function UrlReplaceHandler() {
    }
    UrlReplaceHandler.prototype.open = function (url) {
        window.location.replace(url);
    };
    return UrlReplaceHandler;
}());

var EMPTY_CAMPAIGN = {
    utm_campaign: undefined,
    utm_content: undefined,
    utm_id: undefined,
    utm_medium: undefined,
    utm_source: undefined,
    utm_term: undefined,
    gclid: undefined,
    fbclid: undefined
};
var EMPTY_DOMAIN = {
    current: undefined,
    referrer: undefined
};
var isEmptyCampaign = function (campaign) {
    return isSameCampaign(campaign, EMPTY_CAMPAIGN);
};
var isSameCampaign = function (a, b) {
    return Object.keys(EMPTY_CAMPAIGN).every(function (key) { return a[key] === b[key]; });
};
var isNewCampaign = function (previousCampaign, newCampaign, domain) {
    if (previousCampaign === null) {
        return true;
    }
    if (isEmptyCampaign(newCampaign) && domain.current === domain.referrer) {
        return false;
    }
    return !isSameCampaign(previousCampaign, newCampaign);
};
var setCampaignToUrl = function (campaign, url) {
    for (var _i = 0, _a = Object.entries(campaign); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (Strings.isNotEmptyString(value)) {
            url.searchParams.set(key, value);
        }
    }
    return url;
};

var CampaignManager = /** @class */ (function () {
    function CampaignManager(storage, parser, core, userManager) {
        this.storage = storage;
        this.parser = parser;
        this.core = core;
        this.userManager = userManager;
    }
    CampaignManager.prototype.startNewCampaign = function (user, campaign, timestamp) {
        var campaignProperties = __assign(__assign({}, EMPTY_CAMPAIGN), campaign);
        var builder = new PropertyOperationsBuilder();
        for (var _i = 0, _a = Object.entries(campaignProperties); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (value) {
                builder.set(key, value);
            }
            else {
                builder.unset(key);
            }
        }
        var operations = builder.build();
        var event = operations.toEvent();
        var hackleUser = this.userManager.toHackleUser(user);
        this.core.track(event, hackleUser, timestamp);
        this.userManager.updateUserProperties(operations);
    };
    CampaignManager.prototype.startNewCampaignIfNeeded = function (user, timestamp) {
        var previousCampaign = this.storage.get();
        var newCampaign = this.parser.parse();
        var domain = this.parser.parseDomain();
        if (isNewCampaign(previousCampaign, newCampaign, domain)) {
            this.storage.set(newCampaign);
            this.startNewCampaign(user, newCampaign, timestamp);
        }
    };
    CampaignManager.prototype.onSessionEnded = function (sessionId, user, timestamp) { };
    CampaignManager.prototype.onSessionStarted = function (sessionId, user, timestamp) {
        this.startNewCampaignIfNeeded(user, timestamp);
    };
    return CampaignManager;
}());

var CampaignStorage = /** @class */ (function () {
    function CampaignStorage(storage) {
        this.storage = storage;
    }
    CampaignStorage.prototype.get = function () {
        var value = this.storage.getItem(MARKETING_STORAGE_KEY);
        if (!value)
            return null;
        return JSON.parse(value);
    };
    CampaignStorage.prototype.set = function (campaign) {
        this.storage.setItem(MARKETING_STORAGE_KEY, JSON.stringify(campaign));
    };
    return CampaignStorage;
}());

var LocationSearchParser = /** @class */ (function () {
    function LocationSearchParser(search) {
        this.search = search;
    }
    LocationSearchParser.prototype.getQueryParam = function (name) {
        var params = this.getQueryParams(function () { return true; });
        return params[name] || "";
    };
    LocationSearchParser.prototype.getQueryParams = function (condition) {
        var params = {};
        var queries = this.search.substring(1).split("&");
        for (var _i = 0, queries_1 = queries; _i < queries_1.length; _i++) {
            var query = queries_1[_i];
            var _a = query.split("="), key = _a[0], value = _a[1];
            if (!condition || condition(key, value)) {
                var decodedValue = UrlUtil.tryDecodeURIComponent(value);
                if (decodedValue) {
                    params[key] = decodedValue;
                }
            }
        }
        return params;
    };
    return LocationSearchParser;
}());

var DomainUtil = /** @class */ (function () {
    function DomainUtil() {
    }
    DomainUtil.extractDomain = function (hostname) {
        var domain_regex = this.DOMAIN_MATCH_REGEX;
        var parts = hostname.split(".");
        var tld = parts[parts.length - 1];
        if (tld.length > 4 || tld === "com" || tld === "org") {
            domain_regex = this.SIMPLE_DOMAIN_MATCH_REGEX;
        }
        var matches = hostname.match(domain_regex);
        return matches ? matches[0] : hostname;
    };
    DomainUtil.DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
    DomainUtil.SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
    return DomainUtil;
}());

var CampaignParser = /** @class */ (function () {
    function CampaignParser(pageManager) {
        this.pageManager = pageManager;
    }
    CampaignParser.prototype.parse = function (search) {
        var params = this.params(search);
        return this.resolve(params);
    };
    CampaignParser.prototype.params = function (search) {
        var _search = ObjectUtil.isNotNullOrUndefined(search) ? search : this.pageManager.currentPage.queryParameter;
        return new LocationSearchParser(_search).getQueryParams(CampaignParser.CAMPAIGN_QUERY_CONDITION);
    };
    CampaignParser.prototype.resolve = function (params) {
        return {
            utm_campaign: params[UTM_CAMPAIGN],
            utm_content: params[UTM_CONTENT],
            utm_id: params[UTM_ID],
            utm_medium: params[UTM_MEDIUM],
            utm_source: params[UTM_SOURCE],
            utm_term: params[UTM_TERM],
            gclid: params[GCLID],
            fbclid: params[FBCLID]
        };
    };
    CampaignParser.prototype.parseDomain = function () {
        var _this = this;
        if (typeof window === "undefined") {
            return EMPTY_DOMAIN;
        }
        var referrerDomain = function () {
            var referrer = _this.pageManager.currentPage.referrer;
            if (!referrer)
                return undefined;
            var referrerHostname = new URL(referrer).hostname;
            return DomainUtil.extractDomain(referrerHostname);
        };
        return {
            current: DomainUtil.extractDomain(this.pageManager.currentPage.hostname),
            referrer: referrerDomain()
        };
    };
    // Campaign value must not be an empty string
    CampaignParser.CAMPAIGN_QUERY_CONDITION = function (key, value) {
        return Strings.isNotEmptyString(value);
    };
    return CampaignParser;
}());
var UTM_CAMPAIGN = "utm_campaign";
var UTM_CONTENT = "utm_content";
var UTM_ID = "utm_id";
var UTM_MEDIUM = "utm_medium";
var UTM_SOURCE = "utm_source";
var UTM_TERM = "utm_term";
var GCLID = "gclid";
var FBCLID = "fbclid";

var GoogleAnalyticsManager = /** @class */ (function () {
    function GoogleAnalyticsManager(userEventEmitter, determiner) {
        var _this = this;
        this.userEventEmitter = userEventEmitter;
        this.determiner = determiner;
        this.onEvent = function (event) {
            var exposure = _this.determiner.determineTargetExposureOrNull(event);
            if (!exposure)
                return;
            _this.send(exposure);
        };
        this.initialize();
    }
    GoogleAnalyticsManager.prototype.initialize = function () {
        this.userEventEmitter.on("event", this.onEvent);
    };
    GoogleAnalyticsManager.prototype.send = function (exposure) {
        var experimentKey = exposure.experiment.key;
        var variationKey = exposure.variationKey;
        var exp_variant_string = "HACKLE-EXPERIMENT_".concat(experimentKey, "_V").concat(exposure.experiment.version, "-").concat(variationKey);
        try {
            // @ts-ignore
            window.gtag("event", "experience_impression", {
                exp_variant_string: exp_variant_string
            });
        }
        catch (e) {
            Logger.log.error("Unexpected exception while sending an event to Google Analytics with gtag: ".concat(e));
        }
    };
    return GoogleAnalyticsManager;
}());

var GoogleAnalyticsDeterminer = /** @class */ (function () {
    function GoogleAnalyticsDeterminer(workspaceFetcher) {
        this.workspaceFetcher = workspaceFetcher;
    }
    GoogleAnalyticsDeterminer.prototype.determineTargetExposureOrNull = function (event) {
        var workspace = this.workspaceFetcher.get();
        if (!workspace)
            return null;
        var attributes = workspace.getAttributes();
        if (!attributes.integration_ga_experiment)
            return null;
        if (!UserEvent.isExposureEvent(event))
            return null;
        if (event.experiment.status !== "RUNNING")
            return null;
        if (event.decisionReason !== DecisionReason.TRAFFIC_ALLOCATED)
            return null;
        return event;
    };
    return GoogleAnalyticsDeterminer;
}());

var DEFAULT_CONFIG$1 = {
    user: undefined,
    debug: false,
    log_disabled: false,
    automaticPageTracking: true,
    pollingIntervalMillis: NO_POLLING,
    exposureEventDedupIntervalMillis: DEFAULT_DEDUP_INTERVAL_MILLIS,
    sessionTimeoutMillis: DEFAULT_SESSION_TIMEOUT_MILLIS,
    autoOpenDevTool: false,
    sdkUrl: DEFAULT_SDK_URL,
    eventUrl: DEFAULT_EVENT_URL,
    monitoringUrl: DEFAULT_MONITORING_URL,
    cdnUrl: DEFAULT_CDN_URL,
    sameSiteCookie: "LAX",
    secureCookie: false,
    SDK_NAME_HEADER: "javascript-sdk_browser",
    SDK_VERSION_HEADER: SDK_VERSION,
    IAM_RENDERER_VERSION_HEADER: IAM_RENDERER_VERSION
};
var Configurations = /** @class */ (function () {
    function Configurations() {
    }
    Configurations.config = function (config) {
        return __assign(__assign(__assign({}, DEFAULT_CONFIG$1), config), { automaticPageTracking: Configurations.resolveAutomaticPageTracking(config) });
    };
    Configurations.resolveAutomaticPageTracking = function (config) {
        if (typeof (config === null || config === void 0 ? void 0 : config.automaticPageTracking) !== "boolean" && typeof (config === null || config === void 0 ? void 0 : config.auto_track_page_view) !== "boolean") {
            return DEFAULT_CONFIG$1.automaticPageTracking;
        }
        return !!config.automaticPageTracking || !!config.auto_track_page_view;
    };
    Configurations.logging = function (config) {
        Logger.initCounter(function (level) { return Metrics.counter("log", { level: level }); });
        Logger.setLogLevel(logLevels.INFO);
        if (config.log_disabled) {
            Logger.setLogLevel(logLevels.DISABLE);
        }
        else {
            if (config.debug) {
                Logger.setLogLevel(logLevels.DEBUG);
            }
        }
    };
    Configurations.sdk = function (sdkKey, config) {
        Logger.log.debug("SDK key: ".concat(sdkKey));
        if (!sdkKey) {
            Logger.log.error("invalid sdk key: '".concat(sdkKey, "' (expected: not null, not undefined and not empty string)"));
        }
        return {
            key: sdkKey,
            name: config.SDK_NAME_HEADER,
            version: config.SDK_VERSION_HEADER
        };
    };
    Configurations.isBeaconSupported = function () {
        var useBeacon = false;
        if (typeof window !== "undefined") {
            useBeacon = window && window.navigator && !!window.navigator.sendBeacon && true;
            if (useBeacon) {
                Logger.log.debug("support sendBeacon API");
            }
        }
        return useBeacon;
    };
    Configurations.pollingIntervalMillis = function (config) {
        if (config.pollingIntervalMillis === undefined) {
            return NO_POLLING;
        }
        // noinspection SuspiciousTypeOfGuard
        if (typeof config.pollingIntervalMillis !== "number") {
            return NO_POLLING;
        }
        if (config.pollingIntervalMillis <= 0) {
            return NO_POLLING;
        }
        return Math.max(config.pollingIntervalMillis, BROWSER_MIN_POOL_INTERVAL);
    };
    Configurations.dedupIntervalMillis = function (config) {
        if (config.exposureEventDedupIntervalMillis === undefined) {
            return DEFAULT_DEDUP_INTERVAL_MILLIS;
        }
        // noinspection SuspiciousTypeOfGuard
        if (typeof config.exposureEventDedupIntervalMillis !== "number") {
            return DEFAULT_DEDUP_INTERVAL_MILLIS;
        }
        if (config.exposureEventDedupIntervalMillis < 1000 || config.exposureEventDedupIntervalMillis > 1000 * 60 * 60) {
            Logger.log.warn("Exposure event dedup interval is outside allowed range[1_000ms..3_600_000ms]. Setting to default value[1m].");
            return DEFAULT_DEDUP_INTERVAL_MILLIS;
        }
        return config.exposureEventDedupIntervalMillis;
    };
    return Configurations;
}());

var CompositeSynchronizer = /** @class */ (function () {
    function CompositeSynchronizer() {
        this.synchronizers = [];
    }
    CompositeSynchronizer.prototype.add = function (synchronizer) {
        this.synchronizers.push(synchronizer);
    };
    CompositeSynchronizer.prototype.sync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(this.synchronizers.map(function (it) { return _this.safe(it.sync()); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CompositeSynchronizer.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(this.synchronizers.map(function (it) { return _this.safe(it.close()); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CompositeSynchronizer.prototype.safe = function (promise) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, promise];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        Logger.log.error("Failed to sync: ".concat(e_1));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return CompositeSynchronizer;
}());

var PollingSynchronizer = /** @class */ (function () {
    function PollingSynchronizer(delegate, scheduler, intervalMillis) {
        this.delegate = delegate;
        this.scheduler = scheduler;
        this.intervalMillis = intervalMillis;
        this.pollingJob = null;
    }
    PollingSynchronizer.prototype.sync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.delegate.sync()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        Logger.log.error("Failed to sync: ".concat(e_1));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PollingSynchronizer.prototype.start = function () {
        var _this = this;
        if (this.intervalMillis === NO_POLLING) {
            return;
        }
        if (this.pollingJob !== null) {
            return;
        }
        this.pollingJob = this.scheduler.schedulePeriodically(this.intervalMillis, this.intervalMillis, function () { return _this.sync(); });
    };
    PollingSynchronizer.prototype.stop = function () {
        var _a;
        if (this.intervalMillis === NO_POLLING) {
            return;
        }
        (_a = this.pollingJob) === null || _a === void 0 ? void 0 : _a.cancel();
        this.pollingJob = null;
    };
    PollingSynchronizer.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.stop();
                        return [4 /*yield*/, this.delegate.close()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return PollingSynchronizer;
}());

var TimerScheduler = /** @class */ (function () {
    function TimerScheduler(scheduleType) {
        this.scheduleType = scheduleType;
    }
    TimerScheduler.prototype.schedule = function (delayMillis, task) {
        var job = new TimeoutScheduledJob(delayMillis, task);
        job.start();
        return job;
    };
    TimerScheduler.prototype.schedulePeriodically = function (delayMillis, intervalMillis, task) {
        var job;
        switch (this.scheduleType) {
            case "setTimeout":
                job = new TimeoutPeriodicScheduledJob(delayMillis, intervalMillis, task);
                break;
            case "setInterval":
                job = new IntervalPeriodicScheduledJob(delayMillis, intervalMillis, task);
                break;
        }
        job.start();
        return job;
    };
    return TimerScheduler;
}());
var TimeoutScheduledJob = /** @class */ (function () {
    function TimeoutScheduledJob(delayMillis, task) {
        this.delayMillis = delayMillis;
        this.task = task;
        this.timeout = null;
    }
    TimeoutScheduledJob.prototype.start = function () {
        var _this = this;
        this.timeout = setTimeout(function () {
            try {
                _this.task();
            }
            catch (e) {
                Logger.log.error("Failed to run task: ".concat(e));
            }
            finally {
                _this.timeout = null;
            }
        }, this.delayMillis);
    };
    TimeoutScheduledJob.prototype.cancel = function () {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    };
    return TimeoutScheduledJob;
}());
var TimeoutPeriodicScheduledJob = /** @class */ (function () {
    function TimeoutPeriodicScheduledJob(delayMillis, intervalMillis, task) {
        this.delayMillis = delayMillis;
        this.intervalMillis = intervalMillis;
        this.task = task;
        this.timeout = null;
    }
    TimeoutPeriodicScheduledJob.prototype.start = function () {
        var _this = this;
        this.timeout = setTimeout(function () { return _this.run(); }, this.delayMillis);
    };
    TimeoutPeriodicScheduledJob.prototype.run = function () {
        var _this = this;
        try {
            this.task();
        }
        catch (e) {
            Logger.log.error("Failed to run task: ".concat(e));
        }
        this.timeout = setTimeout(function () { return _this.run(); }, this.intervalMillis);
    };
    TimeoutPeriodicScheduledJob.prototype.cancel = function () {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    };
    return TimeoutPeriodicScheduledJob;
}());
var IntervalPeriodicScheduledJob = /** @class */ (function () {
    function IntervalPeriodicScheduledJob(delayMillis, intervalMillis, task) {
        this.delayMillis = delayMillis;
        this.intervalMillis = intervalMillis;
        this.task = task;
        this.timeout = null;
        this.interval = null;
    }
    IntervalPeriodicScheduledJob.prototype.start = function () {
        var _this = this;
        this.timeout = setTimeout(function () {
            _this.run();
            _this.interval = setInterval(function () { return _this.run(); }, _this.intervalMillis);
        }, this.delayMillis);
    };
    IntervalPeriodicScheduledJob.prototype.run = function () {
        try {
            this.task();
        }
        catch (e) {
            Logger.log.error("Failed to run task: ".concat(e));
        }
    };
    IntervalPeriodicScheduledJob.prototype.cancel = function () {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    };
    return IntervalPeriodicScheduledJob;
}());

var HttpWorkspaceFetcher = /** @class */ (function () {
    function HttpWorkspaceFetcher(url, transport) {
        this.url = url;
        this.transport = transport;
    }
    HttpWorkspaceFetcher.prototype.fetchIfModified = function (lastModified) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.createRequest(lastModified);
                        return [4 /*yield*/, this.execute(request)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(response)];
                }
            });
        });
    };
    HttpWorkspaceFetcher.prototype.createRequest = function (lastModified) {
        var builder = TransportRequest.builder().url(this.url).method("GET");
        if (lastModified !== null) {
            builder.addHeader(TransportHeaders.IF_MODIFIED_SINCE, lastModified);
        }
        return builder.build();
    };
    HttpWorkspaceFetcher.prototype.execute = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var sample, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sample = TimerSample.start();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.transport.send(request)];
                    case 2:
                        response = _a.sent();
                        ApiCallMetrics.record("get.workspace", sample, response);
                        return [2 /*return*/, response];
                    case 3:
                        e_1 = _a.sent();
                        ApiCallMetrics.record("get.workspace", sample, null);
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HttpWorkspaceFetcher.prototype.handleResponse = function (response) {
        if (response.isNotModified()) {
            return null;
        }
        if (!response.isSuccessful()) {
            throw new Error("Http status code: ".concat(response.statusCode));
        }
        if (response.body === null) {
            throw new Error("Response body is empty");
        }
        var dto = JSON.parse(response.body);
        var lastModified = response.headers.get(TransportHeaders.LAST_MODIFIED);
        return { config: dto, lastModified: lastModified };
    };
    return HttpWorkspaceFetcher;
}());

var DefaultUserCohortFetcher = /** @class */ (function () {
    function DefaultUserCohortFetcher(url, transport) {
        this.url = url;
        this.transport = transport;
    }
    DefaultUserCohortFetcher.prototype.fetch = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.createRequest(user);
                        return [4 /*yield*/, this.execute(request)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(response)];
                }
            });
        });
    };
    DefaultUserCohortFetcher.prototype.createRequest = function (user) {
        var identifiers = { identifiers: resolveIdentifiers(user) };
        var body = Base64.encodeURL(JSON.stringify(identifiers));
        return TransportRequest.builder().url(this.url).method("GET").addHeader("X-HACKLE-USER", body).build();
    };
    DefaultUserCohortFetcher.prototype.execute = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var sample, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sample = TimerSample.start();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.transport.send(request)];
                    case 2:
                        response = _a.sent();
                        ApiCallMetrics.record("get.cohorts", sample, response);
                        return [2 /*return*/, response];
                    case 3:
                        e_1 = _a.sent();
                        ApiCallMetrics.record("get.cohorts", sample, null);
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DefaultUserCohortFetcher.prototype.handleResponse = function (response) {
        if (!response.isSuccessful()) {
            throw new Error("Http status code: ".concat(response.statusCode));
        }
        if (response.body === null) {
            throw new Error("Response body is null");
        }
        var dto = JSON.parse(response.body);
        return UserCohorts.fromDto(dto);
    };
    return DefaultUserCohortFetcher;
}());

var DefaultUserTargetFetcher = /** @class */ (function () {
    function DefaultUserTargetFetcher(url, transport) {
        this.url = url;
        this.transport = transport;
    }
    DefaultUserTargetFetcher.prototype.fetch = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.createRequest(user);
                        return [4 /*yield*/, this.execute(request)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(response)];
                }
            });
        });
    };
    DefaultUserTargetFetcher.prototype.createRequest = function (user) {
        var identifiers = { identifiers: resolveIdentifiers(user) };
        var body = Base64.encodeURL(JSON.stringify(identifiers));
        return TransportRequest.builder().url(this.url).method("GET").addHeader("X-HACKLE-USER", body).build();
    };
    DefaultUserTargetFetcher.prototype.execute = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var sample, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sample = TimerSample.start();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.transport.send(request)];
                    case 2:
                        response = _a.sent();
                        ApiCallMetrics.record("get.user-targets", sample, response);
                        return [2 /*return*/, response];
                    case 3:
                        e_1 = _a.sent();
                        ApiCallMetrics.record("get.user-targets", sample, null);
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DefaultUserTargetFetcher.prototype.handleResponse = function (response) {
        if (!response.isSuccessful()) {
            throw new Error("Http status code: ".concat(response.statusCode));
        }
        if (response.body === null) {
            throw new Error("Response body is null");
        }
        var dto = JSON.parse(response.body);
        return UserTargets.fromDto(dto);
    };
    return DefaultUserTargetFetcher;
}());

var Workspace = /** @class */ (function () {
    function Workspace(experiments, splitUrlExperiments, featureFlags, buckets, eventTypes, segments, containers, parameterConfigurations, remoteConfigParameters, inAppMessages, attributes) {
        this.experiments = CollectionUtil.associateBy(experiments, function (it) { return it.key; });
        this.splitUrlExperiments = CollectionUtil.associateBy(splitUrlExperiments, function (it) { return it.key; });
        this.featureFlags = CollectionUtil.associateBy(featureFlags, function (it) { return it.key; });
        this.buckets = CollectionUtil.associateBy(buckets, function (it) { return it.id; });
        this.eventTypes = CollectionUtil.associateBy(eventTypes, function (it) { return it.key; });
        this.segments = CollectionUtil.associateBy(segments, function (it) { return it.key; });
        this.containers = CollectionUtil.associateBy(containers, function (it) { return it.id; });
        this.parameterConfigurations = CollectionUtil.associateBy(parameterConfigurations, function (it) { return it.id; });
        this.remoteConfigParameters = CollectionUtil.associateBy(remoteConfigParameters, function (it) { return it.key; });
        this.inAppMessages = CollectionUtil.associateBy(inAppMessages, function (it) { return it.key; });
        this.attributes = attributes;
    }
    Workspace.prototype.getExperiments = function () {
        return Array.from(this.experiments.values());
    };
    Workspace.prototype.getSplitUrlExperiments = function () {
        return Array.from(this.splitUrlExperiments.values());
    };
    Workspace.prototype.getFeatureFlags = function () {
        return Array.from(this.featureFlags.values());
    };
    Workspace.prototype.getInAppMessages = function () {
        return Array.from(this.inAppMessages.values());
    };
    Workspace.prototype.getExperimentOrNull = function (experimentKey) {
        return this.experiments.get(experimentKey);
    };
    Workspace.prototype.getFeatureFlagOrNull = function (featureKey) {
        return this.featureFlags.get(featureKey);
    };
    Workspace.prototype.getBucketOrNull = function (bucketId) {
        return this.buckets.get(bucketId);
    };
    Workspace.prototype.getEventTypeOrNull = function (eventKey) {
        return this.eventTypes.get(eventKey);
    };
    Workspace.prototype.getSegmentOrNull = function (segmentKey) {
        return this.segments.get(segmentKey);
    };
    Workspace.prototype.getContainerOrNull = function (containerId) {
        return this.containers.get(containerId);
    };
    Workspace.prototype.getParameterConfigurationOrNull = function (parameterConfigurationId) {
        return this.parameterConfigurations.get(parameterConfigurationId);
    };
    Workspace.prototype.getRemoteConfigParameterOrNull = function (remoteConfigParameterKey) {
        return this.remoteConfigParameters.get(remoteConfigParameterKey);
    };
    Workspace.prototype.getInAppMessageOrNull = function (messageKey) {
        return this.inAppMessages.get(messageKey);
    };
    Workspace.prototype.getAttributes = function () {
        return this.attributes;
    };
    Workspace.from = function (dto) {
        var parameterConfigurations = dto.parameterConfigurations.map(ParameterConfiguration.fromJson);
        var experiments = CollectionUtil.mapNotNullOrUndefined(dto.experiments, function (it) {
            return Experiment.fromJson("AB_TEST", it, parameterConfigurations);
        });
        var splitUrlExperiments = CollectionUtil.mapNotNullOrUndefined(dto.experiments, function (it) {
            return Experiment.fromJson("AB_TEST", it, parameterConfigurations);
        }).filter(function (experiment) { return experiment.implementationType === "SPLIT_URL"; });
        var featureFlags = CollectionUtil.mapNotNullOrUndefined(dto.featureFlags, function (it) {
            return Experiment.fromJson("FEATURE_FLAG", it, parameterConfigurations);
        });
        var buckets = dto.buckets.map(Bucket.fromJson);
        var eventTypes = dto.events.map(EventType.fromJson);
        var segments = CollectionUtil.mapNotNullOrUndefined(dto.segments, Segment.fromJson);
        var containers = dto.containers.map(Container.fromJson);
        var remoteConfigParameters = CollectionUtil.mapNotNullOrUndefined(dto.remoteConfigParameters, RemoteConfigParameter.fromJson);
        var inAppMessages = CollectionUtil.mapNotNullOrUndefined(dto.inAppMessages, InAppMessage.fromJson);
        var attributes = dto.workspace.attributes;
        return new Workspace(experiments, splitUrlExperiments, featureFlags, buckets, eventTypes, segments, containers, parameterConfigurations, remoteConfigParameters, inAppMessages, attributes);
    };
    return Workspace;
}());

var WorkspaceManager = /** @class */ (function () {
    function WorkspaceManager(workspaceConfigStorage, workspaceFetcher) {
        this.workspaceConfigStorage = workspaceConfigStorage;
        this.workspaceFetcher = workspaceFetcher;
        this.workspace = null;
        this.lastModified = null;
        var config = this.workspaceConfigStorage.get();
        if (config) {
            this.setConfig(config);
        }
    }
    WorkspaceManager.prototype.setConfig = function (config) {
        this.setWorkspace(config);
        this.lastModified = config.lastModified;
    };
    WorkspaceManager.prototype.setWorkspace = function (config) {
        try {
            this.workspace = Workspace.from(config.config);
        }
        catch (e) {
            Logger.log.error("Failed to set workspace: ".concat(e));
        }
    };
    WorkspaceManager.prototype.get = function () {
        return this.workspace;
    };
    WorkspaceManager.prototype.sync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var config, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.workspaceFetcher.fetchIfModified(this.lastModified)];
                    case 1:
                        config = _a.sent();
                        if (config) {
                            this.setConfig(config);
                            this.workspaceConfigStorage.set(config);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        Logger.log.error("Failed to sync workspace: ".concat(e_1));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WorkspaceManager.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    return WorkspaceManager;
}());

var BrowserEventDispatcher = /** @class */ (function () {
    function BrowserEventDispatcher(transport, synchronousTransport, // maybe beacon
    retryManager) {
        this.transport = transport;
        this.synchronousTransport = synchronousTransport;
        this.retryManager = retryManager;
    }
    BrowserEventDispatcher.prototype.dispatch = function (events, sync) {
        var dto = events.map(function (it) { return it.toDto(); });
        if (sync) {
            return this.dispatchEventsSynchronously(dto);
        }
        return this.dispatchEvents(dto);
    };
    BrowserEventDispatcher.prototype.dispatchEventsSynchronously = function (events) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // add to retry manager first in case of fast close
                    return [4 /*yield*/, this.retryManager.add(events)];
                    case 1:
                        // add to retry manager first in case of fast close
                        _a.sent();
                        return [4 /*yield*/, this.synchronousTransport.send(events)];
                    case 2:
                        response = _a.sent();
                        if (!(response.isSuccessful() || response.isClientError())) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.retryManager.delete(events)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BrowserEventDispatcher.prototype.dispatchEvents = function (events) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.transport.send(events)];
                    case 1:
                        response = _a.sent();
                        if (response.isSuccessful() || response.isClientError()) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.retryManager.add(events)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return BrowserEventDispatcher;
}());

function toPayload(events) {
    var exposures = new Array();
    var tracks = new Array();
    var remoteConfigs = new Array();
    events.forEach(function (event) {
        if (event instanceof UserEvent) {
            if (UserEvent.isExposureEvent(event)) {
                exposures.push(event.toDto());
            }
            else if (UserEvent.isTrackEvent(event)) {
                tracks.push(event.toDto());
            }
            else if (UserEvent.isRemoteConfigEvent(event)) {
                remoteConfigs.push(event.toDto());
            }
        }
        else {
            if (UserEvent.isExposureEventDto(event)) {
                exposures.push(event);
            }
            else if (UserEvent.isTrackEventDto(event)) {
                tracks.push(event);
            }
            else if (UserEvent.isRemoteConfigEventDto(event)) {
                remoteConfigs.push(event);
            }
        }
    });
    return {
        exposureEvents: exposures,
        trackEvents: tracks,
        remoteConfigEvents: remoteConfigs
    };
}

var EventTransport = /** @class */ (function () {
    function EventTransport(url, transport) {
        this.url = url;
        this.transport = transport;
    }
    EventTransport.prototype.send = function (events) {
        var request = this.createRequest(events);
        return this.execute(request);
    };
    EventTransport.prototype.createRequest = function (events) {
        var payload = toPayload(events);
        return TransportRequest.builder()
            .url(this.url)
            .method("POST")
            .addHeader("Content-Type", "application/json")
            .body(JSON.stringify(payload))
            .build();
    };
    EventTransport.prototype.execute = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var sample, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sample = TimerSample.start();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.transport.send(request)];
                    case 2:
                        response = _a.sent();
                        ApiCallMetrics.record("post.events", sample, response);
                        return [2 /*return*/, response];
                    case 3:
                        e_1 = _a.sent();
                        ApiCallMetrics.record("post.events", sample, null);
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return EventTransport;
}());

var BrowserEventRetryManager = /** @class */ (function () {
    function BrowserEventRetryManager(repository, transport) {
        this.repository = repository;
        this.transport = transport;
    }
    BrowserEventRetryManager.prototype.add = function (events) {
        return this.repository.add(events);
    };
    BrowserEventRetryManager.prototype.delete = function (events) {
        return this.repository.delete(events);
    };
    BrowserEventRetryManager.prototype.flush = function () {
        return __awaiter(this, void 0, void 0, function () {
            var events, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.repository.read()];
                    case 1:
                        events = _a.sent();
                        if (events.length === 0) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.transport.send(events)];
                    case 2:
                        response = _a.sent();
                        if (!(response.isSuccessful() || response.isClientError())) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.delete(events)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BrowserEventRetryManager.prototype.onLifecycleChanged = function (lifecycle, _) {
        switch (lifecycle) {
            case "visible":
            case "pageshow":
                this.flush().catch(function (e) { return Logger.log.warn("Failed to flush retry events: ".concat(e)); });
                return;
            case "blur":
            case "focus":
            case "hidden":
            case "locationChange":
            case "pagehide":
                return;
        }
    };
    return BrowserEventRetryManager;
}());

var Emitter = /** @class */ (function () {
    function Emitter() {
        this.listeners = {};
    }
    Emitter.prototype.on = function (eventName, fn) {
        this.listeners[eventName] = (this.listeners[eventName] || []).concat(fn);
    };
    Emitter.prototype.off = function (eventName, fn) {
        this.listeners[eventName] = (this.listeners[eventName] || []).filter(function (f) { return f !== fn; });
    };
    Emitter.prototype.emit = function (eventName, params) {
        (this.listeners[eventName] || []).forEach(function (fn) {
            fn(params);
        });
    };
    return Emitter;
}());

var UserEventEmitter = /** @class */ (function (_super) {
    __extends(UserEventEmitter, _super);
    function UserEventEmitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UserEventEmitter;
}(Emitter));

var DefaultEventProcessor = /** @class */ (function (_super) {
    __extends(DefaultEventProcessor, _super);
    function DefaultEventProcessor(eventDispatcher, eventDispatchMaxSize, flushScheduler, flushIntervalMillis) {
        var _this = _super.call(this) || this;
        _this.eventDispatcher = eventDispatcher;
        _this.eventDispatchMaxSize = eventDispatchMaxSize;
        _this.flushScheduler = flushScheduler;
        _this.flushIntervalMillis = flushIntervalMillis;
        _this.queue = [];
        _this.flushingJob = null;
        return _this;
    }
    DefaultEventProcessor.prototype.process = function (event) {
        this.enqueue(event);
        this.emit("event", event);
    };
    DefaultEventProcessor.prototype.enqueue = function (event) {
        if (this.queue.length === 0) {
            this.scheduleFlush();
        }
        this.queue.push(event);
        if (this.queue.length >= this.eventDispatchMaxSize) {
            this.flush();
        }
    };
    DefaultEventProcessor.prototype.scheduleFlush = function () {
        var _this = this;
        var _a;
        (_a = this.flushingJob) === null || _a === void 0 ? void 0 : _a.cancel();
        this.flushingJob = this.flushScheduler.schedule(this.flushIntervalMillis, function () { return _this.flush(); });
    };
    DefaultEventProcessor.prototype.flush = function (sync) {
        var _a;
        if (sync === void 0) { sync = false; }
        (_a = this.flushingJob) === null || _a === void 0 ? void 0 : _a.cancel();
        if (this.queue.length === 0) {
            return;
        }
        this.eventDispatcher.dispatch(this.queue, sync).catch(function (e) { return Logger.log.warn("Failed to dispatch events: ".concat(e)); });
        this.queue = [];
    };
    DefaultEventProcessor.prototype.close = function () {
        this.flush(true);
    };
    return DefaultEventProcessor;
}(UserEventEmitter));

var SdkHeaderInterceptor = /** @class */ (function () {
    function SdkHeaderInterceptor(sdk, clock, delegate) {
        this.sdk = sdk;
        this.clock = clock;
        this.delegate = delegate;
    }
    SdkHeaderInterceptor.prototype.send = function (request) {
        var newRequest = request
            .toBuilder()
            .addHeader(SDK_KEY_HEADER, this.sdk.key)
            .addHeader(SDK_NAME_HEADER, this.sdk.name)
            .addHeader(SDK_VERSION_HEADER, this.sdk.version)
            .addHeader(SDK_TIME_HEADER, this.clock.currentMillis().toString())
            .build();
        return this.delegate.send(newRequest);
    };
    return SdkHeaderInterceptor;
}());

var Transports = /** @class */ (function () {
    function Transports() {
    }
    Transports.intercept = function (sdk, transport) {
        if (transport instanceof SdkHeaderInterceptor) {
            return transport;
        }
        return new SdkHeaderInterceptor(sdk, SystemClock.instance, transport);
    };
    return Transports;
}());

var XhrTransport = /** @class */ (function () {
    function XhrTransport() {
    }
    XhrTransport.create = function () {
        return new XhrTransport();
    };
    XhrTransport.prototype.send = function (request) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            if (request.options.timeoutMillis) {
                xhr.timeout = request.options.timeoutMillis;
            }
            xhr.open(request.method, request.url);
            xhr.onreadystatechange = function () {
                if (xhr.readyState !== xhr.DONE) {
                    return;
                }
                if (xhr.status === 0) {
                    reject(new Error("Request Error"));
                    return;
                }
                var response = handleResponse(xhr);
                resolve(response);
            };
            setRequestHeaders(xhr, request);
            xhr.send(request.body);
        });
    };
    return XhrTransport;
}());
function setRequestHeaders(xhr, request) {
    var headers = request.headers.raw();
    for (var name_1 in headers) {
        if (headers.hasOwnProperty(name_1)) {
            xhr.setRequestHeader(name_1, headers[name_1]);
        }
    }
}
function handleResponse(xhr) {
    return new TransportResponse(xhr.status, xhr.responseText, responseHeaderFromXhr(xhr));
}
function responseHeaderFromXhr(xhr) {
    var builder = TransportHeaders.builder();
    var responseHeaders = xhr.getAllResponseHeaders();
    if (!responseHeaders) {
        return builder.build();
    }
    for (var _i = 0, _a = responseHeaders.split("\r\n"); _i < _a.length; _i++) {
        var header = _a[_i];
        var index = header.indexOf(": ");
        if (index > 0) {
            var name_2 = header.slice(0, index);
            var value = header.slice(index + 2);
            builder.add(name_2, value);
        }
    }
    return builder.build();
}

var BeaconTransport = /** @class */ (function () {
    function BeaconTransport() {
    }
    BeaconTransport.create = function () {
        return new BeaconTransport();
    };
    BeaconTransport.prototype.send = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var beaconSupport = false;
            if (typeof window !== "undefined") {
                beaconSupport = window && window.navigator && !!window.navigator.sendBeacon && true;
            }
            if (!beaconSupport) {
                throw new Error("BeaconTransport not supported.");
            }
            var body = _this.createBody(request);
            var success = window.navigator.sendBeacon(request.url, body);
            if (!success) {
                throw Error("Failed to sendBeacon");
            }
            resolve(TransportResponse.ok());
        });
    };
    BeaconTransport.prototype.createBody = function (request) {
        var params = new URLSearchParams();
        var sdkKey = request.headers.get(SDK_KEY_HEADER);
        if (sdkKey) {
            params.append("sdkKey", sdkKey);
        }
        params.append("sdkName", request.headers.getOrDefault(SDK_NAME_HEADER, "unknown"));
        params.append("sdkVersion", request.headers.getOrDefault(SDK_VERSION_HEADER, "unknown"));
        var sdkTime = request.headers.get(SDK_TIME_HEADER);
        if (sdkTime) {
            params.append("sdkTime", sdkTime);
        }
        if (request.body) {
            params.append("data", request.body);
        }
        return params;
    };
    return BeaconTransport;
}());

var PromptAppInvocator = /** @class */ (function () {
    function PromptAppInvocator(invocationResponseResolver) {
        this.invocationResponseResolver = invocationResponseResolver;
    }
    PromptAppInvocator.prototype.invoke = function (invocationRequestDto) {
        var result = window.prompt(JSON.stringify(invocationRequestDto));
        return this.invocationResponseResolver.resolve(result);
    };
    return PromptAppInvocator;
}());
var FunctionAppInvocator = /** @class */ (function () {
    function FunctionAppInvocator(invocationResponseResolver) {
        this.invocationResponseResolver = invocationResponseResolver;
    }
    FunctionAppInvocator.prototype.invoke = function (invocationRequestDto) {
        var _a;
        if (!((_a = window._hackleApp) === null || _a === void 0 ? void 0 : _a.invoke)) {
            throw new Error("window._hackleApp.invoke is not implemented");
        }
        var result = window._hackleApp.invoke(JSON.stringify(invocationRequestDto));
        return this.invocationResponseResolver.resolve(result);
    };
    return FunctionAppInvocator;
}());

var InvocationType;
(function (InvocationType) {
    InvocationType["prompt"] = "prompt";
    InvocationType["function"] = "function";
})(InvocationType || (InvocationType = {}));
var InvocatorFactory = /** @class */ (function () {
    function InvocatorFactory() {
    }
    InvocatorFactory.prototype.getInvocator = function (invocationType, invocationResponseResolver) {
        if (invocationType === InvocationType.prompt) {
            return new PromptAppInvocator(invocationResponseResolver);
        }
        if (invocationType === InvocationType.function) {
            return new FunctionAppInvocator(invocationResponseResolver);
        }
        return null;
    };
    return InvocatorFactory;
}());

var SplitUrlManager = /** @class */ (function () {
    function SplitUrlManager(determiner, redirector, userManager, core) {
        this.determiner = determiner;
        this.redirector = redirector;
        this.userManager = userManager;
        this.core = core;
    }
    SplitUrlManager.prototype.onPageStarted = function (_, __) {
        var user = this.userManager.resolve();
        var context = this.determiner.determineOrNull(user);
        if (!context)
            return;
        this.core.flush(true);
        this.redirector.redirect(context);
    };
    SplitUrlManager.prototype.onPageEnded = function (_, ___) { };
    return SplitUrlManager;
}());

var SplitUrlContext = /** @class */ (function () {
    function SplitUrlContext(workspace, experiment, decision, user) {
        this.workspace = workspace;
        this.experiment = experiment;
        this.decision = decision;
        this.user = user;
    }
    return SplitUrlContext;
}());

var SplitUrlDeterminer = /** @class */ (function () {
    function SplitUrlDeterminer(workspaceFetcher, splitUrlMatcher, splitUrlRedirectedCookieStorage, core) {
        this.workspaceFetcher = workspaceFetcher;
        this.splitUrlMatcher = splitUrlMatcher;
        this.splitUrlRedirectedCookieStorage = splitUrlRedirectedCookieStorage;
        this.core = core;
    }
    SplitUrlDeterminer.prototype.determineOrNull = function (user) {
        if (this.splitUrlRedirectedCookieStorage.alreadyRedirected()) {
            this.splitUrlRedirectedCookieStorage.clear();
            return null;
        }
        var workspace = this.workspaceFetcher.get();
        if (!workspace)
            return null;
        for (var _i = 0, _a = workspace.getSplitUrlExperiments(); _i < _a.length; _i++) {
            var experiment = _a[_i];
            var isMatch = this.splitUrlMatcher.matches(workspace, experiment, user);
            if (isMatch) {
                var decision = this.core.experiment(experiment.key, user, "A");
                return new SplitUrlContext(workspace, experiment, decision, user);
            }
        }
        return null;
    };
    return SplitUrlDeterminer;
}());

var SplitUrlMatcher = /** @class */ (function () {
    function SplitUrlMatcher(targetMatcher) {
        this.targetMatcher = targetMatcher;
    }
    SplitUrlMatcher.prototype.matches = function (workspace, experiment, user) {
        if (experiment.implementationType !== "SPLIT_URL")
            return false;
        if (!experiment.splitUrlTargets)
            return false;
        var splitUrlTargets = experiment.splitUrlTargets;
        var request = SplitUrlEvaluatorRequest.of(workspace, user);
        if (splitUrlTargets.excludeTargets.length > 0) {
            if (this.targetMatcher.anyMatches(request, EvaluatorContext.create(), splitUrlTargets.excludeTargets)) {
                return false;
            }
        }
        return (splitUrlTargets.includeTargets.length > 0 &&
            this.targetMatcher.anyMatches(request, EvaluatorContext.create(), splitUrlTargets.includeTargets));
    };
    return SplitUrlMatcher;
}());
var SplitUrlEvaluatorRequest = /** @class */ (function () {
    function SplitUrlEvaluatorRequest(key, user, workspace) {
        this.key = key;
        this.user = user;
        this.workspace = workspace;
    }
    SplitUrlEvaluatorRequest.of = function (workspace, user) {
        return new SplitUrlEvaluatorRequest(new EvaluatorKey("SPLIT_URL", v4()), user, workspace);
    };
    return SplitUrlEvaluatorRequest;
}());

var SplitUrlRedirector = /** @class */ (function () {
    function SplitUrlRedirector(urlResolver, urlHandler, splitUrlRedirectedCookieStorage, initializeEventDispatcher) {
        this.urlResolver = urlResolver;
        this.urlHandler = urlHandler;
        this.splitUrlRedirectedCookieStorage = splitUrlRedirectedCookieStorage;
        this.initializeEventDispatcher = initializeEventDispatcher;
    }
    SplitUrlRedirector.prototype.redirect = function (context) {
        var url = this.urlResolver.resolveOrNull(context);
        if (!url)
            return;
        this.initializeEventDispatcher.setNeedDispatch(false);
        this.splitUrlRedirectedCookieStorage.setRedirected(true);
        this.urlHandler.open(url);
    };
    return SplitUrlRedirector;
}());

var SplitUrlResolver = /** @class */ (function () {
    function SplitUrlResolver(campaignParser) {
        this.campaignParser = campaignParser;
    }
    SplitUrlResolver.prototype.resolveOrNull = function (context) {
        try {
            var splitUrlConfigDto = JSON.parse(context.decision.get(SplitUrlResolver.SPLIT_URL_CONFIG_KEY, ""));
            var splitUrlConfig = SplitUrlConfig.fromDto(splitUrlConfigDto);
            if (!splitUrlConfig.needRedirect) {
                return null;
            }
            return this.resolveByRedirectType(splitUrlConfig.redirectType, splitUrlConfig.redirectUrl, context);
        }
        catch (e) {
            return null;
        }
    };
    SplitUrlResolver.prototype.resolveByRedirectType = function (type, redirectUrl, context) {
        if (!redirectUrl) {
            return null;
        }
        switch (type) {
            case SplitUrlRedirectType.MANUAL:
                return this.resolveManualRedirectUrl(redirectUrl, context);
            default:
                return null;
        }
    };
    SplitUrlResolver.prototype.resolveManualRedirectUrl = function (redirectUrl, context) {
        var url = UrlUtil.tryParse(redirectUrl);
        if (!url)
            return null;
        // Decorate campaign for MANUAL redirect
        return this.decorateCampaign(url, context);
    };
    SplitUrlResolver.prototype.decorateCampaign = function (url, context) {
        var search = context.user.hackleProperties["queryParameter"];
        if (Strings.isNotEmptyString(search)) {
            var campaign = this.campaignParser.parse(search);
            return setCampaignToUrl(campaign, url);
        }
        else {
            return url;
        }
    };
    SplitUrlResolver.SPLIT_URL_CONFIG_KEY = "redirectUrl";
    return SplitUrlResolver;
}());

var SplitUrlRedirectedCookieStorage = /** @class */ (function () {
    function SplitUrlRedirectedCookieStorage(storage, cookieKey, cookieStorageOptions) {
        this.storage = storage;
        this.cookieKey = cookieKey;
        this.cookieStorageOptions = cookieStorageOptions;
    }
    SplitUrlRedirectedCookieStorage.prototype.alreadyRedirected = function () {
        try {
            var value = this.storage.getItem(this.cookieKey);
            if (ObjectUtil.isNullOrUndefined(value))
                return false;
            return Boolean(JSON.parse(value));
        }
        catch (e) {
            return false;
        }
    };
    SplitUrlRedirectedCookieStorage.prototype.clear = function () {
        this.storage.removeItem(this.cookieKey);
    };
    SplitUrlRedirectedCookieStorage.prototype.setRedirected = function (redirected) {
        this.storage.setItem(this.cookieKey, String(redirected), this.cookieStorageOptions);
    };
    return SplitUrlRedirectedCookieStorage;
}());

var BrowserInitializeDoneEventDispatcher = /** @class */ (function () {
    function BrowserInitializeDoneEventDispatcher() {
        this.needDispatch = true;
    }
    BrowserInitializeDoneEventDispatcher.prototype.setNeedDispatch = function (needDispatch) {
        this.needDispatch = needDispatch;
    };
    BrowserInitializeDoneEventDispatcher.prototype.dispatchDoneEventIfNeeded = function () {
        if (this.needDispatch) {
            window.dispatchEvent(new CustomEvent(BrowserInitializeDoneEventDispatcher.HACKLE_INITIALIZE_DONE_EVENT_TYPE));
        }
    };
    BrowserInitializeDoneEventDispatcher.HACKLE_INITIALIZE_DONE_EVENT_TYPE = "hackle-initialize-done";
    return BrowserInitializeDoneEventDispatcher;
}());

var BrowserWorkspaceConfigStorage = /** @class */ (function () {
    function BrowserWorkspaceConfigStorage(sdk, storage) {
        this.sdk = sdk;
        this.storage = storage;
    }
    BrowserWorkspaceConfigStorage.prototype.get = function () {
        var json = this.storage.getItem(WORKSPACE_CONFIG_STORAGE_KEY);
        if (ObjectUtil.isNullOrUndefined(json))
            return null;
        try {
            var config = JSON.parse(json);
            if (this.sdk.version !== config.version) {
                this.clear();
                return null;
            }
            return config;
        }
        catch (e) {
            this.clear();
            return null;
        }
    };
    BrowserWorkspaceConfigStorage.prototype.set = function (config) {
        var versionedConfig = __assign(__assign({}, config), { version: this.sdk.version });
        this.storage.setItem(WORKSPACE_CONFIG_STORAGE_KEY, JSON.stringify(versionedConfig));
    };
    BrowserWorkspaceConfigStorage.prototype.clear = function () {
        this.storage.removeItem(WORKSPACE_CONFIG_STORAGE_KEY);
    };
    return BrowserWorkspaceConfigStorage;
}());

var log$4 = Logger.log;
var LifecycleManager = /** @class */ (function () {
    function LifecycleManager(clock) {
        if (clock === void 0) { clock = SystemClock.instance; }
        this.clock = clock;
        this.listeners = [];
        this._initialized = false;
    }
    LifecycleManager.prototype.install = function (browserName) {
        if (browserName === void 0) { browserName = null; }
        try {
            // bind LifecycleManager instance for use when overriding history methods
            var changeLifecycle_1 = this.changeLifecycle.bind(this);
            // add page events for detect page initialization and termination
            window.addEventListener("pageshow", function () { return changeLifecycle_1("pageshow"); });
            window.addEventListener("pagehide", function () { return changeLifecycle_1("pagehide"); });
            // add visibilitychange events for detect tab change, tab close, and more
            document.addEventListener("visibilitychange", function () { return changeLifecycle_1(document.visibilityState); });
            // add blur, focus events for detect browser focus changes
            window.addEventListener("blur", function () { return changeLifecycle_1("blur"); });
            window.addEventListener("focus", function () { return changeLifecycle_1("focus"); });
            // use the beforeunload event because the safari browser cannot detect when the page ends
            if (LifecycleManager.isSafariBrowser(browserName)) {
                window.addEventListener("beforeunload", function () { return changeLifecycle_1("hidden"); });
            }
            history.pushState = (function (f) {
                return function pushState() {
                    try {
                        // @ts-ignore
                        var ret = f.apply(history, arguments);
                        changeLifecycle_1("locationChange");
                        return ret;
                    }
                    catch (e) {
                        if (e instanceof Error || typeof e === "string") {
                            log$4.error(e);
                        }
                    }
                };
            })(history.pushState);
            history.replaceState = (function (f) {
                return function replaceState() {
                    try {
                        // @ts-ignore
                        var ret = f.apply(history, arguments);
                        changeLifecycle_1("locationChange");
                        return ret;
                    }
                    catch (e) {
                        if (e instanceof Error || typeof e === "string") {
                            log$4.error(e);
                        }
                    }
                };
            })(history.replaceState);
            window.addEventListener("popstate", function () {
                try {
                    changeLifecycle_1("locationChange");
                }
                catch (e) {
                    if (e instanceof Error || typeof e === "string") {
                        log$4.error(e);
                    }
                }
            });
        }
        catch (e) {
            if (e instanceof Error || typeof e === "string") {
                log$4.error(e);
            }
        }
    };
    LifecycleManager.prototype.addListener = function (listener) {
        this.listeners.push(listener);
    };
    LifecycleManager.prototype.initialize = function () {
        this._initialized = true;
        this.changeLifecycle("pageshow");
    };
    LifecycleManager.prototype.changeLifecycle = function (lifecycle) {
        if (this._initialized) {
            this.publish(lifecycle);
        }
    };
    LifecycleManager.prototype.publish = function (lifecycle) {
        var timestamp = this.clock.currentMillis();
        this.listeners.forEach(function (listener) {
            listener.onLifecycleChanged(lifecycle, timestamp);
        });
    };
    LifecycleManager.isSafariBrowser = function (browserName) {
        if (ObjectUtil.isNullOrUndefined(browserName)) {
            return false;
        }
        return browserName.toLowerCase().includes("safari");
    };
    return LifecycleManager;
}());

var Throttler = /** @class */ (function () {
    function Throttler(limiter) {
        this.limiter = limiter;
    }
    Throttler.create = function (intervalMillis, limit, clock) {
        if (clock === void 0) { clock = SystemClock.instance; }
        var limiter = new ThrottleLimiter(clock, intervalMillis, limit);
        return new Throttler(limiter);
    };
    Throttler.prototype.execute = function (accept, reject) {
        if (this.limiter.tryAcquire()) {
            return accept();
        }
        else {
            return reject();
        }
    };
    return Throttler;
}());
var ThrottleLimiter = /** @class */ (function () {
    function ThrottleLimiter(clock, intervalMillis, limit) {
        this.clock = clock;
        this.intervalMillis = intervalMillis;
        this.limit = limit;
        this.currentScope = null;
    }
    ThrottleLimiter.prototype.tryAcquire = function () {
        var now = this.clock.currentMillis();
        var scope = this.refreshScopeIfNeeded(now);
        return scope.tryAcquire();
    };
    ThrottleLimiter.prototype.refreshScopeIfNeeded = function (now) {
        if (this.currentScope == null || this.currentScope.isExpired(now)) {
            this.currentScope = new ThrottleScope(now + this.intervalMillis, this.limit);
        }
        return this.currentScope;
    };
    return ThrottleLimiter;
}());
var ThrottleScope = /** @class */ (function () {
    function ThrottleScope(expirationTime, token) {
        this.expirationTime = expirationTime;
        this.token = token;
    }
    ThrottleScope.prototype.isExpired = function (now) {
        return this.expirationTime < now;
    };
    ThrottleScope.prototype.tryAcquire = function () {
        if (this.token > 0) {
            this.token -= 1;
            return true;
        }
        else {
            return false;
        }
    };
    return ThrottleScope;
}());

var DelegatingUserEventDedupDeterminer = /** @class */ (function () {
    function DelegatingUserEventDedupDeterminer(determiners) {
        this.determiners = determiners;
    }
    DelegatingUserEventDedupDeterminer.prototype.isDedupTarget = function (event) {
        var determiner = this.determiners.find(function (it) { return it.supports(event); });
        if (!determiner)
            return false;
        return determiner.isDedupTarget(event);
    };
    return DelegatingUserEventDedupDeterminer;
}());

var CachedUserEventDeterminer = /** @class */ (function () {
    function CachedUserEventDeterminer(dedupIntervalMillis, clock) {
        this.dedupIntervalMillis = dedupIntervalMillis;
        this.clock = clock;
        this.cache = {};
        this.currentUser = null;
    }
    CachedUserEventDeterminer.prototype.isDedupTarget = function (event) {
        var _a;
        if (this.dedupIntervalMillis === NO_DEDUP) {
            return false;
        }
        if (!IdentifierUtil.isEquals(event.user.identifiers, (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.identifiers)) {
            this.currentUser = event.user;
            this.cache = {};
        }
        var key = this.cacheKey(event);
        var now = this.clock.currentMillis();
        var firstMillis = this.cache[key];
        if (firstMillis !== undefined && now - firstMillis <= this.dedupIntervalMillis) {
            return true;
        }
        this.cache[key] = now;
        return false;
    };
    return CachedUserEventDeterminer;
}());

var RemoteConfigEventDedupDeterminer = /** @class */ (function (_super) {
    __extends(RemoteConfigEventDedupDeterminer, _super);
    function RemoteConfigEventDedupDeterminer(dedupIntervalMillis, clock) {
        if (clock === void 0) { clock = SystemClock.instance; }
        return _super.call(this, dedupIntervalMillis, clock) || this;
    }
    RemoteConfigEventDedupDeterminer.prototype.supports = function (event) {
        return UserEvent.isRemoteConfigEvent(event);
    };
    RemoteConfigEventDedupDeterminer.prototype.cacheKey = function (event) {
        return [event.parameter.id, event.valueId, event.decisionReason].join("-");
    };
    return RemoteConfigEventDedupDeterminer;
}(CachedUserEventDeterminer));

var ExposureEventDedupDeterminer = /** @class */ (function (_super) {
    __extends(ExposureEventDedupDeterminer, _super);
    function ExposureEventDedupDeterminer(dedupIntervalMillis, clock) {
        if (clock === void 0) { clock = SystemClock.instance; }
        return _super.call(this, dedupIntervalMillis, clock) || this;
    }
    ExposureEventDedupDeterminer.prototype.supports = function (event) {
        return UserEvent.isExposureEvent(event);
    };
    ExposureEventDedupDeterminer.prototype.cacheKey = function (event) {
        return [event.experiment.id, event.variationId, event.variationKey, event.decisionReason].join("-");
    };
    return ExposureEventDedupDeterminer;
}(CachedUserEventDeterminer));

var InvocationResponseResolver = /** @class */ (function () {
    function InvocationResponseResolver() {
    }
    InvocationResponseResolver.prototype.isInvocatorResponse = function (response) {
        return (typeof response === "object" &&
            response !== null &&
            "success" in response &&
            typeof response.success === "boolean" &&
            "message" in response &&
            typeof response.message === "string");
    };
    InvocationResponseResolver.prototype.resolve = function (response) {
        var parsed = JSON.parse(response !== null && response !== void 0 ? response : "");
        if (!this.isInvocatorResponse(parsed)) {
            throw new Error("invalid invocator response data");
        }
        if (!parsed.success) {
            throw new Error("failed response");
        }
        var invocationResponseDto = {
            message: parsed.message,
            success: parsed.success,
            data: parsed.data
        };
        return invocationResponseDto;
    };
    return InvocationResponseResolver;
}());

var HackleAppInvocationProcessor = /** @class */ (function () {
    function HackleAppInvocationProcessor(invocator) {
        this.invocator = invocator;
    }
    HackleAppInvocationProcessor.prototype.createInvocationRequestDto = function (_a) {
        var command = _a.command, parameters = _a.parameters, browserProperties = _a.browserProperties;
        return { _hackle: { command: command, parameters: parameters, browserProperties: browserProperties } };
    };
    HackleAppInvocationProcessor.prototype.process = function (invocation) {
        var _a;
        var request = this.createInvocationRequestDto(invocation);
        return (_a = this.invocator.invoke(request).data) !== null && _a !== void 0 ? _a : null;
    };
    return HackleAppInvocationProcessor;
}());

var log$3 = Logger.log;
var PageEventTracker = /** @class */ (function () {
    function PageEventTracker(core, userManager) {
        this.core = core;
        this.userManager = userManager;
    }
    PageEventTracker.prototype.onPageStarted = function (page, timestamp) {
        this.track(page, timestamp);
    };
    PageEventTracker.prototype.onPageEnded = function (_, ___) { };
    PageEventTracker.prototype.track = function (page, timestamp) {
        var _a;
        log$3.debug("tracking page view");
        var hackleEvent = {
            key: PageEventTracker.PAGE_VIEW_EVENT_KEY,
            properties: (_a = {},
                _a[PageEventTracker.PAGE_NAME_PROPERTY_KEY] = page.pageTitle,
                _a)
        };
        this.core.track(hackleEvent, this.userManager.resolve(), timestamp);
    };
    PageEventTracker.PAGE_VIEW_EVENT_KEY = "$page_view";
    PageEventTracker.PAGE_NAME_PROPERTY_KEY = "$page_name";
    return PageEventTracker;
}());

var PageManager = /** @class */ (function () {
    function PageManager() {
        this.listeners = [];
        this._currentPage = null;
    }
    Object.defineProperty(PageManager.prototype, "currentPage", {
        get: function () {
            var _a;
            // If the current page does not exist in the getter function so that pageStart can be started lazily
            // a new page is created and returned.
            return (_a = this._currentPage) !== null && _a !== void 0 ? _a : Page.createWithCurrentPage();
        },
        enumerable: false,
        configurable: true
    });
    PageManager.prototype.updatePage = function (page, timestamp) {
        var previousPage = this._currentPage;
        if (previousPage && page.isEquals(previousPage)) {
            return;
        }
        if (previousPage) {
            this.publishEnd(previousPage, timestamp);
        }
        this._currentPage = page;
        this.publishStart(page, timestamp);
    };
    PageManager.prototype.publishStart = function (page, timestamp) {
        for (var _i = 0, _a = this.listeners; _i < _a.length; _i++) {
            var listener = _a[_i];
            listener.onPageStarted(page, timestamp);
        }
    };
    PageManager.prototype.publishEnd = function (page, timestamp) {
        for (var _i = 0, _a = this.listeners; _i < _a.length; _i++) {
            var listener = _a[_i];
            listener.onPageEnded(page, timestamp);
        }
    };
    PageManager.prototype.onLifecycleChanged = function (lifecycle, timestamp) {
        switch (lifecycle) {
            case "pageshow":
            case "locationChange":
                var page = Page.createWithCurrentPage();
                return this.updatePage(page, timestamp);
            case "visible":
            case "pagehide":
            case "blur":
            case "focus":
            case "hidden":
                return;
        }
    };
    PageManager.prototype.addListener = function (listener) {
        this.listeners.push(listener);
    };
    return PageManager;
}());

var log$2 = Logger.log;
var EngagementManager = /** @class */ (function () {
    function EngagementManager(pageManager, minimumEngagementDurationMillis) {
        this.pageManager = pageManager;
        this.minimumEngagementDurationMillis = minimumEngagementDurationMillis;
        this.listeners = [];
        this._lastEngagementTime = null;
    }
    Object.defineProperty(EngagementManager.prototype, "lastEngagementTime", {
        get: function () {
            return this._lastEngagementTime;
        },
        enumerable: false,
        configurable: true
    });
    EngagementManager.prototype.startEngagement = function (timestamp) {
        log$2.debug("startEngagement timestamp:".concat(timestamp, ", page:").concat(this.pageManager.currentPage.url));
        this._lastEngagementTime = timestamp;
    };
    EngagementManager.prototype.endEngagement = function (page, timestamp) {
        if (ObjectUtil.isNullOrUndefined(this._lastEngagementTime))
            return;
        var startTimestamp = this._lastEngagementTime;
        this._lastEngagementTime = timestamp;
        var durationMillis = timestamp - startTimestamp;
        if (durationMillis < this.minimumEngagementDurationMillis) {
            return;
        }
        var engagement = { page: page, durationMillis: durationMillis };
        this.publish(engagement, timestamp);
    };
    EngagementManager.prototype.publish = function (engagement, timestamp) {
        log$2.debug("onEngagement timestamp:".concat(timestamp, ", page:").concat(this.pageManager.currentPage.url));
        for (var _i = 0, _a = this.listeners; _i < _a.length; _i++) {
            var listener = _a[_i];
            listener.onEngagement(engagement, timestamp);
        }
    };
    EngagementManager.prototype.onPageStarted = function (_, timestamp) {
        this.startEngagement(timestamp);
    };
    EngagementManager.prototype.onPageEnded = function (page, timestamp) {
        this.endEngagement(page, timestamp);
    };
    EngagementManager.prototype.onLifecycleChanged = function (lifecycle, timestamp) {
        switch (lifecycle) {
            case "visible":
            case "focus":
                return this.startEngagement(timestamp);
            case "pagehide":
            case "hidden":
            case "blur":
                return this.endEngagement(this.pageManager.currentPage, timestamp);
            case "pageshow":
            case "locationChange":
                return;
        }
    };
    EngagementManager.prototype.addListener = function (listener) {
        this.listeners.push(listener);
    };
    return EngagementManager;
}());

var EngagementEventTracker = /** @class */ (function () {
    function EngagementEventTracker(core, userManager) {
        this.core = core;
        this.userManager = userManager;
    }
    EngagementEventTracker.prototype.onEngagement = function (engagement, timestamp) {
        var _a;
        var hackleEvent = {
            key: EngagementEventTracker.ENGAGEMENT_EVENT_KEY,
            properties: (_a = {},
                _a[PageEventTracker.PAGE_NAME_PROPERTY_KEY] = engagement.page.pageTitle,
                _a[EngagementEventTracker.ENGAGEMENT_TIME_PROPERTY_KEY] = engagement.durationMillis,
                _a)
        };
        this.core.track(hackleEvent, this.userManager.resolve(), timestamp);
    };
    EngagementEventTracker.ENGAGEMENT_EVENT_KEY = "$engagement";
    EngagementEventTracker.ENGAGEMENT_TIME_PROPERTY_KEY = "$engagement_time_ms";
    return EngagementEventTracker;
}());

var PIIEventManager = /** @class */ (function () {
    function PIIEventManager(core, userManager) {
        this.core = core;
        this.userManager = userManager;
    }
    PIIEventManager.prototype.setPhoneNumber = function (phoneNumber, timestamp) {
        var properties = new PropertyOperationsBuilder()
            .set(PIIEventManager.PHONE_NUMBER_PROPERTY_KEY, phoneNumber.getValue())
            .build();
        var securedEvent = properties.toSecuredEvent();
        this.track(securedEvent, timestamp);
    };
    PIIEventManager.prototype.unsetPhoneNumber = function (timestamp) {
        var properties = new PropertyOperationsBuilder().unset(PIIEventManager.PHONE_NUMBER_PROPERTY_KEY).build();
        var securedEvent = properties.toSecuredEvent();
        this.track(securedEvent, timestamp);
    };
    PIIEventManager.prototype.track = function (event, timestamp) {
        var hackleUser = this.userManager.resolve();
        this.core.track(event, hackleUser, timestamp);
    };
    PIIEventManager.PHONE_NUMBER_PROPERTY_KEY = "$phone_number";
    return PIIEventManager;
}());

var DefaultBrowserPropertyProvider = /** @class */ (function () {
    function DefaultBrowserPropertyProvider() {
    }
    DefaultBrowserPropertyProvider.prototype.getBrowserProperties = function (page) {
        return BrowserPropertyGenerator.generate(window, page !== null && page !== void 0 ? page : Page.createWithCurrentPage());
    };
    return DefaultBrowserPropertyProvider;
}());

var InAppMessageScheduleRequest = /** @class */ (function () {
    function InAppMessageScheduleRequest(schedule, scheduleType, requestedAt) {
        this.schedule = schedule;
        this.scheduleType = scheduleType;
        this.requestedAt = requestedAt;
    }
    Object.defineProperty(InAppMessageScheduleRequest.prototype, "delayMillis", {
        get: function () {
            return this.schedule.time.deliverAt - this.requestedAt;
        },
        enumerable: false,
        configurable: true
    });
    InAppMessageScheduleRequest.prototype.toString = function () {
        return "InAppMessageScheduleRequest(scheduleType=".concat(this.scheduleType, ", requestedAt=").concat(this.requestedAt, ")");
    };
    return InAppMessageScheduleRequest;
}());

var InAppMessageSchedule = /** @class */ (function () {
    function InAppMessageSchedule(dispatchId, inAppMessageKey, identifiers, time, reason, eventBasedContext) {
        this.dispatchId = dispatchId;
        this.inAppMessageKey = inAppMessageKey;
        this.identifiers = identifiers;
        this.time = time;
        this.reason = reason;
        this.eventBasedContext = eventBasedContext;
    }
    InAppMessageSchedule.prototype.toRequest = function (type, requestedAt) {
        return new InAppMessageScheduleRequest(this, type, requestedAt);
    };
    InAppMessageSchedule.create = function (trigger) {
        return new InAppMessageSchedule(v4(), trigger.inAppMessage.key, trigger.event.user.identifiers, InAppMessageScheduleTime.of(trigger.inAppMessage, trigger.event.timestamp), trigger.reason, new InAppMessageEventBasedContext(trigger.event.insertId, trigger.event.event));
    };
    InAppMessageSchedule.fromDelayStorageEntity = function (delay, delayRestoredAt) {
        return new InAppMessageSchedule(delay.schedule.dispatchId, delay.schedule.inAppMessageKey, delay.schedule.identifiers, new InAppMessageScheduleTime(delayRestoredAt, delay.schedule.time.deliverAt), delay.schedule.reason, delay.schedule.eventBasedContext);
    };
    return InAppMessageSchedule;
}());
var InAppMessageScheduleTime = /** @class */ (function () {
    function InAppMessageScheduleTime(startedAt, deliverAt) {
        this.startedAt = startedAt;
        this.deliverAt = deliverAt;
    }
    InAppMessageScheduleTime.prototype.delayMillis = function (at) {
        return this.deliverAt - at;
    };
    InAppMessageScheduleTime.of = function (inAppMessage, startedAt) {
        return new InAppMessageScheduleTime(startedAt, inAppMessage.eventTrigger.delay.deliverAt(startedAt));
    };
    return InAppMessageScheduleTime;
}());
var InAppMessageEventBasedContext = /** @class */ (function () {
    function InAppMessageEventBasedContext(insertId, event) {
        this.insertId = insertId;
        this.event = event;
    }
    return InAppMessageEventBasedContext;
}());

var InAppMessageManager = /** @class */ (function () {
    function InAppMessageManager(scheduleProcessor, delayStorage, triggerProcessor, resetProcessor, userEventEmitter, clock) {
        this.scheduleProcessor = scheduleProcessor;
        this.delayStorage = delayStorage;
        this.triggerProcessor = triggerProcessor;
        this.resetProcessor = resetProcessor;
        this.userEventEmitter = userEventEmitter;
        this.clock = clock;
        this.initialize();
    }
    InAppMessageManager.prototype.initialize = function () {
        var _this = this;
        /**
         * add event listener
         */
        this.userEventEmitter.on("event", function (event) {
            _this.onEvent(event);
        });
    };
    InAppMessageManager.prototype.destroy = function () {
        var _this = this;
        this.userEventEmitter.off("event", function (event) {
            _this.onEvent(event);
        });
    };
    InAppMessageManager.prototype.onEvent = function (event) {
        this.triggerProcessor.process(event);
    };
    /**
     * @override
     */
    InAppMessageManager.prototype.onUserUpdated = function (oldUser, newUser, timestamp) {
        var oldIdentifiers = resolveIdentifiers(oldUser);
        var newIdentifiers = resolveIdentifiers(newUser);
        this.resetProcessor.process({ identifiers: oldIdentifiers }, { identifiers: newIdentifiers });
    };
    InAppMessageManager.prototype.loadDelaySchedule = function () {
        var _this = this;
        /**
         * schedule delay from DelayStorage
         * if the delay is expired, remove the delay from DelayStorage
         */
        this.delayStorage.values().forEach(function (delay) {
            var delayRestoredAt = _this.clock.currentMillis();
            var scheduleRequest = InAppMessageSchedule.fromDelayStorageEntity(delay, delayRestoredAt).toRequest("STORED", delayRestoredAt);
            _this.scheduleProcessor.process(scheduleRequest);
        });
    };
    return InAppMessageManager;
}());

var InAppMessageExperimentEvaluator = /** @class */ (function (_super) {
    __extends(InAppMessageExperimentEvaluator, _super);
    function InAppMessageExperimentEvaluator(evaluator) {
        return _super.call(this, evaluator) || this;
    }
    /**
     * @override
     */
    InAppMessageExperimentEvaluator.prototype.resolve = function (request, context, evaluation) {
        context.setProperty("experiment_id", evaluation.experiment.id);
        context.setProperty("experiment_key", evaluation.experiment.key);
        context.setProperty("variation_id", evaluation.variationId);
        context.setProperty("variation_key", evaluation.variationKey);
        context.setProperty("experiment_decision_reason", evaluation.reason);
        return evaluation;
    };
    return InAppMessageExperimentEvaluator;
}(ExperimentContextualEvaluator));

var InAppMessageEvaluator = /** @class */ (function (_super) {
    __extends(InAppMessageEvaluator, _super);
    function InAppMessageEvaluator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return InAppMessageEvaluator;
}(ContextualEvaluator));

var InAppMessageLayoutEvaluation = /** @class */ (function () {
    function InAppMessageLayoutEvaluation(request, reason, targetEvaluations, message, properties) {
        this.request = request;
        this.reason = reason;
        this.targetEvaluations = targetEvaluations;
        this.message = message;
        this.properties = properties;
    }
    Object.defineProperty(InAppMessageLayoutEvaluation.prototype, "inAppMessage", {
        get: function () {
            return this.request.inAppMessage;
        },
        enumerable: false,
        configurable: true
    });
    InAppMessageLayoutEvaluation.of = function (request, context, message) {
        return new InAppMessageLayoutEvaluation(request, DecisionReason.IN_APP_MESSAGE_TARGET, context.targetEvaluations, message, context.properties);
    };
    return InAppMessageLayoutEvaluation;
}());

var InAppMessageEvaluatorRequest = /** @class */ (function () {
    function InAppMessageEvaluatorRequest() {
    }
    Object.defineProperty(InAppMessageEvaluatorRequest.prototype, "key", {
        get: function () {
            return new EvaluatorKey("IN_APP_MESSAGE", this.inAppMessage.id);
        },
        enumerable: false,
        configurable: true
    });
    return InAppMessageEvaluatorRequest;
}());

var InAppMessageLayoutRequest = /** @class */ (function (_super) {
    __extends(InAppMessageLayoutRequest, _super);
    function InAppMessageLayoutRequest(workspace, user, inAppMessage) {
        var _this = _super.call(this) || this;
        _this.workspace = workspace;
        _this.user = user;
        _this.inAppMessage = inAppMessage;
        return _this;
    }
    InAppMessageLayoutRequest.of = function (request) {
        if (request instanceof InAppMessageLayoutRequest)
            return request;
        return new InAppMessageLayoutRequest(request.workspace, request.user, request.inAppMessage);
    };
    InAppMessageLayoutRequest.prototype.toString = function () {
        return "InAppMessageLayoutRequest(type=".concat(this.key.type, ", key=").concat(this.inAppMessage.key, ")");
    };
    return InAppMessageLayoutRequest;
}(InAppMessageEvaluatorRequest));

var InAppMessageLayoutEvaluator = /** @class */ (function (_super) {
    __extends(InAppMessageLayoutEvaluator, _super);
    function InAppMessageLayoutEvaluator(experimentEvaluator, selector, eventRecorder) {
        var _this = _super.call(this) || this;
        _this.experimentEvaluator = experimentEvaluator;
        _this.selector = selector;
        _this.eventRecorder = eventRecorder;
        return _this;
    }
    /**
     * @override
     */
    InAppMessageLayoutEvaluator.prototype.supports = function (request) {
        return request instanceof InAppMessageLayoutRequest;
    };
    /**
     * @override
     */
    InAppMessageLayoutEvaluator.prototype.evaluateInternal = function (request, context) {
        var experimentContext = request.inAppMessage.messageContext.experimentContext;
        var message = experimentContext !== null
            ? this.evaluateExperiment(request, context, experimentContext)
            : this.evaluateDefault(request, context);
        return InAppMessageLayoutEvaluation.of(request, context, message);
    };
    InAppMessageLayoutEvaluator.prototype.evaluateDefault = function (request, context) {
        var langCondition = LangCondition(request.inAppMessage.messageContext.defaultLang);
        return this.selector.select(request.inAppMessage, langCondition);
    };
    InAppMessageLayoutEvaluator.prototype.evaluateExperiment = function (request, context, experimentContext) {
        var experiment = ObjectUtil.requiredNotNullOrUndefined(request.workspace.getExperimentOrNull(experimentContext.key), function () { return "Experiment[key=".concat(experimentContext.key, "]"); });
        var experimentEvaluation = this.experimentEvaluator.evaluate(request, context, experiment);
        var langCondition = LangCondition(request.inAppMessage.messageContext.defaultLang);
        var experimentCondition = ExperimentCondition(experimentEvaluation.variationKey);
        return this.selector.select(request.inAppMessage, function (message) { return langCondition(message) && experimentCondition(message); });
    };
    /**
     * @override
     */
    InAppMessageLayoutEvaluator.prototype.record = function (request, evaluation) {
        this.eventRecorder.record(request, evaluation);
    };
    return InAppMessageLayoutEvaluator;
}(InAppMessageEvaluator));
function LangCondition(lang) {
    return function (message) { return lang === message.lang; };
}
function ExperimentCondition(variationKey) {
    return function (message) { return variationKey === message.variationKey; };
}

var InAppMessageLayoutSelector = /** @class */ (function () {
    function InAppMessageLayoutSelector() {
    }
    InAppMessageLayoutSelector.prototype.select = function (inAppMessage, condition) {
        var message = inAppMessage.messageContext.messages.find(condition);
        return ObjectUtil.requiredNotNullOrUndefined(message, function () { return "InAppMessage must be decided [".concat(inAppMessage.id, "]"); });
    };
    return InAppMessageLayoutSelector;
}());

var InAppMessageRecorder = /** @class */ (function () {
    function InAppMessageRecorder(storage) {
        this.storage = storage;
        this.STORE_MAX_SIZE = 100;
    }
    InAppMessageRecorder.prototype.record = function (request, response) {
        if (request.reason === DecisionReason.OVERRIDDEN) {
            return;
        }
        try {
            this.doRecord(request);
        }
        catch (e) {
            Logger.log.error("Failed to record InAppMessageImpression: ".concat(e));
        }
    };
    InAppMessageRecorder.prototype.doRecord = function (request) {
        var impressions = this.storage.get(request.inAppMessage);
        var impression = {
            identifiers: request.user.identifiers,
            timestamp: request.requestedAt
        };
        var newImpressions = __spreadArray(__spreadArray([], impressions, true), [impression], false);
        var victimCriteriaIndex = newImpressions.length > this.STORE_MAX_SIZE ? newImpressions.length - this.STORE_MAX_SIZE : 0;
        var impressionToSave = newImpressions.slice(victimCriteriaIndex);
        this.storage.set(request.inAppMessage, impressionToSave);
    };
    return InAppMessageRecorder;
}());

var InAppMessagePresentResponse = /** @class */ (function () {
    function InAppMessagePresentResponse(dispatchId, context) {
        this.dispatchId = dispatchId;
        this.context = context;
    }
    /**
     * @override
     */
    InAppMessagePresentResponse.prototype.toString = function () {
        return "InAppMessagePresentResponse(dispatchId=".concat(this.dispatchId, ", inAppMessage=").concat(this.context.inAppMessage, ", displayType=").concat(this.context.message.layout.displayType, ", layoutType=").concat(this.context.message.layout.layoutType, ")");
    };
    InAppMessagePresentResponse.of = function (request, context) {
        return new InAppMessagePresentResponse(request.dispatchId, context);
    };
    return InAppMessagePresentResponse;
}());

var InAppMessagePresentationContext = /** @class */ (function () {
    function InAppMessagePresentationContext(dispatchId, inAppMessage, message, user, decisionReason, properties) {
        this.dispatchId = dispatchId;
        this.inAppMessage = inAppMessage;
        this.message = message;
        this.user = user;
        this.decisionReason = decisionReason;
        this.properties = properties;
    }
    /**
     * @override
     */
    InAppMessagePresentationContext.prototype.toString = function () {
        return "InAppMessagePresentationContext(dispatchId=".concat(this.dispatchId, ", inAppMessage=").concat(this.inAppMessage, ", message=").concat(this.message, ")");
    };
    InAppMessagePresentationContext.of = function (request) {
        return new InAppMessagePresentationContext(request.dispatchId, request.inAppMessage, request.message, request.user, request.reason, request.properties);
    };
    return InAppMessagePresentationContext;
}());

var InAppMessagePresentProcessor = /** @class */ (function () {
    function InAppMessagePresentProcessor(presenter, recorder) {
        this.presenter = presenter;
        this.recorder = recorder;
    }
    InAppMessagePresentProcessor.prototype.process = function (request) {
        Logger.log.debug("InAppMessage Present Request: ".concat(request));
        var response = this.present(request);
        this.recorder.record(request, response);
        Logger.log.debug("InAppMessage Present Response: ".concat(response));
        return response;
    };
    InAppMessagePresentProcessor.prototype.present = function (request) {
        var context = InAppMessagePresentationContext.of(request);
        this.presenter.present(context);
        return InAppMessagePresentResponse.of(request, context);
    };
    return InAppMessagePresentProcessor;
}());

var InAppMessageIdentifierChecker = /** @class */ (function () {
    function InAppMessageIdentifierChecker() {
    }
    InAppMessageIdentifierChecker.prototype.isIdentifierChanged = function (oldIdentifiers, newIdentifiers) {
        var oldUserId = oldIdentifiers[IdentifierType.USER];
        var newUserId = newIdentifiers[IdentifierType.USER];
        if (oldUserId !== undefined && newUserId !== undefined) {
            return oldUserId !== newUserId;
        }
        var oldDeviceId = oldIdentifiers[IdentifierType.DEVICE];
        var newDeviceId = newIdentifiers[IdentifierType.DEVICE];
        if (oldDeviceId !== undefined && newDeviceId !== undefined) {
            return oldDeviceId !== newDeviceId;
        }
        return false;
    };
    return InAppMessageIdentifierChecker;
}());

var InAppMessageDelayScheduler = /** @class */ (function () {
    function InAppMessageDelayScheduler(clock, scheduler) {
        this.clock = clock;
        this.scheduler = scheduler;
    }
    Object.defineProperty(InAppMessageDelayScheduler.prototype, "listener", {
        get: function () {
            return this._listener;
        },
        set: function (listener) {
            this._listener = listener;
        },
        enumerable: false,
        configurable: true
    });
    InAppMessageDelayScheduler.prototype.schedule = function (delay) {
        var _this = this;
        var job = this.scheduler.schedule(delay.delayMillis, function () { return _this.delayCommand(delay); });
        return new ScheduledInAppMessageDelayTask(delay, job);
    };
    InAppMessageDelayScheduler.prototype.delayCommand = function (delay) {
        var _a;
        var now = this.clock.currentMillis();
        var request = delay.schedule.toRequest("DELAYED", now);
        (_a = this.listener) === null || _a === void 0 ? void 0 : _a.onSchedule(request);
    };
    return InAppMessageDelayScheduler;
}());
var ScheduledInAppMessageDelayTask = /** @class */ (function () {
    function ScheduledInAppMessageDelayTask(delay, job) {
        this.delay = delay;
        this.job = job;
    }
    ScheduledInAppMessageDelayTask.prototype.cancel = function () {
        this.job.cancel();
        Logger.log.debug("InAppMessageDelay cancelled: ".concat(this.delay));
    };
    return ScheduledInAppMessageDelayTask;
}());

var InAppMessageDelay = /** @class */ (function () {
    function InAppMessageDelay(schedule, requestedAt) {
        this.schedule = schedule;
        this.requestedAt = requestedAt;
    }
    Object.defineProperty(InAppMessageDelay.prototype, "delayMillis", {
        get: function () {
            return this.schedule.time.delayMillis(this.requestedAt);
        },
        enumerable: false,
        configurable: true
    });
    InAppMessageDelay.from = function (request) {
        return new InAppMessageDelay(request.schedule, request.requestedAt);
    };
    /**
     * @override
     */
    InAppMessageDelay.prototype.toString = function () {
        return "InAppMessageDelay(dispatchId=".concat(this.schedule.dispatchId, ", requestedAt=").concat(this.requestedAt, ")");
    };
    return InAppMessageDelay;
}());

var InAppMessageDelayManager = /** @class */ (function () {
    function InAppMessageDelayManager(scheduler, tasks, storage) {
        this.scheduler = scheduler;
        this.tasks = tasks;
        this.storage = storage;
    }
    InAppMessageDelayManager.prototype.registerAndDelay = function (request) {
        this.storage.set(request.schedule.inAppMessageKey, request.schedule.dispatchId, InAppMessageDelay.from(request));
        return this.delay(request);
    };
    InAppMessageDelayManager.prototype.delay = function (request) {
        var delay = InAppMessageDelay.from(request);
        var task = this.scheduler.schedule(delay);
        this.tasks.set(delay.schedule.dispatchId, task);
        Logger.log.debug("InAppMessage Delay started: dispatchId=".concat(request.schedule.dispatchId));
        return delay;
    };
    InAppMessageDelayManager.prototype.delete = function (request) {
        var _a, _b;
        var delay = (_b = (_a = this.tasks.get(request.schedule.dispatchId)) === null || _a === void 0 ? void 0 : _a.delay) !== null && _b !== void 0 ? _b : null;
        if (delay) {
            Logger.log.debug("InAppMessage Delay deleted: dispatchId=".concat(request.schedule.dispatchId));
        }
        this.tasks.delete(request.schedule.dispatchId);
        this.storage.remove(request.schedule.inAppMessageKey, request.schedule.dispatchId);
        return delay;
    };
    InAppMessageDelayManager.prototype.cancelAll = function () {
        var snapshot = Array.from(this.tasks.values());
        snapshot.forEach(function (task) { return task.cancel(); });
        this.tasks.clear();
        this.storage.clear();
        Logger.log.debug("InAppMessage Delay clear.");
        return snapshot.map(function (task) { return task.delay; });
    };
    return InAppMessageDelayManager;
}());

var InAppMessageDeliverResponse = /** @class */ (function () {
    function InAppMessageDeliverResponse(dispatchId, inAppMessageKey, code, presentResponse) {
        this.dispatchId = dispatchId;
        this.inAppMessageKey = inAppMessageKey;
        this.code = code;
        this.presentResponse = presentResponse;
    }
    /**
     * @override
     */
    InAppMessageDeliverResponse.prototype.toString = function () {
        return "InAppMessageDeliverResponse(dispatchId=".concat(this.dispatchId, ", inAppMessageKey=").concat(this.inAppMessageKey, ", code=").concat(this.code, ")");
    };
    InAppMessageDeliverResponse.of = function (request, code, presentResponse) {
        if (presentResponse === void 0) { presentResponse = null; }
        return new InAppMessageDeliverResponse(request.dispatchId, request.inAppMessageKey, code, presentResponse);
    };
    return InAppMessageDeliverResponse;
}());

var InAppMessagePresentRequest = /** @class */ (function () {
    function InAppMessagePresentRequest(dispatchId, inAppMessage, message, user, requestedAt, reason, properties) {
        this.dispatchId = dispatchId;
        this.inAppMessage = inAppMessage;
        this.message = message;
        this.user = user;
        this.requestedAt = requestedAt;
        this.reason = reason;
        this.properties = properties;
    }
    /**
     * @override
     */
    InAppMessagePresentRequest.prototype.toString = function () {
        return "InAppMessagePresentRequest(dispatchId=".concat(this.dispatchId, ", inAppMessage=").concat(this.inAppMessage, ", user=").concat(this.user.identifiers, ", requestedAt=").concat(this.requestedAt, ", reason=").concat(this.reason, ", properties=").concat(this.properties, ")");
    };
    InAppMessagePresentRequest.of = function (request, inAppMessage, user, eligibilityEvaluation, layoutEvaluation) {
        return new InAppMessagePresentRequest(request.dispatchId, inAppMessage, layoutEvaluation.message, user, request.requestedAt, eligibilityEvaluation.reason, __assign(__assign({}, request.properties), layoutEvaluation.properties));
    };
    return InAppMessagePresentRequest;
}());

var InAppMessageEligibilityRequest = /** @class */ (function (_super) {
    __extends(InAppMessageEligibilityRequest, _super);
    function InAppMessageEligibilityRequest(workspace, user, inAppMessage, timestamp) {
        var _this = _super.call(this) || this;
        _this.workspace = workspace;
        _this.user = user;
        _this.inAppMessage = inAppMessage;
        _this.timestamp = timestamp;
        return _this;
    }
    InAppMessageEligibilityRequest.prototype.toString = function () {
        return "InAppMessageEligibilityRequest(type=".concat(this.key.type, ", key=").concat(this.inAppMessage.key, ")");
    };
    return InAppMessageEligibilityRequest;
}(InAppMessageEvaluatorRequest));

var InAppMessageDeliverProcessor = /** @class */ (function () {
    function InAppMessageDeliverProcessor(workspaceFetcher, userManager, identifierChecker, layoutResolver, evaluateProcessor, presentProcessor, userDecorator) {
        this.workspaceFetcher = workspaceFetcher;
        this.userManager = userManager;
        this.identifierChecker = identifierChecker;
        this.layoutResolver = layoutResolver;
        this.evaluateProcessor = evaluateProcessor;
        this.presentProcessor = presentProcessor;
        this.userDecorator = userDecorator;
    }
    InAppMessageDeliverProcessor.prototype.response = function (request) {
        try {
            return this.deliver(request);
        }
        catch (err) {
            Logger.log.error("Failed to process InAppMessageDeliver: ".concat(err));
            return InAppMessageDeliverResponse.of(request, "EXCEPTION");
        }
    };
    InAppMessageDeliverProcessor.prototype.process = function (request) {
        Logger.log.debug("InAppMessage Deliver Request: ".concat(request));
        var response = this.response(request);
        Logger.log.debug("InAppMessage Deliver Response: ".concat(response));
        return response;
    };
    InAppMessageDeliverProcessor.prototype.deliver = function (request) {
        // check Workspace
        var workspace = this.workspaceFetcher.get();
        if (!workspace) {
            return InAppMessageDeliverResponse.of(request, "WORKSPACE_NOT_FOUND");
        }
        // check InAppMessage
        var inAppMessage = workspace.getInAppMessageOrNull(request.inAppMessageKey);
        if (!inAppMessage) {
            return InAppMessageDeliverResponse.of(request, "IN_APP_MESSAGE_NOT_FOUND");
        }
        // check User
        var user = this.userDecorator.decorate(this.userManager.resolve());
        var isIdentifierChanged = this.identifierChecker.isIdentifierChanged(request.identifiers, user.identifiers);
        if (isIdentifierChanged) {
            return InAppMessageDeliverResponse.of(request, "IDENTIFIER_CHANGED");
        }
        // resolve layout
        var layoutEvaluation = this.layoutResolver.resolve(workspace, inAppMessage, user);
        // check Evaluation (re-eval + dedup)
        var eligibilityRequest = new InAppMessageEligibilityRequest(workspace, user, inAppMessage, request.requestedAt);
        var eligibilityEvaluation = this.evaluateProcessor.process("DELIVER", eligibilityRequest);
        if (!eligibilityEvaluation.isEligible) {
            return InAppMessageDeliverResponse.of(request, "INELIGIBLE");
        }
        // present
        var presentRequest = InAppMessagePresentRequest.of(request, inAppMessage, user, eligibilityEvaluation, layoutEvaluation);
        var presentResponse = this.presentProcessor.process(presentRequest);
        return InAppMessageDeliverResponse.of(request, "PRESENT", presentResponse);
    };
    return InAppMessageDeliverProcessor;
}());

var InAppMessageSchedulerFactory = /** @class */ (function () {
    function InAppMessageSchedulerFactory(schedulers) {
        this.schedulers = schedulers;
    }
    InAppMessageSchedulerFactory.prototype.get = function (scheduleType) {
        return ObjectUtil.requiredNotNullOrUndefined(this.schedulers.find(function (scheduler) { return scheduler.supports(scheduleType); }), function () { return "Unsupported InAppMessageScheduleType[".concat(scheduleType, "]"); });
    };
    return InAppMessageSchedulerFactory;
}());

var InAppMessageScheduleResponse = /** @class */ (function () {
    function InAppMessageScheduleResponse(dispatchId, inAppMessageKey, code, deliverResponse, delay) {
        this.dispatchId = dispatchId;
        this.inAppMessageKey = inAppMessageKey;
        this.code = code;
        this.deliverResponse = deliverResponse;
        this.delay = delay;
    }
    /**
     * @override
     */
    InAppMessageScheduleResponse.prototype.toString = function () {
        return "InAppMessageScheduleResponse(dispatchId=".concat(this.dispatchId, ", inAppMessageKey=").concat(this.inAppMessageKey, ", code=").concat(this.code, ")");
    };
    InAppMessageScheduleResponse.of = function (request, code, deliverResponse, delay) {
        if (deliverResponse === void 0) { deliverResponse = null; }
        if (delay === void 0) { delay = null; }
        return new InAppMessageScheduleResponse(request.schedule.dispatchId, request.schedule.inAppMessageKey, code, deliverResponse, delay);
    };
    return InAppMessageScheduleResponse;
}());

var InAppMessageDeliverRequest = /** @class */ (function () {
    function InAppMessageDeliverRequest(dispatchId, inAppMessageKey, identifiers, requestedAt, reason, properties) {
        this.dispatchId = dispatchId;
        this.inAppMessageKey = inAppMessageKey;
        this.identifiers = identifiers;
        this.requestedAt = requestedAt;
        this.reason = reason;
        this.properties = properties;
    }
    InAppMessageDeliverRequest.of = function (request) {
        var builder = new PropertiesBuilder();
        var properties = builder.add("$trigger_event_insert_id", request.schedule.eventBasedContext.insertId).build();
        return new InAppMessageDeliverRequest(request.schedule.dispatchId, request.schedule.inAppMessageKey, request.schedule.identifiers, request.requestedAt, request.schedule.reason, ObjectUtil.fromMap(properties));
    };
    InAppMessageDeliverRequest.prototype.toString = function () {
        return "InAppMessageDeliverRequest(dispatchId=".concat(this.dispatchId, ", inAppMessageKey=").concat(this.inAppMessageKey, ", identifiers=").concat(this.identifiers, ", requestedAt=").concat(this.requestedAt, ", reason=").concat(this.reason);
    };
    return InAppMessageDeliverRequest;
}());

var AbstractInAppMessageScheduler = /** @class */ (function () {
    function AbstractInAppMessageScheduler() {
    }
    /**
     * @override
     */
    AbstractInAppMessageScheduler.prototype.schedule = function (action, request) {
        switch (action) {
            case "DELIVER":
                return this.deliver(request);
            case "DELAY":
                return this.delay(request);
            case "IGNORE":
                return this.ignore(request);
        }
    };
    return AbstractInAppMessageScheduler;
}());

var DelayedInAppMessageScheduler = /** @class */ (function (_super) {
    __extends(DelayedInAppMessageScheduler, _super);
    function DelayedInAppMessageScheduler(deliverProcessor, delayManager) {
        var _this = _super.call(this) || this;
        _this.deliverProcessor = deliverProcessor;
        _this.delayManager = delayManager;
        return _this;
    }
    /**
     * @override
     */
    DelayedInAppMessageScheduler.prototype.supports = function (scheduleType) {
        return scheduleType === "DELAYED";
    };
    /**
     * @override
     */
    DelayedInAppMessageScheduler.prototype.deliver = function (request) {
        var delay = this.delayManager.delete(request);
        ObjectUtil.requiredNotNullOrUndefined(delay, function () { return "InAppMessageDelay not found (inAppMessageKey=".concat(request.schedule.inAppMessageKey, ")"); });
        var deliverRequest = InAppMessageDeliverRequest.of(request);
        var deliverResponse = this.deliverProcessor.process(deliverRequest);
        return InAppMessageScheduleResponse.of(request, "DELIVER", deliverResponse);
    };
    /**
     * @override
     */
    DelayedInAppMessageScheduler.prototype.delay = function (request) {
        var delay = this.delayManager.delay(request);
        return InAppMessageScheduleResponse.of(request, "DELAY", null, delay);
    };
    /**
     * @override
     */
    DelayedInAppMessageScheduler.prototype.ignore = function (request) {
        var delay = this.delayManager.delete(request);
        return InAppMessageScheduleResponse.of(request, "IGNORE", null, delay);
    };
    return DelayedInAppMessageScheduler;
}(AbstractInAppMessageScheduler));

var TriggeredInAppMessageScheduler = /** @class */ (function (_super) {
    __extends(TriggeredInAppMessageScheduler, _super);
    function TriggeredInAppMessageScheduler(deliverProcessor, delayManager) {
        var _this = _super.call(this) || this;
        _this.deliverProcessor = deliverProcessor;
        _this.delayManager = delayManager;
        return _this;
    }
    /**
     * @override
     */
    TriggeredInAppMessageScheduler.prototype.supports = function (scheduleType) {
        return scheduleType === "TRIGGERED";
    };
    /**
     * @override
     */
    TriggeredInAppMessageScheduler.prototype.deliver = function (request) {
        var deliverRequest = InAppMessageDeliverRequest.of(request);
        var deliverResponse = this.deliverProcessor.process(deliverRequest);
        return InAppMessageScheduleResponse.of(request, "DELIVER", deliverResponse);
    };
    /**
     * @override
     */
    TriggeredInAppMessageScheduler.prototype.delay = function (request) {
        var delay = this.delayManager.registerAndDelay(request);
        return InAppMessageScheduleResponse.of(request, "DELAY", null, delay);
    };
    /**
     * @override
     */
    TriggeredInAppMessageScheduler.prototype.ignore = function (request) {
        return InAppMessageScheduleResponse.of(request, "IGNORE");
    };
    return TriggeredInAppMessageScheduler;
}(AbstractInAppMessageScheduler));

var InAppMessageScheduleProcessor = /** @class */ (function () {
    function InAppMessageScheduleProcessor(actionDeterminer, schedulerFactory) {
        this.actionDeterminer = actionDeterminer;
        this.schedulerFactory = schedulerFactory;
    }
    InAppMessageScheduleProcessor.prototype.process = function (request) {
        Logger.log.debug("InAppMessage Schedule Request: ".concat(request));
        var response = this.schedule(request);
        Logger.log.debug("InAppMessage Schedule Response: ".concat(response));
        return response;
    };
    InAppMessageScheduleProcessor.prototype.schedule = function (request) {
        try {
            var action = this.actionDeterminer.determine(request);
            var scheduler = this.schedulerFactory.get(request.scheduleType);
            return scheduler.schedule(action, request);
        }
        catch (e) {
            Logger.log.error("Failed to process InAppMessageSchedule: ".concat(e));
            return InAppMessageScheduleResponse.of(request, "EXCEPTION");
        }
    };
    InAppMessageScheduleProcessor.prototype.onSchedule = function (request) {
        this.process(request);
    };
    return InAppMessageScheduleProcessor;
}());

var InAppMessageScheduleActionDeterminer = /** @class */ (function () {
    function InAppMessageScheduleActionDeterminer() {
        /**
         * Deliver only requests made within the past 10 seconds
         */
        this.DELIVER_DURATION_THRESHOLD_MILLIS = -1 * 10 * 1000;
    }
    InAppMessageScheduleActionDeterminer.prototype.shouldIgnoreRequest = function (request) {
        if (request.scheduleType !== "STORED")
            return false;
        var delayMillis = request.delayMillis;
        return delayMillis < 0;
    };
    InAppMessageScheduleActionDeterminer.prototype.determineAction = function (request) {
        var delayMillis = request.delayMillis;
        if (delayMillis > 0) {
            return "DELAY";
        }
        if (delayMillis >= this.DELIVER_DURATION_THRESHOLD_MILLIS) {
            return "DELIVER";
        }
        if (delayMillis < this.DELIVER_DURATION_THRESHOLD_MILLIS) {
            return "IGNORE";
        }
        throw new Error("InAppMessageScheduleAction cannot be determined (key=".concat(request.schedule.inAppMessageKey, ")"));
    };
    InAppMessageScheduleActionDeterminer.prototype.determine = function (request) {
        if (this.shouldIgnoreRequest(request)) {
            return "IGNORE";
        }
        var action = this.determineAction(request);
        Logger.log.debug("InAppMessage ScheduleAction determined: action=".concat(action, ", dispatchId=").concat(request.schedule.dispatchId));
        return action;
    };
    return InAppMessageScheduleActionDeterminer;
}());

var InAppMessageTrigger = /** @class */ (function () {
    function InAppMessageTrigger(inAppMessage, reason, event) {
        this.inAppMessage = inAppMessage;
        this.reason = reason;
        this.event = event;
    }
    /**
     * @override
     */
    InAppMessageTrigger.prototype.toString = function () {
        return "InAppMessageTrigger(inAppMessage=".concat(this.inAppMessage.toString(), ", reason=").concat(this.reason, ", insertId=").concat(this.event.insertId, ", timestamp=").concat(this.event.timestamp, ", event=").concat(this.event.event.key, ")");
    };
    return InAppMessageTrigger;
}());

var InAppMessageTriggerDeterminer = /** @class */ (function () {
    function InAppMessageTriggerDeterminer(workspaceFetcher, eventMatcher, evaluateProcessor) {
        this.workspaceFetcher = workspaceFetcher;
        this.eventMatcher = eventMatcher;
        this.evaluateProcessor = evaluateProcessor;
    }
    InAppMessageTriggerDeterminer.prototype.determine = function (event) {
        var trackEvent = UserEvent.isTrackEvent(event) ? event : null;
        if (!trackEvent)
            return null;
        var workspace = this.workspaceFetcher.get();
        if (!workspace)
            return null;
        for (var _i = 0, _a = workspace.getInAppMessages(); _i < _a.length; _i++) {
            var inAppMessage = _a[_i];
            var matches = this.eventMatcher.matches(workspace, inAppMessage, trackEvent);
            if (!matches) {
                continue;
            }
            var evaluation = this.evaluate(workspace, inAppMessage, trackEvent);
            if (evaluation.isEligible) {
                return new InAppMessageTrigger(inAppMessage, evaluation.reason, trackEvent);
            }
        }
        return null;
    };
    InAppMessageTriggerDeterminer.prototype.evaluate = function (workspace, inAppMessage, event) {
        var request = new InAppMessageEligibilityRequest(workspace, event.user, inAppMessage, event.timestamp);
        return this.evaluateProcessor.process("TRIGGER", request);
    };
    return InAppMessageTriggerDeterminer;
}());

var InAppMessageTriggerHandler = /** @class */ (function () {
    function InAppMessageTriggerHandler(scheduleProcessor) {
        this.scheduleProcessor = scheduleProcessor;
    }
    InAppMessageTriggerHandler.prototype.handle = function (trigger) {
        var schedule = InAppMessageSchedule.create(trigger);
        var scheduleRequest = schedule.toRequest("TRIGGERED", trigger.event.timestamp);
        this.scheduleProcessor.process(scheduleRequest);
    };
    return InAppMessageTriggerHandler;
}());

var InAppMessageTriggerProcessor = /** @class */ (function () {
    function InAppMessageTriggerProcessor(determiner, handler) {
        this.determiner = determiner;
        this.handler = handler;
    }
    InAppMessageTriggerProcessor.prototype.process = function (event) {
        try {
            var trigger = this.determiner.determine(event);
            if (!trigger)
                return;
            Logger.log.debug("InAppMessage triggered: ".concat(trigger));
            this.handler.handle(trigger);
        }
        catch (e) {
            Logger.log.error("Failed to process InAppMessage event trigger: ".concat(e));
        }
    };
    return InAppMessageTriggerProcessor;
}());

var InAppMessageResetProcessor = /** @class */ (function () {
    function InAppMessageResetProcessor(identifierChecker, delayManager) {
        this.identifierChecker = identifierChecker;
        this.delayManager = delayManager;
    }
    InAppMessageResetProcessor.prototype.process = function (oldUser, newUser) {
        try {
            var isIdentifierChanged = this.identifierChecker.isIdentifierChanged(resolveIdentifiers(oldUser), resolveIdentifiers(newUser));
            if (isIdentifierChanged) {
                this.delayManager.cancelAll();
            }
        }
        catch (e) {
            Logger.log.error("Failed to reset InAppMessage: ".concat(e));
        }
    };
    return InAppMessageResetProcessor;
}());

var InAppMessageDelayLocalStorage = /** @class */ (function () {
    function InAppMessageDelayLocalStorage(storage) {
        this.storage = storage;
        this.storageKey = "iam-delay";
    }
    InAppMessageDelayLocalStorage.prototype.getDelayStorageItem = function () {
        var storageItem = this.storage.getItem(this.storageKey);
        if (ObjectUtil.isNullOrUndefined(storageItem))
            return null;
        try {
            return JSON.parse(storageItem);
        }
        catch (error) {
            Logger.log.warn("Failed to get delay storage item: ".concat(error));
            return null;
        }
    };
    InAppMessageDelayLocalStorage.prototype.get = function (inAppMessageKey, dispatchId) {
        var _a, _b;
        var delayStorageItem = this.getDelayStorageItem();
        if (ObjectUtil.isNullOrUndefined(delayStorageItem))
            return null;
        return (_b = (_a = delayStorageItem[inAppMessageKey]) === null || _a === void 0 ? void 0 : _a.find(function (delay) { return delay.schedule.dispatchId === dispatchId; })) !== null && _b !== void 0 ? _b : null;
    };
    InAppMessageDelayLocalStorage.prototype.set = function (inAppMessageKey, dispatchId, delay) {
        var _a;
        var _b;
        var prevItem = this.getDelayStorageItem();
        if (ObjectUtil.isNullOrUndefined(prevItem)) {
            Logger.log.debug("No delay storage item found. create new item");
            this.storage.setItem(this.storageKey, JSON.stringify((_a = {}, _a[inAppMessageKey] = [delay], _a)));
            return;
        }
        var targetEntities = (_b = prevItem[inAppMessageKey]) !== null && _b !== void 0 ? _b : [];
        targetEntities.push(delay);
        prevItem[inAppMessageKey] = targetEntities;
        this.storage.setItem(this.storageKey, JSON.stringify(prevItem));
    };
    InAppMessageDelayLocalStorage.prototype.remove = function (inAppMessageKey, dispatchId) {
        var prevItem = this.getDelayStorageItem();
        var targetEntities = prevItem === null || prevItem === void 0 ? void 0 : prevItem[inAppMessageKey];
        if (ObjectUtil.isNullOrUndefined(prevItem) || ObjectUtil.isNullOrUndefined(targetEntities)) {
            Logger.log.debug("No delay storage item found for ".concat(inAppMessageKey, ". do nothing"));
            return;
        }
        prevItem[inAppMessageKey] = targetEntities.filter(function (delay) { return delay.schedule.dispatchId !== dispatchId; });
        if (prevItem[inAppMessageKey].length === 0) {
            delete prevItem[inAppMessageKey];
        }
        this.storage.setItem(this.storageKey, JSON.stringify(prevItem));
    };
    InAppMessageDelayLocalStorage.prototype.values = function () {
        var delayStorageItem = this.getDelayStorageItem();
        if (ObjectUtil.isNullOrUndefined(delayStorageItem)) {
            Logger.log.debug("No delay storage item found. do nothing");
            return [];
        }
        return Object.values(delayStorageItem).flat();
    };
    InAppMessageDelayLocalStorage.prototype.clear = function () {
        this.storage.removeItem(this.storageKey);
    };
    return InAppMessageDelayLocalStorage;
}());

var UserEventFactory = /** @class */ (function () {
    function UserEventFactory(clock) {
        this.clock = clock;
    }
    UserEventFactory.prototype.create = function (request, evaluation) {
        var _this = this;
        var timestamp = this.clock.currentMillis();
        var events = new Array();
        var rootEvent = this.createEvent(request, evaluation, timestamp, {});
        if (rootEvent) {
            events.push(rootEvent);
        }
        evaluation.targetEvaluations.forEach(function (targetEvaluation) {
            var _a;
            var properties = (_a = {},
                _a[UserEventFactory.ROOT_TYPE] = request.key.type,
                _a[UserEventFactory.ROOT_ID] = request.key.id,
                _a);
            var targetEvent = _this.createEvent(request, targetEvaluation, timestamp, properties);
            if (targetEvent) {
                events.push(targetEvent);
            }
        });
        return events;
    };
    UserEventFactory.prototype.createEvent = function (request, evaluation, timestamp, properties) {
        var _a;
        if (evaluation instanceof ExperimentEvaluation) {
            properties[UserEventFactory.CONFIG_ID_PROPERTY_KEY] = (_a = evaluation.config) === null || _a === void 0 ? void 0 : _a.id;
            properties[UserEventFactory.EXPERIMENT_VERSION_KEY] = evaluation.experiment.version;
            properties[UserEventFactory.EXECUTION_VERSION_KEY] = evaluation.experiment.executionVersion;
            return UserEvent.exposure(request.user, evaluation, properties, timestamp);
        }
        if (evaluation instanceof RemoteConfigEvaluation) {
            return UserEvent.remoteConfig(request.user, evaluation, __assign(__assign({}, properties), evaluation.properties), timestamp);
        }
        return null;
    };
    UserEventFactory.ROOT_TYPE = "$targetingRootType";
    UserEventFactory.ROOT_ID = "$targetingRootId";
    UserEventFactory.CONFIG_ID_PROPERTY_KEY = "$parameterConfigurationId";
    UserEventFactory.EXPERIMENT_VERSION_KEY = "$experiment_version";
    UserEventFactory.EXECUTION_VERSION_KEY = "$execution_version";
    return UserEventFactory;
}());

var EvaluationEventRecorder = /** @class */ (function () {
    function EvaluationEventRecorder(eventFactory, eventProcessor) {
        this.eventFactory = eventFactory;
        this.eventProcessor = eventProcessor;
    }
    EvaluationEventRecorder.prototype.record = function (request, evaluation) {
        var _this = this;
        var events = this.eventFactory.create(request, evaluation);
        events.forEach(function (event) {
            _this.eventProcessor.process(event);
        });
    };
    return EvaluationEventRecorder;
}());

var InAppMessageEligibilityEvaluation = /** @class */ (function () {
    function InAppMessageEligibilityEvaluation(reason, targetEvaluations, inAppMessage, isEligible, layoutEvaluation) {
        this.reason = reason;
        this.targetEvaluations = targetEvaluations;
        this.inAppMessage = inAppMessage;
        this.isEligible = isEligible;
        this.layoutEvaluation = layoutEvaluation;
    }
    InAppMessageEligibilityEvaluation.eligible = function (request, context, reason) {
        return InAppMessageEligibilityEvaluation.of(request, context, reason, true);
    };
    InAppMessageEligibilityEvaluation.ineligible = function (request, context, reason) {
        return InAppMessageEligibilityEvaluation.of(request, context, reason, false);
    };
    InAppMessageEligibilityEvaluation.of = function (request, context, reason, isEligible) {
        return new InAppMessageEligibilityEvaluation(String(reason), context.targetEvaluations, request.inAppMessage, isEligible, context.get(InAppMessageLayoutEvaluation));
    };
    return InAppMessageEligibilityEvaluation;
}());

var PlatformInAppMessageEligibilityFlowEvaluator = /** @class */ (function () {
    function PlatformInAppMessageEligibilityFlowEvaluator() {
    }
    PlatformInAppMessageEligibilityFlowEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        var isWebPlatform = request.inAppMessage.supports("WEB");
        if (!isWebPlatform) {
            return InAppMessageEligibilityEvaluation.ineligible(request, context, DecisionReason.UNSUPPORTED_PLATFORM);
        }
        return nextFlow.evaluate(request, context);
    };
    return PlatformInAppMessageEligibilityFlowEvaluator;
}());
var OverrideInAppMessageEligibilityFlowEvaluator = /** @class */ (function () {
    function OverrideInAppMessageEligibilityFlowEvaluator(userOverrideMatcher) {
        this.userOverrideMatcher = userOverrideMatcher;
    }
    OverrideInAppMessageEligibilityFlowEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        var isOverrideMatched = this.userOverrideMatcher.matches(request, context);
        if (isOverrideMatched) {
            return InAppMessageEligibilityEvaluation.eligible(request, context, DecisionReason.OVERRIDDEN);
        }
        return nextFlow.evaluate(request, context);
    };
    return OverrideInAppMessageEligibilityFlowEvaluator;
}());
var DraftInAppMessageEligibilityFlowEvaluator = /** @class */ (function () {
    function DraftInAppMessageEligibilityFlowEvaluator() {
    }
    DraftInAppMessageEligibilityFlowEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        var isDraft = request.inAppMessage.status === "DRAFT";
        if (isDraft) {
            return InAppMessageEligibilityEvaluation.ineligible(request, context, DecisionReason.IN_APP_MESSAGE_DRAFT);
        }
        return nextFlow.evaluate(request, context);
    };
    return DraftInAppMessageEligibilityFlowEvaluator;
}());
var PauseInAppMessageEligibilityFlowEvaluator = /** @class */ (function () {
    function PauseInAppMessageEligibilityFlowEvaluator() {
    }
    PauseInAppMessageEligibilityFlowEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        var isPause = request.inAppMessage.status === "PAUSE";
        if (isPause) {
            return InAppMessageEligibilityEvaluation.ineligible(request, context, DecisionReason.IN_APP_MESSAGE_PAUSED);
        }
        return nextFlow.evaluate(request, context);
    };
    return PauseInAppMessageEligibilityFlowEvaluator;
}());
var PeriodInAppMessageEligibilityFlowEvaluator = /** @class */ (function () {
    function PeriodInAppMessageEligibilityFlowEvaluator() {
    }
    PeriodInAppMessageEligibilityFlowEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        var isWithinPeriod = request.inAppMessage.period.within(request.timestamp);
        if (!isWithinPeriod) {
            return InAppMessageEligibilityEvaluation.ineligible(request, context, DecisionReason.NOT_IN_IN_APP_MESSAGE_PERIOD);
        }
        return nextFlow.evaluate(request, context);
    };
    return PeriodInAppMessageEligibilityFlowEvaluator;
}());
var TimetableInAppMessageEligibilityFlowEvaluator = /** @class */ (function () {
    function TimetableInAppMessageEligibilityFlowEvaluator() {
    }
    TimetableInAppMessageEligibilityFlowEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        var isWithinTimetable = request.inAppMessage.timetable.within(request.timestamp);
        if (!isWithinTimetable) {
            return InAppMessageEligibilityEvaluation.ineligible(request, context, DecisionReason.NOT_IN_IN_APP_MESSAGE_TIMETABLE);
        }
        return nextFlow.evaluate(request, context);
    };
    return TimetableInAppMessageEligibilityFlowEvaluator;
}());
var HiddenInAppMessageEligibilityFlowEvaluator = /** @class */ (function () {
    function HiddenInAppMessageEligibilityFlowEvaluator(hiddenMatcher) {
        this.hiddenMatcher = hiddenMatcher;
    }
    HiddenInAppMessageEligibilityFlowEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        var isHidden = this.hiddenMatcher.matches(request, context);
        if (isHidden) {
            return InAppMessageEligibilityEvaluation.ineligible(request, context, DecisionReason.IN_APP_MESSAGE_HIDDEN);
        }
        return nextFlow.evaluate(request, context);
    };
    return HiddenInAppMessageEligibilityFlowEvaluator;
}());
var TargetInAppMessageEligibilityFlowEvaluator = /** @class */ (function () {
    function TargetInAppMessageEligibilityFlowEvaluator(targetMatcher) {
        this.targetMatcher = targetMatcher;
    }
    TargetInAppMessageEligibilityFlowEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        var isTargetMatched = this.targetMatcher.matches(request, context);
        if (!isTargetMatched) {
            return InAppMessageEligibilityEvaluation.ineligible(request, context, DecisionReason.NOT_IN_IN_APP_MESSAGE_TARGET);
        }
        return nextFlow.evaluate(request, context);
    };
    return TargetInAppMessageEligibilityFlowEvaluator;
}());
var FrequencyInAppMessageEligibilityFlowEvaluator = /** @class */ (function () {
    function FrequencyInAppMessageEligibilityFlowEvaluator(frequencyCapMatcher) {
        this.frequencyCapMatcher = frequencyCapMatcher;
    }
    FrequencyInAppMessageEligibilityFlowEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        var isFrequencyCapped = this.frequencyCapMatcher.matches(request, context);
        if (isFrequencyCapped) {
            return InAppMessageEligibilityEvaluation.ineligible(request, context, DecisionReason.IN_APP_MESSAGE_FREQUENCY_CAPPED);
        }
        return nextFlow.evaluate(request, context);
    };
    return FrequencyInAppMessageEligibilityFlowEvaluator;
}());
var EligibleInAppMessageEligibilityFlowEvaluator = /** @class */ (function () {
    function EligibleInAppMessageEligibilityFlowEvaluator() {
    }
    EligibleInAppMessageEligibilityFlowEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        return InAppMessageEligibilityEvaluation.eligible(request, context, DecisionReason.IN_APP_MESSAGE_TARGET);
    };
    return EligibleInAppMessageEligibilityFlowEvaluator;
}());
var LayoutResolveInAppMessageEligibilityFlowEvaluator = /** @class */ (function () {
    function LayoutResolveInAppMessageEligibilityFlowEvaluator(layoutEvaluator) {
        this.layoutEvaluator = layoutEvaluator;
    }
    LayoutResolveInAppMessageEligibilityFlowEvaluator.prototype.evaluate = function (request, context, nextFlow) {
        var layoutRequest = InAppMessageLayoutRequest.of(request);
        var layoutEvaluation = this.layoutEvaluator.evaluate(layoutRequest, EvaluatorContext.create());
        context.set(InAppMessageLayoutEvaluation, layoutEvaluation);
        return nextFlow.evaluate(request, context);
    };
    return LayoutResolveInAppMessageEligibilityFlowEvaluator;
}());

var UserOverrideInAppMessageMatcher = /** @class */ (function () {
    function UserOverrideInAppMessageMatcher() {
    }
    UserOverrideInAppMessageMatcher.prototype.matches = function (request, context) {
        var _this = this;
        return request.inAppMessage.targetContext.overrides.some(function (it) { return _this.isUserOverridden(request, it); });
    };
    UserOverrideInAppMessageMatcher.prototype.isUserOverridden = function (request, userOverride) {
        var identifier = request.user.identifiers[userOverride.identifierType];
        if (ObjectUtil.isNullOrUndefined(identifier)) {
            return false;
        }
        return userOverride.identifiers.includes(identifier);
    };
    return UserOverrideInAppMessageMatcher;
}());
var TargetInAppMessageMatcher = /** @class */ (function () {
    function TargetInAppMessageMatcher(targetMatcher) {
        this.targetMatcher = targetMatcher;
    }
    TargetInAppMessageMatcher.prototype.matches = function (request, context) {
        var _this = this;
        var targets = request.inAppMessage.targetContext.targets;
        if (targets.length === 0) {
            return true;
        }
        return targets.some(function (it) { return _this.targetMatcher.matches(request, context, it); });
    };
    return TargetInAppMessageMatcher;
}());
var HiddenInAppMessageMatcher = /** @class */ (function () {
    function HiddenInAppMessageMatcher(storage) {
        this.storage = storage;
    }
    HiddenInAppMessageMatcher.prototype.matches = function (request, context) {
        return this.storage.exist(request.inAppMessage, request.timestamp);
    };
    return HiddenInAppMessageMatcher;
}());
var InAppMessageFrequencyCapMatcher = /** @class */ (function () {
    function InAppMessageFrequencyCapMatcher(storage) {
        this.storage = storage;
    }
    InAppMessageFrequencyCapMatcher.prototype.matches = function (request, context) {
        var inAppMessage = request.inAppMessage, user = request.user, timestamp = request.timestamp;
        return this.isFrequencyCapped(inAppMessage, user, timestamp);
    };
    InAppMessageFrequencyCapMatcher.prototype.isFrequencyCapped = function (inAppMessage, user, timestamp) {
        if (!inAppMessage.eventTrigger.frequencyCap) {
            return false;
        }
        var contexts = this.createMatchContexts(inAppMessage.eventTrigger.frequencyCap);
        if (contexts.length === 0) {
            return false;
        }
        var impressions = this.storage.get(inAppMessage);
        for (var _i = 0, impressions_1 = impressions; _i < impressions_1.length; _i++) {
            var impression = impressions_1[_i];
            for (var _a = 0, contexts_1 = contexts; _a < contexts_1.length; _a++) {
                var context = contexts_1[_a];
                if (context.matches(user, timestamp, impression)) {
                    return true;
                }
            }
        }
        return false;
    };
    InAppMessageFrequencyCapMatcher.prototype.createMatchContexts = function (frequencyCap) {
        var contexts = [];
        for (var _i = 0, _a = frequencyCap.identifierCaps; _i < _a.length; _i++) {
            var identifierCap = _a[_i];
            contexts.push(new MatchContext(new IdentifierCapPredicate(identifierCap)));
        }
        if (frequencyCap.durationCap) {
            contexts.push(new MatchContext(new DurationCapPredicate(frequencyCap.durationCap)));
        }
        return contexts;
    };
    return InAppMessageFrequencyCapMatcher;
}());
var MatchContext = /** @class */ (function () {
    function MatchContext(predicate) {
        this.matchCount = 0;
        this.predicate = predicate;
    }
    MatchContext.prototype.matches = function (user, timestamp, impression) {
        if (this.predicate.matches(user, timestamp, impression)) {
            this.matchCount += 1;
        }
        return this.matchCount >= this.predicate.thresholdCount;
    };
    return MatchContext;
}());
var IdentifierCapPredicate = /** @class */ (function () {
    function IdentifierCapPredicate(identifierCap) {
        this.identifierCap = identifierCap;
    }
    Object.defineProperty(IdentifierCapPredicate.prototype, "thresholdCount", {
        get: function () {
            return this.identifierCap.count;
        },
        enumerable: false,
        configurable: true
    });
    IdentifierCapPredicate.prototype.matches = function (user, _timestamp, impression) {
        var userIdentifier = user.identifiers[this.identifierCap.identifierType];
        if (ObjectUtil.isNullOrUndefined(userIdentifier))
            return false;
        var impressionIdentifier = impression.identifiers[this.identifierCap.identifierType];
        if (ObjectUtil.isNullOrUndefined(impressionIdentifier))
            return false;
        return userIdentifier === impressionIdentifier;
    };
    return IdentifierCapPredicate;
}());
var DurationCapPredicate = /** @class */ (function () {
    function DurationCapPredicate(durationCap) {
        this.durationCap = durationCap;
    }
    Object.defineProperty(DurationCapPredicate.prototype, "thresholdCount", {
        get: function () {
            return this.durationCap.count;
        },
        enumerable: false,
        configurable: true
    });
    DurationCapPredicate.prototype.matches = function (_user, timestamp, impression) {
        return timestamp - impression.timestamp <= this.durationCap.durationMillis;
    };
    return DurationCapPredicate;
}());

var InAppMessageEligibilityFlowFactory = /** @class */ (function () {
    function InAppMessageEligibilityFlowFactory(inAppMessageHiddenStorage, inAppMessageImpressionStorage, layoutEvaluator) {
        this.layoutEvaluator = layoutEvaluator;
        var targetMatcher = HackleCoreContext.get("targetMatcher");
        var evaluateFlow = [
            new PlatformInAppMessageEligibilityFlowEvaluator(),
            new OverrideInAppMessageEligibilityFlowEvaluator(new UserOverrideInAppMessageMatcher()),
            new DraftInAppMessageEligibilityFlowEvaluator(),
            new PauseInAppMessageEligibilityFlowEvaluator(),
            new PeriodInAppMessageEligibilityFlowEvaluator(),
            new TimetableInAppMessageEligibilityFlowEvaluator(),
            new TargetInAppMessageEligibilityFlowEvaluator(new TargetInAppMessageMatcher(targetMatcher))
        ];
        var layoutFlow = [new LayoutResolveInAppMessageEligibilityFlowEvaluator(this.layoutEvaluator)];
        var deduplicateFlow = [
            new FrequencyInAppMessageEligibilityFlowEvaluator(new InAppMessageFrequencyCapMatcher(inAppMessageImpressionStorage)),
            new HiddenInAppMessageEligibilityFlowEvaluator(new HiddenInAppMessageMatcher(inAppMessageHiddenStorage))
        ];
        var eligibleFlow = [new EligibleInAppMessageEligibilityFlowEvaluator()];
        this.triggerFlow = EvaluationFlow.of.apply(EvaluationFlow, __spreadArray(__spreadArray(__spreadArray(__spreadArray([], evaluateFlow, false), layoutFlow, false), deduplicateFlow, false), eligibleFlow, false));
        this.deliverFlow = EvaluationFlow.of.apply(EvaluationFlow, __spreadArray(__spreadArray([], deduplicateFlow, false), eligibleFlow, false));
        this.deliverReEvaluateFlow = EvaluationFlow.of.apply(EvaluationFlow, __spreadArray(__spreadArray(__spreadArray([], evaluateFlow, false), deduplicateFlow, false), eligibleFlow, false));
    }
    InAppMessageEligibilityFlowFactory.prototype.getTriggerFlow = function () {
        return this.triggerFlow;
    };
    InAppMessageEligibilityFlowFactory.prototype.getDeliverFlow = function (reEvaluate) {
        return reEvaluate ? this.deliverReEvaluateFlow : this.deliverFlow;
    };
    return InAppMessageEligibilityFlowFactory;
}());

var InAppMessageEligibilityEvaluator = /** @class */ (function (_super) {
    __extends(InAppMessageEligibilityEvaluator, _super);
    function InAppMessageEligibilityEvaluator(evaluationFlow, eventRecorder) {
        var _this = _super.call(this) || this;
        _this.evaluationFlow = evaluationFlow;
        _this.eventRecorder = eventRecorder;
        return _this;
    }
    /**
     * @override
     */
    InAppMessageEligibilityEvaluator.prototype.supports = function (request) {
        return request.inAppMessage !== undefined;
    };
    /**
     * @override
     */
    InAppMessageEligibilityEvaluator.prototype.evaluateInternal = function (request, context) {
        var _a;
        return ((_a = this.evaluationFlow.evaluate(request, context)) !== null && _a !== void 0 ? _a : InAppMessageEligibilityEvaluation.ineligible(request, context, DecisionReason.NOT_IN_IN_APP_MESSAGE_TARGET));
    };
    /**
     * @override
     */
    InAppMessageEligibilityEvaluator.prototype.record = function (request, evaluation) {
        this.eventRecorder.record(request, evaluation);
        // evaluation which is ineligible with nonnullable layout evaluation means that message is deduplicated or hidden.
        // for preventing imbalance, we should record layout evaluation tracking exposure event.
        if (!evaluation.isEligible && evaluation.layoutEvaluation !== null) {
            this.eventRecorder.record(evaluation.layoutEvaluation.request, evaluation.layoutEvaluation);
        }
    };
    return InAppMessageEligibilityEvaluator;
}(InAppMessageEvaluator));

var InAppMessageEvaluateProcessor = /** @class */ (function () {
    function InAppMessageEvaluateProcessor(core, flowFactory, eventRecorder) {
        this.core = core;
        this.flowFactory = flowFactory;
        this.eventRecorder = eventRecorder;
    }
    InAppMessageEvaluateProcessor.prototype.process = function (type, request) {
        var flow = this.resolveFlow(type, request);
        var evaluator = new InAppMessageEligibilityEvaluator(flow, this.eventRecorder);
        return this.core.inAppMessage(request, EvaluatorContext.create(), evaluator);
    };
    InAppMessageEvaluateProcessor.prototype.resolveFlow = function (type, request) {
        var _a, _b;
        return type === "TRIGGER"
            ? this.flowFactory.getTriggerFlow()
            : this.flowFactory.getDeliverFlow((_b = (_a = request.inAppMessage.evaluateContext) === null || _a === void 0 ? void 0 : _a.atDeliverTime) !== null && _b !== void 0 ? _b : false);
    };
    return InAppMessageEvaluateProcessor;
}());

var InAppMessageLayoutResolver = /** @class */ (function () {
    function InAppMessageLayoutResolver(core, layoutEvaluator) {
        this.core = core;
        this.layoutEvaluator = layoutEvaluator;
    }
    InAppMessageLayoutResolver.prototype.resolve = function (workspace, inAppMessage, user) {
        var request = new InAppMessageLayoutRequest(workspace, user, inAppMessage);
        return this.core.inAppMessage(request, EvaluatorContext.create(), this.layoutEvaluator);
    };
    return InAppMessageLayoutResolver;
}());

var StoredInAppMessageScheduler = /** @class */ (function (_super) {
    __extends(StoredInAppMessageScheduler, _super);
    function StoredInAppMessageScheduler(deliverProcessor, delayManager) {
        var _this = _super.call(this) || this;
        _this.deliverProcessor = deliverProcessor;
        _this.delayManager = delayManager;
        return _this;
    }
    /**
     * @override
     */
    StoredInAppMessageScheduler.prototype.supports = function (scheduleType) {
        return scheduleType === "STORED";
    };
    /**
     * @override
     */
    StoredInAppMessageScheduler.prototype.deliver = function (request) {
        var delay = this.delayManager.delete(request);
        ObjectUtil.requiredNotNullOrUndefined(delay, function () { return "InAppMessageDelay not found (inAppMessageKey=".concat(request.schedule.inAppMessageKey, ")"); });
        var deliverRequest = InAppMessageDeliverRequest.of(request);
        var deliverResponse = this.deliverProcessor.process(deliverRequest);
        return InAppMessageScheduleResponse.of(request, "DELIVER", deliverResponse, delay);
    };
    /**
     * @override
     */
    StoredInAppMessageScheduler.prototype.delay = function (request) {
        var delay = this.delayManager.delay(request);
        Logger.log.debug("StoredDelay is scheduled (inAppMessageKey=".concat(request.schedule.inAppMessageKey, ", delayMillis=").concat(request.delayMillis.toLocaleString(), ")"));
        return InAppMessageScheduleResponse.of(request, "DELAY", null, delay);
    };
    /**
     * @override
     */
    StoredInAppMessageScheduler.prototype.ignore = function (request) {
        var delay = this.delayManager.delete(request);
        return InAppMessageScheduleResponse.of(request, "IGNORE", null, delay);
    };
    return StoredInAppMessageScheduler;
}(AbstractInAppMessageScheduler));

var SessionUserDecorator = /** @class */ (function () {
    function SessionUserDecorator(sessionManager) {
        this.sessionManager = sessionManager;
    }
    SessionUserDecorator.prototype.decorate = function (user) {
        if (user.identifiers[IdentifierType.SESSION])
            return user;
        var sessionId = this.sessionManager.currentSessionId;
        if (ObjectUtil.isNullOrUndefined(sessionId))
            return user;
        var identifiers = new IdentifiersBuilder()
            .addIdentifiers(user.identifiers)
            .add(IdentifierType.SESSION, sessionId)
            .build();
        return __assign(__assign({}, user), { identifiers: identifiers });
    };
    return SessionUserDecorator;
}());

var SessionUserEventDecorator = /** @class */ (function () {
    function SessionUserEventDecorator(sessionUserDecorator) {
        this.sessionUserDecorator = sessionUserDecorator;
    }
    SessionUserEventDecorator.prototype.decorate = function (event) {
        var user = this.sessionUserDecorator.decorate(event.user);
        return event.copyWithUser(user);
    };
    return SessionUserEventDecorator;
}());

var HackleAppPageListener = /** @class */ (function () {
    function HackleAppPageListener(invocationProcessor, browserPropertyProvider) {
        this.invocationProcessor = invocationProcessor;
        this.browserPropertyProvider = browserPropertyProvider;
    }
    HackleAppPageListener.prototype.onPageStarted = function (page, _timestamp) {
        this.track(page, _timestamp);
    };
    HackleAppPageListener.prototype.onPageEnded = function (_page, _timestamp) {
        // do nothing
    };
    HackleAppPageListener.prototype.track = function (page, _timestamp) {
        var _a;
        var event = {
            key: PageEventTracker.PAGE_VIEW_EVENT_KEY,
            properties: (_a = {},
                _a[PageEventTracker.PAGE_NAME_PROPERTY_KEY] = page.pageTitle,
                _a)
        };
        var invocation = {
            command: "track",
            parameters: {
                event: event,
                /**
                 * @description use app side user instead of web side user.
                 */
                user: undefined
            },
            browserProperties: this.browserPropertyProvider.getBrowserProperties(page)
        };
        this.invocationProcessor.process(invocation);
    };
    return HackleAppPageListener;
}());

var AbstractHackleWebAppClientFactory = /** @class */ (function () {
    function AbstractHackleWebAppClientFactory(sdkKey, config, invocationProcessor, browserPropertyProvider, lifecycleCompositeManager) {
        this.sdkKey = sdkKey;
        this.config = config;
        this.invocationProcessor = invocationProcessor;
        this.browserPropertyProvider = browserPropertyProvider;
        this.lifecycleCompositeManager = lifecycleCompositeManager;
    }
    return AbstractHackleWebAppClientFactory;
}());

var DEFAULT_CONFIG = {
    automaticScreenTracking: false,
    automaticEngagementTracking: false
};
var log$1 = Logger.log;
var HackleWebViewConfigurations = /** @class */ (function () {
    function HackleWebViewConfigurations(configResolver) {
        this.configResolver = configResolver;
    }
    HackleWebViewConfigurations.prototype.config = function () {
        var webAppConfig = this.configResolver.resolve();
        return __assign(__assign({}, DEFAULT_CONFIG), webAppConfig);
    };
    return HackleWebViewConfigurations;
}());
var HackleWebViewConfigurationResolver = /** @class */ (function () {
    function HackleWebViewConfigurationResolver(hackleApp) {
        this.hackleApp = hackleApp;
    }
    HackleWebViewConfigurationResolver.prototype.supports = function (hackleApp) {
        return "getWebViewConfig" in hackleApp && ObjectUtil.isNotNullOrUndefined(hackleApp.getWebViewConfig);
    };
    HackleWebViewConfigurationResolver.prototype.resolveAutomaticEngagementTracking = function (parsedConfig) {
        if (typeof parsedConfig.automaticEngagementTracking !== "boolean") {
            return DEFAULT_CONFIG.automaticEngagementTracking;
        }
        return parsedConfig.automaticEngagementTracking;
    };
    HackleWebViewConfigurationResolver.prototype.resolveAutomaticScreenTracking = function (parsedConfig) {
        if (typeof parsedConfig.automaticScreenTracking !== "boolean") {
            return DEFAULT_CONFIG.automaticScreenTracking;
        }
        return parsedConfig.automaticScreenTracking;
    };
    HackleWebViewConfigurationResolver.prototype.resolve = function () {
        try {
            if (!this.supports(this.hackleApp))
                return DEFAULT_CONFIG;
            var serializedConfig = this.hackleApp.getWebViewConfig();
            var parsedConfig = JSON.parse(serializedConfig);
            return {
                automaticEngagementTracking: this.resolveAutomaticEngagementTracking(parsedConfig),
                automaticScreenTracking: this.resolveAutomaticScreenTracking(parsedConfig)
            };
        }
        catch (err) {
            log$1.warn("Failed to resolve web view config: ".concat(err));
            return DEFAULT_CONFIG;
        }
    };
    return HackleWebViewConfigurationResolver;
}());

var HackleAppEngagementListener = /** @class */ (function () {
    function HackleAppEngagementListener(invocationProcessor, browserPropertyProvider) {
        this.invocationProcessor = invocationProcessor;
        this.browserPropertyProvider = browserPropertyProvider;
    }
    HackleAppEngagementListener.prototype.onEngagement = function (engagement, timestamp) {
        this.track(engagement, timestamp);
    };
    HackleAppEngagementListener.prototype.track = function (engagement, _timestamp) {
        var _a;
        var event = {
            key: HackleAppEngagementListener.ENGAGEMENT_EVENT_KEY,
            properties: (_a = {},
                _a[PageEventTracker.PAGE_NAME_PROPERTY_KEY] = engagement.page.pageTitle,
                _a[HackleAppEngagementListener.ENGAGEMENT_TIME_PROPERTY_KEY] = engagement.durationMillis,
                _a)
        };
        var invocation = {
            command: "track",
            parameters: {
                event: event,
                /**
                 * @description use app side user instead of web side user.
                 */
                user: undefined
            },
            browserProperties: this.browserPropertyProvider.getBrowserProperties(engagement.page)
        };
        this.invocationProcessor.process(invocation);
    };
    HackleAppEngagementListener.ENGAGEMENT_EVENT_KEY = "$engagement";
    HackleAppEngagementListener.ENGAGEMENT_TIME_PROPERTY_KEY = "$engagement_time_ms";
    return HackleAppEngagementListener;
}());

var LifecycleCompositeManager = /** @class */ (function () {
    function LifecycleCompositeManager(lifecycleManager, pageManager, engagementManager, browserName) {
        this.lifecycleManager = lifecycleManager;
        this.pageManager = pageManager;
        this.engagementManager = engagementManager;
        this.lifecycleManager = lifecycleManager;
        this.pageManager = pageManager;
        this.engagementManager = engagementManager;
        /**
         * Composite Lifecycle, Engagement and Page
         */
        this.install(typeof browserName === "string" ? browserName : null);
    }
    LifecycleCompositeManager.prototype.addPageListener = function (listener) {
        this.pageManager.addListener(listener);
    };
    LifecycleCompositeManager.prototype.addEngagementListener = function (listener) {
        this.engagementManager.addListener(listener);
    };
    LifecycleCompositeManager.prototype.addLifecycleListener = function (listener) {
        this.lifecycleManager.addListener(listener);
    };
    LifecycleCompositeManager.prototype.initialize = function () {
        this.lifecycleManager.initialize();
    };
    LifecycleCompositeManager.prototype.install = function (browserName) {
        this.pageManager.addListener(this.engagementManager);
        this.lifecycleManager.addListener(this.pageManager);
        this.lifecycleManager.addListener(this.engagementManager);
        this.lifecycleManager.install(browserName);
    };
    return LifecycleCompositeManager;
}());

var HackleSubscriptionOperationsBuilder = /** @class */ (function () {
    function HackleSubscriptionOperationsBuilder() {
        this.operations = new Map();
    }
    HackleSubscriptionOperationsBuilder.prototype.marketing = function (value) {
        this.operations.set("$marketing", value);
        return this;
    };
    HackleSubscriptionOperationsBuilder.prototype.information = function (value) {
        this.operations.set("$information", value);
        return this;
    };
    HackleSubscriptionOperationsBuilder.prototype.custom = function (key, value) {
        this.operations.set(key, value);
        return this;
    };
    HackleSubscriptionOperationsBuilder.prototype.build = function () {
        return new HackleSubscriptionOperations(this.operations);
    };
    return HackleSubscriptionOperationsBuilder;
}());
var HackleSubscriptionOperations = /** @class */ (function () {
    function HackleSubscriptionOperations(operations) {
        this.operations = operations;
    }
    HackleSubscriptionOperations.prototype.toEvent = function (key) {
        var propertyOperationsBuilder = new PropertyOperationsBuilder();
        this.operations.forEach(function (status, key) {
            propertyOperationsBuilder.set(key, status);
        });
        return {
            key: key,
            properties: ObjectUtil.fromMap(this.operations),
        };
    };
    HackleSubscriptionOperations.prototype.toRecord = function () {
        var object = {};
        this.operations.forEach(function (status, key) {
            object[key] = status;
        });
        return object;
    };
    return HackleSubscriptionOperations;
}());

var HackleSubscriptionStatus;
(function (HackleSubscriptionStatus) {
    HackleSubscriptionStatus["SUBSCRIBED"] = "SUBSCRIBED";
    HackleSubscriptionStatus["UNSUBSCRIBED"] = "UNSUBSCRIBED";
    HackleSubscriptionStatus["UNKNOWN"] = "UNKNOWN";
})(HackleSubscriptionStatus || (HackleSubscriptionStatus = {}));

/**
 * @exports WebViewLifecycleCompositeManager, a composite manager for web view lifecycle only.
 */
var WebViewLifecycleCompositeManager = /** @class */ (function () {
    function WebViewLifecycleCompositeManager(browserName, engagementDurationMillis) {
        if (engagementDurationMillis === void 0) { engagementDurationMillis = DEFAULT_ENGAGEMENT_DURATION_MILLIS; }
        var lifecycleManager = new LifecycleManager();
        var pageManager = new PageManager();
        var engagementManager = new EngagementManager(pageManager, engagementDurationMillis);
        this.compositeManager = new LifecycleCompositeManager(lifecycleManager, pageManager, engagementManager, browserName);
    }
    WebViewLifecycleCompositeManager.prototype.addPageListener = function (listener) {
        this.compositeManager.addPageListener(listener);
    };
    WebViewLifecycleCompositeManager.prototype.addEngagementListener = function (listener) {
        this.compositeManager.addEngagementListener(listener);
    };
    WebViewLifecycleCompositeManager.prototype.addLifecycleListener = function (listener) {
        this.compositeManager.addLifecycleListener(listener);
    };
    WebViewLifecycleCompositeManager.prototype.initialize = function () {
        this.compositeManager.initialize();
    };
    return WebViewLifecycleCompositeManager;
}());

var log = Logger.log;
var hackleClientCache = null;
var NativeAppClientFactory = /** @class */ (function (_super) {
    __extends(NativeAppClientFactory, _super);
    function NativeAppClientFactory(sdkKey, config, invocationProcessor, browserPropertyProvider, lifecycleCompositeManager) {
        return _super.call(this, sdkKey, config, invocationProcessor, browserPropertyProvider, lifecycleCompositeManager) || this;
    }
    NativeAppClientFactory.prototype.create = function (webViewConfig) {
        var client = new NativeAppHackleClient(this.invocationProcessor, this.browserPropertyProvider);
        this.initialize(webViewConfig);
        return client;
    };
    NativeAppClientFactory.prototype.initialize = function (webViewConfig) {
        if (webViewConfig.automaticScreenTracking) {
            this.lifecycleCompositeManager.addPageListener(new HackleAppPageListener(this.invocationProcessor, this.browserPropertyProvider));
        }
        if (webViewConfig.automaticEngagementTracking) {
            this.lifecycleCompositeManager.addEngagementListener(new HackleAppEngagementListener(this.invocationProcessor, this.browserPropertyProvider));
        }
        this.lifecycleCompositeManager.initialize();
    };
    return NativeAppClientFactory;
}(AbstractHackleWebAppClientFactory));
var WebViewClientFactory = /** @class */ (function (_super) {
    __extends(WebViewClientFactory, _super);
    function WebViewClientFactory(sdkKey, config, invocationProcessor, browserPropertyProvider, lifecycleCompositeManager) {
        return _super.call(this, sdkKey, config, invocationProcessor, browserPropertyProvider, lifecycleCompositeManager) || this;
    }
    WebViewClientFactory.prototype.create = function (_webViewConfig) {
        var browserClient = createBrowserClient(this.sdkKey, this.config, this.lifecycleCompositeManager);
        var nativeAppClient = new NativeAppHackleClient(this.invocationProcessor, this.browserPropertyProvider);
        var client = new WebViewHackleClient(browserClient, nativeAppClient);
        this.initialize(client);
        return client;
    };
    WebViewClientFactory.prototype.initialize = function (client) {
        client.syncUser();
    };
    return WebViewClientFactory;
}(AbstractHackleWebAppClientFactory));
var WebAppClientFactory = /** @class */ (function () {
    function WebAppClientFactory(sdkKey, config, invocationProcessor, browserPropertyProvider, lifecycleCompositeManager) {
        var _a;
        this.sdkKey = sdkKey;
        this.config = config;
        this.invocationProcessor = invocationProcessor;
        this.browserPropertyProvider = browserPropertyProvider;
        this.lifecycleCompositeManager = lifecycleCompositeManager;
        this.factories = (_a = {},
            _a[HackleAppMode.native] = new NativeAppClientFactory(this.sdkKey, this.config, this.invocationProcessor, this.browserPropertyProvider, this.lifecycleCompositeManager),
            _a[HackleAppMode.web_view_wrapper] = new WebViewClientFactory(this.sdkKey, this.config, this.invocationProcessor, this.browserPropertyProvider, this.lifecycleCompositeManager),
            _a);
    }
    WebAppClientFactory.prototype.create = function (appMode, webAppConfig) {
        var factory = this.factories[appMode];
        if (!factory) {
            throw new Error("Unsupported HackleAppMode: ".concat(appMode));
        }
        return factory.create(webAppConfig);
    };
    return WebAppClientFactory;
}());
function createInstance(sdkKey, _config) {
    // Config
    var config = Configurations.config(_config);
    // Logging
    Configurations.logging(config);
    // BrowserPropertyProvider
    var browserPropertyProvider = new DefaultBrowserPropertyProvider();
    var browserName = browserPropertyProvider.getBrowserProperties()["browserName"];
    // LifecycleCompositeManager
    var pageManager = new PageManager();
    var lifecycleManager = new LifecycleManager();
    var engagementManager = new EngagementManager(pageManager, DEFAULT_ENGAGEMENT_DURATION_MILLIS);
    var lifecycleComposite = new LifecycleCompositeManager(lifecycleManager, pageManager, engagementManager, typeof browserName === "string" ? browserName : null);
    // check WebApp client
    try {
        if (isHackleWebApp(window) && sdkKey === window._hackleApp.getAppSdkKey()) {
            return createWebAppClient(sdkKey, config, window._hackleApp, lifecycleComposite, browserPropertyProvider);
        }
    }
    catch (e) {
        log.error("Unexpected exception while check WebApp client: ".concat(e));
    }
    return createBrowserClient(sdkKey, config, lifecycleComposite);
}
function createWebAppClient(sdkKey, browserConfig, hackleApp, lifecycleComposite, browserPropertyProvider) {
    var _a, _b, _c;
    var invocatorFactory = new InvocatorFactory();
    var invocator = invocatorFactory.getInvocator(hackleApp.getInvocationType(), new InvocationResponseResolver());
    if (invocator === null) {
        throw new Error("Failed to get invocator with invocationType:".concat(hackleApp.getInvocationType()));
    }
    var invocationProcessor = new HackleAppInvocationProcessor(invocator);
    var _webAppClientFactory = new WebAppClientFactory(sdkKey, browserConfig, invocationProcessor, browserPropertyProvider, lifecycleComposite);
    var hackleWebAppConfigurationManager = new HackleWebViewConfigurations(new HackleWebViewConfigurationResolver(hackleApp));
    var appMode = (_c = (_b = (_a = hackleApp.getAppMode) === null || _a === void 0 ? void 0 : _a.call(hackleApp)) === null || _b === void 0 ? void 0 : _b.toLowerCase()) !== null && _c !== void 0 ? _c : HackleAppMode.native;
    var webViewConfig = hackleWebAppConfigurationManager.config();
    return _webAppClientFactory.create(appMode, webViewConfig);
}
function createBrowserClient(sdkKey, config, lifecycleCompositeManager) {
    var _a, _b;
    // SDK
    var sdk = Configurations.sdk(sdkKey, config);
    // check cache
    if (hackleClientCache) {
        log.debug("use already exists hackleClient");
        return hackleClientCache;
    }
    // _hackle_id
    var identifierManager = new IdentifierManager();
    identifierManager.initialize();
    // Storage
    var localStorage = new WindowLocalStorage();
    var cookieStorage = CookieStorage.getInstance({
        days: COOKIE_EXPIRE_DAYS,
        isCrossSubdomain: true,
        sameSite: config.sameSiteCookie,
        isSecure: config.secureCookie
    });
    // Beacon
    var isBeaconSupported = Configurations.isBeaconSupported();
    // Transport
    var defaultTransport = Transports.intercept(sdk, XhrTransport.create());
    var beaconTransport = Transports.intercept(sdk, BeaconTransport.create());
    var synchronousTransport = defaultTransport;
    if (isBeaconSupported) {
        synchronousTransport = beaconTransport;
    }
    // Synchronizer
    var compositeSynchronizer = new CompositeSynchronizer();
    var pollingSynchronizer = new PollingSynchronizer(compositeSynchronizer, new TimerScheduler("setTimeout"), Configurations.pollingIntervalMillis(config));
    // WorkspaceManager
    var workspaceConfigStorage = new BrowserWorkspaceConfigStorage(sdk, KeyTransformStorage.postfix(localStorage, "_".concat(sdkKey.slice(0, 8))));
    var httpWorkspaceFetcher = new HttpWorkspaceFetcher(Urls.clientFetch(config.sdkUrl, sdk.key), defaultTransport);
    var workspaceManager = new WorkspaceManager(workspaceConfigStorage, httpWorkspaceFetcher);
    compositeSynchronizer.add(workspaceManager);
    // UserManager
    var userTargetFetcher = new DefaultUserTargetFetcher(Urls.userTargets(config.sdkUrl), defaultTransport);
    var cohortFetcher = new DefaultUserCohortFetcher(Urls.userCohorts(config.sdkUrl), defaultTransport);
    var campaignParser = new CampaignParser(lifecycleCompositeManager.pageManager);
    var userStorage = new UserStorage(KeyTransformStorage.postfix(cookieStorage, "_".concat(sdkKey)));
    var previousUser = userStorage.getUser();
    var initUser = config.user || null;
    var userManager = new UserManagerImpl(getUserId(), userStorage, userTargetFetcher, cohortFetcher, campaignParser, lifecycleCompositeManager.pageManager, SystemClock.instance, previousUser, initUser);
    compositeSynchronizer.add(userManager);
    // SessionManager
    var sessionManager = new SessionManagerImpl(config.sessionTimeoutMillis, KeyTransformStorage.postfix(cookieStorage, "_".concat(sdkKey.slice(8))));
    userManager.addListener(sessionManager);
    // EventProcessor
    var repository = new EventRepositoryImpl(localStorage, "".concat(LOCAL_STORAGE_KEY_PREFIX, "_").concat(sdkKey), BROWSER_BATCH_SIZE);
    var eventTransport = new EventTransport(Urls.clientDispatch(config.eventUrl), defaultTransport);
    var synchronousEventTransport = eventTransport;
    if (isBeaconSupported) {
        synchronousEventTransport = new EventTransport(Urls.beaconDispatch(config.eventUrl, sdk.key), beaconTransport);
    }
    var retryManager = new BrowserEventRetryManager(repository, eventTransport);
    var eventDispatcher = new BrowserEventDispatcher(eventTransport, synchronousEventTransport, retryManager);
    var eventDedupDeterminer = new DelegatingUserEventDedupDeterminer([
        new RemoteConfigEventDedupDeterminer(Configurations.dedupIntervalMillis(config)),
        new ExposureEventDedupDeterminer(Configurations.dedupIntervalMillis(config))
    ]);
    var defaultEventProcessor = new DefaultEventProcessor(eventDispatcher, BROWSER_BATCH_SIZE, new TimerScheduler("setTimeout"), BROWSER_FLUSH_INTERVAL);
    var browserEventProcessor = new BrowserEventProcessor(defaultEventProcessor, eventDedupDeterminer, sessionManager, userManager);
    var sessionUserDecorator = new SessionUserDecorator(sessionManager);
    var sessionUserEventDecorator = new SessionUserEventDecorator(sessionUserDecorator);
    browserEventProcessor.addDecorator(sessionUserEventDecorator);
    // InitializeEventDispatcher
    var initializeEventDispatcher = new BrowserInitializeDoneEventDispatcher();
    // Core
    var abOverrideStorage = new HackleUserManualOverrideStorage(new ListStorage(cookieStorage, "".concat(OVERRIDE_AB_STORAGE_PREFIX, "_").concat(sdkKey.slice(0, 8))));
    var ffOverrideStorage = new HackleUserManualOverrideStorage(new ListStorage(cookieStorage, "".concat(OVERRIDE_FF_STORAGE_PREFIX, "_").concat(sdkKey.slice(0, 8))));
    var inAppMessageHiddenStorage = new InAppMessageHiddenLocalStorage(KeyTransformStorage.prefix(localStorage, "".concat(IAM_HIDE_STORAGE_PREFIX, "_").concat(sdkKey.slice(0, 8), "_")));
    var inAppMessageImpressionStorage = new InAppMessageImpressionLocalStorage(KeyTransformStorage.prefix(localStorage, "".concat(IAM_IMPRESSION_STORAGE_PREFIX, "_").concat(sdkKey.slice(0, 8), "_")));
    var eventFactory = new UserEventFactory(SystemClock.instance);
    var eventRecorder = new EvaluationEventRecorder(eventFactory, browserEventProcessor);
    var core = HackleCore.create(workspaceManager, eventFactory, browserEventProcessor, [
        abOverrideStorage,
        ffOverrideStorage
    ]);
    // PIIEventManager
    var piiEventManager = new PIIEventManager(core, userManager);
    // CampaignManager, SessionTracker
    var campaignManager = new CampaignManager(new CampaignStorage(KeyTransformStorage.postfix(cookieStorage, "_".concat(sdkKey.slice(0, 8)))), campaignParser, core, userManager);
    var sessionEventTracker = new SessionEventTracker(userManager, core);
    // Add SessionListener
    // CampaignManager MUST be added before SessionTracker to include campaign properties in session events.
    sessionManager.addListener(campaignManager);
    sessionManager.addListener(sessionEventTracker);
    // InAppMessage
    var inAppMessageEventTracker = new InAppMessageEventTracker(core);
    var inAppMessageActionHandlerFactory = new InAppMessageActionHandlerFactory([
        new InAppMessageCloseActionHandler(),
        new InAppMessageLinkActionHandler(new UrlLinkHandler()),
        new InAppMessageLinkAndCloseActionHandler(new UrlLinkHandler()),
        new InAppMessageHiddenActionHandler(inAppMessageHiddenStorage, SystemClock.instance),
        new InAppMessageLinkNewWindowActionHandler(new UrlLinkNewWindowHandler()),
        new InAppMessageLinkNewWindowAndCloseActionHandler(new UrlLinkNewWindowHandler()),
        new InAppMessageLinkNewTabActionHandler(new UrlLinkNewTabHandler()),
        new InAppMessageLinkNewTabAndCloseActionHandler(new UrlLinkNewTabHandler())
    ]);
    var inAppMessageEventProcessorFactory = new InAppMessageEventProcessorFactory([
        new InAppMessageImpressionEventProcessor(),
        new InAppMessageActionEventProcessor(inAppMessageActionHandlerFactory),
        new InAppMessageCloseEventProcessor()
    ]);
    var inAppMessageEventHandler = new InAppMessageEventHandler(SystemClock.instance, inAppMessageEventTracker, inAppMessageEventProcessorFactory);
    var inAppMessageInteractionHandlerFactory = new InAppMessageInteractionHandlerFactory([
        new InAppMessageCloseInteractionHandler(),
        new InAppMessageActionInteractionHandler(inAppMessageEventHandler),
        new InAppMessageImageImpressionInteractionHandler(inAppMessageEventHandler)
    ]);
    var inAppMessageRenderScriptLoader = new InAppMessageRenderScriptLoader(Urls.inAppMessageRenderer(config.cdnUrl, config.IAM_RENDERER_VERSION_HEADER));
    var inAppMessageUi = new InAppMessageUi(InAppMessageViewFactory.create(inAppMessageRenderScriptLoader), inAppMessageEventHandler, inAppMessageInteractionHandlerFactory);
    var evaluator = HackleCoreContext.get("delegatingEvaluator");
    var inAppMessageLayoutEvaluator = new InAppMessageLayoutEvaluator(new InAppMessageExperimentEvaluator(evaluator), new InAppMessageLayoutSelector(), eventRecorder);
    var inAppMessageRecorder = new InAppMessageRecorder(inAppMessageImpressionStorage);
    var inAppMessagePresentProcessor = new InAppMessagePresentProcessor(inAppMessageUi, inAppMessageRecorder);
    var inAppMessageIdentifierChecker = new InAppMessageIdentifierChecker();
    var inAppMessageEligibilityFlowFactory = new InAppMessageEligibilityFlowFactory(inAppMessageHiddenStorage, inAppMessageImpressionStorage, inAppMessageLayoutEvaluator);
    var inAppMessageLayoutResolver = new InAppMessageLayoutResolver(core, inAppMessageLayoutEvaluator);
    var inAppMessageDelayScheduler = new InAppMessageDelayScheduler(SystemClock.instance, new TimerScheduler("setTimeout"));
    var inAppMessageDelayStorage = new InAppMessageDelayLocalStorage(KeyTransformStorage.prefix(localStorage, "".concat(CAMPAIGN_DELAY_STORAGE_KEY, "_").concat(sdkKey.slice(0, 8), "_")));
    var inAppMessageDelayManager = new InAppMessageDelayManager(inAppMessageDelayScheduler, new Map(), inAppMessageDelayStorage);
    var inAppMessageEvaluateProcessor = new InAppMessageEvaluateProcessor(core, inAppMessageEligibilityFlowFactory, eventRecorder);
    var inAppMessageDeliverProcessor = new InAppMessageDeliverProcessor(workspaceManager, userManager, inAppMessageIdentifierChecker, inAppMessageLayoutResolver, inAppMessageEvaluateProcessor, inAppMessagePresentProcessor, sessionUserDecorator);
    var schedulers = [
        new DelayedInAppMessageScheduler(inAppMessageDeliverProcessor, inAppMessageDelayManager),
        new TriggeredInAppMessageScheduler(inAppMessageDeliverProcessor, inAppMessageDelayManager),
        new StoredInAppMessageScheduler(inAppMessageDeliverProcessor, inAppMessageDelayManager)
    ];
    var inAppMessageScheduleProcessor = new InAppMessageScheduleProcessor(new InAppMessageScheduleActionDeterminer(), new InAppMessageSchedulerFactory(schedulers));
    inAppMessageDelayScheduler.listener = inAppMessageScheduleProcessor;
    var inAppMessageEventMatcher = new InAppMessageEventMatcher(new InAppMessageEventTriggerRuleMatcher(HackleCoreContext.get("targetMatcher")));
    var inAppMessageTriggerDeterminer = new InAppMessageTriggerDeterminer(workspaceManager, inAppMessageEventMatcher, inAppMessageEvaluateProcessor);
    var inAppMessageTriggerHandler = new InAppMessageTriggerHandler(inAppMessageScheduleProcessor);
    var inAppMessageTriggerProcessor = new InAppMessageTriggerProcessor(inAppMessageTriggerDeterminer, inAppMessageTriggerHandler);
    var inAppMessageResetProcessor = new InAppMessageResetProcessor(inAppMessageIdentifierChecker, inAppMessageDelayManager);
    var inAppMessageManager = new InAppMessageManager(inAppMessageScheduleProcessor, inAppMessageDelayStorage, inAppMessageTriggerProcessor, inAppMessageResetProcessor, defaultEventProcessor, SystemClock.instance);
    userManager.addListener(inAppMessageManager);
    // GA Integration
    var googleAnalyticsDeterminer = new GoogleAnalyticsDeterminer(workspaceManager);
    new GoogleAnalyticsManager(defaultEventProcessor, googleAnalyticsDeterminer);
    // EngagementEventTracker
    var engagementEventTracker = new EngagementEventTracker(core, userManager);
    lifecycleCompositeManager.addEngagementListener(engagementEventTracker);
    // PageEventTracker
    var pageEventTracker = new PageEventTracker(core, userManager);
    if (config.automaticPageTracking) {
        lifecycleCompositeManager.addPageListener(pageEventTracker);
    }
    // SplitUrl
    var splitUrlMatcher = new SplitUrlMatcher(HackleCoreContext.get("targetMatcher"));
    var splitUrlRedirectedCheckStorage = new SplitUrlRedirectedCookieStorage(cookieStorage, SPLIT_URL_REDIRECT_CHECK_COOKIE_KEY, { days: SPLIT_URL_REDIRECT_CHECK_COOKIE_EXPIRE_DAYS });
    var splitUrlDeterminer = new SplitUrlDeterminer(workspaceManager, splitUrlMatcher, splitUrlRedirectedCheckStorage, core);
    var splitUrlRedirector = new SplitUrlRedirector(new SplitUrlResolver(campaignParser), new UrlReplaceHandler(), splitUrlRedirectedCheckStorage, initializeEventDispatcher);
    var splitUrlManager = new SplitUrlManager(splitUrlDeterminer, splitUrlRedirector, userManager, core);
    lifecycleCompositeManager.addPageListener(splitUrlManager);
    // UserExplorer
    var userExplorer = new HackleUserExplorerImpl(core, userManager, abOverrideStorage, ffOverrideStorage);
    var isValidDevToolConfig = ((_a = config.devTool) === null || _a === void 0 ? void 0 : _a.userExplorer) && typeof ((_b = config.devTool) === null || _b === void 0 ? void 0 : _b.userExplorer) === "function";
    var devTools = config.devTool && isValidDevToolConfig ? { manager: config.devTool, userExplorer: userExplorer } : undefined;
    // Metrics
    var monitoringMetricRegistry = new MonitoringMetricRegistry(Urls.monitoring(config.monitoringUrl), defaultTransport, synchronousTransport, new TimerScheduler("setTimeout"), METRIC_FLUSH_INTERVAL);
    Metrics.addRegistry(monitoringMetricRegistry);
    // add LifecycleManager Listener
    lifecycleCompositeManager.addLifecycleListener(sessionManager);
    lifecycleCompositeManager.addLifecycleListener(identifierManager);
    lifecycleCompositeManager.addLifecycleListener(retryManager);
    lifecycleCompositeManager.addLifecycleListener(browserEventProcessor);
    lifecycleCompositeManager.addLifecycleListener(monitoringMetricRegistry);
    // Instantiate
    pollingSynchronizer.start();
    var fetchThrottler = Throttler.create(FETCH_THROTTLE_INTERVAL_MILLIS, 1);
    var hackleClient = new HackleClientImpl(core, pollingSynchronizer, sessionManager, userManager, piiEventManager, fetchThrottler, pageEventTracker, inAppMessageUi, devTools);
    hackleClientCache = hackleClient;
    // Post instantiate
    var autoOpenDevTool = function () {
        if (config.autoOpenDevTool) {
            if (!config.devTool) {
                log.error("DevTool is not provided");
            }
            else {
                hackleClient.showUserExplorer();
            }
        }
    };
    var refresh = function () {
        var timestamp = Date.now();
        var currentUser = userManager.currentUser;
        // Session Refresh
        var currentSessionId = sessionManager.currentSessionId;
        var newSessionId;
        if (isSameUser(previousUser, currentUser)) {
            newSessionId = sessionManager.startNewSessionIfNeeded(currentUser, timestamp);
        }
        else {
            newSessionId = sessionManager.startNewSession(previousUser, currentUser, timestamp);
        }
        // Campaign Refresh
        if (newSessionId === currentSessionId) {
            // If new session is started, CampaignManager automatically restarts the campaign.
            // Attempts to cover when session is not newly started, but the campaign changes.
            campaignManager.startNewCampaignIfNeeded(currentUser, timestamp);
        }
    };
    new GlobalErrorHandler().install(core, userManager);
    refresh();
    hackleClient.onReady(function () {
        autoOpenDevTool();
        lifecycleCompositeManager.initialize();
        initializeEventDispatcher.dispatchDoneEventIfNeeded();
        inAppMessageManager.loadDelaySchedule();
    });
    return hackleClient;
}
var index_browser = {
    createInstance: createInstance,
    getUserId: getUserId,
    setUserId: setUserId,
    removeUserId: removeUserId,
    Logger: Logger
};

export { Bucket, Cohort, Container, ContainerGroup, CoreVersion, Decision, DecisionReason, DefaultBrowserPropertyProvider, Delay, EXPERIMENT_IMPLEMENTATION_TYPE, EmptyHackleRemoteConfig, EmptyParameterConfig, EventType, Experiment, FeatureFlagDecision, HackleInAppMessageActionImpl, HackleSubscriptionOperations, HackleSubscriptionOperationsBuilder, HackleSubscriptionStatus, IAM_ACTION_AREA, IAM_ACTION_TYPE, IAM_BEHAVIOR, IAM_DISPLAY_TYPE, IAM_HORIZONTAL_ALIGNMENT, IAM_LAYOUT_TYPE, IAM_ORIENTATION, IAM_PLATFORM_TYPE, IAM_STATUS, IAM_TIMETABLE_TYPE, IAM_TIMEUNIT, IAM_VERTICAL_ALIGNMENT, IdentifierType, IdentifiersBuilder, InAppMessage, InAppMessageAction, InAppMessageAfterCondition, InAppMessageAlignment, InAppMessageBackground, InAppMessageButton, InAppMessageButtonStyle, InAppMessageContext, InAppMessageContextLayout, InAppMessageContextMessage, InAppMessageDurationCap, InAppMessageEvaluateContext, InAppMessageEventFrequencyCap, InAppMessageEventTrigger, InAppMessageEventTriggerRule, InAppMessageExperimentContext, InAppMessageIdentifierCap, InAppMessageImage, InAppMessageImageAutoScroll, InAppMessagePeriodAlways, InAppMessagePeriodCustom, InAppMessagePositionalButton, InAppMessageTargetContext, InAppMessageText, InAppMessageTextAttribute, InAppMessageTextStyle, InAppMessageTimetable, InAppMessageTimetableAll, InAppMessageTimetableCustom, InAppMessageTimetableSlot, InAppMessageUserOverride, Logger, MATCH_OPERATORS, MATCH_TYPES, MATCH_VALUE_TYPES, MetaVersion, ParameterConfiguration, PropertyOperations, PropertyOperationsBuilder, RemoteConfigDecision, RemoteConfigParameter, RemoteConfigParameterValue, RemoteConfigTargetRule, SEGMENT_TYPES, Segment, Slot, SplitUrlConfig, SplitUrlRedirectType, SplitUrlTargets, TARGET_ACTION_TYPES, TARGET_KEY_TYPES, Target, TargetAction, TargetCondition, TargetKey, TargetMatch, TargetRule, TargetingType, UserTargetEvent, Variation, Version, WebViewLifecycleCompositeManager, createInstance, index_browser as default, getUserId, removeUserId, resolveIdentifiers, sanitizeUser, setUserId };
//# sourceMappingURL=index.browser.es.js.map
